import * as React from 'react';
import React__default, { createContext, createElement as createElement$1, Component, useReducer, useContext, useState, useRef, useEffect, useLayoutEffect, forwardRef } from 'react';
import { useHistory, Link, NavLink, useParams, useLocation, BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import styled, { createGlobalStyle, css as css$1 } from 'styled-components';
import Collapse from '@kunukn/react-collapse';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$d() {
  _extends$d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$d.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$2(o, p);
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct$1(Parent, args, Class) {
  if (_isNativeReflectConstruct$1()) {
    _construct$1 = Reflect.construct;
  } else {
    _construct$1 = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$2(instance, Class.prototype);
      return instance;
    };
  }

  return _construct$1.apply(null, arguments);
}

function _isNativeFunction$1(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper$1(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper$1 = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction$1(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct$1(Class, arguments, _getPrototypeOf$1(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$2(Wrapper, Class);
  };

  return _wrapNativeSuper$1(Class);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$3(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$2(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var SiteContext = /*#__PURE__*/React__default.createContext({
  sites: [],
  site: {},
  page: {},
  featuredNews: [],
  news: [],
  latestNews: [],
  total: 0,
  post: {},
  menus: {},
  grants: {},
  results: [],
  root: 'http://localhost:4242',
  defaultTitle: '',
  defaultDescription: '',
  defaultAsset: '',
  getSites: function getSites() {},
  getSite: function getSite(slug) {},
  getHomepage: function getHomepage(site) {},
  getPage: function getPage(id, site) {},
  getNews: function getNews(site, category, page) {},
  getLatestNews: function getLatestNews(site) {},
  getRelatedPosts: function getRelatedPosts(site, id, resolve) {},
  getNewsCategories: function getNewsCategories(site, resolve) {},
  clearTotal: function clearTotal() {},
  getPost: function getPost(id, site) {},
  clearPost: function clearPost() {},
  getMenus: function getMenus() {},
  getGrants: function getGrants(site) {},
  getResults: function getResults(site, query) {}
});

var SET_SITES = 'SET_SITES';
var SET_SITE = 'SET_SITE';
var SET_PAGE = 'SET_PAGE';
var SET_NEWS = 'SET_NEWS';
var APPEND_NEWS = 'APPEND_NEWS';
var SET_LATEST_NEWS = 'SET_LATEST_NEWS';
var SET_TOTAL = 'SET_TOTAL';
var SET_POST = 'SET_POST';
var SET_MENUS = 'SET_MENUS';
var SET_GRANTS = 'SET_GRANTS';
var SET_META = 'SET_META';
var SET_RESULTS = 'SET_RESULTS';

var setSites = function setSites(sites, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    sites: sites
  });
};

var setSite = function setSite(site, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    site: site
  });
};

var setPage = function setPage(page, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    page: page
  });
};

var setNews = function setNews(news, featuredNews, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    news: news,
    featuredNews: featuredNews
  });
};

var appendNews = function appendNews(news, state) {
  var updatedNews = _toConsumableArray(state.news);

  updatedNews = updatedNews.concat(news);
  return _objectSpread2(_objectSpread2({}, state), {}, {
    news: updatedNews
  });
};

var setLatestNews = function setLatestNews(latestNews, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    latestNews: latestNews
  });
};

var setTotal = function setTotal(total, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    total: total
  });
};

var setPost = function setPost(post, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    post: post
  });
};

var setMenus = function setMenus(menus, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    menus: menus
  });
};

var setGrants = function setGrants(grants, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    grants: grants
  });
};

var setMeta = function setMeta(defaultDescription, defaultAsset, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    defaultDescription: defaultDescription,
    defaultAsset: defaultAsset
  });
};

var setResults = function setResults(results, state) {
  return _objectSpread2(_objectSpread2({}, state), {}, {
    results: results
  });
};

var siteReducer = function siteReducer(state, action) {
  switch (action.type) {
    case SET_SITES:
      return setSites(action.sites, state);

    case SET_SITE:
      return setSite(action.site, state);

    case SET_PAGE:
      return setPage(action.page, state);

    case SET_NEWS:
      return setNews(action.news, action.featuredNews, state);

    case APPEND_NEWS:
      return appendNews(action.news, state);

    case SET_LATEST_NEWS:
      return setLatestNews(action.latestNews, state);

    case SET_TOTAL:
      return setTotal(action.total, state);

    case SET_POST:
      return setPost(action.post, state);

    case SET_MENUS:
      return setMenus(action.menus, state);

    case SET_GRANTS:
      return setGrants(action.grants, state);

    case SET_META:
      return setMeta(action.defaultDescription, action.defaultAsset, state);

    case SET_RESULTS:
      return setResults(action.results, state);

    default:
      return state;
  }
};

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var _React$createContext = /*#__PURE__*/createContext(null),
    Consumer = _React$createContext.Consumer,
    Provider = _React$createContext.Provider;

var HeadTag = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(HeadTag, _React$Component);

  function HeadTag() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      canUseDOM: false
    };
    _this.headTags = null;
    _this.index = -1;
    return _this;
  }

  var _proto = HeadTag.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        tag = _this$props.tag,
        name = _this$props.name,
        property = _this$props.property;
    this.setState({
      canUseDOM: true
    });
    this.index = this.headTags.addClientTag(tag, name || property);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var tag = this.props.tag;
    this.headTags.removeClientTag(tag, this.index);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        Tag = _this$props2.tag,
        rest = _objectWithoutPropertiesLoose$2(_this$props2, ["tag"]);

    var canUseDOM = this.state.canUseDOM;
    return /*#__PURE__*/createElement$1(Consumer, null, function (headTags) {
      if (headTags == null) {
        throw Error('<HeadProvider /> should be in the tree');
      }

      _this2.headTags = headTags;

      if (canUseDOM) {
        if (!headTags.shouldRenderTag(Tag, _this2.index)) {
          return null;
        }

        var ClientComp = /*#__PURE__*/createElement$1(Tag, rest);
        return /*#__PURE__*/createPortal(ClientComp, document.head);
      }

      var ServerComp = /*#__PURE__*/createElement$1(Tag, _extends$c({
        "data-rh": ""
      }, rest));
      headTags.addServerTag(ServerComp);
      return null;
    });
  };

  return HeadTag;
}(Component);

var cascadingTags = ['title', 'meta'];

var HeadProvider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(HeadProvider, _React$Component);

  function HeadProvider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.indices = new Map();
    _this.state = {
      addClientTag: function addClientTag(tag, name) {
        // consider only cascading tags
        if (cascadingTags.indexOf(tag) !== -1) {
          _this.setState(function (state) {
            var _ref;

            var names = state[tag] || [];
            return _ref = {}, _ref[tag] = [].concat(names, [name]), _ref;
          }); // track indices synchronously


          var _assertThisInitialize = _assertThisInitialized$1(_this),
              indices = _assertThisInitialize.indices;

          var index = indices.has(tag) ? indices.get(tag) + 1 : 0;
          indices.set(tag, index);
          return index;
        }

        return -1;
      },
      shouldRenderTag: function shouldRenderTag(tag, index) {
        if (cascadingTags.indexOf(tag) !== -1) {
          var names = _this.state[tag]; // eslint-disable-line react/destructuring-assignment
          // check if the tag is the last one of similar

          return names && names.lastIndexOf(names[index]) === index;
        }

        return true;
      },
      removeClientTag: function removeClientTag(tag, index) {
        _this.setState(function (state) {
          var names = state[tag];

          if (names) {
            var _ref2;

            names[index] = null;
            return _ref2 = {}, _ref2[tag] = names, _ref2;
          }

          return null;
        });
      },
      addServerTag: function addServerTag(tagNode) {
        var _this$props$headTags = _this.props.headTags,
            headTags = _this$props$headTags === void 0 ? [] : _this$props$headTags; // tweak only cascading tags

        if (cascadingTags.indexOf(tagNode.type) !== -1) {
          var index = headTags.findIndex(function (prev) {
            var prevName = prev.props.name || prev.props.property;
            var nextName = tagNode.props.name || tagNode.props.property;
            return prev.type === tagNode.type && prevName === nextName;
          });

          if (index !== -1) {
            headTags.splice(index, 1);
          }
        }

        headTags.push(tagNode);
      }
    };
    return _this;
  }

  var _proto = HeadProvider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var ssrTags = document.head.querySelectorAll("[data-rh=\"\"]"); // `forEach` on `NodeList` is not supported in Googlebot, so use a workaround

    Array.prototype.forEach.call(ssrTags, function (ssrTag) {
      return ssrTag.parentNode.removeChild(ssrTag);
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        headTags = _this$props.headTags,
        children = _this$props.children;

    if (typeof window === 'undefined' && Array.isArray(headTags) === false) {
      throw Error('headTags array should be passed to <HeadProvider /> in node');
    }

    return /*#__PURE__*/createElement$1(Provider, {
      value: this.state
    }, children);
  };

  return HeadProvider;
}(Component);

var Title = function Title(props) {
  return /*#__PURE__*/createElement$1(HeadTag, _extends$c({
    tag: "title"
  }, props));
};

var Meta = function Meta(props) {
  return /*#__PURE__*/createElement$1(HeadTag, _extends$c({
    tag: "meta"
  }, props));
};

var SiteProvider = function SiteProvider(_ref) {
  var root = _ref.root,
      title = _ref.title,
      children = _ref.children;
  var history = useHistory();

  var _useReducer = useReducer(siteReducer, {
    sites: [],
    site: {},
    page: {},
    featuredNews: [],
    news: [],
    latestNews: [],
    total: 0,
    post: {},
    menus: {},
    grants: {},
    results: [],
    root: root,
    defaultTitle: title,
    defaultDescription: '',
    defaultAsset: ''
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var getSites = function getSites() {
    fetch("".concat(state.root, "/sites.json")).then(function (response) {
      return response.json();
    }).then(function (data) {
      dispatch({
        type: SET_SITES,
        sites: data
      });
    })["catch"](function (error) {
      console.error(error);
      history.push('/500');
    });
  };

  var getSite = function getSite(slug) {
    fetch("".concat(state.root, "/sites/get_site.json?site=").concat(slug)).then(function (response) {
      return response.json();
    }).then(function (data) {
      dispatch({
        type: SET_SITE,
        site: data
      });
    })["catch"](function (error) {
      console.error(error);
      history.push('/500');
    });
  };

  var getHomepage = function getHomepage(site) {
    fetch("".concat(state.root, "/sites/homepage.json?site=").concat(site)).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.page) {
        dispatch({
          type: SET_PAGE,
          page: data.page
        });
        dispatch({
          type: SET_META,
          defaultDescription: data.page.meta_description,
          defaultAsset: data.page.meta_asset
        });
      }
    })["catch"](function (error) {
      console.error(error);
      history.push('/500');
    });
  };

  var getPage = function getPage(id, site) {
    fetch("".concat(state.root, "/sites/page.json?slug=").concat(id, "&site=").concat(site)).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.page) {
        dispatch({
          type: SET_PAGE,
          page: data.page
        });
      } else {
        history.push('/404');
      }
    })["catch"](function (error) {
      console.error(error);
      history.push('/500');
    });
  };

  var getNews = function getNews(site, category, page) {
    var path = "".concat(state.root, "/sites/news.json?site=").concat(site);

    if (category) {
      path += "&category=".concat(category);
    }

    if (page) {
      path += "&page=".concat(page);
    }

    fetch(path).then(function (response) {
      return response.json();
    }).then(function (data) {
      dispatch({
        type: SET_TOTAL,
        total: data.total
      });

      if (page) {
        dispatch({
          type: APPEND_NEWS,
          news: data.news
        });
      } else {
        dispatch({
          type: SET_NEWS,
          news: data.news,
          featuredNews: data.featured
        });
      }
    })["catch"](function (error) {
      console.error(error);
      history.push('/500');
    });
  };

  var getPost = function getPost(id, site) {
    fetch("".concat(state.root, "/sites/post.json?slug=").concat(id, "&site=").concat(site)).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.post) {
        dispatch({
          type: SET_POST,
          post: data.post
        });
      } else {
        history.push('/404');
      }
    })["catch"](function (error) {
      console.error(error);
      history.push('/500');
    });
  };

  var clearPost = function clearPost() {
    dispatch({
      type: SET_POST,
      post: {}
    });
  };

  var getLatestNews = function getLatestNews(site) {
    fetch("".concat(state.root, "/sites/latest_news.json?site=").concat(site)).then(function (response) {
      return response.json();
    }).then(function (data) {
      dispatch({
        type: SET_LATEST_NEWS,
        latestNews: data
      });
    })["catch"](function (error) {
      console.error(error);
      history.push('/500');
    });
  };

  var getNewsCategories = function getNewsCategories(site, resolve) {
    fetch("".concat(state.root, "/sites/news_categories.json?site=").concat(site)).then(function (response) {
      return response.json();
    }).then(function (categories) {
      return resolve(categories);
    })["catch"](function (error) {
      console.error(error);
      resolve([]);
    });
  };

  var getRelatedPosts = function getRelatedPosts(site, id, resolve) {
    fetch("".concat(state.root, "/sites/read_more.json?site=").concat(site, "&id=").concat(id)).then(function (response) {
      return response.json();
    }).then(function (posts) {
      return resolve(posts);
    })["catch"](function (error) {
      console.error(error);
      resolve([]);
    });
  };

  var clearTotal = function clearTotal() {
    dispatch({
      type: SET_TOTAL,
      total: 0
    });
  };

  var getMenus = function getMenus(site) {
    fetch("".concat(state.root, "/sites/menus.json?site=").concat(site)).then(function (response) {
      return response.json();
    }).then(function (data) {
      dispatch({
        type: SET_MENUS,
        menus: data.menus
      });
    })["catch"](function (error) {
      console.error(error);
    });
  };

  var getGrants = function getGrants(site) {
    var path = "".concat(state.root, "/grants.json?site=").concat(site);
    fetch(path).then(function (response) {
      return response.json();
    }).then(function (data) {
      dispatch({
        type: SET_GRANTS,
        grants: data.grants
      });
    })["catch"](function (error) {
      console.error(error);
      history.push('/500');
    });
  };

  var getResults = function getResults(site, query) {
    fetch("".concat(state.root, "/search.json?site=").concat(site, "&q=").concat(query)).then(function (response) {
      return response.json();
    }).then(function (data) {
      dispatch({
        type: SET_RESULTS,
        results: data
      });
    })["catch"](function (error) {
      console.error(error);
      history.push('/500');
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Title, null, state.defaultTitle), /*#__PURE__*/React__default.createElement(SiteContext.Provider, {
    value: {
      sites: state.sites,
      site: state.site,
      page: state.page,
      featuredNews: state.featuredNews,
      news: state.news,
      latestNews: state.latestNews,
      total: state.total,
      post: state.post,
      menus: state.menus,
      grants: state.grants,
      results: state.results,
      root: state.root,
      defaultTitle: state.defaultTitle,
      defaultDescription: state.defaultDescription,
      defaultAsset: state.defaultAsset,
      getSites: getSites,
      getSite: getSite,
      getHomepage: getHomepage,
      getPage: getPage,
      getNews: getNews,
      getLatestNews: getLatestNews,
      getNewsCategories: getNewsCategories,
      getRelatedPosts: getRelatedPosts,
      clearTotal: clearTotal,
      getPost: getPost,
      clearPost: clearPost,
      getMenus: getMenus,
      getGrants: getGrants,
      getResults: getResults
    }
  }, children));
};

SiteProvider.propTypes = {
  children: PropTypes.node.isRequired
};

var cambria = "05dd8b19f8b6cdb6.ttf";

var cambriaItalic = "3eaf16230da5d867.ttf";

var cambriaBold = "d196c26acc9f5e3c.ttf";

var cambriaBoldItalic = "596ad94352af19f7.ttf";

var _templateObject;
var DefaultStyles = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @font-face {\n    font-family: \"cambria\";\n    src: url(", ") format(\"ttf\");\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: \"cambria\";\n    src: url(", ") format(\"ttf\");\n    font-weight: normal;\n    font-style: italic;\n  }\n\n  @font-face {\n    font-family: \"cambria\";\n    src: url(", ") format(\"ttf\");\n    font-weight: 700;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: \"cambria\";\n    src: url(", ") format(\"ttf\");\n    font-weight: 700;\n    font-style: italic;\n  }\n\n  html {\n    box-sizing: border-box;\n    scroll-behavior: smooth;\n  }\n\n  body {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 100%;\n    font-family: cambria, serif;\n    margin: 0;\n  }\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n\n  h1 {\n    font-family: proxima-nova-condensed, sans-serif;\n    font-weight: 600;\n    font-size: 48px;\n    line-height: 1;\n    color: ", ";\n    margin-top: 0;\n    margin-bottom: 20px;\n\n    @media (min-width: 768px) {\n      font-size: 85px;\n    }\n  }\n\n  h2 {\n    font-family: proxima-nova-condensed, sans-serif;\n    font-weight: 600;\n    font-size: 36px;\n    line-height: 1;\n    color: #1d2042;\n    margin-top: 0;\n    margin-bottom: 14px;\n\n    @media (min-width: 768px) {\n      font-size: 56px;\n      margin-bottom: 46px;\n    }\n  }\n\n  h3 {\n    font-family: proxima-nova-condensed, sans-serif;\n    font-weight: 700;\n    font-size: 36px;\n    line-height: 1;\n    color: #1d2042;\n    margin-top: 0;\n    margin-bottom: 20px;\n\n    @media (min-width: 768px) {\n      font-size: 36px;\n    }\n  }\n\n  h4 {\n    font-family: proxima-nova-condensed, sans-serif;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 1.08;\n    color: #1d2042;\n    margin-top: 0;\n    margin-bottom: 16px;\n  }\n\n  h5 {\n    font-family: proxima-nova, sans-serif;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 1.3125;\n    text-transform: uppercase;\n    color: #1d2042;\n    margin-top: 0;\n    margin-bottom: 16px;\n  }\n\n  h6 {\n    font-family: proxima-nova, sans-serif;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 1.17;\n    color: #1d2042;\n    margin-top: 0;\n    margin-bottom: 16px;\n  }\n\n  p, ul, ol {\n    font-size: 18px;\n    color: #000;\n    line-height: 1.3;\n    margin-top: 0;\n    margin-bottom: 20px;\n\n    @media (min-width: 600px) {\n      font-size: 20px;\n    }\n\n    &.large {\n      font-size: 21px;\n      margin-bottom: 28px;\n\n      @media (min-width: 600px) {\n        font-size: 24px;\n        margin-bottom: 38px;\n      }\n    }\n  }\n\n  p, ul, ol {\n    + h1,\n    + h2,\n    + h3,\n    + h4 {\n      margin-top: 52px;\n    }\n  }\n\n  ul, ol {\n    padding-left: 20px;\n  }\n\n  .collapse-css-transition {\n    transition: height 0.35s ease-out;\n  }\n"])), cambria, cambriaItalic, cambriaBold, cambriaBoldItalic, function (props) {
  return props.color ? props.color : '#1d2042';
});

var defaultLogo = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%22239%22%20height%3D%2255%22%3E%3Cdefs%3E%3Cpath%20id%3D%22a%22%20d%3D%22M0%2055h237.599V.243H0z%22%2F%3E%3C%2Fdefs%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20transform%3D%22translate%28.5%29%22%3E%3Cpath%20fill%3D%22%238E8FA0%22%20d%3D%22M69%2037h6v1.511h-4.39v3.616h4.271v1.511H70.61V49H69zM78.772%2044.952h3.456l-1.737-6.369-1.72%206.37zm3.807%201.511H78.42L77.737%2049H76l3.49-12h2.001L85%2049h-1.737l-.684-2.537zM96.333%2039.789L93.337%2049h-.674l-2.978-9.211V49H88V37h2.323L93%2045.276%2095.713%2037H98v12h-1.667zM101%2049h2V37h-2zM106%2037h1.717v10.489H112V49h-6zM115.664%2043.962L112%2037h1.885l2.615%205.343L119.132%2037H121l-3.646%206.962V49h-1.69zM129%2037h6v1.511h-4.39v3.616h4.271v1.511h-4.271V49H129zM142.084%2038.64c-1.83%200-2.822%201.983-2.822%204.561%200%202.545.993%204.563%202.822%204.563%201.829%200%202.84-2.018%202.84-4.563%200-2.578-1.011-4.56-2.84-4.56m0-1.492c2.892%200%204.546%202.631%204.546%206.052%200%203.422-1.654%206.053-4.546%206.053-2.874%200-4.512-2.631-4.512-6.053%200-3.42%201.638-6.052%204.512-6.052m7.77.193h1.654v7.86c0%201.684.82%202.579%202.23%202.579%201.411%200%202.23-.895%202.23-2.58v-7.86h1.655v7.843c0%202.614-1.464%204.07-3.885%204.07s-3.885-1.456-3.885-4.07v-7.842zM162.919%2040.482v8.562h-1.655V37.342h1.672l4.477%208.298v-8.298h1.654v11.702h-1.585zM175.984%2047.57c2.038%200%203.083-1.86%203.083-4.369%200-2.543-1.028-4.385-3.083-4.385h-1.62v8.754h1.62zm-3.275-10.228h3.275c3.066%200%204.79%202.491%204.79%205.86%200%203.386-1.707%205.842-4.773%205.842h-3.292V37.342zm12.612%207.755h3.432l-1.725-6.211-1.707%206.21zm3.78%201.473h-4.128l-.68%202.474h-1.724l3.466-11.702h1.986l3.484%2011.702h-1.724l-.68-2.474zM195.199%2038.816h-2.7v-1.474h7.072v1.474h-2.717v10.228h-1.655z%22%2F%3E%3Cmask%20id%3D%22b%22%20fill%3D%22%23fff%22%3E%3Cuse%20xlink%3Ahref%3D%22%23a%22%2F%3E%3C%2Fmask%3E%3Cpath%20fill%3D%22%238E8FA0%22%20mask%3D%22url%28%23b%29%22%20d%3D%22M202.463%2049.044h1.655V37.342h-1.655zM211.852%2038.64c-1.829%200-2.822%201.983-2.822%204.561%200%202.545.993%204.563%202.822%204.563%201.83%200%202.84-2.018%202.84-4.563%200-2.578-1.01-4.56-2.84-4.56m0-1.492c2.892%200%204.547%202.631%204.547%206.052%200%203.422-1.655%206.053-4.547%206.053-2.874%200-4.511-2.631-4.511-6.053%200-3.42%201.637-6.052%204.511-6.052M221.277%2040.482v8.562h-1.655V37.342h1.672l4.477%208.298v-8.298h1.655v11.702h-1.585zM231.206%2046.482c.61.72%201.603%201.281%202.735%201.281%201.341%200%201.986-.807%201.986-1.737%200-1.175-1.045-1.684-2.212-2.228-1.411-.649-3.031-1.35-3.031-3.474%200-1.806%201.41-3.175%203.483-3.175%201.325%200%202.422.456%203.206%201.245l-.837%201.264c-.644-.702-1.515-1.018-2.42-1.018-1.011%200-1.742.632-1.742%201.597%200%201%20.992%201.456%202.09%201.982%201.463.684%203.135%201.474%203.135%203.702%200%201.807-1.202%203.333-3.64%203.333-1.585%200-2.788-.579-3.606-1.473l.853-1.299z%22%2F%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M0%2055h54.368V.243H0V55zm4.544-4.577h45.28V4.82H4.544v45.603zm78.561-27.166V17.8l-.064-.131a258.844%20258.844%200%200%200-3.797-.065c-2.682.022-4.023.054-4.023.098l.065.065v5.36c0%201.154.086%202.07.26%202.744.042.153.34.327.892.523.551.196.924.294%201.12.294.085%200%20.134.163.145.49.01.327-.016.567-.08.72-.11%200-.775-.045-1.997-.132-1.222-.086-2.114-.13-2.676-.13-.563%200-1.379.038-2.45.114-1.07.077-1.768.126-2.093.148-.086-.088-.13-.273-.13-.556%200-.436.022-.654.066-.654.26%200%20.67-.087%201.232-.261.563-.174.877-.348.941-.523.151-.588.228-1.47.228-2.647V10.774c0-1.328-.077-2.178-.228-2.55-.108-.238-.41-.445-.908-.62-.498-.174-.876-.261-1.136-.261-.086%200-.13-.218-.13-.654%200-.326.022-.511.065-.555l4.51.196c.562%200%202.142-.065%204.738-.196.064.109.097.337.097.686%200%20.349-.044.523-.13.523-.195%200-.573.093-1.136.277-.562.186-.876.355-.94.507-.174.458-.26%201.384-.26%202.778v4.64l.065.098c2.12.044%203.417.065%203.893.065.584%200%201.85-.02%203.797-.065.043-.043.064-.087.064-.13v-4.739c0-1.133-.076-1.993-.227-2.582-.065-.174-.362-.36-.892-.555-.53-.196-.914-.294-1.152-.294-.087%200-.135-.18-.146-.54-.011-.359.027-.582.114-.67%202.985.132%204.596.197%204.834.197.325%200%201.785-.065%204.38-.196.066.196.098.392.098.588%200%20.414-.055.62-.162.62-.195%200-.574.094-1.136.278-.563.186-.865.355-.909.507-.173.654-.26%201.58-.26%202.778v12.222c0%201.176.087%202.102.26%202.777.044.152.341.316.893.49.551.175.924.261%201.119.261.086%200%20.13.23.13.687%200%20.174-.033.36-.097.556-.195%200-.833-.045-1.915-.132-1.082-.086-1.904-.13-2.466-.13-.584%200-1.465.038-2.644.114-1.18.077-1.91.126-2.19.148-.087-.088-.125-.311-.113-.67.01-.36.059-.54.145-.54.238%200%20.638-.098%201.2-.294.563-.196.877-.38.942-.555.13-.501.194-1.361.194-2.582m11.891-12.549c0-1.393-.087-2.243-.26-2.548-.108-.174-.41-.354-.908-.54-.498-.184-.865-.277-1.103-.277-.087%200-.13-.185-.13-.556%200-.392.022-.61.065-.653.325.022.843.06%201.557.114.714.055%201.25.088%201.607.098.357.011.87.006%201.54-.016.433%200%201.948-.066%204.543-.196.065.196.098.392.098.588%200%20.414-.044.62-.13.62-.195%200-.584.094-1.168.279-.584.185-.898.354-.94.506a7.69%207.69%200%200%200-.164%201.095%2013.17%2013.17%200%200%200-.064%201.193v12.58c0%201.243.086%202.201.26%202.876.042.153.34.327.892.523.551.196.924.294%201.119.294.086%200%20.13.208.13.621%200%20.261-.022.458-.065.589-.152%200-.8-.045-1.947-.131-1.147-.087-2.001-.131-2.563-.131-.584%200-1.439.038-2.563.115-1.125.076-1.84.124-2.142.147-.087-.088-.13-.262-.13-.524%200-.457.033-.686.098-.686.237%200%20.637-.092%201.2-.277.563-.185.876-.365.941-.54.151-.588.227-1.459.227-2.614V10.708zm14.26-4.378c.432%200%201.946-.066%204.542-.196.065.196.098.392.098.588%200%20.414-.044.62-.13.62-.195%200-.584.094-1.168.279-.584.185-.898.354-.941.506-.152.588-.227%201.46-.227%202.614v12.386c0%201.067.086%201.851.26%202.352.107.349.843.523%202.206.523h.843c1.34%200%202.552-.283%203.634-.85.368-.196.784-.566%201.25-1.11a6.25%206.25%200%200%200%201.086-1.83c.043-.131.195-.197.455-.197.518%200%20.843.066.973.196-1.06%203.007-1.644%204.88-1.752%205.621-1.233%200-3.159-.022-5.776-.065a392.62%20392.62%200%200%200-5.321-.066l-4.737.197c-.087-.088-.13-.273-.13-.556%200-.436.043-.654.13-.654.26%200%20.665-.076%201.217-.229.551-.152.86-.315.924-.49.13-.5.195-1.459.195-2.875V10.61c0-1.329-.087-2.146-.26-2.451-.108-.174-.41-.354-.908-.54-.498-.184-.865-.277-1.103-.277-.087%200-.13-.185-.13-.556%200-.392.021-.61.065-.653%202.985.13%204.553.196%204.705.196m20.067%200c.432%200%201.946-.066%204.542-.196.065.196.098.392.098.588%200%20.414-.044.62-.13.62-.195%200-.584.094-1.168.279-.584.185-.898.354-.941.506-.152.588-.227%201.46-.227%202.614v12.386c0%201.067.086%201.851.26%202.352.107.349.843.523%202.206.523h.843c1.341%200%202.552-.283%203.634-.85.368-.196.784-.566%201.25-1.11a6.25%206.25%200%200%200%201.086-1.83c.043-.131.195-.197.455-.197.519%200%20.843.066.973.196-1.06%203.007-1.644%204.88-1.752%205.621-1.233%200-3.158-.022-5.776-.065a392.62%20392.62%200%200%200-5.32-.066l-4.738.197c-.087-.088-.13-.273-.13-.556%200-.436.043-.654.13-.654.26%200%20.665-.076%201.217-.229.551-.152.86-.315.925-.49.13-.5.194-1.459.194-2.875V10.61c0-1.329-.086-2.146-.26-2.451-.108-.174-.41-.354-.908-.54-.498-.184-.865-.277-1.103-.277-.087%200-.13-.185-.13-.556%200-.392.021-.61.065-.653%202.985.13%204.553.196%204.705.196m20.554%200c.432%200%201.043-.027%201.833-.082.79-.054%201.314-.092%201.574-.114.216.697%201.103%202.75%202.66%206.16%201.558%203.41%202.714%206.061%203.472%207.957h.065c.043%200%20.065-.011.065-.033%201.665-4.161%202.985-7.592%203.958-10.294l1.07-3.66c.39.044%201.266.066%202.63.066.129%200%201.492-.066%204.087-.196.086.13.13.305.13.522%200%20.458-.054.687-.162.687h-.033c-.54%200-.995.13-1.362.392-.325.24-.477.686-.455%201.34.044.871.151%203.126.325%206.764.173%203.638.28%205.959.324%206.96.065%201.33.228%202.332.487%203.007.086.196.373.392.86.588.486.196.827.294%201.022.294.086%200%20.13.218.13.654%200%20.24-.022.425-.065.556-.238-.023-.844-.071-1.817-.148a31.418%2031.418%200%200%200-2.304-.114c-.584%200-1.439.038-2.563.114-1.125.077-1.839.125-2.141.148-.109-.11-.163-.284-.163-.524%200-.457.033-.686.097-.686.238%200%20.606-.098%201.104-.294.497-.196.8-.403.908-.62.173-.328.26-.633.26-.916%200-.5-.022-1.144-.065-1.928l-.26-8.3c-.086-1.46-.173-2.19-.26-2.19-.043%200-.096.077-.162.23l-5.613%2014.084c-.086.218-.26.452-.519.702-.26.25-.52.376-.779.376-.064%200-.162-.022-.291-.065l-7.139-16.144-.551%2012.582c0%20.632.01%201.024.032%201.176.065.283.54.572%201.428.866.887.294%201.47.441%201.752.441.086%200%20.13.218.13.654%200%20.24-.022.425-.065.556-.173%200-.823-.045-1.947-.131-1.125-.087-1.968-.131-2.53-.131-.563%200-1.342.038-2.337.114-.995.077-1.666.125-2.012.148-.086-.088-.13-.273-.13-.556%200-.414.033-.62.098-.62.39%200%201.022-.165%201.898-.491.877-.327%201.335-.72%201.379-1.177.043-.5.086-1.024.13-1.568.065-1.133.14-2.805.227-5.016.086-2.212.163-4.34.227-6.389.065-2.048.108-3.213.13-3.496%200-.24-.033-.436-.097-.588-.065-.174-.412-.332-1.038-.474-.628-.142-1.082-.213-1.363-.213-.087%200-.13-.229-.13-.686%200-.24.043-.403.13-.49.302.022.86.06%201.67.114.812.055%201.498.082%202.06.082m32.69%2012.417c.648.066%201.448.099%202.4.099.866%200%201.633-.022%202.304-.066l.098-.163-2.337-5.85-2.53%205.85c0%20.087.021.13.065.13m5.32%207.941c.476%200%20.963-.103%201.46-.31.498-.207.747-.485.747-.833%200-.044-.27-.773-.811-2.19l-.973-2.385c-.087-.087-.163-.131-.228-.131-.411-.022-1.45-.033-3.115-.033-1.427%200-2.52.011-3.277.033-.086%200-.162.055-.227.163l-1.07%202.484c-.433.98-.65%201.645-.65%201.993%200%20.349.195.621.585.817.39.196.73.31%201.022.343.292.033.546.05.762.05.065.021.098.195.098.522s-.022.556-.065.687c-.282-.023-.85-.071-1.704-.147a24.516%2024.516%200%200%200-2.092-.115c-.541%200-1.19.038-1.947.115-.758.076-1.342.124-1.752.147-.087-.088-.13-.25-.13-.49%200-.459.021-.687.065-.687.26%200%20.692-.115%201.298-.343.605-.229.984-.463%201.135-.703.173-.261.352-.582.535-.964.184-.38.33-.691.439-.931l.162-.392%207.17-16.6c.238-.567.638-.85%201.2-.85.325%200%20.585.142.78.425l6.651%2016.567c.41%201.003.767%201.896%201.07%202.68.13.349.487.616%201.071.8.584.186%201.027.278%201.33.278.087%200%20.13.186.13.556%200%20.37-.021.588-.064.654-.087%200-.752-.044-1.996-.131-1.244-.087-2.147-.131-2.71-.131-.15%200-1.784.087-4.898.262-.087-.088-.13-.311-.13-.67%200-.36.043-.54.13-.54m29.282-16.045c0-1.241-.141-2.026-.422-2.352-.195-.24-.6-.458-1.217-.654-.616-.196-1.054-.294-1.314-.294-.087%200-.14-.18-.162-.54-.022-.358%200-.582.065-.67%201.99.175%203.417.262%204.283.262.54%200%201.281-.037%202.222-.114l1.8-.147c.087.174.13.37.13.588%200%20.414-.053.62-.161.62-1.19%200-2.088.36-2.693%201.08-.304.37-.455%201.165-.455%202.385v12.417c0%20.785.043%202.31.13%204.575-.087.087-.357.13-.811.13-.26%200-.595-.25-1.006-.75l-13.206-16.536V23.16c0%201.198.087%201.972.26%202.32.195.371.65.66%201.363.866.714.207%201.233.31%201.557.31.065%200%20.103.186.114.556.01.37-.006.6-.049.686-.195%200-.833-.043-1.914-.13-1.082-.087-1.904-.131-2.466-.131-.563%200-1.277.038-2.142.115-.865.075-1.492.124-1.881.146-.065-.065-.098-.261-.098-.588%200-.413.033-.62.098-.62.216%200%20.464-.022.746-.066.28-.043.638-.169%201.07-.376.433-.206.747-.474.941-.8.216-.349.325-1.144.325-2.386V10.219c0-1.133-.162-1.907-.487-2.32-.108-.153-.486-.284-1.135-.393-.65-.108-1.125-.163-1.428-.163-.087%200-.14-.18-.162-.54-.022-.358.01-.582.097-.67.346.023%201.033.072%202.06.148%201.028.077%201.823.114%202.385.114.735%200%201.796-.087%203.18-.261.368.74%201.087%201.814%202.158%203.219a209.26%20209.26%200%200%200%204.137%205.212c1.687%202.07%203.027%203.769%204.023%205.098.043-.153.065-.6.065-1.34v-7.68z%22%20mask%3D%22url%28%23b%29%22%2F%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M31.116%2035.01v-6.344l-.075-.152c-2.364-.05-3.835-.076-4.414-.076-3.118.026-4.677.064-4.677.114l.076.076v6.23c0%201.343.1%202.407.301%203.192.05.177.396.38%201.038.607.64.228%201.075.342%201.301.342.1%200%20.157.19.17.57.012.38-.02.66-.095.836-.126%200-.899-.05-2.32-.152-1.42-.101-2.458-.152-3.111-.152-.655%200-1.603.045-2.848.133-1.245.088-2.056.146-2.433.171-.101-.101-.151-.316-.151-.646%200-.506.025-.76.075-.76.302%200%20.78-.1%201.433-.303.655-.203%201.02-.405%201.095-.608.175-.684.264-1.71.264-3.077V20.498c0-1.545-.089-2.532-.264-2.963-.126-.279-.478-.52-1.057-.722-.578-.203-1.018-.304-1.32-.304-.1%200-.15-.253-.15-.76%200-.38.024-.595.075-.646%203.47.152%205.218.228%205.243.228.654%200%202.49-.076%205.507-.228.076.128.114.393.114.798%200%20.406-.051.608-.152.608-.226%200-.666.108-1.32.323-.654.215-1.018.412-1.094.589-.201.531-.301%201.608-.301%203.229v5.395l.075.113c2.464.052%203.973.076%204.526.076.68%200%202.15-.024%204.414-.076.05-.05.075-.1.075-.151v-5.509c0-1.317-.088-2.318-.264-3.002-.075-.202-.421-.417-1.037-.645-.616-.228-1.063-.342-1.339-.342-.101%200-.157-.21-.17-.627-.013-.418.031-.677.132-.779%203.47.152%205.343.228%205.62.228.378%200%202.075-.076%205.093-.228.075.228.113.456.113.684%200%20.482-.063.722-.188.722-.227%200-.667.108-1.32.323-.655.215-1.007.412-1.057.589-.201.76-.302%201.836-.302%203.229v14.209c0%201.367.1%202.444.302%203.229.05.177.396.367%201.037.57.642.203%201.076.304%201.302.304.1%200%20.15.265.15.797%200%20.203-.037.418-.112.646-.227%200-.97-.05-2.226-.152-1.258-.101-2.213-.152-2.867-.152-.679%200-1.704.045-3.074.133-1.371.088-2.22.146-2.546.171-.101-.101-.145-.36-.132-.779.012-.418.069-.627.17-.627.276%200%20.741-.114%201.395-.342.654-.227%201.018-.442%201.094-.645.151-.583.226-1.583.226-3.001%22%20mask%3D%22url%28%23b%29%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var _g$5;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.75
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.588 14.588l6.088 6.088"
  }))));
}

var sharedButtonStyles = css$1(["display:inline-block;background:none;border-radius:2px;font-family:proxima-nova,sans-serif;font-weight:800;font-size:20px;line-height:1;letter-spacing:0.47px;text-transform:uppercase;padding:15px 42px 14px;transition:opacity 0.2s ease-out;cursor:pointer;text-decoration:none;&:hover,&:focus{opacity:0.65;}"]);
var StyledButtonLink = styled(Link).withConfig({
  displayName: "ButtonLink__StyledButtonLink",
  componentId: "sc-3x6su8-0"
})(["", " border:4px solid ", ";color:", ";"], sharedButtonStyles, function (props) {
  return props.secondary ? '#fff' : props.color;
}, function (props) {
  return props.secondary ? '#fff' : props.color;
});
var StyledExternalLink$2 = styled.a.withConfig({
  displayName: "ButtonLink__StyledExternalLink",
  componentId: "sc-3x6su8-1"
})(["", " border:4px solid ", ";color:", ";display:inline-flex;justify-content:center;align-items:center;"], sharedButtonStyles, function (props) {
  return props.secondary ? '#fff' : props.color;
}, function (props) {
  return props.secondary ? '#fff' : props.color;
});

var ButtonLink = function ButtonLink(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? false : _ref$secondary,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      to = _ref.to,
      label = _ref.label;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, external ? /*#__PURE__*/React__default.createElement(StyledExternalLink$2, {
    color: color,
    secondary: secondary,
    href: to,
    target: "_blank",
    rel: "noreferrer"
  }, label) : to.match(/http/g) ? /*#__PURE__*/React__default.createElement(StyledExternalLink$2, {
    color: color,
    secondary: secondary,
    href: to
  }, label) : /*#__PURE__*/React__default.createElement(StyledButtonLink, {
    color: color,
    secondary: secondary,
    to: to
  }, label));
};

ButtonLink.propTypes = {
  secondary: PropTypes.bool,
  to: PropTypes.string,
  label: PropTypes.string,
  external: PropTypes.bool
};

var convertHexToRGB = function convertHexToRGB(h, string) {
  var r = 0,
      g = 0,
      b = 0; // 3 digits

  if (h.length == 4) {
    r = "0x".concat(h[1]).concat(h[1]);
    g = "0x".concat(h[2]).concat(h[2]);
    b = "0x".concat(h[3]).concat(h[3]); // 6 digits
  } else if (h.length == 7) {
    r = "0x".concat(h[1]).concat(h[2]);
    g = "0x".concat(h[3]).concat(h[4]);
    b = "0x".concat(h[5]).concat(h[6]);
  }

  if (string) {
    return "".concat(+r, ", ").concat(+g, ", ").concat(+b);
  } else {
    return [+r, +g, +b];
  }
};

var convertRGBtoHSL = function convertRGBtoHSL(r, g, b) {
  // Make r, g, and b fractions of 1
  r /= 255;
  g /= 255;
  b /= 255; // Find greatest and smallest channel values

  var cmin = Math.min(r, g, b),
      cmax = Math.max(r, g, b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0; // Calculate hue
  // No difference

  if (delta == 0) h = 0; // Red is max
  else if (cmax == r) h = (g - b) / delta % 6; // Green is max
    else if (cmax == g) h = (b - r) / delta + 2; // Blue is max
      else h = (r - g) / delta + 4;
  h = Math.round(h * 60); // Make negative hues positive behind 360°

  if (h < 0) h += 360; // Calculate lightness

  l = (cmax + cmin) / 2; // Calculate saturation

  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1)); // Multiply l and s by 100

  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);
  return [h, s, l];
};

function convertRGBAtoHEX(rgba) {
  var values = rgba.replace(/rgba?\(/, '').replace(/\)/, '').replace(/[\s+]/g, '').split(',');
  var a = parseFloat(values[3] || 1),
      r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
      g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
      b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
  return '#' + ('0' + r.toString(16)).slice(-2) + ('0' + g.toString(16)).slice(-2) + ('0' + b.toString(16)).slice(-2);
} // menu dropdowns, input backgrounds


var getSecondaryColor = function getSecondaryColor(hex) {
  var rgb = convertHexToRGB(hex);
  var hsl = convertRGBtoHSL(rgb[0], rgb[1], rgb[2]);
  return "hsl(".concat(hsl[0], ", ").concat(hsl[1] - 4, "%, ").concat(hsl[2] + 5, "%)");
}; // input borders


var getTertiaryColor = function getTertiaryColor(hex) {
  var rgb = convertHexToRGB(hex);
  var hsl = convertRGBtoHSL(rgb[0], rgb[1], rgb[2]);
  return "hsl(".concat(hsl[0], ", ").concat(hsl[1] - 11, "%, ").concat(hsl[2] + 10, "%)");
}; // menu hover, active borders


var getActiveColor = function getActiveColor(hex) {
  var rgb = convertHexToRGB(hex);
  var hsl = convertRGBtoHSL(rgb[0], rgb[1], rgb[2]);
  return "hsl(".concat(hsl[0], ", ").concat(hsl[1] - 10, "%, ").concat(hsl[2] + 21, "%)");
};

var getLightColor = function getLightColor(hex) {
  var rgb = convertHexToRGB(hex, true);
  return "rgba(".concat(rgb, ", 0.1)");
};

var SlideUp = function SlideUp(element) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 350;
  return new Promise(function (resolve) {
    element.style.height = element.offsetHeight + 'px';
    element.style.transitionProperty = "height, margin, padding";
    element.style.transitionDuration = duration + 'ms';
    element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    window.setTimeout(function () {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
      resolve(false);
    }, duration);
  });
};

var SlideDown = function SlideDown(element) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 350;
  return new Promise(function () {
    element.style.removeProperty('display');
    var display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;
    var height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    element.offsetHeight;
    element.style.transitionProperty = "height, margin, padding";
    element.style.transitionDuration = duration + 'ms';
    element.style.height = height + 'px';
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    window.setTimeout(function () {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
    }, duration);
  });
};

var SlideToggle = function SlideToggle(element) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 350;

  if (window.getComputedStyle(element).display === 'none') {
    return SlideDown(element, duration);
  } else {
    return SlideUp(element, duration);
  }
};

var StyledHeader = styled.header.withConfig({
  displayName: "Header__StyledHeader",
  componentId: "sc-131qfc1-0"
})(["background-color:", ";min-height:80px;display:flex;align-items:center;position:relative;z-index:5;@media (min-width:1024px){min-height:122px;padding:15px 45px;}.logo{background-color:", ";width:100%;height:100%;padding:15px 20px;display:flex;align-items:center;position:absolute;top:0;left:0;z-index:2;@media (min-width:1024px){width:auto;height:auto;display:block;position:static;}}img{display:block;height:44px;filter:brightness(0) invert(1);@media (min-width:1024px){height:58px;}}nav{width:100%;background-color:", ";margin-left:auto;margin-right:6px;transition:opacity 0.35s ease-out,transform 0.35s ease-out;position:absolute;top:0;left:0;transform:translateY(-100%);@media (min-width:1024px){width:auto;position:relative;transform:translateY(0) !important;}&.open{transform:translate(0);}&.hide{opacity:0;}+ a{@media (min-width:1024px){margin-left:18px !important;}}> a{color:", ";background-color:white;border:0;padding-left:16px;padding-right:16px;margin-left:auto;font-size:18px;margin:48px 20px 0;&:last-child{margin-bottom:48px;}@media (min-width:1024px){display:none;}}& > div:last-child{width:100%;height:auto;margin-top:48px;padding:0 20px 48px;@media (min-width:1024px){display:none;}form{pointer-events:auto;}}form{position:relative;input{width:100%;opacity:1;}}}ul{margin:0;padding:100px 0 0;@media (min-width:1024px){display:flex;margin:0;padding:0;}}li{list-style:none;padding:20px 20px 0;position:relative;overflow:hidden;@media (min-width:1024px){padding:0 17px;overflow:visible;}&:hover,&:focus-within{.subnav{left:-17px;}}> button{width:43px;height:43px;display:flex;justify-content:center;align-items:center;border:0;border-radius:0;position:absolute;top:18px;right:20px;background-color:", ";cursor:pointer;transition:opacity 0.2s ease-out;@media (min-width:1024px){display:none;}&:hover,&:focus{opacity:0.65;}svg{transition:transform 0.35s ease-out;}&.open{svg{transform:rotate(-180deg);}}}a{text-decoration:none;font-family:proxima-nova-condensed,sans-serif;font-weight:700;color:white;font-size:28px;line-height:1.08;display:block;position:relative;padding-bottom:11px;padding-right:50px;transition:opacity 0.2s ease-out;border-bottom:2px solid ", ";@media (min-width:1024px){font-size:20px;padding:12px 0;border-bottom:0;}@media (min-width:1200px){font-size:24px;padding:16px 0;}&::after{@media (min-width:1024px){content:'';width:100%;height:5px;position:absolute;bottom:0;left:0;}}&:hover,&:focus{opacity:0.65;@media (min-width:1024px){opacity:1;}&::after{background-color:", ";}~ .subnav{left:-17px;}}}.subnav{width:100%;background-color:", ";padding:24px 20px 2px;border-radius:2px;display:none;@media (min-width:1024px){width:198px;padding:34px 30px 13px;position:absolute;top:100%;left:-99999px;display:block !important;}&.open{display:block;}li{padding:0;margin-bottom:19px;}a{font-size:24px;font-weight:500;padding:0;transition:opacity 0.2s ease-out;border-bottom:0;@media (min-width:1024px){font-size:20px;}@media (min-width:1200px){font-size:24px;}&::after{display:none;}&:hover,&:focus{opacity:0.65;}}}}> div{display:none;@media (min-width:1024px){display:block;}}> a:last-child:not(:first-child){display:none;color:", ";background-color:white;border:0;padding-left:16px;padding-right:16px;margin-left:auto;font-size:18px;@media (min-width:1024px){display:inline-flex;}@media (min-width:1200px){font-size:20px;}}"], function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return getActiveColor(props.color);
}, function (props) {
  return getActiveColor(props.color);
}, function (props) {
  return getActiveColor(props.color);
}, function (props) {
  return getSecondaryColor(props.color);
}, function (props) {
  return props.color;
});
var HeaderSearch = styled.div.withConfig({
  displayName: "Header__HeaderSearch",
  componentId: "sc-131qfc1-1"
})(["height:48px;width:48px;margin-right:20px;position:relative;transition:width 0.35s ease-out;flex:0 0 auto;@media (min-width:1200px){margin-right:30px;}+ a{margin-left:0 !important;}button{width:48px;height:48px;padding:0;background:none;border:0;border-radius:0;display:flex;justify-content:center;align-items:center;position:absolute;top:0;right:0;cursor:pointer;svg{width:22px;}}form{position:absolute;top:0;right:0;pointer-events:none;input{width:48px;height:48px;border:2px solid;border-radius:4px;color:white;font-family:proxima-nova,sans-serif;font-weight:400;font-size:18px;padding:0 14px;opacity:0;transition:opacity 0.2s ease-out,width 0.35s ease-out;&::placeholder{color:white;opacity:0.75;}&:focus{outline:none;}}button{z-index:1;}&.show{pointer-events:auto;input{width:484px;opacity:1;}}}"]);
var MobileToggle = styled.button.withConfig({
  displayName: "Header__MobileToggle",
  componentId: "sc-131qfc1-2"
})(["background:none;border:0;border-radius:0;width:32px;height:24px;margin-left:auto;margin-right:20px;position:relative;z-index:3;transition:opacity 0.2s ease-out;cursor:pointer;@media (min-width:1024px){display:none;}&:hover,&:focus{opacity:0.65;}span{width:100%;height:2px;background-color:white;border-radius:2px;position:absolute;left:0;&:nth-child(1){top:0;transition:transform 0.2s ease-out,top 0.2s 0.2s ease-out;}&:nth-child(2){top:11px;transition:opacity 0s 0.2s ease-out;}&:nth-child(3){top:22px;transition:transform 0.2s ease-out,top 0.2s 0.2s ease-out;}}&.open{span{&:nth-child(1){top:11px;transform:rotate(45deg);transition:top 0.2s ease-out,transform 0.2s 0.2s ease-out;}&:nth-child(2){opacity:0;}&:nth-child(3){top:11px;transform:rotate(-45deg);transition:top 0.2s ease-out,transform 0.2s 0.2s ease-out;}}}"]);

var Header = function Header(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      site = _ref.site;
  var context = useContext(SiteContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      hideSearch = _useState6[0],
      setHideSearch = _useState6[1];

  var inputRef = useRef(null);
  useEffect(function () {
    context.getSite(site);
    context.getMenus(site);
  }, []);
  useEffect(function () {
    var children = Array.from(document.querySelectorAll('.children-toggle'));
    children.forEach(function (toggle) {
      toggle.addEventListener('click', showChildren);
    });
    return function () {
      children.forEach(function (toggle) {
        toggle.removeEventListener('click', showChildren);
      });
    };
  }, [context.menus.primary]);
  useEffect(function () {
    if (!context.site.hideSearch) {
      setHideSearch(false);
    } else {
      setHideSearch(true);
    }
  }, [context.site]);

  var showChildren = function showChildren(e) {
    var target = e.currentTarget;
    target.classList.toggle('open');
    SlideToggle(target.nextSibling);
  };

  return /*#__PURE__*/React__default.createElement(StyledHeader, {
    color: color
  }, site && context.site.logo ? /*#__PURE__*/React__default.createElement("a", {
    className: "logo",
    href: "/"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(context.root).concat(context.site.logo)
  })) : !site ? /*#__PURE__*/React__default.createElement("a", {
    className: "logo",
    href: "/"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: defaultLogo
  })) : null, context.menus.primary && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MobileToggle, {
    className: open ? 'open' : '',
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", null)), /*#__PURE__*/React__default.createElement("nav", {
    className: "".concat(search ? 'hide' : '', " ").concat(open ? 'open' : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: "".concat(context.menus.primary)
    }
  }), context.site.grantPortal && /*#__PURE__*/React__default.createElement(ButtonLink, {
    to: context.site.grantPortal,
    label: "To Apply/Login",
    external: true
  }), !hideSearch && /*#__PURE__*/React__default.createElement(HeaderSearch, null, /*#__PURE__*/React__default.createElement("form", {
    action: "/search",
    className: search ? 'show' : ''
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    name: "query",
    placeholder: "Keyword",
    ref: inputRef,
    onBlur: function onBlur() {
      return setSearch(false);
    },
    style: {
      backgroundColor: getSecondaryColor(color),
      borderColor: getTertiaryColor(color)
    }
  }), /*#__PURE__*/React__default.createElement("button", {
    type: "submit"
  }, /*#__PURE__*/React__default.createElement(SvgIconSearch, null))))), !hideSearch && /*#__PURE__*/React__default.createElement(HeaderSearch, null, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      setSearch(true);
      inputRef.current.focus();
    }
  }, /*#__PURE__*/React__default.createElement(SvgIconSearch, null)), /*#__PURE__*/React__default.createElement("form", {
    action: "/search",
    className: search ? 'show' : ''
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    name: "query",
    placeholder: "Keyword",
    ref: inputRef,
    onBlur: function onBlur() {
      return setSearch(false);
    },
    style: {
      backgroundColor: getSecondaryColor(color),
      borderColor: getTertiaryColor(color)
    }
  }), /*#__PURE__*/React__default.createElement("button", {
    type: "submit"
  }, /*#__PURE__*/React__default.createElement(SvgIconSearch, null))))), context.site.grantPortal && /*#__PURE__*/React__default.createElement(ButtonLink, {
    to: context.site.grantPortal,
    label: "To Apply/Login",
    external: true
  }));
};

Header.propTypes = {
  color: PropTypes.string,
  logo: PropTypes.string
};

var _defs, _g$4;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.4 26.4"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_plus_svg__a9b03ee1-fa12-4a0d-8583-c87ce9482a5b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px}"))), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    id: "icon_plus_svg__f22004db-4299-4d77-a60f-844824a04385",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_plus_svg__a59b63b8-0e05-4f49-bf1f-e700e0d479ea",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon_plus_svg__a9b03ee1-fa12-4a0d-8583-c87ce9482a5b",
    d: "M13.2 2v22.4M2 13.2h22.4"
  })))));
}

var _path;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function SvgIconMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M2.483 14.168h22.4"
  })));
}

var StyledFooter = styled.footer.withConfig({
  displayName: "Footer__StyledFooter",
  componentId: "sc-1atl2i5-0"
})(["background-color:#1d2042;color:white;padding:32px 20px 50px;@media (min-width:768px){padding:46px 65px 60px;}&.child-footer{padding-bottom:36px;}div{@media (min-width:600px){display:flex;flex-wrap:wrap;}}.logo{margin-bottom:32px;@media (min-width:600px){margin-bottom:42px;}&.logo--parent{width:100%;flex:0 0 auto;margin-bottom:42px;}img{display:block;height:44px;filter:brightness(0) invert(1);@media (min-width:1320px){height:58px;}}}p{width:100%;max-width:216px;flex:0 0 auto;font-family:proxima-nova,sans-serif;font-size:12px;margin-bottom:2px;color:#d1d1d1;@media (min-width:600px){max-width:none;}a{color:#d1d1d1;text-decoration:none;transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.65;}}span{display:block;margin-bottom:2px;@media (min-width:768px){display:inline-block;width:8px;margin-bottom:0;}}}"]);
var SiteNav = styled.nav.withConfig({
  displayName: "Footer__SiteNav",
  componentId: "sc-1atl2i5-1"
})(["width:100%;flex:0 0 auto;@media (min-width:600px){min-width:531px;}@media (min-width:1320px){width:48%;}button{width:100%;text-align:left;background:none;border:0;border-radius:0;color:white;padding:12px 0;font-family:proxima-nova-condensed,sans-serif;font-size:24px;font-weight:700;border-top:2px solid ", ";border-bottom:2px solid ", ";margin:36px 0;cursor:pointer;transition:opacity 0.2s ease-out;position:relative;&:hover,&:focus{opacity:0.65;}@media (min-width:600px){display:none;}svg{width:28px;position:absolute;top:50%;transform:translateY(-50%);right:2px;&:last-child{display:none;}}&.open{svg{display:none;&:last-child{display:block;}}}}.collapse-css-transition{@media (min-width:600px){visibility:visible !important;overflow:visible !important;height:auto !important;}}ul{list-style:none;margin:0 0 28px;padding:0;overflow:hidden;@media (min-width:600px){display:grid;grid-template-columns:repeat(2,1fr);grid-gap:4px 80px;border-bottom:0;overflow:visible;margin-bottom:42px;}@media (min-width:1320px){margin:0;padding-left:72px;grid-gap:4px 80px;}}li{padding-right:20px;padding-bottom:4px;&:last-child{@media (max-width:599px){padding-bottom:16px;}}@media (min-width:600px){padding-bottom:0;}@media (min-width:1320px){padding-right:0;}}a{font-family:proxima-nova-condensed,sans-serif;font-size:14px;color:white;text-decoration:none;transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.65;}}+ div{@media (min-width:600px){display:grid;grid-template-columns:repeat(2,1fr);grid-gap:0 80px;min-width:531px;p{grid-column:1 / span 2;}}@media (min-width:1320px){width:37%;flex:0 0 auto;margin-left:auto;}}"], getTertiaryColor('#1d2042'), getTertiaryColor('#1d2042'));
var FooterNav = styled.nav.withConfig({
  displayName: "Footer__FooterNav",
  componentId: "sc-1atl2i5-2"
})(["margin-bottom:32px;@media (min-width:600px){margin-bottom:42px;}@media (min-width:1320px){margin-bottom:100px;}&.child-nav{margin-left:auto;@media (min-width:1320px){margin-bottom:70px;}ul{@media (max-width:599px){margin-top:42px;}}}ul{margin:0;padding:0;list-style:none;ul{display:none;}}li{margin-bottom:14px;&:last-child{margin-bottom:0;}}a{color:white;font-size:20px;text-decoration:none;transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.65;}}"]);
var Address = styled.div.withConfig({
  displayName: "Footer__Address",
  componentId: "sc-1atl2i5-3"
})(["display:block;margin-bottom:10px;@media (min-width:600px){margin-bottom:42px;}@media (min-width:1320px){margin-bottom:100px;}p{font-family:cambria,serif;color:white;font-size:20px;white-space:pre-wrap;}"]);

var Footer = function Footer(_ref) {
  var site = _ref.site;
  var context = useContext(SiteContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openSites = _useState2[0],
      setOpenSites = _useState2[1];

  useEffect(function () {
    if (!site) {
      context.getSites();
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(StyledFooter, {
    className: site ? 'child-footer' : ''
  }, /*#__PURE__*/React__default.createElement("div", null, site && context.site.logo ? /*#__PURE__*/React__default.createElement("a", {
    className: "logo",
    href: "/"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(context.root).concat(context.site.logo)
  })) : !site ? /*#__PURE__*/React__default.createElement("a", {
    className: "logo logo--parent",
    href: "/"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: defaultLogo
  })) : null, !site ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, context.sites.length > 0 && /*#__PURE__*/React__default.createElement(SiteNav, null, /*#__PURE__*/React__default.createElement("button", {
    className: openSites ? 'open' : '',
    type: "button",
    onClick: function onClick() {
      return setOpenSites(!openSites);
    }
  }, "View our Foundations", /*#__PURE__*/React__default.createElement(SvgIconPlus, null), /*#__PURE__*/React__default.createElement(SvgIconMinus, null)), /*#__PURE__*/React__default.createElement(Collapse, {
    className: "collapse-css-transition",
    isOpen: openSites
  }, /*#__PURE__*/React__default.createElement("ul", null, context.sites.sort(function (a, b) {
    return a.title === 'Henry L. Hillman Foundation' ? -1 : b.name === 'Henry L. Hillman Foundation' ? 1 : a.title > b.title ? 1 : -1;
  }).map(function (child, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: index
    }, /*#__PURE__*/React__default.createElement("a", {
      href: child.url,
      target: "_blank"
    }, child.title));
  })))), /*#__PURE__*/React__default.createElement("div", null, context.menus.address && /*#__PURE__*/React__default.createElement(Address, null, /*#__PURE__*/React__default.createElement("p", null, context.menus.address)), context.menus.footer && /*#__PURE__*/React__default.createElement(FooterNav, null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: context.menus.footer
    }
  })), /*#__PURE__*/React__default.createElement("p", null, "Copyright \xA9 ", new Date().getFullYear(), " Hillman Family Foundations. All rights reserved."), /*#__PURE__*/React__default.createElement("p", null, "This site was designed to meet the WCAG 2.1 Web Accessibility Standards."), /*#__PURE__*/React__default.createElement("p", null, "Website design and development by", ' ', /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.walltowall.com",
    target: "_blank",
    rel: "noreferrer"
  }, "Wall-to-Wall Studios")))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, context.menus.footer && /*#__PURE__*/React__default.createElement(FooterNav, {
    className: "child-nav"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: context.menus.footer
    }
  })), /*#__PURE__*/React__default.createElement("p", {
    className: "child-copy"
  }, "Copyright \xA9 ", new Date().getFullYear(), " Hillman Family Foundations. All rights reserved.", /*#__PURE__*/React__default.createElement("span", null), "This site was designed to meet the WCAG 2.1 Web Accessibility Standards.", /*#__PURE__*/React__default.createElement("span", null), "Website design and development by", ' ', /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.walltowall.com",
    target: "_blank",
    rel: "noreferrer"
  }, "Wall-to-Wall Studios")))));
};

var StyledWysiwyg = styled.div.withConfig({
  displayName: "Wysiwyg__StyledWysiwyg",
  componentId: "f5lc7t-0"
})(["padding:50px 20px 42px;@media (min-width:768px){display:flex;padding:50px 6.9% 42px;", "}", " &:last-child{margin-bottom:62px;@media (min-width:768px){padding-bottom:100px;}}> div:first-child{@media (min-width:768px){width:70%;flex:0 0 auto;", " > *{max-width:800px;", "}}a{color:", ";transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.65;}}*:last-child{margin-bottom:0;}}+ div[class*=\"Accordion\"]{padding-top:0;}+ div[class*=\"CallToAction\"]{margin-top:42px;}& img{max-width:100%;}"], function (props) {
  return props.start ? "align-items: flex-start;" : "";
}, function (props) {
  return props.colored ? "\n    background-color: ".concat(props.color, ";\n\n    & * {\n      color: white;\n    }\n  ") : "";
}, function (props) {
  return props.flip ? "order: 1;" : "";
}, function (props) {
  return props.flip ? "padding-left: 60px;" : "padding-right: 60px;";
}, function (props) {
  return props.color;
});
var Quote = styled.div.withConfig({
  displayName: "Wysiwyg__Quote",
  componentId: "f5lc7t-1"
})(["border-left:8px solid ", ";", " @media (min-width:768px){", " flex:1 1 auto;margin-top:0;", "}p{font-size:32px;font-family:cambria,serif;color:", ";padding:24px 0 24px 18px;margin:0;@media (min-width:768px){padding:0 0 4px 24px;font-size:24px;}@media (min-width:1440px){font-size:32px;}}h5{padding:14px 0 0 18px;margin-bottom:0;@media (min-width:768px){padding-left:24px;}}"], function (props) {
  return props.colored ? "white" : props.color ? props.color : "#1D2042";
}, function (props) {
  return props.fullWidth ? "" : "margin-top: 42px;";
}, function (props) {
  return props.fullWidth ? "" : "width: 30%;";
}, function (props) {
  return props.position === "center" ? "align-self: center;" : props.position === "bottom" ? "align-self: flex-end;" : "align-self: flex-start;";
}, function (props) {
  return props.colored ? "white" : props.color ? "#2f2f2f" : "#1D2042";
});

var Wysiwyg = function Wysiwyg(_ref) {
  var copy = _ref.copy,
      color = _ref.color,
      quote = _ref.quote,
      quoteAuthor = _ref.quoteAuthor,
      quoteAuthorLine2 = _ref.quoteAuthorLine2,
      quotePosition = _ref.quotePosition;
  return copy ? /*#__PURE__*/React__default.createElement(StyledWysiwyg, {
    color: color
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  }), quote && /*#__PURE__*/React__default.createElement(Quote, {
    position: quotePosition,
    color: color
  }, quoteAuthor ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", null, quote), /*#__PURE__*/React__default.createElement("h5", null, quoteAuthor, quoteAuthorLine2 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("br", null), quoteAuthorLine2))) : /*#__PURE__*/React__default.createElement("p", null, quote))) : null;
};

Wysiwyg.propTypes = {
  copy: PropTypes.string.isRequired,
  quote: PropTypes.string,
  quoteAuthor: PropTypes.string,
  quoteAuthorLine2: PropTypes.string,
  quotePosition: PropTypes.string
};

var StyledAccordions = styled.div.withConfig({
  displayName: "Accordions__StyledAccordions",
  componentId: "sc-1y9hap6-0"
})(["padding:50px 20px 42px;@media (min-width:768px){display:flex;padding:50px 6.9% 42px;}> div:first-child{@media (min-width:768px){width:70%;flex:0 0 auto;> *{max-width:800px;padding-right:115px;}}}"]);
var AccordionControls = styled.div.withConfig({
  displayName: "Accordions__AccordionControls",
  componentId: "sc-1y9hap6-1"
})(["text-align:right;padding-bottom:16px;button{border:0;background:none;padding:0;border-radius:0;text-decoration:underline;cursor:pointer;transition:opacity 0.2s ease-out;font-family:proxima-nova-condensed,sans-serif;font-weight:500;font-size:18px;margin-left:18px;&:hover,&:focus{opacity:0.65;}&.disabled{opacity:0.25;cursor:default;text-decoration:none;}}"]);
var Accordion = styled.div.withConfig({
  displayName: "Accordions__Accordion",
  componentId: "sc-1y9hap6-2"
})(["&:last-child{position:relative;&::after{content:'';background-color:#eeeeef;width:100%;height:2px;position:absolute;bottom:0;left:0;@media (min-width:768px){width:calc(100% - 115px);}}}button{width:100%;background:none;border:0;border-radius:0;text-align:left;font-family:proxima-nova-condensed,sans-serif;font-size:20px;font-weight:700;color:#1d2042;padding:20px 50px 20px 0;border-top:2px solid #eeeeef;position:relative;transition:opacity 0.2s ease-out;cursor:pointer;line-height:1.3;@media (min-width:768px){font-size:24px;}&:hover,&:focus{opacity:0.65;}svg{width:20px;height:20px;padding:0 !important;position:absolute;top:50%;right:12px;transform:translateY(-50%);&:last-child{display:none;}*{stroke:#1d2042;}}&.open{svg{display:none;&:last-child{display:block;}}}}div{padding-right:50px;a{color:", ";transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.65;}}}"], function (props) {
  return props.color;
});

var Accordions = function Accordions(_ref) {
  var accordions = _ref.accordions,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      quote = _ref.quote,
      quoteAuthor = _ref.quoteAuthor,
      quoteAuthorLine2 = _ref.quoteAuthorLine2,
      quotePosition = _ref.quotePosition;

  var _useState = useState(accordions),
      _useState2 = _slicedToArray(_useState, 2),
      content = _useState2[0],
      setContent = _useState2[1];

  var toggleAccordion = function toggleAccordion(index) {
    var updatedContent = _toConsumableArray(content);

    updatedContent[index].open = !updatedContent[index].open;
    setContent(updatedContent);
  };

  var expandAll = function expandAll() {
    var updatedContent = _toConsumableArray(content);

    updatedContent.forEach(function (accordion) {
      accordion.open = true;
    });
    setContent(updatedContent);
  };

  var collapseAll = function collapseAll() {
    var updatedContent = _toConsumableArray(content);

    updatedContent.forEach(function (accordion) {
      accordion.open = false;
    });
    setContent(updatedContent);
  };

  var disableExpand = function disableExpand() {
    var disabled = true;
    content.forEach(function (accordion) {
      if (!accordion.open) {
        disabled = false;
      }
    });
    return disabled;
  };

  var disableCollapse = function disableCollapse() {
    var disabled = true;
    content.forEach(function (accordion) {
      if (accordion.open) {
        disabled = false;
      }
    });
    return disabled;
  };

  return /*#__PURE__*/React__default.createElement(StyledAccordions, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(AccordionControls, null, /*#__PURE__*/React__default.createElement("button", {
    className: disableExpand() ? 'disabled' : '',
    onClick: expandAll
  }, "Expand All"), /*#__PURE__*/React__default.createElement("button", {
    className: disableCollapse() ? 'disabled' : '',
    onClick: collapseAll
  }, "Collapse All")), content.map(function (accordion, index) {
    return /*#__PURE__*/React__default.createElement(Accordion, {
      key: index,
      color: color
    }, /*#__PURE__*/React__default.createElement("button", {
      className: accordion.open ? 'open' : '',
      onClick: function onClick() {
        return toggleAccordion(index);
      }
    }, accordion.title, /*#__PURE__*/React__default.createElement(SvgIconPlus, null), /*#__PURE__*/React__default.createElement(SvgIconMinus, null)), /*#__PURE__*/React__default.createElement(Collapse, {
      className: "collapse-css-transition",
      isOpen: accordion.open
    }, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: accordion.content
      }
    })));
  })), quote && /*#__PURE__*/React__default.createElement(Quote, {
    position: quotePosition,
    color: color
  }, quoteAuthor ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", null, quote), /*#__PURE__*/React__default.createElement("h5", null, quoteAuthor, quoteAuthorLine2 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("br", null), quoteAuthorLine2))) : /*#__PURE__*/React__default.createElement("p", null, quote)));
};

var StyledAnchor = styled.div.withConfig({
  displayName: "Anchor__StyledAnchor",
  componentId: "sc-9gbos3-0"
})(["display:block;height:78px;margin:-78px 0 0;pointer-events:none;"]);

var Anchor = function Anchor(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/React__default.createElement(StyledAnchor, {
    className: "anchor",
    id: name
  });
};

var StyledCallToAction = styled.div.withConfig({
  displayName: "CallToAction__StyledCallToAction",
  componentId: "sc-1j0ly7d-0"
})(["background-color:", ";text-align:center;padding:40px 20px 48px;@media (min-width:768px){padding:67px 6.9% 72px;}*{color:white;max-width:686px;margin-left:auto;margin-right:auto;}h2{@media (min-width:768px){margin-bottom:26px;}}a{border-color:white;padding-left:16px;padding-right:16px;@media (min-width:768px){margin-top:13px;}}"], function (props) {
  return props.color;
});

var CallToAction = function CallToAction(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      heading = _ref.heading,
      copy = _ref.copy,
      link = _ref.link,
      linkText = _ref.linkText;
  return /*#__PURE__*/React__default.createElement(StyledCallToAction, {
    color: color
  }, heading && /*#__PURE__*/React__default.createElement("h2", null, heading), copy && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  }), (link || {}).url && /*#__PURE__*/React__default.createElement(ButtonLink, {
    label: linkText || 'Learn More',
    to: link.url,
    external: link.new_tab ? true : false
  }));
};

var StyledPhotoCredit = styled.p.withConfig({
  displayName: "PhotoCredit__StyledPhotoCredit",
  componentId: "sc-4cq7ek-0"
})(["position:absolute;bottom:0;right:0;z-index:2;margin:0;color:white;background:rgba(0,0,0,0.4);font-family:proxima-nova,sans-serif;font-size:12px;padding:4px 12px;"]);

var PhotoCredit = function PhotoCredit(_ref) {
  var children = _ref.children,
      className = _ref.className,
      reference = _ref.reference;
  return /*#__PURE__*/React__default.createElement(StyledPhotoCredit, {
    ref: reference,
    className: className
  }, children);
};

PhotoCredit.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};

var StyledChildHero = styled.div.withConfig({
  displayName: "ChildHero__StyledChildHero",
  componentId: "sc-1rmcog3-0"
})(["background-color:#1d2042;position:relative;@media (min-width:768px){min-height:72vh;}"]);
var ChildHeroCopy = styled.div.withConfig({
  displayName: "ChildHero__ChildHeroCopy",
  componentId: "sc-1rmcog3-1"
})(["padding:26px 20px 50px;position:relative;z-index:1;background-color:", ";@media (min-width:768px){min-height:72vh;width:50%;padding:49px 6.9vw 90px;background-color:", ";display:flex;flex-direction:column;justify-content:center;}h1,h2,h3,h4,h5,h6,p,li{color:white;}h1{font-size:52px;line-height:0.95;@media (min-width:768px){font-size:48px;margin-left:-4px;}@media (min-width:1024px){font-size:70px;}}h5{display:none;@media (min-width:768px){display:block;color:white;}}> div *:last-child{margin-bottom:0;}"], function (props) {
  return props.color;
}, function (props) {
  return "rgba(".concat(convertHexToRGB(props.color, true), ", 0.8)");
});
var ChildHeroImage = styled.div.withConfig({
  displayName: "ChildHero__ChildHeroImage",
  componentId: "sc-1rmcog3-2"
})(["position:relative;@media (min-width:768px){width:100%;height:100%;position:absolute;top:0;left:0;}&::before{content:\"\";display:block;padding-top:100%;@media (min-width:768px){display:none;}}img{width:100%;height:100%;position:absolute;top:0;left:0;object-fit:cover;}&.top-left img{object-position:top left;}&.top-center img{object-position:top;}&.top-right img{object-position:top right;}&.center-left img{object-position:center left;}&.center img{object-position:center;}&.center-right img{object-position:center right;}&.bottom-left img{object-position:bottom left;}&.bottom-center img{object-position:bottom;}&.bottom-right img{object-position:bottom right;}"]);

var ChildHero = function ChildHero(_ref) {
  var color = _ref.color,
      heading = _ref.heading,
      copy = _ref.copy,
      image = _ref.image,
      alt = _ref.alt,
      credit = _ref.credit,
      focus = _ref.focus,
      cities = _ref.cities,
      hideLocation = _ref.hideLocation,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? "" : _ref$root;
  return /*#__PURE__*/React__default.createElement(StyledChildHero, null, /*#__PURE__*/React__default.createElement(ChildHeroImage, {
    className: focus
  }, image && /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(root).concat(image),
    alt: alt
  }), credit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, credit)), /*#__PURE__*/React__default.createElement(ChildHeroCopy, {
    color: color
  }, (cities || []).length > 0 && !hideLocation && /*#__PURE__*/React__default.createElement("h5", null, cities.join(", ")), heading && /*#__PURE__*/React__default.createElement("h1", null, heading), copy && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  })));
};

ChildHero.propTypes = {
  color: PropTypes.string,
  heading: PropTypes.string,
  copy: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string,
  credit: PropTypes.string,
  focus: PropTypes.string
};

var _g$3;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function SvgIconDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 12
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11L21.107.393M.5.393L11.107 11"
  }))));
}

var dropdown = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2222%22%20height%3D%2212%22%20viewBox%3D%220%200%2022%2012%22%3E%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke%3D%22%23FFF%22%20transform%3D%22matrix%281%200%200%20-1%20.5%2011%29%22%3E%20%20%20%20%3Cline%20x1%3D%2210%22%20x2%3D%2220.607%22%20y2%3D%2210.607%22%2F%3E%20%20%20%20%3Cline%20x2%3D%2210.607%22%20y1%3D%2210.607%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var HOOKS = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"];
var defaults$1 = {
  _disable: [],
  allowInput: false,
  allowInvalidPreload: false,
  altFormat: "F j, Y",
  altInput: false,
  altInputClass: "form-control input",
  animate: (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: true,
  clickOpens: true,
  closeOnSelect: true,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: false,
  enableSeconds: false,
  enableTime: false,
  errorHandler: function errorHandler(err) {
    return typeof console !== "undefined" && console.warn(err);
  },
  getWeek: function getWeek(givenDate) {
    var date = new Date(givenDate.getTime());
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    var week1 = new Date(date.getFullYear(), 0, 4);
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: false,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: false,
  now: new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: undefined,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: false,
  showMonths: 1,
  "static": false,
  time_24hr: false,
  weekNumbers: false,
  wrap: false
};

var english = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  },
  months: {
    shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function ordinal(nth) {
    var s = nth % 100;
    if (s > 3 && s < 21) return "th";

    switch (s % 10) {
      case 1:
        return "st";

      case 2:
        return "nd";

      case 3:
        return "rd";

      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: false
};

var pad = function pad(number) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return "000".concat(number).slice(length * -1);
};

var _int$1 = function _int(bool) {
  return bool === true ? 1 : 0;
};
function debounce(fn, wait) {
  var t;
  return function () {
    var _arguments = arguments,
        _this = this;

    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this, _arguments);
    }, wait);
  };
}
var arrayify = function arrayify(obj) {
  return obj instanceof Array ? obj : [obj];
};

function toggleClass$1(elem, className, bool) {
  if (bool === true) return elem.classList.add(className);
  elem.classList.remove(className);
}
function createElement(tag, className, content) {
  var e = window.document.createElement(tag);
  className = className || "";
  content = content || "";
  e.className = className;
  if (content !== undefined) e.textContent = content;
  return e;
}
function clearNode(node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
}
function findParent(node, condition) {
  if (condition(node)) return node;else if (node.parentNode) return findParent(node.parentNode, condition);
  return undefined;
}
function createNumberInput(inputClassName, opts) {
  var wrapper = createElement("div", "numInputWrapper"),
      numInput = createElement("input", "numInput " + inputClassName),
      arrowUp = createElement("span", "arrowUp"),
      arrowDown = createElement("span", "arrowDown");

  if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
    numInput.type = "number";
  } else {
    numInput.type = "text";
    numInput.pattern = "\\d*";
  }

  if (opts !== undefined) for (var key in opts) {
    numInput.setAttribute(key, opts[key]);
  }
  wrapper.appendChild(numInput);
  wrapper.appendChild(arrowUp);
  wrapper.appendChild(arrowDown);
  return wrapper;
}
function getEventTarget(event) {
  try {
    if (typeof event.composedPath === "function") {
      var path = event.composedPath();
      return path[0];
    }

    return event.target;
  } catch (error) {
    return event.target;
  }
}

var doNothing = function doNothing() {
  return undefined;
};

var monthToStr = function monthToStr(monthNumber, shorthand, locale) {
  return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var revFormat = {
  D: doNothing,
  F: function F(dateObj, monthName, locale) {
    dateObj.setMonth(locale.months.longhand.indexOf(monthName));
  },
  G: function G(dateObj, hour) {
    dateObj.setHours(parseFloat(hour));
  },
  H: function H(dateObj, hour) {
    dateObj.setHours(parseFloat(hour));
  },
  J: function J(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  K: function K(dateObj, amPM, locale) {
    dateObj.setHours(dateObj.getHours() % 12 + 12 * _int$1(new RegExp(locale.amPM[1], "i").test(amPM)));
  },
  M: function M(dateObj, shortMonth, locale) {
    dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
  },
  S: function S(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  U: function U(_, unixSeconds) {
    return new Date(parseFloat(unixSeconds) * 1000);
  },
  W: function W(dateObj, weekNum, locale) {
    var weekNumber = parseInt(weekNum);
    var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
    date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
    return date;
  },
  Y: function Y(dateObj, year) {
    dateObj.setFullYear(parseFloat(year));
  },
  Z: function Z(_, ISODate) {
    return new Date(ISODate);
  },
  d: function d(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  h: function h(dateObj, hour) {
    dateObj.setHours(parseFloat(hour));
  },
  i: function i(dateObj, minutes) {
    dateObj.setMinutes(parseFloat(minutes));
  },
  j: function j(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  l: doNothing,
  m: function m(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  n: function n(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  s: function s(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  u: function u(_, unixMillSeconds) {
    return new Date(parseFloat(unixMillSeconds));
  },
  w: doNothing,
  y: function y(dateObj, year) {
    dateObj.setFullYear(2000 + parseFloat(year));
  }
};
var tokenRegex = {
  D: "(\\w+)",
  F: "(\\w+)",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "(\\w+)",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "(\\w+)",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
};
var formats = {
  Z: function Z(date) {
    return date.toISOString();
  },
  D: function D(date, locale, options) {
    return locale.weekdays.shorthand[formats.w(date, locale, options)];
  },
  F: function F(date, locale, options) {
    return monthToStr(formats.n(date, locale, options) - 1, false, locale);
  },
  G: function G(date, locale, options) {
    return pad(formats.h(date, locale, options));
  },
  H: function H(date) {
    return pad(date.getHours());
  },
  J: function J(date, locale) {
    return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
  },
  K: function K(date, locale) {
    return locale.amPM[_int$1(date.getHours() > 11)];
  },
  M: function M(date, locale) {
    return monthToStr(date.getMonth(), true, locale);
  },
  S: function S(date) {
    return pad(date.getSeconds());
  },
  U: function U(date) {
    return date.getTime() / 1000;
  },
  W: function W(date, _, options) {
    return options.getWeek(date);
  },
  Y: function Y(date) {
    return pad(date.getFullYear(), 4);
  },
  d: function d(date) {
    return pad(date.getDate());
  },
  h: function h(date) {
    return date.getHours() % 12 ? date.getHours() % 12 : 12;
  },
  i: function i(date) {
    return pad(date.getMinutes());
  },
  j: function j(date) {
    return date.getDate();
  },
  l: function l(date, locale) {
    return locale.weekdays.longhand[date.getDay()];
  },
  m: function m(date) {
    return pad(date.getMonth() + 1);
  },
  n: function n(date) {
    return date.getMonth() + 1;
  },
  s: function s(date) {
    return date.getSeconds();
  },
  u: function u(date) {
    return date.getTime();
  },
  w: function w(date) {
    return date.getDay();
  },
  y: function y(date) {
    return String(date.getFullYear()).substring(2);
  }
};

var createDateFormatter = function createDateFormatter(_ref) {
  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? defaults$1 : _ref$config,
      _ref$l10n = _ref.l10n,
      l10n = _ref$l10n === void 0 ? english : _ref$l10n,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  return function (dateObj, frmt, overrideLocale) {
    var locale = overrideLocale || l10n;

    if (config.formatDate !== undefined && !isMobile) {
      return config.formatDate(dateObj, frmt, locale);
    }

    return frmt.split("").map(function (c, i, arr) {
      return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
    }).join("");
  };
};
var createDateParser = function createDateParser(_ref2) {
  var _ref2$config = _ref2.config,
      config = _ref2$config === void 0 ? defaults$1 : _ref2$config,
      _ref2$l10n = _ref2.l10n,
      l10n = _ref2$l10n === void 0 ? english : _ref2$l10n;
  return function (date, givenFormat, timeless, customLocale) {
    if (date !== 0 && !date) return undefined;
    var locale = customLocale || l10n;
    var parsedDate;
    var dateOrig = date;
    if (date instanceof Date) parsedDate = new Date(date.getTime());else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);else if (typeof date === "string") {
      var format = givenFormat || (config || defaults$1).dateFormat;
      var datestr = String(date).trim();

      if (datestr === "today") {
        parsedDate = new Date();
        timeless = true;
      } else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);else if (config && config.parseDate) parsedDate = config.parseDate(date, format);else {
        parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
        var matched,
            ops = [];

        for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
          var token = format[i];
          var isBackSlash = token === "\\";
          var escaped = format[i - 1] === "\\" || isBackSlash;

          if (tokenRegex[token] && !escaped) {
            regexStr += tokenRegex[token];
            var match = new RegExp(regexStr).exec(date);

            if (match && (matched = true)) {
              ops[token !== "Y" ? "push" : "unshift"]({
                fn: revFormat[token],
                val: match[++matchIndex]
              });
            }
          } else if (!isBackSlash) regexStr += ".";

          ops.forEach(function (_ref3) {
            var fn = _ref3.fn,
                val = _ref3.val;
            return parsedDate = fn(parsedDate, val, locale) || parsedDate;
          });
        }

        parsedDate = matched ? parsedDate : undefined;
      }
    }

    if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
      config.errorHandler(new Error("Invalid date provided: ".concat(dateOrig)));
      return undefined;
    }

    if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
    return parsedDate;
  };
};
function compareDates(date1, date2) {
  var timeless = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (timeless !== false) {
    return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
  }

  return date1.getTime() - date2.getTime();
}
var isBetween = function isBetween(ts, ts1, ts2) {
  return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var duration = {
  DAY: 86400000
};
function getDefaultHours(config) {
  var hours = config.defaultHour;
  var minutes = config.defaultMinute;
  var seconds = config.defaultSeconds;

  if (config.minDate !== undefined) {
    var minHour = config.minDate.getHours();
    var minMinutes = config.minDate.getMinutes();
    var minSeconds = config.minDate.getSeconds();

    if (hours < minHour) {
      hours = minHour;
    }

    if (hours === minHour && minutes < minMinutes) {
      minutes = minMinutes;
    }

    if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
  }

  if (config.maxDate !== undefined) {
    var maxHr = config.maxDate.getHours();
    var maxMinutes = config.maxDate.getMinutes();
    hours = Math.min(hours, maxHr);
    if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
    if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
  }

  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
}

if (typeof Object.assign !== "function") {
  Object.assign = function (target) {
    if (!target) {
      throw TypeError("Cannot convert undefined or null to object");
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var _loop = function _loop() {
      var source = _args[_i];

      if (source) {
        Object.keys(source).forEach(function (key) {
          return target[key] = source[key];
        });
      }
    };

    for (var _i = 0, _args = args; _i < _args.length; _i++) {
      _loop();
    }

    return target;
  };
}

var DEBOUNCED_CHANGE_MS = 300;

function FlatpickrInstance(element, instanceConfig) {
  var self = {
    config: Object.assign(Object.assign({}, defaults$1), flatpickr.defaultConfig),
    l10n: english
  };
  self.parseDate = createDateParser({
    config: self.config,
    l10n: self.l10n
  });
  self._handlers = [];
  self.pluginElements = [];
  self.loadedPlugins = [];
  self._bind = bind;
  self._setHoursFromDate = setHoursFromDate;
  self._positionCalendar = positionCalendar;
  self.changeMonth = changeMonth;
  self.changeYear = changeYear;
  self.clear = clear;
  self.close = close;
  self._createElement = createElement;
  self.destroy = destroy;
  self.isEnabled = isEnabled;
  self.jumpToDate = jumpToDate;
  self.open = open;
  self.redraw = redraw;
  self.set = set;
  self.setDate = setDate;
  self.toggle = toggle;

  function setupHelperFunctions() {
    self.utils = {
      getDaysInMonth: function getDaysInMonth() {
        var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.currentMonth;
        var yr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.currentYear;
        if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
        return self.l10n.daysInMonth[month];
      }
    };
  }

  function init() {
    self.element = self.input = element;
    self.isOpen = false;
    parseConfig();
    setupLocale();
    setupInputs();
    setupDates();
    setupHelperFunctions();
    if (!self.isMobile) build();
    bindEvents();

    if (self.selectedDates.length || self.config.noCalendar) {
      if (self.config.enableTime) {
        setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
      }

      updateValue(false);
    }

    setCalendarWidth();
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!self.isMobile && isSafari) {
      positionCalendar();
    }

    triggerEvent("onReady");
  }

  function bindToInstance(fn) {
    return fn.bind(self);
  }

  function setCalendarWidth() {
    var config = self.config;

    if (config.weekNumbers === false && config.showMonths === 1) {
      return;
    } else if (config.noCalendar !== true) {
      window.requestAnimationFrame(function () {
        if (self.calendarContainer !== undefined) {
          self.calendarContainer.style.visibility = "hidden";
          self.calendarContainer.style.display = "block";
        }

        if (self.daysContainer !== undefined) {
          var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
          self.daysContainer.style.width = daysWidth + "px";
          self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
          self.calendarContainer.style.removeProperty("visibility");
          self.calendarContainer.style.removeProperty("display");
        }
      });
    }
  }

  function updateTime(e) {
    if (self.selectedDates.length === 0) {
      var defaultDate = self.config.minDate === undefined || compareDates(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
      var defaults = getDefaultHours(self.config);
      defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
      self.selectedDates = [defaultDate];
      self.latestSelectedDateObj = defaultDate;
    }

    if (e !== undefined && e.type !== "blur") {
      timeWrapper(e);
    }

    var prevValue = self._input.value;
    setHoursFromInputs();
    updateValue();

    if (self._input.value !== prevValue) {
      self._debouncedChange();
    }
  }

  function ampm2military(hour, amPM) {
    return hour % 12 + 12 * _int$1(amPM === self.l10n.amPM[1]);
  }

  function military2ampm(hour) {
    switch (hour % 24) {
      case 0:
      case 12:
        return 12;

      default:
        return hour % 12;
    }
  }

  function setHoursFromInputs() {
    if (self.hourElement === undefined || self.minuteElement === undefined) return;
    var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24,
        minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60,
        seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;

    if (self.amPM !== undefined) {
      hours = ampm2military(hours, self.amPM.textContent);
    }

    var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.minDate, true) === 0;
    var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.maxDate, true) === 0;

    if (limitMaxHours) {
      var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
      hours = Math.min(hours, maxTime.getHours());
      if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
      if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
    }

    if (limitMinHours) {
      var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
      hours = Math.max(hours, minTime.getHours());
      if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
      if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
    }

    setHours(hours, minutes, seconds);
  }

  function setHoursFromDate(dateObj) {
    var date = dateObj || self.latestSelectedDateObj;

    if (date) {
      setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
  }

  function setHours(hours, minutes, seconds) {
    if (self.latestSelectedDateObj !== undefined) {
      self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
    }

    if (!self.hourElement || !self.minuteElement || self.isMobile) return;
    self.hourElement.value = pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * _int$1(hours % 12 === 0) : hours);
    self.minuteElement.value = pad(minutes);
    if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[_int$1(hours >= 12)];
    if (self.secondElement !== undefined) self.secondElement.value = pad(seconds);
  }

  function onYearInput(event) {
    var eventTarget = getEventTarget(event);
    var year = parseInt(eventTarget.value) + (event.delta || 0);

    if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) {
      changeYear(year);
    }
  }

  function bind(element, event, handler, options) {
    if (event instanceof Array) return event.forEach(function (ev) {
      return bind(element, ev, handler, options);
    });
    if (element instanceof Array) return element.forEach(function (el) {
      return bind(el, event, handler, options);
    });
    element.addEventListener(event, handler, options);

    self._handlers.push({
      remove: function remove() {
        return element.removeEventListener(event, handler);
      }
    });
  }

  function triggerChange() {
    triggerEvent("onChange");
  }

  function bindEvents() {
    if (self.config.wrap) {
      ["open", "close", "toggle", "clear"].forEach(function (evt) {
        Array.prototype.forEach.call(self.element.querySelectorAll("[data-".concat(evt, "]")), function (el) {
          return bind(el, "click", self[evt]);
        });
      });
    }

    if (self.isMobile) {
      setupMobile();
      return;
    }

    var debouncedResize = debounce(onResize, 50);
    self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
    if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function (e) {
      if (self.config.mode === "range") onMouseOver(getEventTarget(e));
    });
    bind(window.document.body, "keydown", onKeyDown);
    if (!self.config.inline && !self.config["static"]) bind(window, "resize", debouncedResize);
    if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);else bind(window.document, "mousedown", documentClick);
    bind(window.document, "focus", documentClick, {
      capture: true
    });

    if (self.config.clickOpens === true) {
      bind(self._input, "focus", self.open);
      bind(self._input, "click", self.open);
    }

    if (self.daysContainer !== undefined) {
      bind(self.monthNav, "click", onMonthNavClick);
      bind(self.monthNav, ["keyup", "increment"], onYearInput);
      bind(self.daysContainer, "click", selectDate);
    }

    if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
      var selText = function selText(e) {
        return getEventTarget(e).select();
      };

      bind(self.timeContainer, ["increment"], updateTime);
      bind(self.timeContainer, "blur", updateTime, {
        capture: true
      });
      bind(self.timeContainer, "click", timeIncrement);
      bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
      if (self.secondElement !== undefined) bind(self.secondElement, "focus", function () {
        return self.secondElement && self.secondElement.select();
      });

      if (self.amPM !== undefined) {
        bind(self.amPM, "click", function (e) {
          updateTime(e);
          triggerChange();
        });
      }
    }

    if (self.config.allowInput) {
      bind(self._input, "blur", onBlur);
    }
  }

  function jumpToDate(jumpDate, triggerChange) {
    var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
    var oldYear = self.currentYear;
    var oldMonth = self.currentMonth;

    try {
      if (jumpTo !== undefined) {
        self.currentYear = jumpTo.getFullYear();
        self.currentMonth = jumpTo.getMonth();
      }
    } catch (e) {
      e.message = "Invalid date supplied: " + jumpTo;
      self.config.errorHandler(e);
    }

    if (triggerChange && self.currentYear !== oldYear) {
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }

    if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
      triggerEvent("onMonthChange");
    }

    self.redraw();
  }

  function timeIncrement(e) {
    var eventTarget = getEventTarget(e);
    if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
  }

  function incrementNumInput(e, delta, inputElem) {
    var target = e && getEventTarget(e);
    var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
    var event = createEvent("increment");
    event.delta = delta;
    input && input.dispatchEvent(event);
  }

  function build() {
    var fragment = window.document.createDocumentFragment();
    self.calendarContainer = createElement("div", "flatpickr-calendar");
    self.calendarContainer.tabIndex = -1;

    if (!self.config.noCalendar) {
      fragment.appendChild(buildMonthNav());
      self.innerContainer = createElement("div", "flatpickr-innerContainer");

      if (self.config.weekNumbers) {
        var _buildWeeks = buildWeeks(),
            weekWrapper = _buildWeeks.weekWrapper,
            weekNumbers = _buildWeeks.weekNumbers;

        self.innerContainer.appendChild(weekWrapper);
        self.weekNumbers = weekNumbers;
        self.weekWrapper = weekWrapper;
      }

      self.rContainer = createElement("div", "flatpickr-rContainer");
      self.rContainer.appendChild(buildWeekdays());

      if (!self.daysContainer) {
        self.daysContainer = createElement("div", "flatpickr-days");
        self.daysContainer.tabIndex = -1;
      }

      buildDays();
      self.rContainer.appendChild(self.daysContainer);
      self.innerContainer.appendChild(self.rContainer);
      fragment.appendChild(self.innerContainer);
    }

    if (self.config.enableTime) {
      fragment.appendChild(buildTime());
    }

    toggleClass$1(self.calendarContainer, "rangeMode", self.config.mode === "range");
    toggleClass$1(self.calendarContainer, "animate", self.config.animate === true);
    toggleClass$1(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
    self.calendarContainer.appendChild(fragment);
    var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;

    if (self.config.inline || self.config["static"]) {
      self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");

      if (self.config.inline) {
        if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
      }

      if (self.config["static"]) {
        var wrapper = createElement("div", "flatpickr-wrapper");
        if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
        wrapper.appendChild(self.element);
        if (self.altInput) wrapper.appendChild(self.altInput);
        wrapper.appendChild(self.calendarContainer);
      }
    }

    if (!self.config["static"] && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
  }

  function createDay(className, date, dayNumber, i) {
    var dateIsEnabled = isEnabled(date, true),
        dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
    dayElement.dateObj = date;
    dayElement.$i = i;
    dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));

    if (className.indexOf("hidden") === -1 && compareDates(date, self.now) === 0) {
      self.todayDateElem = dayElement;
      dayElement.classList.add("today");
      dayElement.setAttribute("aria-current", "date");
    }

    if (dateIsEnabled) {
      dayElement.tabIndex = -1;

      if (isDateSelected(date)) {
        dayElement.classList.add("selected");
        self.selectedDateElem = dayElement;

        if (self.config.mode === "range") {
          toggleClass$1(dayElement, "startRange", self.selectedDates[0] && compareDates(date, self.selectedDates[0], true) === 0);
          toggleClass$1(dayElement, "endRange", self.selectedDates[1] && compareDates(date, self.selectedDates[1], true) === 0);
          if (className === "nextMonthDay") dayElement.classList.add("inRange");
        }
      }
    } else {
      dayElement.classList.add("flatpickr-disabled");
    }

    if (self.config.mode === "range") {
      if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
    }

    if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && dayNumber % 7 === 1) {
      self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
    }

    triggerEvent("onDayCreate", dayElement);
    return dayElement;
  }

  function focusOnDayElem(targetNode) {
    targetNode.focus();
    if (self.config.mode === "range") onMouseOver(targetNode);
  }

  function getFirstAvailableDay(delta) {
    var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
    var endMonth = delta > 0 ? self.config.showMonths : -1;

    for (var m = startMonth; m != endMonth; m += delta) {
      var month = self.daysContainer.children[m];
      var startIndex = delta > 0 ? 0 : month.children.length - 1;
      var endIndex = delta > 0 ? month.children.length : -1;

      for (var i = startIndex; i != endIndex; i += delta) {
        var c = month.children[i];
        if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
      }
    }

    return undefined;
  }

  function getNextAvailableDay(current, delta) {
    var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
    var endMonth = delta > 0 ? self.config.showMonths : -1;
    var loopDelta = delta > 0 ? 1 : -1;

    for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
      var month = self.daysContainer.children[m];
      var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
      var numMonthDays = month.children.length;

      for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
        var c = month.children[i];
        if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
      }
    }

    self.changeMonth(loopDelta);
    focusOnDay(getFirstAvailableDay(loopDelta), 0);
    return undefined;
  }

  function focusOnDay(current, offset) {
    var dayFocused = isInView(document.activeElement || document.body);
    var startElem = current !== undefined ? current : dayFocused ? document.activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);

    if (startElem === undefined) {
      self._input.focus();
    } else if (!dayFocused) {
      focusOnDayElem(startElem);
    } else {
      getNextAvailableDay(startElem, offset);
    }
  }

  function buildMonthDays(year, month) {
    var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
    var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
    var daysInMonth = self.utils.getDaysInMonth(month, year),
        days = window.document.createDocumentFragment(),
        isMultiMonth = self.config.showMonths > 1,
        prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay",
        nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
    var dayNumber = prevMonthDays + 1 - firstOfMonth,
        dayIndex = 0;

    for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
      days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
    }

    for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
      days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
    }

    for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
      days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
    }

    var dayContainer = createElement("div", "dayContainer");
    dayContainer.appendChild(days);
    return dayContainer;
  }

  function buildDays() {
    if (self.daysContainer === undefined) {
      return;
    }

    clearNode(self.daysContainer);
    if (self.weekNumbers) clearNode(self.weekNumbers);
    var frag = document.createDocumentFragment();

    for (var i = 0; i < self.config.showMonths; i++) {
      var d = new Date(self.currentYear, self.currentMonth, 1);
      d.setMonth(self.currentMonth + i);
      frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
    }

    self.daysContainer.appendChild(frag);
    self.days = self.daysContainer.firstChild;

    if (self.config.mode === "range" && self.selectedDates.length === 1) {
      onMouseOver();
    }
  }

  function buildMonthSwitch() {
    if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;

    var shouldBuildMonth = function shouldBuildMonth(month) {
      if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) {
        return false;
      }

      return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
    };

    self.monthsDropdownContainer.tabIndex = -1;
    self.monthsDropdownContainer.innerHTML = "";

    for (var i = 0; i < 12; i++) {
      if (!shouldBuildMonth(i)) continue;
      var month = createElement("option", "flatpickr-monthDropdown-month");
      month.value = new Date(self.currentYear, i).getMonth().toString();
      month.textContent = monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
      month.tabIndex = -1;

      if (self.currentMonth === i) {
        month.selected = true;
      }

      self.monthsDropdownContainer.appendChild(month);
    }
  }

  function buildMonth() {
    var container = createElement("div", "flatpickr-month");
    var monthNavFragment = window.document.createDocumentFragment();
    var monthElement;

    if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") {
      monthElement = createElement("span", "cur-month");
    } else {
      self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
      self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
      bind(self.monthsDropdownContainer, "change", function (e) {
        var target = getEventTarget(e);
        var selectedMonth = parseInt(target.value, 10);
        self.changeMonth(selectedMonth - self.currentMonth);
        triggerEvent("onMonthChange");
      });
      buildMonthSwitch();
      monthElement = self.monthsDropdownContainer;
    }

    var yearInput = createNumberInput("cur-year", {
      tabindex: "-1"
    });
    var yearElement = yearInput.getElementsByTagName("input")[0];
    yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);

    if (self.config.minDate) {
      yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
    }

    if (self.config.maxDate) {
      yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
      yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
    }

    var currentMonth = createElement("div", "flatpickr-current-month");
    currentMonth.appendChild(monthElement);
    currentMonth.appendChild(yearInput);
    monthNavFragment.appendChild(currentMonth);
    container.appendChild(monthNavFragment);
    return {
      container: container,
      yearElement: yearElement,
      monthElement: monthElement
    };
  }

  function buildMonths() {
    clearNode(self.monthNav);
    self.monthNav.appendChild(self.prevMonthNav);

    if (self.config.showMonths) {
      self.yearElements = [];
      self.monthElements = [];
    }

    for (var m = self.config.showMonths; m--;) {
      var month = buildMonth();
      self.yearElements.push(month.yearElement);
      self.monthElements.push(month.monthElement);
      self.monthNav.appendChild(month.container);
    }

    self.monthNav.appendChild(self.nextMonthNav);
  }

  function buildMonthNav() {
    self.monthNav = createElement("div", "flatpickr-months");
    self.yearElements = [];
    self.monthElements = [];
    self.prevMonthNav = createElement("span", "flatpickr-prev-month");
    self.prevMonthNav.innerHTML = self.config.prevArrow;
    self.nextMonthNav = createElement("span", "flatpickr-next-month");
    self.nextMonthNav.innerHTML = self.config.nextArrow;
    buildMonths();
    Object.defineProperty(self, "_hidePrevMonthArrow", {
      get: function get() {
        return self.__hidePrevMonthArrow;
      },
      set: function set(bool) {
        if (self.__hidePrevMonthArrow !== bool) {
          toggleClass$1(self.prevMonthNav, "flatpickr-disabled", bool);
          self.__hidePrevMonthArrow = bool;
        }
      }
    });
    Object.defineProperty(self, "_hideNextMonthArrow", {
      get: function get() {
        return self.__hideNextMonthArrow;
      },
      set: function set(bool) {
        if (self.__hideNextMonthArrow !== bool) {
          toggleClass$1(self.nextMonthNav, "flatpickr-disabled", bool);
          self.__hideNextMonthArrow = bool;
        }
      }
    });
    self.currentYearElement = self.yearElements[0];
    updateNavigationCurrentMonth();
    return self.monthNav;
  }

  function buildTime() {
    self.calendarContainer.classList.add("hasTime");
    if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
    var defaults = getDefaultHours(self.config);
    self.timeContainer = createElement("div", "flatpickr-time");
    self.timeContainer.tabIndex = -1;
    var separator = createElement("span", "flatpickr-time-separator", ":");
    var hourInput = createNumberInput("flatpickr-hour", {
      "aria-label": self.l10n.hourAriaLabel
    });
    self.hourElement = hourInput.getElementsByTagName("input")[0];
    var minuteInput = createNumberInput("flatpickr-minute", {
      "aria-label": self.l10n.minuteAriaLabel
    });
    self.minuteElement = minuteInput.getElementsByTagName("input")[0];
    self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
    self.hourElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
    self.minuteElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
    self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
    self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
    self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
    self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
    self.hourElement.setAttribute("maxlength", "2");
    self.minuteElement.setAttribute("min", "0");
    self.minuteElement.setAttribute("max", "59");
    self.minuteElement.setAttribute("maxlength", "2");
    self.timeContainer.appendChild(hourInput);
    self.timeContainer.appendChild(separator);
    self.timeContainer.appendChild(minuteInput);
    if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");

    if (self.config.enableSeconds) {
      self.timeContainer.classList.add("hasSeconds");
      var secondInput = createNumberInput("flatpickr-second");
      self.secondElement = secondInput.getElementsByTagName("input")[0];
      self.secondElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
      self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
      self.secondElement.setAttribute("min", "0");
      self.secondElement.setAttribute("max", "59");
      self.secondElement.setAttribute("maxlength", "2");
      self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
      self.timeContainer.appendChild(secondInput);
    }

    if (!self.config.time_24hr) {
      self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[_int$1((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
      self.amPM.title = self.l10n.toggleTitle;
      self.amPM.tabIndex = -1;
      self.timeContainer.appendChild(self.amPM);
    }

    return self.timeContainer;
  }

  function buildWeekdays() {
    if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");else clearNode(self.weekdayContainer);

    for (var i = self.config.showMonths; i--;) {
      var container = createElement("div", "flatpickr-weekdaycontainer");
      self.weekdayContainer.appendChild(container);
    }

    updateWeekdays();
    return self.weekdayContainer;
  }

  function updateWeekdays() {
    if (!self.weekdayContainer) {
      return;
    }

    var firstDayOfWeek = self.l10n.firstDayOfWeek;

    var weekdays = _toConsumableArray(self.l10n.weekdays.shorthand);

    if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
      weekdays = [].concat(_toConsumableArray(weekdays.splice(firstDayOfWeek, weekdays.length)), _toConsumableArray(weekdays.splice(0, firstDayOfWeek)));
    }

    for (var i = self.config.showMonths; i--;) {
      self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        ".concat(weekdays.join("</span><span class='flatpickr-weekday'>"), "\n      </span>\n      ");
    }
  }

  function buildWeeks() {
    self.calendarContainer.classList.add("hasWeeks");
    var weekWrapper = createElement("div", "flatpickr-weekwrapper");
    weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
    var weekNumbers = createElement("div", "flatpickr-weeks");
    weekWrapper.appendChild(weekNumbers);
    return {
      weekWrapper: weekWrapper,
      weekNumbers: weekNumbers
    };
  }

  function changeMonth(value) {
    var isOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var delta = isOffset ? value : value - self.currentMonth;
    if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
    self.currentMonth += delta;

    if (self.currentMonth < 0 || self.currentMonth > 11) {
      self.currentYear += self.currentMonth > 11 ? 1 : -1;
      self.currentMonth = (self.currentMonth + 12) % 12;
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }

    buildDays();
    triggerEvent("onMonthChange");
    updateNavigationCurrentMonth();
  }

  function clear() {
    var triggerChangeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var toInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    self.input.value = "";
    if (self.altInput !== undefined) self.altInput.value = "";
    if (self.mobileInput !== undefined) self.mobileInput.value = "";
    self.selectedDates = [];
    self.latestSelectedDateObj = undefined;

    if (toInitial === true) {
      self.currentYear = self._initialDate.getFullYear();
      self.currentMonth = self._initialDate.getMonth();
    }

    if (self.config.enableTime === true) {
      var _getDefaultHours = getDefaultHours(self.config),
          hours = _getDefaultHours.hours,
          minutes = _getDefaultHours.minutes,
          seconds = _getDefaultHours.seconds;

      setHours(hours, minutes, seconds);
    }

    self.redraw();
    if (triggerChangeEvent) triggerEvent("onChange");
  }

  function close() {
    self.isOpen = false;

    if (!self.isMobile) {
      if (self.calendarContainer !== undefined) {
        self.calendarContainer.classList.remove("open");
      }

      if (self._input !== undefined) {
        self._input.classList.remove("active");
      }
    }

    triggerEvent("onClose");
  }

  function destroy() {
    if (self.config !== undefined) triggerEvent("onDestroy");

    for (var i = self._handlers.length; i--;) {
      self._handlers[i].remove();
    }

    self._handlers = [];

    if (self.mobileInput) {
      if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
      self.mobileInput = undefined;
    } else if (self.calendarContainer && self.calendarContainer.parentNode) {
      if (self.config["static"] && self.calendarContainer.parentNode) {
        var wrapper = self.calendarContainer.parentNode;
        wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);

        if (wrapper.parentNode) {
          while (wrapper.firstChild) {
            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
          }

          wrapper.parentNode.removeChild(wrapper);
        }
      } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
    }

    if (self.altInput) {
      self.input.type = "text";
      if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
      delete self.altInput;
    }

    if (self.input) {
      self.input.type = self.input._type;
      self.input.classList.remove("flatpickr-input");
      self.input.removeAttribute("readonly");
    }

    ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "monthsDropdownContainer", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (k) {
      try {
        delete self[k];
      } catch (_) {}
    });
  }

  function isCalendarElem(elem) {
    if (self.config.appendTo && self.config.appendTo.contains(elem)) return true;
    return self.calendarContainer.contains(elem);
  }

  function documentClick(e) {
    if (self.isOpen && !self.config.inline) {
      var eventTarget = getEventTarget(e);
      var isCalendarElement = isCalendarElem(eventTarget);
      var isInput = eventTarget === self.input || eventTarget === self.altInput || self.element.contains(eventTarget) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
      var lostFocus = e.type === "blur" ? isInput && e.relatedTarget && !isCalendarElem(e.relatedTarget) : !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
      var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
        return elem.contains(eventTarget);
      });

      if (lostFocus && isIgnored) {
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) {
          updateTime();
        }

        self.close();

        if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) {
          self.clear(false);
          self.redraw();
        }
      }
    }
  }

  function changeYear(newYear) {
    if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
    var newYearNum = newYear,
        isNewYear = self.currentYear !== newYearNum;
    self.currentYear = newYearNum || self.currentYear;

    if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {
      self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
    } else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {
      self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
    }

    if (isNewYear) {
      self.redraw();
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }
  }

  function isEnabled(date) {
    var timeless = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var _a;

    var dateToCheck = self.parseDate(date, undefined, timeless);
    if (self.config.minDate && dateToCheck && compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
    if (!self.config.enable && self.config.disable.length === 0) return true;
    if (dateToCheck === undefined) return false;
    var bool = !!self.config.enable,
        array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;

    for (var i = 0, d; i < array.length; i++) {
      d = array[i];
      if (typeof d === "function" && d(dateToCheck)) return bool;else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;else if (typeof d === "string") {
        var parsed = self.parseDate(d, undefined, true);
        return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
      } else if (_typeof(d) === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
    }

    return !bool;
  }

  function isInView(elem) {
    if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
    return false;
  }

  function onBlur(e) {
    var isInput = e.target === self._input;

    if (isInput && (self.selectedDates.length > 0 || self._input.value.length > 0) && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
      self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
  }

  function onKeyDown(e) {
    var eventTarget = getEventTarget(e);
    var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
    var allowInput = self.config.allowInput;
    var allowKeydown = self.isOpen && (!allowInput || !isInput);
    var allowInlineKeydown = self.config.inline && isInput && !allowInput;

    if (e.keyCode === 13 && isInput) {
      if (allowInput) {
        self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
        return eventTarget.blur();
      } else {
        self.open();
      }
    } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
      var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);

      switch (e.keyCode) {
        case 13:
          if (isTimeObj) {
            e.preventDefault();
            updateTime();
            focusAndClose();
          } else selectDate(e);

          break;

        case 27:
          e.preventDefault();
          focusAndClose();
          break;

        case 8:
        case 46:
          if (isInput && !self.config.allowInput) {
            e.preventDefault();
            self.clear();
          }

          break;

        case 37:
        case 39:
          if (!isTimeObj && !isInput) {
            e.preventDefault();

            if (self.daysContainer !== undefined && (allowInput === false || document.activeElement && isInView(document.activeElement))) {
              var _delta = e.keyCode === 39 ? 1 : -1;

              if (!e.ctrlKey) focusOnDay(undefined, _delta);else {
                e.stopPropagation();
                changeMonth(_delta);
                focusOnDay(getFirstAvailableDay(1), 0);
              }
            }
          } else if (self.hourElement) self.hourElement.focus();

          break;

        case 38:
        case 40:
          e.preventDefault();
          var delta = e.keyCode === 40 ? 1 : -1;

          if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
            if (e.ctrlKey) {
              e.stopPropagation();
              changeYear(self.currentYear - delta);
              focusOnDay(getFirstAvailableDay(1), 0);
            } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
          } else if (eventTarget === self.currentYearElement) {
            changeYear(self.currentYear - delta);
          } else if (self.config.enableTime) {
            if (!isTimeObj && self.hourElement) self.hourElement.focus();
            updateTime(e);

            self._debouncedChange();
          }

          break;

        case 9:
          if (isTimeObj) {
            var elems = [self.hourElement, self.minuteElement, self.secondElement, self.amPM].concat(self.pluginElements).filter(function (x) {
              return x;
            });
            var i = elems.indexOf(eventTarget);

            if (i !== -1) {
              var target = elems[i + (e.shiftKey ? -1 : 1)];
              e.preventDefault();

              (target || self._input).focus();
            }
          } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
            e.preventDefault();

            self._input.focus();
          }

          break;
      }
    }

    if (self.amPM !== undefined && eventTarget === self.amPM) {
      switch (e.key) {
        case self.l10n.amPM[0].charAt(0):
        case self.l10n.amPM[0].charAt(0).toLowerCase():
          self.amPM.textContent = self.l10n.amPM[0];
          setHoursFromInputs();
          updateValue();
          break;

        case self.l10n.amPM[1].charAt(0):
        case self.l10n.amPM[1].charAt(0).toLowerCase():
          self.amPM.textContent = self.l10n.amPM[1];
          setHoursFromInputs();
          updateValue();
          break;
      }
    }

    if (isInput || isCalendarElem(eventTarget)) {
      triggerEvent("onKeyDown", e);
    }
  }

  function onMouseOver(elem) {
    if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains("flatpickr-day") || elem.classList.contains("flatpickr-disabled"))) return;
    var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(),
        initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(),
        rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()),
        rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
    var containsDisabled = false;
    var minRange = 0,
        maxRange = 0;

    for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
      if (!isEnabled(new Date(t), true)) {
        containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
        if (t < initialDate && (!minRange || t > minRange)) minRange = t;else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
      }
    }

    for (var m = 0; m < self.config.showMonths; m++) {
      var month = self.daysContainer.children[m];

      var _loop = function _loop(i, l) {
        var dayElem = month.children[i],
            date = dayElem.dateObj;
        var timestamp = date.getTime();
        var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;

        if (outOfRange) {
          dayElem.classList.add("notAllowed");
          ["inRange", "startRange", "endRange"].forEach(function (c) {
            dayElem.classList.remove(c);
          });
          return "continue";
        } else if (containsDisabled && !outOfRange) return "continue";

        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
          dayElem.classList.remove(c);
        });

        if (elem !== undefined) {
          elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
          if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
          if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
        }
      };

      for (var i = 0, l = month.children.length; i < l; i++) {
        var _ret = _loop(i, l);

        if (_ret === "continue") continue;
      }
    }
  }

  function onResize() {
    if (self.isOpen && !self.config["static"] && !self.config.inline) positionCalendar();
  }

  function open(e) {
    var positionElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self._positionElement;

    if (self.isMobile === true) {
      if (e) {
        e.preventDefault();
        var eventTarget = getEventTarget(e);

        if (eventTarget) {
          eventTarget.blur();
        }
      }

      if (self.mobileInput !== undefined) {
        self.mobileInput.focus();
        self.mobileInput.click();
      }

      triggerEvent("onOpen");
      return;
    } else if (self._input.disabled || self.config.inline) {
      return;
    }

    var wasOpen = self.isOpen;
    self.isOpen = true;

    if (!wasOpen) {
      self.calendarContainer.classList.add("open");

      self._input.classList.add("active");

      triggerEvent("onOpen");
      positionCalendar(positionElement);
    }

    if (self.config.enableTime === true && self.config.noCalendar === true) {
      if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) {
        setTimeout(function () {
          return self.hourElement.select();
        }, 50);
      }
    }
  }

  function minMaxDateSetter(type) {
    return function (date) {
      var dateObj = self.config["_".concat(type, "Date")] = self.parseDate(date, self.config.dateFormat);
      var inverseDateObj = self.config["_".concat(type === "min" ? "max" : "min", "Date")];

      if (dateObj !== undefined) {
        self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
      }

      if (self.selectedDates) {
        self.selectedDates = self.selectedDates.filter(function (d) {
          return isEnabled(d);
        });
        if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
        updateValue();
      }

      if (self.daysContainer) {
        redraw();
        if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();else self.currentYearElement.removeAttribute(type);
        self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
      }
    };
  }

  function parseConfig() {
    var boolOpts = ["wrap", "weekNumbers", "allowInput", "allowInvalidPreload", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];
    var userConfig = Object.assign(Object.assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
    var formats = {};
    self.config.parseDate = userConfig.parseDate;
    self.config.formatDate = userConfig.formatDate;
    Object.defineProperty(self.config, "enable", {
      get: function get() {
        return self.config._enable;
      },
      set: function set(dates) {
        self.config._enable = parseDateRules(dates);
      }
    });
    Object.defineProperty(self.config, "disable", {
      get: function get() {
        return self.config._disable;
      },
      set: function set(dates) {
        self.config._disable = parseDateRules(dates);
      }
    });
    var timeMode = userConfig.mode === "time";

    if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
      var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults$1.dateFormat;
      formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
    }

    if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
      var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults$1.altFormat;
      formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + " h:i".concat(userConfig.enableSeconds ? ":S" : "", " K");
    }

    Object.defineProperty(self.config, "minDate", {
      get: function get() {
        return self.config._minDate;
      },
      set: minMaxDateSetter("min")
    });
    Object.defineProperty(self.config, "maxDate", {
      get: function get() {
        return self.config._maxDate;
      },
      set: minMaxDateSetter("max")
    });

    var minMaxTimeSetter = function minMaxTimeSetter(type) {
      return function (val) {
        self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
      };
    };

    Object.defineProperty(self.config, "minTime", {
      get: function get() {
        return self.config._minTime;
      },
      set: minMaxTimeSetter("min")
    });
    Object.defineProperty(self.config, "maxTime", {
      get: function get() {
        return self.config._maxTime;
      },
      set: minMaxTimeSetter("max")
    });

    if (userConfig.mode === "time") {
      self.config.noCalendar = true;
      self.config.enableTime = true;
    }

    Object.assign(self.config, formats, userConfig);

    for (var i = 0; i < boolOpts.length; i++) {
      self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
    }

    HOOKS.filter(function (hook) {
      return self.config[hook] !== undefined;
    }).forEach(function (hook) {
      self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
    });
    self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    for (var _i = 0; _i < self.config.plugins.length; _i++) {
      var pluginConf = self.config.plugins[_i](self) || {};

      for (var key in pluginConf) {
        if (HOOKS.indexOf(key) > -1) {
          self.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
        } else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
      }
    }

    if (!userConfig.altInputClass) {
      self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
    }

    triggerEvent("onParseConfig");
  }

  function getInputElem() {
    return self.config.wrap ? element.querySelector("[data-input]") : element;
  }

  function setupLocale() {
    if (_typeof(self.config.locale) !== "object" && typeof flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale ".concat(self.config.locale)));
    self.l10n = Object.assign(Object.assign({}, flatpickr.l10ns["default"]), _typeof(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? flatpickr.l10ns[self.config.locale] : undefined);
    tokenRegex.K = "(".concat(self.l10n.amPM[0], "|").concat(self.l10n.amPM[1], "|").concat(self.l10n.amPM[0].toLowerCase(), "|").concat(self.l10n.amPM[1].toLowerCase(), ")");
    var userConfig = Object.assign(Object.assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));

    if (userConfig.time_24hr === undefined && flatpickr.defaultConfig.time_24hr === undefined) {
      self.config.time_24hr = self.l10n.time_24hr;
    }

    self.formatDate = createDateFormatter(self);
    self.parseDate = createDateParser({
      config: self.config,
      l10n: self.l10n
    });
  }

  function positionCalendar(customPositionElement) {
    if (typeof self.config.position === "function") {
      return void self.config.position(self, customPositionElement);
    }

    if (self.calendarContainer === undefined) return;
    triggerEvent("onPreCalendarPosition");
    var positionElement = customPositionElement || self._positionElement;
    var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function (acc, child) {
      return acc + child.offsetHeight;
    }, 0),
        calendarWidth = self.calendarContainer.offsetWidth,
        configPos = self.config.position.split(" "),
        configPosVertical = configPos[0],
        configPosHorizontal = configPos.length > 1 ? configPos[1] : null,
        inputBounds = positionElement.getBoundingClientRect(),
        distanceFromBottom = window.innerHeight - inputBounds.bottom,
        showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
    var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
    toggleClass$1(self.calendarContainer, "arrowTop", !showOnTop);
    toggleClass$1(self.calendarContainer, "arrowBottom", showOnTop);
    if (self.config.inline) return;
    var left = window.pageXOffset + inputBounds.left;
    var isCenter = false;
    var isRight = false;

    if (configPosHorizontal === "center") {
      left -= (calendarWidth - inputBounds.width) / 2;
      isCenter = true;
    } else if (configPosHorizontal === "right") {
      left -= calendarWidth - inputBounds.width;
      isRight = true;
    }

    toggleClass$1(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
    toggleClass$1(self.calendarContainer, "arrowCenter", isCenter);
    toggleClass$1(self.calendarContainer, "arrowRight", isRight);
    var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
    var rightMost = left + calendarWidth > window.document.body.offsetWidth;
    var centerMost = right + calendarWidth > window.document.body.offsetWidth;
    toggleClass$1(self.calendarContainer, "rightMost", rightMost);
    if (self.config["static"]) return;
    self.calendarContainer.style.top = "".concat(top, "px");

    if (!rightMost) {
      self.calendarContainer.style.left = "".concat(left, "px");
      self.calendarContainer.style.right = "auto";
    } else if (!centerMost) {
      self.calendarContainer.style.left = "auto";
      self.calendarContainer.style.right = "".concat(right, "px");
    } else {
      var doc = getDocumentStyleSheet();
      if (doc === undefined) return;
      var bodyWidth = window.document.body.offsetWidth;
      var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
      var centerBefore = ".flatpickr-calendar.centerMost:before";
      var centerAfter = ".flatpickr-calendar.centerMost:after";
      var centerIndex = doc.cssRules.length;
      var centerStyle = "{left:".concat(inputBounds.left, "px;right:auto;}");
      toggleClass$1(self.calendarContainer, "rightMost", false);
      toggleClass$1(self.calendarContainer, "centerMost", true);
      doc.insertRule("".concat(centerBefore, ",").concat(centerAfter).concat(centerStyle), centerIndex);
      self.calendarContainer.style.left = "".concat(centerLeft, "px");
      self.calendarContainer.style.right = "auto";
    }
  }

  function getDocumentStyleSheet() {
    var editableSheet = null;

    for (var i = 0; i < document.styleSheets.length; i++) {
      var sheet = document.styleSheets[i];

      try {
        sheet.cssRules;
      } catch (err) {
        continue;
      }

      editableSheet = sheet;
      break;
    }

    return editableSheet != null ? editableSheet : createStyleSheet();
  }

  function createStyleSheet() {
    var style = document.createElement("style");
    document.head.appendChild(style);
    return style.sheet;
  }

  function redraw() {
    if (self.config.noCalendar || self.isMobile) return;
    buildMonthSwitch();
    updateNavigationCurrentMonth();
    buildDays();
  }

  function focusAndClose() {
    self._input.focus();

    if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) {
      setTimeout(self.close, 0);
    } else {
      self.close();
    }
  }

  function selectDate(e) {
    e.preventDefault();
    e.stopPropagation();

    var isSelectable = function isSelectable(day) {
      return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
    };

    var t = findParent(getEventTarget(e), isSelectable);
    if (t === undefined) return;
    var target = t;
    var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
    var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
    self.selectedDateElem = target;
    if (self.config.mode === "single") self.selectedDates = [selectedDate];else if (self.config.mode === "multiple") {
      var selectedIndex = isDateSelected(selectedDate);
      if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);else self.selectedDates.push(selectedDate);
    } else if (self.config.mode === "range") {
      if (self.selectedDates.length === 2) {
        self.clear(false, false);
      }

      self.latestSelectedDateObj = selectedDate;
      self.selectedDates.push(selectedDate);
      if (compareDates(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
    }
    setHoursFromInputs();

    if (shouldChangeMonth) {
      var isNewYear = self.currentYear !== selectedDate.getFullYear();
      self.currentYear = selectedDate.getFullYear();
      self.currentMonth = selectedDate.getMonth();

      if (isNewYear) {
        triggerEvent("onYearChange");
        buildMonthSwitch();
      }

      triggerEvent("onMonthChange");
    }

    updateNavigationCurrentMonth();
    buildDays();
    updateValue();
    if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);else if (self.selectedDateElem !== undefined && self.hourElement === undefined) {
      self.selectedDateElem && self.selectedDateElem.focus();
    }
    if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();

    if (self.config.closeOnSelect) {
      var single = self.config.mode === "single" && !self.config.enableTime;
      var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;

      if (single || range) {
        focusAndClose();
      }
    }

    triggerChange();
  }

  var CALLBACKS = {
    locale: [setupLocale, updateWeekdays],
    showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
    minDate: [jumpToDate],
    maxDate: [jumpToDate],
    clickOpens: [function () {
      if (self.config.clickOpens === true) {
        bind(self._input, "focus", self.open);
        bind(self._input, "click", self.open);
      } else {
        self._input.removeEventListener("focus", self.open);

        self._input.removeEventListener("click", self.open);
      }
    }]
  };

  function set(option, value) {
    if (option !== null && _typeof(option) === "object") {
      Object.assign(self.config, option);

      for (var key in option) {
        if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function (x) {
          return x();
        });
      }
    } else {
      self.config[option] = value;
      if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function (x) {
        return x();
      });else if (HOOKS.indexOf(option) > -1) self.config[option] = arrayify(value);
    }

    self.redraw();
    updateValue(true);
  }

  function setSelectedDate(inputDate, format) {
    var dates = [];
    if (inputDate instanceof Array) dates = inputDate.map(function (d) {
      return self.parseDate(d, format);
    });else if (inputDate instanceof Date || typeof inputDate === "number") dates = [self.parseDate(inputDate, format)];else if (typeof inputDate === "string") {
      switch (self.config.mode) {
        case "single":
        case "time":
          dates = [self.parseDate(inputDate, format)];
          break;

        case "multiple":
          dates = inputDate.split(self.config.conjunction).map(function (date) {
            return self.parseDate(date, format);
          });
          break;

        case "range":
          dates = inputDate.split(self.l10n.rangeSeparator).map(function (date) {
            return self.parseDate(date, format);
          });
          break;
      }
    } else self.config.errorHandler(new Error("Invalid date supplied: ".concat(JSON.stringify(inputDate))));
    self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function (d) {
      return d instanceof Date && isEnabled(d, false);
    });
    if (self.config.mode === "range") self.selectedDates.sort(function (a, b) {
      return a.getTime() - b.getTime();
    });
  }

  function setDate(date) {
    var triggerChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : self.config.dateFormat;
    if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
    setSelectedDate(date, format);
    self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
    self.redraw();
    jumpToDate(undefined, triggerChange);
    setHoursFromDate();

    if (self.selectedDates.length === 0) {
      self.clear(false);
    }

    updateValue(triggerChange);
    if (triggerChange) triggerEvent("onChange");
  }

  function parseDateRules(arr) {
    return arr.slice().map(function (rule) {
      if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) {
        return self.parseDate(rule, undefined, true);
      } else if (rule && _typeof(rule) === "object" && rule.from && rule.to) return {
        from: self.parseDate(rule.from, undefined),
        to: self.parseDate(rule.to, undefined)
      };

      return rule;
    }).filter(function (x) {
      return x;
    });
  }

  function setupDates() {
    self.selectedDates = [];
    self.now = self.parseDate(self.config.now) || new Date();
    var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
    if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
    self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
    self.currentYear = self._initialDate.getFullYear();
    self.currentMonth = self._initialDate.getMonth();
    if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
    if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
    if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
    self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
    self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
  }

  function setupInputs() {
    self.input = getInputElem();

    if (!self.input) {
      self.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }

    self.input._type = self.input.type;
    self.input.type = "text";
    self.input.classList.add("flatpickr-input");
    self._input = self.input;

    if (self.config.altInput) {
      self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
      self._input = self.altInput;
      self.altInput.placeholder = self.input.placeholder;
      self.altInput.disabled = self.input.disabled;
      self.altInput.required = self.input.required;
      self.altInput.tabIndex = self.input.tabIndex;
      self.altInput.type = "text";
      self.input.setAttribute("type", "hidden");
      if (!self.config["static"] && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
    }

    if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
    self._positionElement = self.config.positionElement || self._input;
  }

  function setupMobile() {
    var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
    self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
    self.mobileInput.tabIndex = 1;
    self.mobileInput.type = inputType;
    self.mobileInput.disabled = self.input.disabled;
    self.mobileInput.required = self.input.required;
    self.mobileInput.placeholder = self.input.placeholder;
    self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";

    if (self.selectedDates.length > 0) {
      self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
    }

    if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
    if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
    if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
    self.input.type = "hidden";
    if (self.altInput !== undefined) self.altInput.type = "hidden";

    try {
      if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
    } catch (_a) {}

    bind(self.mobileInput, "change", function (e) {
      self.setDate(getEventTarget(e).value, false, self.mobileFormatStr);
      triggerEvent("onChange");
      triggerEvent("onClose");
    });
  }

  function toggle(e) {
    if (self.isOpen === true) return self.close();
    self.open(e);
  }

  function triggerEvent(event, data) {
    if (self.config === undefined) return;
    var hooks = self.config[event];

    if (hooks !== undefined && hooks.length > 0) {
      for (var i = 0; hooks[i] && i < hooks.length; i++) {
        hooks[i](self.selectedDates, self.input.value, self, data);
      }
    }

    if (event === "onChange") {
      self.input.dispatchEvent(createEvent("change"));
      self.input.dispatchEvent(createEvent("input"));
    }
  }

  function createEvent(name) {
    var e = document.createEvent("Event");
    e.initEvent(name, true, true);
    return e;
  }

  function isDateSelected(date) {
    for (var i = 0; i < self.selectedDates.length; i++) {
      if (compareDates(self.selectedDates[i], date) === 0) return "" + i;
    }

    return false;
  }

  function isDateInRange(date) {
    if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
    return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
  }

  function updateNavigationCurrentMonth() {
    if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
    self.yearElements.forEach(function (yearElement, i) {
      var d = new Date(self.currentYear, self.currentMonth, 1);
      d.setMonth(self.currentMonth + i);

      if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") {
        self.monthElements[i].textContent = monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
      } else {
        self.monthsDropdownContainer.value = d.getMonth().toString();
      }

      yearElement.value = d.getFullYear().toString();
    });
    self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
    self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
  }

  function getDateStr(format) {
    return self.selectedDates.map(function (dObj) {
      return self.formatDate(dObj, format);
    }).filter(function (d, i, arr) {
      return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
    }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
  }

  function updateValue() {
    var triggerChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (self.mobileInput !== undefined && self.mobileFormatStr) {
      self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
    }

    self.input.value = getDateStr(self.config.dateFormat);

    if (self.altInput !== undefined) {
      self.altInput.value = getDateStr(self.config.altFormat);
    }

    if (triggerChange !== false) triggerEvent("onValueUpdate");
  }

  function onMonthNavClick(e) {
    var eventTarget = getEventTarget(e);
    var isPrevMonth = self.prevMonthNav.contains(eventTarget);
    var isNextMonth = self.nextMonthNav.contains(eventTarget);

    if (isPrevMonth || isNextMonth) {
      changeMonth(isPrevMonth ? -1 : 1);
    } else if (self.yearElements.indexOf(eventTarget) >= 0) {
      eventTarget.select();
    } else if (eventTarget.classList.contains("arrowUp")) {
      self.changeYear(self.currentYear + 1);
    } else if (eventTarget.classList.contains("arrowDown")) {
      self.changeYear(self.currentYear - 1);
    }
  }

  function timeWrapper(e) {
    e.preventDefault();
    var isKeyDown = e.type === "keydown",
        eventTarget = getEventTarget(e),
        input = eventTarget;

    if (self.amPM !== undefined && eventTarget === self.amPM) {
      self.amPM.textContent = self.l10n.amPM[_int$1(self.amPM.textContent === self.l10n.amPM[0])];
    }

    var min = parseFloat(input.getAttribute("min")),
        max = parseFloat(input.getAttribute("max")),
        step = parseFloat(input.getAttribute("step")),
        curValue = parseInt(input.value, 10),
        delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
    var newValue = curValue + step * delta;

    if (typeof input.value !== "undefined" && input.value.length === 2) {
      var isHourElem = input === self.hourElement,
          isMinuteElem = input === self.minuteElement;

      if (newValue < min) {
        newValue = max + newValue + _int$1(!isHourElem) + (_int$1(isHourElem) && _int$1(!self.amPM));
        if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
      } else if (newValue > max) {
        newValue = input === self.hourElement ? newValue - max - _int$1(!self.amPM) : min;
        if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
      }

      if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
        self.amPM.textContent = self.l10n.amPM[_int$1(self.amPM.textContent === self.l10n.amPM[0])];
      }

      input.value = pad(newValue);
    }
  }

  init();
  return self;
}

function _flatpickr(nodeList, config) {
  var nodes = Array.prototype.slice.call(nodeList).filter(function (x) {
    return x instanceof HTMLElement;
  });
  var instances = [];

  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];

    try {
      if (node.getAttribute("data-fp-omit") !== null) continue;

      if (node._flatpickr !== undefined) {
        node._flatpickr.destroy();

        node._flatpickr = undefined;
      }

      node._flatpickr = FlatpickrInstance(node, config || {});
      instances.push(node._flatpickr);
    } catch (e) {
      console.error(e);
    }
  }

  return instances.length === 1 ? instances[0] : instances;
}

if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
  HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
    return _flatpickr(this, config);
  };

  HTMLElement.prototype.flatpickr = function (config) {
    return _flatpickr([this], config);
  };
}

var flatpickr = function flatpickr(selector, config) {
  if (typeof selector === "string") {
    return _flatpickr(window.document.querySelectorAll(selector), config);
  } else if (selector instanceof Node) {
    return _flatpickr([selector], config);
  } else {
    return _flatpickr(selector, config);
  }
};

flatpickr.defaultConfig = {};
flatpickr.l10ns = {
  en: Object.assign({}, english),
  "default": Object.assign({}, english)
};

flatpickr.localize = function (l10n) {
  flatpickr.l10ns["default"] = Object.assign(Object.assign({}, flatpickr.l10ns["default"]), l10n);
};

flatpickr.setDefaults = function (config) {
  flatpickr.defaultConfig = Object.assign(Object.assign({}, flatpickr.defaultConfig), config);
};

flatpickr.parseDate = createDateParser({});
flatpickr.formatDate = createDateFormatter({});
flatpickr.compareDates = compareDates;

if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
  jQuery.fn.flatpickr = function (config) {
    return _flatpickr(this, config);
  };
}

Date.prototype.fp_incr = function (days) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};

if (typeof window !== "undefined") {
  window.flatpickr = flatpickr;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".flatpickr-calendar{background:transparent;opacity:0;display:none;text-align:center;visibility:hidden;padding:0;-webkit-animation:none;animation:none;direction:ltr;border:0;font-size:14px;line-height:24px;border-radius:5px;position:absolute;width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-touch-action:manipulation;touch-action:manipulation;background:#fff;-webkit-box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,0.08);box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,0.08)}.flatpickr-calendar.open,.flatpickr-calendar.inline{opacity:1;max-height:640px;visibility:visible}.flatpickr-calendar.open{display:inline-block;z-index:99999}.flatpickr-calendar.animate.open{-webkit-animation:fpFadeInDown 300ms cubic-bezier(.23,1,.32,1);animation:fpFadeInDown 300ms cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.inline{display:block;position:relative;top:2px}.flatpickr-calendar.static{position:absolute;top:calc(100% + 2px)}.flatpickr-calendar.static.open{z-index:999;display:block}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7){-webkit-box-shadow:none !important;box-shadow:none !important}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1){-webkit-box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-calendar .hasWeeks .dayContainer,.flatpickr-calendar .hasTime .dayContainer{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.flatpickr-calendar .hasWeeks .dayContainer{border-left:0}.flatpickr-calendar.hasTime .flatpickr-time{height:40px;border-top:1px solid #e6e6e6}.flatpickr-calendar.noCalendar.hasTime .flatpickr-time{height:auto}.flatpickr-calendar:before,.flatpickr-calendar:after{position:absolute;display:block;pointer-events:none;border:solid transparent;content:'';height:0;width:0;left:22px}.flatpickr-calendar.rightMost:before,.flatpickr-calendar.arrowRight:before,.flatpickr-calendar.rightMost:after,.flatpickr-calendar.arrowRight:after{left:auto;right:22px}.flatpickr-calendar.arrowCenter:before,.flatpickr-calendar.arrowCenter:after{left:50%;right:50%}.flatpickr-calendar:before{border-width:5px;margin:0 -5px}.flatpickr-calendar:after{border-width:4px;margin:0 -4px}.flatpickr-calendar.arrowTop:before,.flatpickr-calendar.arrowTop:after{bottom:100%}.flatpickr-calendar.arrowTop:before{border-bottom-color:#e6e6e6}.flatpickr-calendar.arrowTop:after{border-bottom-color:#fff}.flatpickr-calendar.arrowBottom:before,.flatpickr-calendar.arrowBottom:after{top:100%}.flatpickr-calendar.arrowBottom:before{border-top-color:#e6e6e6}.flatpickr-calendar.arrowBottom:after{border-top-color:#fff}.flatpickr-calendar:focus{outline:0}.flatpickr-wrapper{position:relative;display:inline-block}.flatpickr-months{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-months .flatpickr-month{background:transparent;color:rgba(0,0,0,0.9);fill:rgba(0,0,0,0.9);height:34px;line-height:1;text-align:center;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}.flatpickr-months .flatpickr-prev-month,.flatpickr-months .flatpickr-next-month{text-decoration:none;cursor:pointer;position:absolute;top:0;height:34px;padding:10px;z-index:3;color:rgba(0,0,0,0.9);fill:rgba(0,0,0,0.9)}.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,.flatpickr-months .flatpickr-next-month.flatpickr-disabled{display:none}.flatpickr-months .flatpickr-prev-month i,.flatpickr-months .flatpickr-next-month i{position:relative}.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,.flatpickr-months .flatpickr-next-month.flatpickr-prev-month{/*\n      /*rtl:begin:ignore*/left:0/*\n      /*rtl:end:ignore*/}/*\n      /*rtl:begin:ignore*/\n/*\n      /*rtl:end:ignore*/\n.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,.flatpickr-months .flatpickr-next-month.flatpickr-next-month{/*\n      /*rtl:begin:ignore*/right:0/*\n      /*rtl:end:ignore*/}/*\n      /*rtl:begin:ignore*/\n/*\n      /*rtl:end:ignore*/\n.flatpickr-months .flatpickr-prev-month:hover,.flatpickr-months .flatpickr-next-month:hover{color:#959ea9}.flatpickr-months .flatpickr-prev-month:hover svg,.flatpickr-months .flatpickr-next-month:hover svg{fill:#f64747}.flatpickr-months .flatpickr-prev-month svg,.flatpickr-months .flatpickr-next-month svg{width:14px;height:14px}.flatpickr-months .flatpickr-prev-month svg path,.flatpickr-months .flatpickr-next-month svg path{-webkit-transition:fill .1s;transition:fill .1s;fill:inherit}.numInputWrapper{position:relative;height:auto}.numInputWrapper input,.numInputWrapper span{display:inline-block}.numInputWrapper input{width:100%}.numInputWrapper input::-ms-clear{display:none}.numInputWrapper input::-webkit-outer-spin-button,.numInputWrapper input::-webkit-inner-spin-button{margin:0;-webkit-appearance:none}.numInputWrapper span{position:absolute;right:0;width:14px;padding:0 4px 0 2px;height:50%;line-height:50%;opacity:0;cursor:pointer;border:1px solid rgba(57,57,57,0.15);-webkit-box-sizing:border-box;box-sizing:border-box}.numInputWrapper span:hover{background:rgba(0,0,0,0.1)}.numInputWrapper span:active{background:rgba(0,0,0,0.2)}.numInputWrapper span:after{display:block;content:\"\";position:absolute}.numInputWrapper span.arrowUp{top:0;border-bottom:0}.numInputWrapper span.arrowUp:after{border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:4px solid rgba(57,57,57,0.6);top:26%}.numInputWrapper span.arrowDown{top:50%}.numInputWrapper span.arrowDown:after{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid rgba(57,57,57,0.6);top:40%}.numInputWrapper span svg{width:inherit;height:auto}.numInputWrapper span svg path{fill:rgba(0,0,0,0.5)}.numInputWrapper:hover{background:rgba(0,0,0,0.05)}.numInputWrapper:hover span{opacity:1}.flatpickr-current-month{font-size:135%;line-height:inherit;font-weight:300;color:inherit;position:absolute;width:75%;left:12.5%;padding:7.48px 0 0 0;line-height:1;height:34px;display:inline-block;text-align:center;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.flatpickr-current-month span.cur-month{font-family:inherit;font-weight:700;color:inherit;display:inline-block;margin-left:.5ch;padding:0}.flatpickr-current-month span.cur-month:hover{background:rgba(0,0,0,0.05)}.flatpickr-current-month .numInputWrapper{width:6ch;width:7ch\\0;display:inline-block}.flatpickr-current-month .numInputWrapper span.arrowUp:after{border-bottom-color:rgba(0,0,0,0.9)}.flatpickr-current-month .numInputWrapper span.arrowDown:after{border-top-color:rgba(0,0,0,0.9)}.flatpickr-current-month input.cur-year{background:transparent;-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;cursor:text;padding:0 0 0 .5ch;margin:0;display:inline-block;font-size:inherit;font-family:inherit;font-weight:300;line-height:inherit;height:auto;border:0;border-radius:0;vertical-align:initial;-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}.flatpickr-current-month input.cur-year:focus{outline:0}.flatpickr-current-month input.cur-year[disabled],.flatpickr-current-month input.cur-year[disabled]:hover{font-size:100%;color:rgba(0,0,0,0.5);background:transparent;pointer-events:none}.flatpickr-current-month .flatpickr-monthDropdown-months{appearance:menulist;background:transparent;border:none;border-radius:0;box-sizing:border-box;color:inherit;cursor:pointer;font-size:inherit;font-family:inherit;font-weight:300;height:auto;line-height:inherit;margin:-1px 0 0 0;outline:none;padding:0 0 0 .5ch;position:relative;vertical-align:initial;-webkit-box-sizing:border-box;-webkit-appearance:menulist;-moz-appearance:menulist;width:auto}.flatpickr-current-month .flatpickr-monthDropdown-months:focus,.flatpickr-current-month .flatpickr-monthDropdown-months:active{outline:none}.flatpickr-current-month .flatpickr-monthDropdown-months:hover{background:rgba(0,0,0,0.05)}.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month{background-color:transparent;outline:none;padding:0}.flatpickr-weekdays{background:transparent;text-align:center;overflow:hidden;width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:28px}.flatpickr-weekdays .flatpickr-weekdaycontainer{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}span.flatpickr-weekday{cursor:default;font-size:90%;background:transparent;color:rgba(0,0,0,0.54);line-height:1;margin:0;text-align:center;display:block;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;font-weight:bolder}.dayContainer,.flatpickr-weeks{padding:1px 0 0 0}.flatpickr-days{position:relative;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;width:307.875px}.flatpickr-days:focus{outline:0}.dayContainer{padding:0;outline:0;text-align:left;width:307.875px;min-width:307.875px;max-width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-wrap:wrap;-ms-flex-pack:justify;-webkit-justify-content:space-around;justify-content:space-around;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);opacity:1}.dayContainer + .dayContainer{-webkit-box-shadow:-1px 0 0 #e6e6e6;box-shadow:-1px 0 0 #e6e6e6}.flatpickr-day{background:none;border:1px solid transparent;border-radius:150px;-webkit-box-sizing:border-box;box-sizing:border-box;color:#393939;cursor:pointer;font-weight:400;width:14.2857143%;-webkit-flex-basis:14.2857143%;-ms-flex-preferred-size:14.2857143%;flex-basis:14.2857143%;max-width:39px;height:39px;line-height:39px;margin:0;display:inline-block;position:relative;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.flatpickr-day.inRange,.flatpickr-day.prevMonthDay.inRange,.flatpickr-day.nextMonthDay.inRange,.flatpickr-day.today.inRange,.flatpickr-day.prevMonthDay.today.inRange,.flatpickr-day.nextMonthDay.today.inRange,.flatpickr-day:hover,.flatpickr-day.prevMonthDay:hover,.flatpickr-day.nextMonthDay:hover,.flatpickr-day:focus,.flatpickr-day.prevMonthDay:focus,.flatpickr-day.nextMonthDay:focus{cursor:pointer;outline:0;background:#e6e6e6;border-color:#e6e6e6}.flatpickr-day.today{border-color:#959ea9}.flatpickr-day.today:hover,.flatpickr-day.today:focus{border-color:#959ea9;background:#959ea9;color:#fff}.flatpickr-day.selected,.flatpickr-day.startRange,.flatpickr-day.endRange,.flatpickr-day.selected.inRange,.flatpickr-day.startRange.inRange,.flatpickr-day.endRange.inRange,.flatpickr-day.selected:focus,.flatpickr-day.startRange:focus,.flatpickr-day.endRange:focus,.flatpickr-day.selected:hover,.flatpickr-day.startRange:hover,.flatpickr-day.endRange:hover,.flatpickr-day.selected.prevMonthDay,.flatpickr-day.startRange.prevMonthDay,.flatpickr-day.endRange.prevMonthDay,.flatpickr-day.selected.nextMonthDay,.flatpickr-day.startRange.nextMonthDay,.flatpickr-day.endRange.nextMonthDay{background:#569ff7;-webkit-box-shadow:none;box-shadow:none;color:#fff;border-color:#569ff7}.flatpickr-day.selected.startRange,.flatpickr-day.startRange.startRange,.flatpickr-day.endRange.startRange{border-radius:50px 0 0 50px}.flatpickr-day.selected.endRange,.flatpickr-day.startRange.endRange,.flatpickr-day.endRange.endRange{border-radius:0 50px 50px 0}.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)){-webkit-box-shadow:-10px 0 0 #569ff7;box-shadow:-10px 0 0 #569ff7}.flatpickr-day.selected.startRange.endRange,.flatpickr-day.startRange.startRange.endRange,.flatpickr-day.endRange.startRange.endRange{border-radius:50px}.flatpickr-day.inRange{border-radius:0;-webkit-box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-day.flatpickr-disabled,.flatpickr-day.flatpickr-disabled:hover,.flatpickr-day.prevMonthDay,.flatpickr-day.nextMonthDay,.flatpickr-day.notAllowed,.flatpickr-day.notAllowed.prevMonthDay,.flatpickr-day.notAllowed.nextMonthDay{color:rgba(57,57,57,0.3);background:transparent;border-color:transparent;cursor:default}.flatpickr-day.flatpickr-disabled,.flatpickr-day.flatpickr-disabled:hover{cursor:not-allowed;color:rgba(57,57,57,0.1)}.flatpickr-day.week.selected{border-radius:0;-webkit-box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7;box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7}.flatpickr-day.hidden{visibility:hidden}.rangeMode .flatpickr-day{margin-top:1px}.flatpickr-weekwrapper{float:left}.flatpickr-weekwrapper .flatpickr-weeks{padding:0 12px;-webkit-box-shadow:1px 0 0 #e6e6e6;box-shadow:1px 0 0 #e6e6e6}.flatpickr-weekwrapper .flatpickr-weekday{float:none;width:100%;line-height:28px}.flatpickr-weekwrapper span.flatpickr-day,.flatpickr-weekwrapper span.flatpickr-day:hover{display:block;width:100%;max-width:none;color:rgba(57,57,57,0.3);background:transparent;cursor:default;border:none}.flatpickr-innerContainer{display:block;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.flatpickr-rContainer{display:inline-block;padding:0;-webkit-box-sizing:border-box;box-sizing:border-box}.flatpickr-time{text-align:center;outline:0;display:block;height:0;line-height:40px;max-height:40px;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-time:after{content:\"\";display:table;clear:both}.flatpickr-time .numInputWrapper{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;width:40%;height:40px;float:left}.flatpickr-time .numInputWrapper span.arrowUp:after{border-bottom-color:#393939}.flatpickr-time .numInputWrapper span.arrowDown:after{border-top-color:#393939}.flatpickr-time.hasSeconds .numInputWrapper{width:26%}.flatpickr-time.time24hr .numInputWrapper{width:49%}.flatpickr-time input{background:transparent;-webkit-box-shadow:none;box-shadow:none;border:0;border-radius:0;text-align:center;margin:0;padding:0;height:inherit;line-height:inherit;color:#393939;font-size:14px;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}.flatpickr-time input.flatpickr-hour{font-weight:bold}.flatpickr-time input.flatpickr-minute,.flatpickr-time input.flatpickr-second{font-weight:400}.flatpickr-time input:focus{outline:0;border:0}.flatpickr-time .flatpickr-time-separator,.flatpickr-time .flatpickr-am-pm{height:inherit;float:left;line-height:inherit;color:#393939;font-weight:bold;width:2%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center}.flatpickr-time .flatpickr-am-pm{outline:0;width:18%;cursor:pointer;text-align:center;font-weight:400}.flatpickr-time input:hover,.flatpickr-time .flatpickr-am-pm:hover,.flatpickr-time input:focus,.flatpickr-time .flatpickr-am-pm:focus{background:#eee}.flatpickr-input[readonly]{cursor:pointer}@-webkit-keyframes fpFadeInDown{from{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}}@keyframes fpFadeInDown{from{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}}";
styleInject(css_248z$2);

var StyledForm = styled.div.withConfig({
  displayName: "ContactForm__StyledForm",
  componentId: "nri3lm-0"
})(["background-color:", ";padding:38px 20px 84px;@media (min-width:768px){padding:61px 6.9% 136px;}h2,h4,p,li{color:white;}h2,p,ul,ol{max-width:816px;margin-left:auto;margin-right:auto;}h2{text-align:center;@media (min-width:768px){margin-bottom:35px;}}h4{margin:42px 0 24px;@media (min-width:768px){margin:42px 17px 24px;}}form{margin-top:34px;max-width:850px;margin:34px auto 0;@media (min-width:768px){margin-top:76px;display:flex;flex-wrap:wrap;align-items:flex-end;}}label{> span{display:block;color:white;font-family:proxima-nova,sans-serif;font-size:16px;font-weight:700;text-transform:uppercase;span{font-family:proxima-nova-condensed,sans-serif;font-size:12px;font-weight:400;margin-left:8px;}}}.form-group{margin-bottom:22px;@media (min-width:768px){width:calc(50% - 34px);margin-left:17px;margin-right:17px;flex:1 0 auto;&--half{width:calc(50% - 17px);}&--thirds{width:calc(33.333% - 22.6px);}}}.full-name,.address-fields{@media (min-width:768px){display:flex;}> label{position:absolute;left:-99999px;}}h4,.dropdown-list,.full-name,.address-fields,.text-area,hr,.submit-button,.checkboxes,.radio-buttons,.likert-scale{@media (min-width:768px){width:calc(100% - 34px);flex:0 0 auto;}}.address-fields{flex-wrap:wrap;@media (min-width:768px){width:100%;margin-left:0;margin-right:0;padding:0 17px;.form-group{width:100%;margin-left:0;margin-right:0;&--thirds{width:calc(33.333% - 22px);flex:0 0 auto;&:nth-last-child(2){margin:0 33px;}}}}}input,textarea,select{width:100%;margin-top:4px;height:48px;background-color:", ";border:2px solid ", ";border-radius:4px;color:white;font-family:proxima-nova,sans-serif;font-weight:400;font-size:18px;padding:0 14px;&::placeholder{color:white;opacity:0.65;}}.file-field{input{background:none;border:0;padding:12px 0 0;}}.dropdown-list{position:relative;&::after{content:'';pointer-events:none;width:24px;height:13px;background-image:url('", "');background-repeat:no-repeat;background-size:contain;position:absolute;bottom:16px;right:12px;}}select{appearance:none;padding-right:42px;}textarea{height:119px;padding:14px;}.checkboxes,.radio-buttons,.likert-scale{margin-bottom:32px;.checkbox,.radio{display:block;position:relative;margin:18px 0;input{width:1px;height:1px;position:absolute;left:-99999px;}span{padding-left:38px;position:relative;&::before{content:'';width:28px;height:28px;background-color:", ";border:2px solid ", ";border-radius:4px;position:absolute;top:-3px;left:0;}&::after{width:16px;height:16px;position:absolute;}}}.checkbox{input:checked + span::after{content:'\xD7';}span{&::after{top:6px;left:2px;font-size:48px;line-height:0.2;}}}.radio{input:checked + span::after{content:'';}span{&::before{border-radius:50%;}&::after{background-color:white;border-radius:50%;top:3px;left:6px;}}}}.likert-scale{.options{margin-top:12px;position:relative;padding:2px 0;@media (min-width:768px){display:flex;justify-content:space-around;padding:0;}&::before{content:'';width:2px;height:100%;background-color:", ";position:absolute;top:0;left:13px;@media (min-width:768px){width:100%;height:2px;top:13px;left:0;}}}.radio{position:relative;@media (min-width:768px){margin:0;text-align:center;padding:34px 6px 0;}span{@media (min-width:768px){padding:0;position:static;}&::before{@media (min-width:768px){top:0;left:calc(50% - 14px);}}&::after{@media (min-width:768px){top:6px;left:calc(50% - 8px);}}}}}hr{margin-bottom:36px;border:0;border-top:2px solid ", ";}.help-text{display:block;font-size:14px;font-family:proxima-nova,serif;font-weight:400;text-transform:none;margin:4px 0;color:white;}.submit-button{text-align:center;margin-top:42px;@media (min-width:768px){margin-top:62px;}}button[type='submit']{background:none;border-radius:2px;font-family:proxima-nova,sans-serif;font-weight:800;font-size:20px;line-height:1;letter-spacing:0.47px;text-transform:uppercase;padding:15px 70px 14px;border:4px solid white;color:white;transition:opacity 0.2s ease-out;cursor:pointer;&:hover,&:focus{opacity:0.65;}}.alert-box.success{max-width:816px;margin-left:auto;margin-right:auto;font-size:24px;color:white;}"], function (props) {
  return props.color;
}, function (props) {
  return props.color === '#373A67' ? '#484B7A' : getSecondaryColor(props.color);
}, function (props) {
  return props.color === '#373A67' ? '#666994' : getTertiaryColor(props.color);
}, dropdown, function (props) {
  return getSecondaryColor(props.color);
}, function (props) {
  return getTertiaryColor(props.color);
}, function (props) {
  return getTertiaryColor(props.color);
}, function (props) {
  return getTertiaryColor(props.color);
});

var ContactForm = function ContactForm(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#373A67' : _ref$color,
      heading = _ref.heading,
      copy = _ref.copy,
      form = _ref.form;
  var context = useContext(SiteContext);
  var formRef = useRef(null);
  useEffect(function () {
    var formSubmit = function formSubmit(event) {
      event.preventDefault();
      var form = formRef.current.querySelector('form');
      var data = new FormData(form);
      var req = new XMLHttpRequest();

      req.onreadystatechange = function (event) {
        if (event.target.response) {
          var response = JSON.parse(event.target.response);
          formRef.current.innerHTML = response.payload;
        }
      };

      req.open('POST', form.getAttribute('action'));
      req.send(data);
    };

    if (formRef.current) {
      var _form = formRef.current.querySelector('form');

      if (_form) {
        _form.setAttribute('action', "".concat(context.root).concat(_form.getAttribute('action')));

        _form.addEventListener('submit', formSubmit);

        var dateFields = Array.from(_form.querySelectorAll('.date-field input[type="text"]'));
        dateFields.forEach(function (field) {
          flatpickr(field, {
            dateFormat: 'F j, Y'
          });
        });
        var timeFields = Array.from(_form.querySelectorAll('.time-field input[type="text"]'));
        timeFields.forEach(function (field) {
          flatpickr(field, {
            dateFormat: 'h:i K',
            noCalendar: true,
            enableTime: true
          });
        });
      }
    }

    return function () {
      if (formRef.current) {
        formRef.current.querySelector('form').removeEventListener('submit', formSubmit);
      }
    };
  }, [formRef]);
  return form ? /*#__PURE__*/React__default.createElement(StyledForm, {
    color: color
  }, heading && /*#__PURE__*/React__default.createElement("h2", null, heading), copy && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: formRef,
    dangerouslySetInnerHTML: {
      __html: form
    }
  })) : null;
};

var StyledDivider = styled.div.withConfig({
  displayName: "Divider__StyledDivider",
  componentId: "sc-6ixk1y-0"
})(["padding:32px 20px;@media (min-width:768px){padding:32px 6.9%;}& hr{border-top:2px solid ", ";}"], function (props) {
  return getLightColor(props.color);
});

var Divider = function Divider(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default.createElement(StyledDivider, {
    color: color
  }, /*#__PURE__*/React__default.createElement("hr", null));
};

/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */

/* eslint-disable no-param-reassign */
function isObject$2(obj) {
  return obj !== null && _typeof(obj) === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend$2(target, src) {
  if (target === void 0) {
    target = {};
  }

  if (src === void 0) {
    src = {};
  }

  Object.keys(src).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
      extend$2(target[key], src[key]);
    }
  });
}

var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ''
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  var doc = typeof document !== 'undefined' ? document : {};
  extend$2(doc, ssrDocument);
  return doc;
}

var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return '';
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }
};

function getWindow() {
  var win = typeof window !== 'undefined' ? window : {};
  extend$2(win, ssrWindow);
  return win;
}

/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
/* eslint-disable no-proto */


function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inheritsLoose(Dom7, _Array);

  function Dom7(items) {
    var _this;

    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
    makeReactive(_assertThisInitialized(_this));
    return _this;
  }

  return Dom7;
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat(arr) {
  if (arr === void 0) {
    arr = [];
  }

  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}

function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}

function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = getWindow();
  var document = getDocument();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

function addClass() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, classNames);
  });
  return this;
}

function removeClass() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
  });
  return this;
}

function toggleClass() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}

function hasClass() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition$1(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
  }

  return this;
}

function on() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function trigger() {
  var window = getWindow();

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd$1(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset$1() {
  if (this.length > 0) {
    var window = getWindow();
    var document = getDocument();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window ? window.scrollY : el.scrollTop;
    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function styles() {
  var window = getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  var window = getWindow();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  var window = getWindow();
  var document = getDocument();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append() {
  var newChild;
  var document = getDocument();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  var document = getDocument();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function next$1(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev$1(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

var Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition$1,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd$1,
  outerWidth: outerWidth,
  outerHeight: outerHeight,
  styles: styles,
  offset: offset$1,
  css: css,
  each: each,
  html: html,
  text: text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next$1,
  nextAll: nextAll,
  prev: prev$1,
  prevAll: prevAll,
  parent: parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});

function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now$1() {
  return Date.now();
}

function getComputedStyle$1(el) {
  var window = getWindow();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var window = getWindow();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle$1(el);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject$1(o) {
  return _typeof(o) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend$1() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype']; // eslint-disable-next-line

  var HTMLElement = typeof window !== 'undefined' ? window.HTMLElement : undefined;

  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !(HTMLElement && nextSource instanceof HTMLElement)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function bindModuleMethods(instance, obj) {
  Object.keys(obj).forEach(function (key) {
    if (isObject$1(obj[key])) {
      Object.keys(obj[key]).forEach(function (subKey) {
        if (typeof obj[key][subKey] === 'function') {
          obj[key][subKey] = obj[key][subKey].bind(instance);
        }
      });
    }

    instance[key] = obj[key];
  });
}

function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return "." + classes.trim().replace(/([\.:\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.');
}

function createElementIfNotDefined($container, params, createElements, checkProps) {
  var document = getDocument();

  if (createElements) {
    Object.keys(checkProps).forEach(function (key) {
      if (!params[key] && params.auto === true) {
        var element = document.createElement('div');
        element.className = checkProps[key];
        $container.append(element);
        params[key] = element;
      }
    });
  }

  return params;
}

var support;

function calcSupport() {
  var window = getWindow();
  var document = getDocument();
  return {
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
    observer: function checkObserver() {
      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
    }(),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}

var device;

function calcDevice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;

  var support = getSupport();
  var window = getWindow();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!device) {
    device = calcDevice(overrides);
  }

  return device;
}

var browser;

function calcBrowser() {
  var window = getWindow();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isEdge: !!window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}

var supportsResizeObserver = function supportsResizeObserver() {
  var window = getWindow();
  return typeof window.ResizeObserver !== 'undefined';
};

var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    extend$1(swiper, {
      resize: {
        observer: null,
        createObserver: function createObserver() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.resize.observer = new ResizeObserver(function (entries) {
            var width = swiper.width,
                height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function (_ref) {
              var contentBoxSize = _ref.contentBoxSize,
                  contentRect = _ref.contentRect,
                  target = _ref.target;
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });

            if (newWidth !== width || newHeight !== height) {
              swiper.resize.resizeHandler();
            }
          });
          swiper.resize.observer.observe(swiper.el);
        },
        removeObserver: function removeObserver() {
          if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
            swiper.resize.observer.unobserve(swiper.el);
            swiper.resize.observer = null;
          }
        },
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },
  on: {
    init: function init(swiper) {
      var window = getWindow();

      if (swiper.params.resizeObserver && supportsResizeObserver()) {
        swiper.resize.createObserver();
        return;
      } // Emit resize


      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy(swiper) {
      var window = getWindow();
      swiper.resize.removeObserver();
      window.removeEventListener('resize', swiper.resize.resizeHandler);
      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
};

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}
var Observer = {
  attach: function attach(target, options) {
    if (options === void 0) {
      options = {};
    }

    var window = getWindow();
    var swiper = this;
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!swiper.support.observer || !swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    } // Observe container


    swiper.observer.attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    swiper.observer.attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};
var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      observer: _extends$7({}, Observer, {
        observers: []
      })
    });
  },
  on: {
    init: function init(swiper) {
      swiper.observer.init();
    },
    destroy: function destroy(swiper) {
      swiper.observer.destroy();
    }
  }
};

var modular = {
  useParams: function useParams(instanceParams) {
    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName]; // Extend params

      if (module.params) {
        extend$1(instanceParams, module.params);
      }
    });
  },
  useModules: function useModules(modulesParams) {
    if (modulesParams === void 0) {
      modulesParams = {};
    }

    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      } // Module create callback


      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  }
};

/* eslint-disable no-underscore-dangle */
var eventsEmitter = {
  on: function on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(data));
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  extend$1(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children("." + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: ''
  });
  var slidesNumberEvenToRows;

  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }

    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  } // Calc slides


  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;

      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;

        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;

          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }

      slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = slide[0],
              clientWidth = _slide$.clientWidth,
              offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: swiper.virtualSize + params.spaceBetween + "px"
    });
  }

  if (params.setWrapperSize) {
    var _$wrapperEl$css;

    $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
  }

  if (params.slidesPerColumn > 1) {
    var _$wrapperEl$css2;

    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

    if (params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid = newSlidesGrid;
    }
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    newSlidesGrid = [];

    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var _slides$filter$css;

    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  extend$1(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
  }

  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  extend$1(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  extend$1(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = $(e.target).closest("." + params.slideClass)[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};

function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }

    swiper.emit('slideChangeTransitionStart');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }

    swiper.emit('slideChangeTransitionEnd');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + _typeof(index) + "] given.");
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGird = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGird) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = -translate;

    if (rtl) {
      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
    }

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      enabled = swiper.enabled;
  if (!enabled) return swiper;
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach(function (snap) {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }

  var prevIndex;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
      nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
  var slides = $wrapperEl.children("." + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = $(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }

      slides = $wrapperEl.children("." + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    var slide = $(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < appendSlides.length; _i += 1) {
    $wrapperEl.append($(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
    $wrapperEl.prepend($(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (_typeof(slides) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }
}

function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (_typeof(slides) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (_typeof(slides) === 'object' && 'length' in slides) {
    for (var _i = 0; _i < slides.length; _i += 1) {
      if (slides[_i]) $wrapperEl.append(slides[_i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
    $wrapperEl.append(slidesBuffer[_i2]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (_typeof(slidesIndexes) === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};

function onTouchStart(event) {
  var swiper = this;
  var document = getDocument();
  var window = getWindow();
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root componenet

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = $(event.path[0]);
  }

  if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass)[0]) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  extend$1(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now$1();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) preventDefault = false;

    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var document = getDocument();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      extend$1(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now$1();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now$1()
    });
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = now$1();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now$1();
  nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now$1() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeModeMomentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(function () {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      swiper.emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

var dummyEventAttached = false;

function dummyEventListener() {}

function attachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
        passive: false,
        capture: capture
      } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }

      if (!dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      document.addEventListener('mousemove', swiper.onTouchMove, capture);
      document.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper.on('observerUpdate', onResize, true);
  }
}

function detachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  } // Resize handler


  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

var events = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

  if (breakpointOnlyParams) {
    ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
      var paramValue = breakpointOnlyParams[param];
      if (typeof paramValue === 'undefined') return;

      if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
        breakpointOnlyParams[param] = 'auto';
      } else if (param === 'slidesPerView') {
        breakpointOnlyParams[param] = parseFloat(paramValue);
      } else {
        breakpointOnlyParams[param] = parseInt(paramValue, 10);
      }
    });
  }

  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = params.slidesPerColumn > 1;
  var isMultiRow = breakpointParams.slidesPerColumn > 1;
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(params.containerModifierClass + "multirow");

    if (breakpointParams.slidesPerColumnFill === 'column') {
      $el.addClass(params.containerModifierClass + "multirow-column");
    }

    swiper.emitContainerClasses();
  }

  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  extend$1(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  extend$1(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = getWindow();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia("(min-width: " + value + "px)").matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};

function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (_typeof(item) === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device,
      support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': support.pointerEvents && !support.touch
  }, {
    'free-mode': params.freeMode
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'multirow': params.slidesPerColumn > 1
  }, {
    'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }], params.containerModifierClass);
  classNames.push.apply(classNames, suffixes);
  $el.addClass([].concat(classNames).join(' '));
  swiper.emitContainerClasses();
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = getWindow();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var params = swiper.params;
  var wasLocked = swiper.isLocked;
  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked; // events

  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

var checkOverflow$1 = {
  checkOverflow: checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: false,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-container-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var prototypes = {
  modular: modular,
  eventsEmitter: eventsEmitter,
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};
var extendedDefaults = {};

var Swiper$1 = /*#__PURE__*/function () {
  function Swiper() {
    var el;
    var params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && $(params.el).length > 1) {
      var swipers = [];
      $(params.el).each(function (containerEl) {
        var newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];

    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }

    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];

      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (_typeof(moduleParams) !== 'object' || moduleParams === null) return;

        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
          params[moduleParamName] = {
            auto: true
          };
        }

        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }

        if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }

        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
      }
    }); // Extend defaults with modules params

    var swiperParams = extend$1({}, defaults);
    swiper.useParams(swiperParams); // Extend defaults with passed params

    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = $; // Extend Swiper

    extend$1(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];

        if (swiper.support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }

        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now$1(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }); // Install Modules

    swiper.useModules();
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  var _proto = Swiper.prototype;

  _proto.enable = function enable() {
    var swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  };

  _proto.disable = function disable() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  };

  _proto.setProgress = function setProgress(progress, speed) {
    var swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    var current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  };

  _proto.emitContainerClasses = function emitContainerClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var classes = swiper.el.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', classes.join(' '));
  };

  _proto.getSlideClasses = function getSlideClasses(slideEl) {
    var swiper = this;
    return slideEl.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  };

  _proto.emitSlidesClasses = function emitSlidesClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var updates = [];
    swiper.slides.each(function (slideEl) {
      var classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl: slideEl,
        classNames: classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  };

  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
    var swiper = this;
    var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
    var spv = 1;

    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;

      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
        if (slides[_i] && !breakLoop) {
          slideSize += slides[_i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }

    return spv;
  };

  _proto.update = function update() {
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    var translated;

    if (swiper.params.freeMode) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  };

  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }

    var swiper = this;
    var currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(function (slideEl) {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  };

  _proto.mount = function mount(el) {
    var swiper = this;
    if (swiper.mounted) return true; // Find el

    var $el = $(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    var getWrapperSelector = function getWrapperSelector() {
      return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
    };

    var getWrapper = function getWrapper() {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        var res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = function (options) {
          return $el.children(options);
        };

        return res;
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    var $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      var document = getDocument();
      var wrapper = document.createElement('div');
      $wrapperEl = $(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children("." + swiper.params.slideClass).each(function (slideEl) {
        $wrapperEl.append(slideEl);
      });
    }

    extend$1(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  };

  _proto.init = function init(el) {
    var swiper = this;
    if (swiper.initialized) return swiper;
    var mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  };

  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }

    if (cleanStyles === void 0) {
      cleanStyles = true;
    }

    var swiper = this;
    var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  };

  Swiper.extendDefaults = function extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  };

  Swiper.installModule = function installModule(module) {
    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now$1();
    Swiper.prototype.modules[name] = module;
  };

  Swiper.use = function use(module) {
    if (Array.isArray(module)) {
      module.forEach(function (m) {
        return Swiper.installModule(m);
      });
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  };

  _createClass(Swiper, null, [{
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer$1]);

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}
var Navigation$1 = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = $(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = $(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    extend$1(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
var Navigation$2 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      navigation: _extends$6({}, Navigation$1)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
};

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}
var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = $(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = createElementIfNotDefined(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = $(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    extend$1(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }
};
var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      pagination: _extends$5({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
};

function isObject(o) {
  return _typeof(o) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }

  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }

  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }

  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }

  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}

/* underscore in name -> watch for changes */
var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

// eslint-disable-next-line

function getParams(obj) {
  if (obj === void 0) {
    obj = {};
  }

  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  extend(params, Swiper$1.defaults);
  extend(params, Swiper$1.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = paramsList.map(function (key) {
    return key.replace(/_/, '');
  });
  Object.keys(obj).forEach(function (key) {
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
}

// eslint-disable-next-line

function initSwiper(swiperParams) {
  return new Swiper$1(swiperParams);
}

function mountSwiper(_ref, swiperParams) {
  var el = _ref.el,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      paginationEl = _ref.paginationEl,
      scrollbarEl = _ref.scrollbarEl,
      swiper = _ref.swiper;

  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}

function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    var breakpoint = Swiper$1.prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
}

function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      key: child.key + "-duplicate-" + index + "-" + position,
      className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/React__default.createElement("div", {
          className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  modifiedSlides.forEach(function (child, index) {
    if (index < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index, 'prepend'));
    }

    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index, 'append'));
    }
  });

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [].concat(prependSlides, modifiedSlides, appendSlides);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren) {
  var keys = [];
  if (!oldParams) return keys;

  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  var oldChildrenKeys = oldChildren.map(function (child) {
    return child.key;
  });
  var childrenKeys = children.map(function (child) {
    return child.key;
  });
  if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
  if (oldChildren.length !== children.length) addKey('children');
  var watchParams = paramsList.filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

function processChildren(c) {
  var slides = [];
  React__default.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}

function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React__default.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}

function updateSwiper(_ref) {
  var swiper = _ref.swiper,
      slides = _ref.slides,
      passedParams = _ref.passedParams,
      changedParams = _ref.changedParams,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      scrollbarEl = _ref.scrollbarEl,
      paginationEl = _ref.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
      pagination = swiper.pagination,
      navigation = swiper.navigation,
      scrollbar = swiper.scrollbar,
      virtual = swiper.virtual,
      thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(function (key) {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}

function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
}

function renderVirtual(swiper, slides, virtualData) {
  var _ref;

  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
    top: virtualData.offset + "px"
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}

var _excluded$2 = ["className", "tag", "wrapperTag", "children", "onSwiper"];

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
var Swiper = /*#__PURE__*/forwardRef(function (_temp, externalElRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$wrapperTag = _ref.wrapperTag,
      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
      children = _ref.children,
      onSwiper = _ref.onSwiper,
      rest = _objectWithoutPropertiesLoose$1(_ref, _excluded$2);

  var eventsAssigned = false;

  var _useState = useState('swiper-container'),
      containerClasses = _useState[0],
      setContainerClasses = _useState[1];

  var _useState2 = useState(null),
      virtualData = _useState2[0],
      setVirtualData = _useState2[1];

  var _useState3 = useState(false),
      breakpointChanged = _useState3[0],
      setBreakpointChanged = _useState3[1];

  var initializedRef = useRef(false);
  var swiperElRef = useRef(null);
  var swiperRef = useRef(null);
  var oldPassedParamsRef = useRef(null);
  var oldSlides = useRef(null);
  var nextElRef = useRef(null);
  var prevElRef = useRef(null);
  var paginationElRef = useRef(null);
  var scrollbarElRef = useRef(null);

  var _getParams = getParams(rest),
      swiperParams = _getParams.params,
      passedParams = _getParams.passedParams,
      restProps = _getParams.rest,
      events = _getParams.events;

  var _getChildren = getChildren(children),
      slides = _getChildren.slides,
      slots = _getChildren.slots;

  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });

  if (!swiperElRef.current) {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = initSwiper(swiperParams);

    swiperRef.current.loopCreate = function () {};

    swiperRef.current.loopDestroy = function () {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  useEffect(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  useEffect(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(function () {
    attachEvents();
    var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return function () {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(function () {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/React__default.createElement(Tag, _extends$4({
    ref: swiperElRef,
    className: uniqueClasses("" + containerClasses + (className ? " " + className : ''))
  }, restProps), slots['container-start'], needsNavigation(swiperParams) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React__default.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React__default.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), /*#__PURE__*/React__default.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
});
Swiper.displayName = 'Swiper';

var _excluded$1 = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
var SwiperSlide = /*#__PURE__*/forwardRef(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var slideElRef = useRef(null);

  var _useState = useState('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/React__default.createElement(Tag, _extends$3({
    ref: slideElRef,
    className: uniqueClasses("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/React__default.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';

var css_248z$1 = "/**\n * Swiper 6.7.5\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2021 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: July 1, 2021\n */\n\n@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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') format('woff');font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-container-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}.swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-container-pointer-events{touch-action:pan-y}.swiper-container-pointer-events.swiper-container-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-container-3d{perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}";
styleInject(css_248z$1);

var prev = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2219%22%20height%3D%2234%22%20viewBox%3D%220%200%2019%2034%22%3E%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke%3D%22%23FFF%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%224%22%20transform%3D%22translate%28-3.895%20-3.134%29%22%3E%20%20%20%20%3Cline%20x1%3D%225.915%22%20x2%3D%2220.769%22%20y1%3D%225.146%22%20y2%3D%2220%22%20transform%3D%22matrix%28-1%200%200%201%2026.684%200%29%22%2F%3E%20%20%20%20%3Cline%20x1%3D%225.915%22%20x2%3D%2220.769%22%20y1%3D%2234.987%22%20y2%3D%2220.133%22%20transform%3D%22matrix%28-1%200%200%201%2026.684%200%29%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _g$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgIconNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 34
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.721 2.012l14.854 14.854M2.721 31.853l14.854-14.854"
  }))));
}

var next = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2234%22%20viewBox%3D%220%200%2020%2034%22%3E%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke%3D%22%23FFF%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2023.49%20-3.134%29%22%3E%20%20%20%20%3Cline%20x1%3D%225.915%22%20x2%3D%2220.769%22%20y1%3D%225.146%22%20y2%3D%2220%22%20transform%3D%22matrix%28-1%200%200%201%2026.684%200%29%22%2F%3E%20%20%20%20%3Cline%20x1%3D%225.915%22%20x2%3D%2220.769%22%20y1%3D%2234.987%22%20y2%3D%2220.133%22%20transform%3D%22matrix%28-1%200%200%201%2026.684%200%29%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

Swiper$1.use([Navigation$2, Pagination$1]);
var StyledGrantImpacts = styled.div.withConfig({
  displayName: "GrantImpacts__StyledGrantImpacts",
  componentId: "cs0xms-0"
})(["padding:23px 0 28px;position:relative;@media (min-width:768px){padding:48px 0 68px;}h2{text-align:center;}.swiper-container{padding:12px 20px 49px;@media (min-width:768px){padding:0 0 49px;}}.swiper-slide{height:auto;@media (max-width:767px){width:88% !important;}}.swiper-pagination{width:100%;position:absolute;bottom:0;left:0;display:flex;justify-content:center;@media (min-width:768px){bottom:-8px;}.swiper-pagination-bullet{display:block;width:12px;height:12px;background-color:#d8d8d8;border-radius:50%;margin:0 7px 14px;&-active{background-color:black;}}}.swiper-button-prev,.swiper-button-next{display:none;@media (min-width:768px){display:block;width:24px;height:42px;position:absolute;top:calc(50% - 10px);transform:translateY(-50%);transition:opacity 0.2s ease-out;z-index:2;cursor:pointer;background-color:", ";&:hover,&:focus{opacity:0.65;}&.swiper-button-disabled{opacity:0;}}}.swiper-button-prev{left:calc(3.45vw - 12px);mask:url(\"", "\") no-repeat center;}.swiper-button-next{right:calc(3.45vw - 12px);mask:url(\"", "\") no-repeat center;}&.no-image{h2{text-align:left;padding-left:20px;@media (min-width:768px){padding-left:6.9%;margin-bottom:12px;}}> div > div{padding-left:20px;@media (min-width:768px){padding-left:0;}}}"], function (props) {
  return props.color;
}, prev, next);
var Impact = styled.div.withConfig({
  displayName: "GrantImpacts__Impact",
  componentId: "cs0xms-1"
})(["width:100%;display:flex;background-color:", ";box-sizing:border-box;@media (max-width:767px){display:block !important;height:100% !important;position:relative !important;left:0 !important;}@media (min-width:768px){background:none;align-items:flex-start;padding:0 6.9%;}"], function (props) {
  return getLightColor(props.color);
});
var ImpactImage = styled.div.withConfig({
  displayName: "GrantImpacts__ImpactImage",
  componentId: "cs0xms-2"
})(["position:relative;background-color:black;@media (min-width:768px){width:50%;flex:0 0 auto;}&::before{content:\"\";display:block;padding-top:66%;}> img,> video,> iframe{width:100%;height:100%;position:absolute;top:0;left:0;}> img{object-fit:cover;}"]);
var ImpactCopy = styled.div.withConfig({
  displayName: "GrantImpacts__ImpactCopy",
  componentId: "cs0xms-3"
})(["text-align:left;padding:11px 12px 3px;@media (min-width:768px){width:50%;flex:0 0 auto;padding:42px 0 18px 42px;}@media (min-width:960px){padding:42px 0 28px 60px;}h3{font-family:cambria,serif;font-size:28px;font-weight:400;line-height:1;@media (min-width:600px){font-size:36px;}@media (min-width:960px){font-size:42px;}@media (min-width:1400px){font-size:54px;}@media (min-width:1600px){font-size:68px;}}h5{font-family:proxima-nova-condensed,sans-serif;font-weight:700;font-size:20px;text-transform:none;line-height:1.08;margin-bottom:3px;@media (min-width:600px){font-size:24px;}}"]);

var GrantImpacts = function GrantImpacts(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#1D2042" : _ref$color,
      heading = _ref.heading,
      impacts = _ref.impacts,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? "" : _ref$root;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2);
      _useState2[0];
      var setActiveIndex = _useState2[1];

  return impacts ? /*#__PURE__*/React__default.createElement(StyledGrantImpacts, {
    color: color
  }, heading && /*#__PURE__*/React__default.createElement("h2", null, heading), /*#__PURE__*/React__default.createElement(Swiper, {
    slidesPerView: "auto",
    spaceBetween: 18,
    navigation: true,
    pagination: {
      clickable: true
    },
    onSlideChange: function onSlideChange(e) {
      return setActiveIndex(e.activeIndex);
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  }, impacts.map(function (impact, index) {
    return /*#__PURE__*/React__default.createElement(SwiperSlide, {
      key: index
    }, /*#__PURE__*/React__default.createElement(Impact, {
      color: color
    }, impact.type === "video" ? /*#__PURE__*/React__default.createElement(ImpactImage, null, impact.video.data && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, impact.video.data.video_id ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, impact.video.data.video_type === "youtube" && /*#__PURE__*/React__default.createElement("iframe", {
      src: "https://www.youtube.com/embed/".concat(impact.video.data.video_id, "?rel=0&mute=0&showinfo=0&controls=1"),
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true
    }), impact.video.data.video_type === "vimeo" && /*#__PURE__*/React__default.createElement("iframe", {
      src: "https://player.vimeo.com/video/".concat(impact.video.data.video_id, "?loop=0&title=0&byline=0&portrait=0"),
      allow: "autoplay; fullscreen"
    })) : /*#__PURE__*/React__default.createElement("video", {
      controls: true
    }, /*#__PURE__*/React__default.createElement("source", {
      src: impact.video.data.image,
      type: "video/mp4"
    })))) : /*#__PURE__*/React__default.createElement(ImpactImage, null, impact.image && /*#__PURE__*/React__default.createElement("img", {
      src: "".concat(root).concat(impact.image),
      alt: impact.image_alt
    }), impact.photo_credit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, impact.photo_credit)), /*#__PURE__*/React__default.createElement(ImpactCopy, null, impact.title && /*#__PURE__*/React__default.createElement("h3", null, impact.title), impact.grantee && /*#__PURE__*/React__default.createElement("h5", null, impact.grantee), impact.description && /*#__PURE__*/React__default.createElement("p", null, impact.description))));
  }))) : null;
};

GrantImpacts.propTypes = {
  heading: PropTypes.string,
  impacts: PropTypes.array
};

var FeaturedGrant = function FeaturedGrant(_ref) {
  var color = _ref.color,
      image = _ref.image,
      alt = _ref.alt,
      credit = _ref.credit,
      name = _ref.name,
      purpose = _ref.purpose,
      amount = _ref.amount,
      year = _ref.year,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? '' : _ref$root;
  return name ? /*#__PURE__*/React__default.createElement(StyledGrantImpacts, {
    className: "".concat(!image ? 'no-image' : '')
  }, /*#__PURE__*/React__default.createElement("h2", null, "Featured Grantee"), /*#__PURE__*/React__default.createElement(Impact, {
    color: color
  }, image && /*#__PURE__*/React__default.createElement(ImpactImage, null, /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(root).concat(image),
    alt: alt
  }), credit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, credit)), /*#__PURE__*/React__default.createElement(ImpactCopy, null, /*#__PURE__*/React__default.createElement("h3", null, name), (amount || year) && /*#__PURE__*/React__default.createElement("h5", null, year, year && amount && ' | ', amount), purpose && /*#__PURE__*/React__default.createElement("p", null, purpose)))) : null;
};

var StyledQuoteContainer = styled.section.withConfig({
  displayName: "FullWidthQuote__StyledQuoteContainer",
  componentId: "sc-14dv15r-0"
})(["padding:50px 20px;@media (min-width:768px){padding:50px 6.9%;}"]);
var StyledInnerContainer = styled.div.withConfig({
  displayName: "FullWidthQuote__StyledInnerContainer",
  componentId: "sc-14dv15r-1"
})(["@media (min-width:768px){max-width:800px;}"]);
var StyledQuote = styled.p.withConfig({
  displayName: "FullWidthQuote__StyledQuote",
  componentId: "sc-14dv15r-2"
})(["color:", ";font-size:1.5rem;font-style:italic;line-height:1.2;@media (min-width:768px){font-size:3rem;}"], function (props) {
  return props.color;
});
var StyledAuthor = styled.h5.withConfig({
  displayName: "FullWidthQuote__StyledAuthor",
  componentId: "sc-14dv15r-3"
})(["font-weight:800;margin-bottom:2px;"]);
var StyledLine2 = styled.h6.withConfig({
  displayName: "FullWidthQuote__StyledLine2",
  componentId: "sc-14dv15r-4"
})(["font-size:0.875rem;text-transform:uppercase;margin:0;color:", ";"], function (props) {
  return props.color;
});

var FullWidthQuote = function FullWidthQuote(_ref) {
  var color = _ref.color,
      quote = _ref.quote,
      authorLine1 = _ref.authorLine1,
      authorLine2 = _ref.authorLine2;
  return /*#__PURE__*/React__default.createElement(StyledQuoteContainer, null, /*#__PURE__*/React__default.createElement(StyledInnerContainer, null, /*#__PURE__*/React__default.createElement(StyledQuote, {
    color: color
  }, quote), authorLine1 && /*#__PURE__*/React__default.createElement(StyledAuthor, null, authorLine1), authorLine2 && /*#__PURE__*/React__default.createElement(StyledLine2, {
    color: color
  }, authorLine2)));
};

var _g$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgIconArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 22
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.312 10.981H28.5M18.697.678l10.606 10.607M18.697 21.285l10.606-10.607"
  }))));
}

var StyledFoundationLinks = styled.div.withConfig({
  displayName: "FoundationLinks__StyledFoundationLinks",
  componentId: "sc-1qjh0gd-0"
})(["padding:50px 20px 23px;@media (min-width:600px){background-color:#eeeff2;}@media (min-width:768px){padding:50px 6.9% 62px;}> div:first-child{max-width:750px;}"]);
var Foundations = styled.div.withConfig({
  displayName: "FoundationLinks__Foundations",
  componentId: "sc-1qjh0gd-1"
})(["margin-top:33px;@media (min-width:600px){display:grid;grid-template-columns:repeat(2,1fr);grid-gap:24px 20px;margin-top:50px;}@media (min-width:800px){grid-template-columns:repeat(3,1fr);margin-top:102px;}@media (min-width:1200px){grid-template-columns:repeat(4,1fr);}@media (min-width:1440px){grid-template-columns:repeat(5,1fr);}"]);
var Foundation = styled.div.withConfig({
  displayName: "FoundationLinks__Foundation",
  componentId: "sc-1qjh0gd-2"
})(["position:relative;margin-bottom:17px;min-height:113px;.collapse-css-transition{@media (min-width:600px){width:100%;position:absolute;top:0;left:0;}}"]);
var FoundationIcon = styled.div.withConfig({
  displayName: "FoundationLinks__FoundationIcon",
  componentId: "sc-1qjh0gd-3"
})(["background-color:rgba(", ",0.9);width:50px;height:50px;position:absolute;top:0;left:0;padding:7px;@media (min-width:600px){width:96px;height:96px;padding:14px;}img{filter:brightness(0) invert(1);}"], function (props) {
  return convertHexToRGB(props.color, true);
});
var FoundationCard = styled.div.withConfig({
  displayName: "FoundationLinks__FoundationCard",
  componentId: "sc-1qjh0gd-4"
})(["background-color:#eeeff2;display:flex;@media (min-width:600px){flex-direction:column;background-color:white;position:relative;min-height:295px;}> h4{display:none;@media (min-width:600px){display:block;margin-top:auto;position:relative;color:white;margin-bottom:0;padding:32px 12px 17px;background-image:linear-gradient( 180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.84) 100% );}}"]);
var FoundationImage = styled.div.withConfig({
  displayName: "FoundationLinks__FoundationImage",
  componentId: "sc-1qjh0gd-5"
})(["width:113px;flex:0 0 auto;position:relative;@media (min-width:600px){width:100%;position:absolute;top:0;left:0;width:100%;height:100%;}&::before{content:\"\";display:block;padding-top:100%;@media (min-width:600px){display:none;}}img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;}"]);
var FoundationCities = styled.div.withConfig({
  displayName: "FoundationLinks__FoundationCities",
  componentId: "sc-1qjh0gd-6"
})(["padding:16px 12px;@media (min-width:600px){padding:12px 9px 10px;position:relative;background-color:white;}h4{color:#373a67;@media (min-width:600px){display:none;}}p{font-size:14px;font-family:proxima-nova-condensed,sans-serif;font-weight:500;text-transform:uppercase;color:#62668d;@media (min-width:600px){margin-bottom:0;}}"]);
var FoundationDescription = styled.div.withConfig({
  displayName: "FoundationLinks__FoundationDescription",
  componentId: "sc-1qjh0gd-7"
})(["background-color:", ";padding:24px 16px 28px;@media (min-width:600px){padding:97px 14px 11px;min-height:295px;}p{color:white;font-size:18px;margin-bottom:15px;}a{position:relative;padding-right:43px;color:white;font-family:proxima-nova,sans-serif;font-weight:800;font-size:18px;text-transform:uppercase;text-decoration:none;transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.65;}svg{position:absolute;top:50%;right:0;transform:translateY(-50%);}}"], function (props) {
  return props.color;
});

var FoundationLinks = function FoundationLinks(_ref) {
  var copy = _ref.copy,
      sites = _ref.sites,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? "" : _ref$root;

  var _useState = useState(sites),
      _useState2 = _slicedToArray(_useState, 2),
      foundations = _useState2[0],
      setFoundations = _useState2[1];

  var showDescription = function showDescription(index) {
    var updatedSites = _toConsumableArray(foundations);

    updatedSites[index].open = true;
    setFoundations(updatedSites);
  };

  var hideDescription = function hideDescription(index) {
    var updatedSites = _toConsumableArray(foundations);

    updatedSites[index].open = false;
    setFoundations(updatedSites);
  };

  var toggleDescription = function toggleDescription(index) {
    var updatedSites = _toConsumableArray(foundations);

    updatedSites[index].open = !updatedSites[index].open;
    setFoundations(updatedSites);
  };

  return /*#__PURE__*/React__default.createElement(StyledFoundationLinks, null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  }), /*#__PURE__*/React__default.createElement(Foundations, null, foundations.sort(function (a, b) {
    return a.name === "Henry L. Hillman Foundation" ? -1 : b.name === "Henry L. Hillman Foundation" ? 1 : a.name > b.name ? 1 : -1;
  }).map(function (site, index) {
    return /*#__PURE__*/React__default.createElement(Foundation, {
      key: index,
      onMouseEnter: function onMouseEnter() {
        return showDescription(index);
      },
      onMouseLeave: function onMouseLeave() {
        return hideDescription(index);
      },
      style: {
        zIndex: site.open ? 2 : 1
      }
    }, /*#__PURE__*/React__default.createElement(FoundationCard, {
      onClick: function onClick() {
        return toggleDescription(index);
      }
    }, /*#__PURE__*/React__default.createElement(FoundationImage, null, site.image && /*#__PURE__*/React__default.createElement("img", {
      src: "".concat(root).concat(site.image)
    })), /*#__PURE__*/React__default.createElement("h4", null, site.name), /*#__PURE__*/React__default.createElement(FoundationCities, null, /*#__PURE__*/React__default.createElement("h4", null, site.name), site.cities.length > 0 && /*#__PURE__*/React__default.createElement("p", null, site.cities.join(" • ")))), /*#__PURE__*/React__default.createElement(Collapse, {
      className: "collapse-css-transition",
      isOpen: site.open
    }, /*#__PURE__*/React__default.createElement(FoundationDescription, {
      color: site.color
    }, /*#__PURE__*/React__default.createElement("p", null, site.description), /*#__PURE__*/React__default.createElement("a", {
      href: site.url,
      target: "_blank",
      rel: "noreferrer"
    }, "Go to Website", /*#__PURE__*/React__default.createElement(SvgIconArrow, null)))), site.icon && /*#__PURE__*/React__default.createElement(FoundationIcon, {
      color: site.color
    }, /*#__PURE__*/React__default.createElement("img", {
      src: "".concat(root).concat(site.icon)
    })));
  })));
};

FoundationLinks.propTypes = {
  copy: PropTypes.string
};

Swiper$1.use([Navigation$2]);
var StyledGallery = styled.div.withConfig({
  displayName: "Gallery__StyledGallery",
  componentId: "sc-18kb9jw-0"
})(["padding:0 0 32px;.swiper-slide{width:80vw;position:relative;@media (min-width:768px){width:48vw;}div{position:relative;&::before{content:'';display:block;padding-top:59%;}}img{width:100%;height:100%;position:absolute;top:0;left:0;object-fit:cover;border-radius:4px;}p{font-family:proxima-nova-condensed,sans-serif;font-size:16px;color:#2f2f2f;margin:9px 0 0;@media (min-width:768px){font-size:18px;margin-top:19px;}}}.swiper-button-prev,.swiper-button-next{display:none;@media (min-width:768px){display:block;width:78px;height:78px;position:absolute;top:50%;transform:translateY(-50%);background-color:rgba(29,32,66,0.77);z-index:2;transition:background-color 0.2s ease-out;cursor:pointer;display:flex;align-items:center;padding-left:28px;&:hover,&:focus{background-color:rgba(29,32,66,1);}}&::before{content:'';display:block;width:28px;height:40px;background-repeat:no-repeat;background-size:contain;}}.swiper-button-prev{left:0;&::before{background-image:url('", "');}}.swiper-button-next{right:0;&::before{background-image:url('", "');}}"], prev, next);

var Gallery = function Gallery(_ref) {
  var slides = _ref.slides,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? '' : _ref$root;
  return slides ? /*#__PURE__*/React__default.createElement(StyledGallery, null, /*#__PURE__*/React__default.createElement(Swiper, {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 24,
    navigation: true,
    loop: true,
    speed: 500,
    breakpoints: {
      768: {
        spaceBetween: 100
      }
    }
  }, slides.map(function (slide, index) {
    return slide.image && /*#__PURE__*/React__default.createElement(SwiperSlide, {
      key: index
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
      src: "".concat(root).concat(slide.image),
      alt: slide.caption
    })), slide.caption && /*#__PURE__*/React__default.createElement("p", null, slide.caption));
  }))) : null;
};

Gallery.propTypes = {
  slides: PropTypes.array
};

var StyledImage = styled.div.withConfig({
  displayName: "Image__StyledImage",
  componentId: "sc-1g5yyux-0"
})(["padding:50px 20px 42px;@media (min-width:768px){padding:50px 6.9% 42px;}div{width:100%;position:relative;@media (min-width:768px){width:48vw;}img{display:block;max-width:100%;border-radius:4px;}}"]);

var Image = function Image(_ref) {
  var image = _ref.image,
      alt = _ref.alt,
      credit = _ref.credit,
      root = _ref.root;
  return image ? /*#__PURE__*/React__default.createElement(StyledImage, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(root).concat(image),
    alt: alt
  }), credit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, credit))) : null;
};

Image.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string,
  credit: PropTypes.string
};

var sharedLinkStyles$1 = css$1(["display:inline-block;color:#1d2042;font-family:proxima-nova-condensed,sans-serif;font-weight:600;font-size:36px;text-decoration:none;position:relative;padding-top:16px;transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.65;}@media (min-width:768px){font-size:56px;}&::before{content:'';width:78px;height:6px;position:absolute;top:0;left:0;@media (min-width:768px){width:104px;height:8px;}}svg{width:20px;margin-left:20px;@media (min-width:768px){width:26px;margin-left:26px;}*{stroke:#1d2042;}}"]);
var LargeLinkContainer = styled.div.withConfig({
  displayName: "LargeLink__LargeLinkContainer",
  componentId: "jrub6m-0"
})(["padding:50px 20px 42px;@media (min-width:768px){padding:50px 6.9% 42px;}"]);
var StyledLargeLink = styled(Link).withConfig({
  displayName: "LargeLink__StyledLargeLink",
  componentId: "jrub6m-1"
})(["", " &::before{background-color:", ";}"], sharedLinkStyles$1, function (props) {
  return props.color;
});
var StyledExternalLink$1 = styled.a.withConfig({
  displayName: "LargeLink__StyledExternalLink",
  componentId: "jrub6m-2"
})(["", " &::before{background-color:", ";}"], sharedLinkStyles$1, function (props) {
  return props.color;
});

var LargeLink = function LargeLink(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      link = _ref.link,
      linkText = _ref.linkText;
  return link && /*#__PURE__*/React__default.createElement(LargeLinkContainer, null, link.new_tab ? /*#__PURE__*/React__default.createElement(StyledExternalLink$1, {
    href: link.url,
    target: "_blank",
    rel: "noreferrer",
    color: color
  }, linkText || 'Learn More', /*#__PURE__*/React__default.createElement(SvgIconNext, null)) : /*#__PURE__*/React__default.createElement(StyledLargeLink, {
    to: link.url,
    color: color
  }, linkText || 'Learn More', /*#__PURE__*/React__default.createElement(SvgIconNext, null)));
};

var StyledPageTitle = styled.div.withConfig({
  displayName: "PageTitle__StyledPageTitle",
  componentId: "sc-19q1s8n-0"
})(["padding:42px 20px 24px;position:relative;@media (min-width:768px){padding:77px 6.9% 56px;}", " img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;filter:grayscale(100%);+ h1{color:white;}}h1{position:relative;color:", ";z-index:2;}"], function (props) {
  return props.image ? css$1(["&::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba( ", ",0.7 );z-index:1;}"], function (props) {
    return convertHexToRGB(props.color, true);
  }) : css$1(["+ div[class*='Wysiwyg']{padding-top:0;}"]);
}, function (props) {
  return props.color;
});

var PageTitle = function PageTitle(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      heading = _ref.heading,
      image = _ref.image,
      alt = _ref.alt,
      credit = _ref.credit,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? '' : _ref$root;
  return /*#__PURE__*/React__default.createElement(StyledPageTitle, {
    color: color,
    image: image
  }, image && /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(root).concat(image),
    alt: alt
  }), /*#__PURE__*/React__default.createElement("h1", null, heading), credit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, credit));
};

PageTitle.propTypes = {
  heading: PropTypes.string,
  image: PropTypes.string
};

var sharedLinkStyles = css$1(["display:inline-block;transition:opacity 0.2s ease-out;text-decoration:none;font-family:proxima-nova,sans-serif;font-size:20px;font-weight:800;text-transform:uppercase;position:relative;padding-left:34px;&:hover,&:focus{opacity:0.65;}&::before{content:\"\";width:28px;height:1px;background-color:#1d2042;position:absolute;top:50%;left:0;}"]);
var arrow = css$1(["&::after{content:\"\";position:absolute;top:50%;left:1px;width:12px;height:12px;border-left:1px solid #1d2042;border-bottom:1px solid #1d2042;margin-top:-6px;transform-origin:center;transform:rotate(45deg);}"]);
var StyledLinkWrapper = styled(Link).withConfig({
  displayName: "StyledLink__StyledLinkWrapper",
  componentId: "xj5tj9-0"
})(["", " color:", ";", ""], sharedLinkStyles, function (props) {
  return props.color;
}, function (props) {
  return props.back ? "".concat(arrow) : "";
});
var StyledExternalLink = styled.a.withConfig({
  displayName: "StyledLink__StyledExternalLink",
  componentId: "xj5tj9-1"
})(["", " color:", ";", ""], sharedLinkStyles, function (props) {
  return props.color;
}, function (props) {
  return props.back ? "".concat(arrow) : "";
});

var StyledLink = function StyledLink(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#1D2042" : _ref$color,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      _ref$native = _ref["native"],
      _native = _ref$native === void 0 ? false : _ref$native,
      to = _ref.to,
      label = _ref.label,
      _ref$back = _ref.back,
      back = _ref$back === void 0 ? false : _ref$back;

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, external ? /*#__PURE__*/React__default.createElement(StyledExternalLink, {
    color: color,
    href: to,
    target: "_blank",
    rel: "noreferrer"
  }, label) : to.match(/http/g) || _native || back ? /*#__PURE__*/React__default.createElement(StyledExternalLink, {
    color: color,
    href: to,
    back: back
  }, label) : /*#__PURE__*/React__default.createElement(StyledLinkWrapper, {
    color: color,
    to: to
  }, label));
};

var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 421.124 425"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 425h421.124V0H0zm34.878-34.878h350.076V36.17H34.878z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Layer 1"
  }))));
}

var StyledFeatured = styled.div.withConfig({
  displayName: "FeaturedPost__StyledFeatured",
  componentId: "sc-27nir1-0"
})(["padding-right:20px;padding-bottom:68px;@media (min-width:768px){display:flex;}"]);
var FeaturedImage = styled.div.withConfig({
  displayName: "FeaturedPost__FeaturedImage",
  componentId: "sc-27nir1-1"
})(["position:relative;margin-bottom:21px;@media (min-width:768px){width:50%;flex:0 0 auto;margin-bottom:0;}&::before{content:'';display:block;padding-top:66.6%;}a{transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.75;}}img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;}svg{width:45%;position:absolute;top:-80px;left:75%;@media (min-width:768px){width:35%;left:86%;}*{fill:", ";}}"], function (props) {
  return getLightColor(props.color);
});
var FeaturedDetails = styled.div.withConfig({
  displayName: "FeaturedPost__FeaturedDetails",
  componentId: "sc-27nir1-2"
})(["padding-left:20px;@media (min-width:768px){padding-top:32px;padding-left:40px;}@media (min-width:960px){padding-top:66px;}a{display:block;text-decoration:none;transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.65;}}h2{font-family:cambria,serif;font-size:36px;font-weight:400;margin-bottom:29px;@media (min-width:960px){font-size:72px;}}h6{font-size:16px;font-weight:500;font-family:proxima-nova-condensed,sans-serif;color:#62668d;margin-bottom:4px;}"]);

var FeaturedPost = function FeaturedPost(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      post = _ref.post;
  return /*#__PURE__*/React__default.createElement(StyledFeatured, null, /*#__PURE__*/React__default.createElement(FeaturedImage, {
    color: color
  }, /*#__PURE__*/React__default.createElement(SvgSquare, null), /*#__PURE__*/React__default.createElement(Link, {
    to: post.url
  }, post.image && /*#__PURE__*/React__default.createElement("img", {
    src: post.image,
    alt: post.alt
  }))), /*#__PURE__*/React__default.createElement(FeaturedDetails, null, /*#__PURE__*/React__default.createElement(Link, {
    to: post.url
  }, /*#__PURE__*/React__default.createElement("h2", null, post.title)), post.categories && /*#__PURE__*/React__default.createElement("h6", null, post.categories.join(', ')), post.excerpt && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: post.excerpt
    }
  }), /*#__PURE__*/React__default.createElement(StyledLink, {
    label: "Read More",
    to: post.url,
    color: color
  })));
};

var StyledCard = styled.div.withConfig({
  displayName: "PostCard__StyledCard",
  componentId: "sc-1n6bcm4-0"
})(["", ""], function (props) {
  return props.large ? css$1(["> div:first-child{margin-bottom:11px;}> div:last-child{h3{@media (min-width:768px){font-size:36px;margin-bottom:30px;}}}"]) : '';
});
var CardImage = styled.div.withConfig({
  displayName: "PostCard__CardImage",
  componentId: "sc-1n6bcm4-1"
})(["position:relative;margin-bottom:9px;&::before{content:'';display:block;padding-top:66.6%;}img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;}a{transition:opacity 0.2s ease-out;cursor:pointer;&:hover,&:focus{opacity:0.75;}}"]);
var CardDetails = styled.div.withConfig({
  displayName: "PostCard__CardDetails",
  componentId: "sc-1n6bcm4-2"
})(["a{display:block;text-decoration:none;transition:opacity 0.2s ease-out;cursor:pointer;&:hover,&:focus{opacity:0.65;}}h3{font-size:24px;margin-bottom:12px;}h6{font-size:16px;font-weight:500;font-family:proxima-nova-condensed,sans-serif;color:#62668d;margin-bottom:4px;}"]);

var PostCard = function PostCard(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      post = _ref.post,
      large = _ref.large;
  return /*#__PURE__*/React__default.createElement(StyledCard, {
    large: large
  }, /*#__PURE__*/React__default.createElement(CardImage, null, /*#__PURE__*/React__default.createElement(Link, {
    to: post.url
  }, post.image && /*#__PURE__*/React__default.createElement("img", {
    src: post.image,
    alt: post.alt
  }))), /*#__PURE__*/React__default.createElement(CardDetails, null, /*#__PURE__*/React__default.createElement(Link, {
    to: post.url
  }, /*#__PURE__*/React__default.createElement("h3", null, post.title)), post.categories && /*#__PURE__*/React__default.createElement("h6", null, post.categories.join(', ')), post.excerpt && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: post.excerpt
    }
  }), /*#__PURE__*/React__default.createElement(StyledLink, {
    label: "Read More",
    to: post.url,
    color: color
  })));
};

var StyledButton = styled.button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "shq4v9-0"
})(["background:none;border-radius:2px;font-family:proxima-nova,sans-serif;font-weight:800;font-size:20px;line-height:1;letter-spacing:0.47px;text-transform:uppercase;padding:15px 42px 14px;border:4px solid ", ";color:", ";transition:opacity 0.2s ease-out;cursor:pointer;&:hover,&:focus{opacity:0.65;}"], function (props) {
  return props.secondary ? '#fff' : props.color;
}, function (props) {
  return props.secondary ? '#fff' : props.color;
});

var Button = function Button(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? false : _ref$secondary,
      onClick = _ref.onClick,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type;
  return /*#__PURE__*/React__default.createElement(StyledButton, {
    color: color,
    secondary: secondary,
    type: type,
    onClick: onClick
  }, label);
};

Button.propTypes = {
  secondary: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string
};

var SEO = function SEO(_ref) {
  var _ref$document = _ref.document,
      document = _ref$document === void 0 ? {} : _ref$document;
  var context = useContext(SiteContext);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Title, null, document.meta_title || context.defaultTitle), /*#__PURE__*/React__default.createElement(Meta, {
    name: "title",
    content: document.meta_title || context.defaultTitle
  }), /*#__PURE__*/React__default.createElement(Meta, {
    name: "description",
    content: document.meta_description || context.defaultDescription
  }), /*#__PURE__*/React__default.createElement(Meta, {
    name: "twitter:card",
    content: "summary"
  }), /*#__PURE__*/React__default.createElement(Meta, {
    property: "twitter:url",
    content: location.href
  }), /*#__PURE__*/React__default.createElement(Meta, {
    property: "og:url",
    content: location.href
  }), /*#__PURE__*/React__default.createElement(Meta, {
    name: "og:title",
    content: document.meta_title || context.defaultTitle
  }), /*#__PURE__*/React__default.createElement(Meta, {
    name: "twitter:title",
    content: document.meta_title || context.defaultTitle
  }), (document.meta_description || context.defaultDescription) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Meta, {
    property: "og:description",
    content: document.meta_description || context.defaultDescription
  }), /*#__PURE__*/React__default.createElement(Meta, {
    property: "twitter:description",
    content: document.meta_description || context.defaultDescription
  })), (document.meta_asset || context.defaultAsset) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Meta, {
    property: "og:image",
    content: "".concat(context.root).concat(document.meta_asset || context.defaultAsset)
  }), /*#__PURE__*/React__default.createElement(Meta, {
    property: "twitter:image",
    content: "".concat(context.root).concat(document.meta_asset || context.defaultAsset)
  })));
};

var SmallGrid = styled.div.withConfig({
  displayName: "News__SmallGrid",
  componentId: "sc-12in93e-0"
})(["display:grid;grid-gap:48px 0;padding:0 20px 103px;@media (min-width:600px){grid-template-columns:repeat(2,1fr);grid-gap:48px 40px;}@media (min-width:768px){grid-gap:92px 58px;padding:0 6.9% 103px;}"]);
var NewsFilters = styled.div.withConfig({
  displayName: "News__NewsFilters",
  componentId: "sc-12in93e-1"
})(["background-color:", ";padding:35px 20px 28px;position:relative;@media (min-width:768px){padding:35px 6.9% 37px;display:flex;align-items:center;&::before{content:'';background-color:white;width:calc(6.9vw + 121px);height:260px;position:absolute;top:0;left:0;}}h6{font-size:16px;text-transform:uppercase;position:relative;@media (min-width:768px){margin-right:68px;}}div{display:flex;flex-wrap:wrap;}button{border:0;border-radius:0;background:none;padding:0 2px 9px;font-family:proxima-nova,sans-serif;font-size:18px;font-weight:700;color:#1d2042;position:relative;transition:opacity 0.2s ease-out;margin-right:22px;margin-bottom:11px;cursor:pointer;&:last-child{margin-right:0;}&:hover,&:focus{opacity:0.65;}&.active{opacity:1;cursor:default;&::after{content:'';width:100%;height:5px;background-color:", ";position:absolute;bottom:0;left:0;}}}"], function (props) {
  return getLightColor(props.color);
}, getSecondaryColor('#1D2042'));
var LargeGrid = styled.div.withConfig({
  displayName: "News__LargeGrid",
  componentId: "sc-12in93e-2"
})(["background-color:", ";display:grid;grid-gap:48px 0;padding:0 20px 103px;@media (min-width:600px){grid-template-columns:repeat(2,1fr);grid-gap:48px 40px;}@media (min-width:768px){grid-gap:92px 58px;padding:0 6.9% 103px;}@media (min-width:960px){grid-template-columns:repeat(3,1fr);}"], function (props) {
  return getLightColor(props.color);
});
var LoadMoreContainer = styled.div.withConfig({
  displayName: "News__LoadMoreContainer",
  componentId: "sc-12in93e-3"
})(["background-color:", ";text-align:center;padding-bottom:103px;"], function (props) {
  return getLightColor(props.color);
});

var News = function News(_ref) {
  var site = _ref.site,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color;
  var context = useContext(SiteContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      initialized = _useState2[0],
      setInitialized = _useState2[1];

  var _useState3 = useState('default'),
      _useState4 = _slicedToArray(_useState3, 2),
      view = _useState4[0],
      setView = _useState4[1];

  var _useState5 = useState(1),
      _useState6 = _slicedToArray(_useState5, 2),
      page = _useState6[0],
      setPage = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      categories = _useState8[0],
      setCategories = _useState8[1];

  var _useState9 = useState({
    category: ''
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      filters = _useState10[0],
      setFilters = _useState10[1];

  useEffect(function () {
    context.getNews(site);
    var getCategories = new Promise(function (resolve) {
      context.getNewsCategories(site, resolve);
    });
    getCategories.then(function (data) {
      setCategories(data);
    });
  }, []); // TODO: set view depending on initial post amount

  useEffect(function () {
    if (!initialized && (context.news.length || context.featuredNews.length)) {
      if (context.featuredNews.length + context.news.length === 1) {
        setView('single');
      } else if (context.featuredNews.length + context.news.length === 2) {
        setView('double');
      }

      setInitialized(true);
    }
  }, [context.news, context.featuredNews]);
  useEffect(function () {
    if (initialized) {
      setPage(1);
      context.getNews(site, filters.category);
    }
  }, [filters]);

  var loadMore = function loadMore() {
    var newPage = page + 1;
    context.getNews(site, filters.category, newPage);
    setPage(newPage);
  };

  return /*#__PURE__*/React__default.createElement("main", null, /*#__PURE__*/React__default.createElement(SEO, {
    document: {
      meta_title: "News - ".concat(context.defaultTitle)
    }
  }), /*#__PURE__*/React__default.createElement(PageTitle, {
    color: color,
    heading: "Grantees in the News"
  }), view === 'single' ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, context.featuredNews.length > 0 ? /*#__PURE__*/React__default.createElement(FeaturedPost, {
    post: context.featuredNews[0],
    color: color
  }) : /*#__PURE__*/React__default.createElement(FeaturedPost, {
    post: context.news[0],
    color: color
  })) : view === 'double' ? /*#__PURE__*/React__default.createElement(SmallGrid, null, context.featuredNews.map(function (post) {
    return /*#__PURE__*/React__default.createElement(PostCard, {
      large: true,
      post: post,
      key: post.id,
      color: color
    });
  }), context.news.map(function (post) {
    return /*#__PURE__*/React__default.createElement(PostCard, {
      large: true,
      post: post,
      key: post.id,
      color: color
    });
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, context.featuredNews.map(function (post) {
    return /*#__PURE__*/React__default.createElement(FeaturedPost, {
      post: post,
      key: post.id,
      color: color
    });
  }), /*#__PURE__*/React__default.createElement(NewsFilters, {
    color: color
  }, /*#__PURE__*/React__default.createElement("h6", null, "Filter By:"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("button", {
    onClick: function onClick() {
      return setFilters({
        category: ''
      });
    },
    className: !filters.category ? 'active' : ''
  }, "All"), categories.map(function (category) {
    return /*#__PURE__*/React__default.createElement("button", {
      onClick: function onClick() {
        return setFilters({
          category: category.id
        });
      },
      className: filters.category === category.id ? 'active' : '',
      key: category.id
    }, category.name);
  }))), /*#__PURE__*/React__default.createElement(LargeGrid, {
    color: color
  }, context.news.map(function (post) {
    return /*#__PURE__*/React__default.createElement(PostCard, {
      post: post,
      key: post.id,
      color: color
    });
  })), context.total > context.news.length && /*#__PURE__*/React__default.createElement(LoadMoreContainer, {
    color: color
  }, /*#__PURE__*/React__default.createElement(Button, {
    color: color,
    onClick: loadMore,
    label: "Load More"
  }))));
};

var StyledLatestNews = styled.div.withConfig({
  displayName: "LatestNews__StyledLatestNews",
  componentId: "sc-1quawvs-0"
})(["background-color:", ";position:relative;padding:32px 20px 74px;@media (min-width:768px){padding:62px 6.9% 103px;}&::before{content:\"\";background-color:white;position:absolute;top:0;left:0;width:74px;height:220px;@media (min-width:768px){width:calc(6.9vw + 86px);height:320px;}}> h2{font-size:36px;position:relative;text-align:center;font-weight:600;margin-bottom:36px;@media (min-width:768px){font-size:56px;margin-bottom:66px;}}div{position:relative;padding:0;background:none;}"], function (props) {
  return getLightColor(props.color);
});
var ButtonContainer = styled.div.withConfig({
  displayName: "LatestNews__ButtonContainer",
  componentId: "sc-1quawvs-1"
})(["padding-top:74px !important;text-align:center;"]);

var LatestNews = function LatestNews(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#D2042" : _ref$color,
      site = _ref.site,
      heading = _ref.heading;
      _ref.link;
      _ref.linkText;
  var context = useContext(SiteContext);
  useEffect(function () {
    context.getLatestNews(site);
  }, []);
  return context.latestNews ? /*#__PURE__*/React__default.createElement(StyledLatestNews, {
    color: color
  }, heading && /*#__PURE__*/React__default.createElement("h2", null, heading), /*#__PURE__*/React__default.createElement(LargeGrid, {
    color: color
  }, context.latestNews.map(function (post) {
    return /*#__PURE__*/React__default.createElement(PostCard, {
      post: post,
      key: post.id
    });
  })), /*#__PURE__*/React__default.createElement(ButtonContainer, null, /*#__PURE__*/React__default.createElement(ButtonLink, {
    to: "/news",
    label: "View All"
  }))) : null;
};

var StyledMedia = styled.div.withConfig({
  displayName: "MediaWithCopy__StyledMedia",
  componentId: "sc-1hzzbjd-0"
})(["position:relative;padding:32px 20px 38px;@media (min-width:768px){display:flex;padding:32px 6.9% 38px;}", ":nth-child(even){@media (min-width:768px){flex-direction:row-reverse;> div:last-child{padding-left:0;padding-right:50px;}}}+ .media{&::before{height:100%;top:0;@media (min-width:768px){height:100%;top:-88px;}}}"], function (props) {
  return props.background ? css$1(["&::before{content:'';width:100%;height:calc(100% - 74px);background-color:", ";position:absolute;top:74px;left:0;z-index:-1;@media (min-width:768px){height:calc(100% - 154px);top:66px;}}"], getLightColor(props.color)) : '';
});
var MediaImage = styled.div.withConfig({
  displayName: "MediaWithCopy__MediaImage",
  componentId: "sc-1hzzbjd-1"
})(["margin-bottom:14px;position:relative;align-self:flex-start;@media (min-width:768px){width:48%;flex:0 0 auto;margin-bottom:0;}img{display:block;width:100%;height:100%;border-radius:2px;object-fit:cover;}"]);
var MediaCopy = styled.div.withConfig({
  displayName: "MediaWithCopy__MediaCopy",
  componentId: "sc-1hzzbjd-2"
})(["position:relative;@media (min-width:768px){flex:1 1 auto;padding:55px 0 70px 50px;}h2{@media (min-width:768px){margin-bottom:30px;}}> a{@media (min-width:768px){margin-top:7px;}}> div{a{color:", ";transition:opacity 0.2s ease-out;&:hover,&:focus{opacity:0.65;}}}"], function (props) {
  return props.color;
});

var MediaWithCopy = function MediaWithCopy(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      image = _ref.image,
      alt = _ref.alt,
      credit = _ref.credit,
      heading = _ref.heading,
      copy = _ref.copy,
      link = _ref.link,
      linkText = _ref.linkText,
      background = _ref.background,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? '' : _ref$root;
  return /*#__PURE__*/React__default.createElement(StyledMedia, {
    className: "media",
    background: background,
    color: color
  }, /*#__PURE__*/React__default.createElement(MediaImage, null, image && /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(root).concat(image),
    alt: alt
  }), credit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, credit)), /*#__PURE__*/React__default.createElement(MediaCopy, {
    color: color
  }, heading && /*#__PURE__*/React__default.createElement("h2", null, heading), copy && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  }), (link || {}).url && /*#__PURE__*/React__default.createElement(StyledLink, {
    color: color,
    label: linkText || 'Read More',
    to: link.url,
    external: link.new_tab ? true : false
  })));
};

MediaWithCopy.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string,
  credit: PropTypes.string,
  heading: PropTypes.string,
  copy: PropTypes.string,
  link: PropTypes.object,
  linkText: PropTypes.string,
  background: PropTypes.bool
};

var StyledObjective = styled.section.withConfig({
  displayName: "Objective__StyledObjective",
  componentId: "sc-1hcohrp-0"
})(["background-color:", ";display:flex;align-items:flex-start;padding:32px 20px;@media (min-width:768px){padding:32px 6.9%;}> img{display:block;width:60px;margin-right:1.25rem;margin-top:-0.75rem;}"], function (props) {
  return getTertiaryColor(props.color);
});
var ObjectiveCopy = styled.div.withConfig({
  displayName: "Objective__ObjectiveCopy",
  componentId: "sc-1hcohrp-1"
})(["& h3{margin-bottom:1rem;}& *{color:white;max-width:800px;}& > div > *:last-child{margin-bottom:0;}"]);

var Objective = function Objective(_ref) {
  var color = _ref.color,
      icon = _ref.icon,
      heading = _ref.heading,
      copy = _ref.copy,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? "" : _ref$root;
  return /*#__PURE__*/React__default.createElement(StyledObjective, {
    color: color
  }, icon && /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(root).concat(icon),
    role: "presentation"
  }), /*#__PURE__*/React__default.createElement(ObjectiveCopy, null, heading && /*#__PURE__*/React__default.createElement("h3", null, heading), copy && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  })));
};

function useInterval(callback, delay) {
  var savedCallback = useRef(callback);
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    if (delay === null) {
      return;
    }

    var id = setInterval(function () {
      return savedCallback.current();
    }, delay);
    return function () {
      return clearInterval(id);
    };
  }, [delay]);
}

var StyledParentHero = styled.div.withConfig({
  displayName: "ParentHero__StyledParentHero",
  componentId: "sc-1yso5nj-0"
})(["background-color:#373a67;display:flex;flex-direction:column-reverse;@media (min-width:768px){flex-direction:row;}"]);
var ParentHeroCopy = styled.div.withConfig({
  displayName: "ParentHero__ParentHeroCopy",
  componentId: "sc-1yso5nj-1"
})(["padding:26px 20px 50px;@media (min-width:768px){width:50%;flex:0 0 auto;padding:49px 6.9vw;display:flex;flex-direction:column;justify-content:center;}h1,p,li{color:white;}h1{font-size:52px;line-height:0.95;@media (min-width:768px){font-size:78px;}@media (min-width:1024px){font-size:110px;}}> div *:last-child{margin-bottom:0;}"]);
var ParentHeroImage = styled.div.withConfig({
  displayName: "ParentHero__ParentHeroImage",
  componentId: "sc-1yso5nj-2"
})(["display:flex;justify-content:center;align-items:center;position:relative;overflow:hidden;@media (min-width:768px){width:50%;}&::before{content:'';display:block;padding-top:100%;}img{width:100%;height:100%;position:absolute;top:0;left:0;object-fit:cover;opacity:0;transition:opacity 2.5s ease-out,transform 2.5s ease-out;}p{opacity:0;transition:opacity 0.5s ease-out;}div{width:59%;border:8.2% solid white;position:relative;&::after{content:'';display:block;padding-top:100%;}svg{position:absolute;top:0;left:0;width:100%;height:100%;}}"]);

var ParentHero = function ParentHero(_ref) {
  var heading = _ref.heading,
      copy = _ref.copy,
      image = _ref.image,
      alt = _ref.alt,
      credit = _ref.credit,
      image2 = _ref.image2,
      alt2 = _ref.alt2,
      credit2 = _ref.credit2,
      image3 = _ref.image3,
      alt3 = _ref.alt3,
      credit3 = _ref.credit3;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      images = _useState2[0],
      setImages = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      active = _useState4[0],
      setActive = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      grow = _useState6[0],
      setGrow = _useState6[1];

  var image1Ref = useRef(null);
  var image2Ref = useRef(null);
  var image3Ref = useRef(null);
  var credit1Ref = useRef(null);
  var credit2Ref = useRef(null);
  var credit3Ref = useRef(null);
  useEffect(function () {
    var loadedImages = [];

    if (image1Ref.current) {
      loadedImages.push({
        image: image1Ref.current,
        credit: credit1Ref.current ? credit1Ref.current : null
      });
      loadedImages[0].image.style.opacity = 1;

      if (loadedImages[0].credit) {
        loadedImages[0].credit.style.opacity = 1;
      }
    }

    if (image2Ref.current) {
      loadedImages.push({
        image: image2Ref.current,
        credit: credit2Ref.current ? credit2Ref.current : null
      });
    }

    if (image3Ref.current) {
      loadedImages.push({
        image: image3Ref.current,
        credit: credit3Ref.current ? credit3Ref.current : null
      });
    }

    setImages(loadedImages);
  }, [image1Ref, image2Ref, image3Ref]);
  useInterval(function () {
    var newImage = active === images.length - 1 ? 0 : active + 1;
    var currentGrow = grow;
    setActive(newImage);
    setGrow(!currentGrow);
    images.forEach(function (img) {
      img.image.style.opacity = 0;
      img.image.style.transform = currentGrow === true ? 'scale(1)' : 'scale(1.1)';

      if (img.credit) {
        img.credit.style.opacity = 0;
      }
    });
    images[newImage].image.style.opacity = 1;

    if (images[newImage].credit) {
      images[newImage].credit.style.opacity = 1;
    }
  }, images.length > 1 ? 5000 : null);
  return /*#__PURE__*/React__default.createElement(StyledParentHero, null, /*#__PURE__*/React__default.createElement(ParentHeroCopy, null, heading && /*#__PURE__*/React__default.createElement("h1", null, heading), copy && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  })), /*#__PURE__*/React__default.createElement(ParentHeroImage, null, image && /*#__PURE__*/React__default.createElement("img", {
    ref: image1Ref,
    src: image,
    alt: alt
  }), image2 && /*#__PURE__*/React__default.createElement("img", {
    ref: image2Ref,
    src: image2,
    alt: alt2
  }), image3 && /*#__PURE__*/React__default.createElement("img", {
    ref: image3Ref,
    src: image3,
    alt: alt3
  }), credit && /*#__PURE__*/React__default.createElement(PhotoCredit, {
    reference: credit1Ref
  }, credit), credit2 && /*#__PURE__*/React__default.createElement(PhotoCredit, {
    reference: credit2Ref
  }, credit2), credit3 && /*#__PURE__*/React__default.createElement(PhotoCredit, {
    reference: credit3Ref
  }, credit3)));
};

ParentHero.propTypes = {
  heading: PropTypes.string,
  copy: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string,
  credit: PropTypes.string,
  image2: PropTypes.string,
  alt2: PropTypes.string,
  credit2: PropTypes.string,
  image3: PropTypes.string,
  alt3: PropTypes.string,
  credit3: PropTypes.string
};

var StyledPriorities = styled.div.withConfig({
  displayName: "Priorities__StyledPriorities",
  componentId: "avkltv-0"
})(["display:grid;grid-gap:2px;@media (min-width:600px){grid-template-columns:repeat(2,1fr);}@media (min-width:768px){grid-template-columns:repeat(3,1fr);}"]);
var Priority = styled.div.withConfig({
  displayName: "Priorities__Priority",
  componentId: "avkltv-1"
})(["background-color:", ";padding:20px 20px 54px;position:relative;@media (min-width:600px){padding:96px 20px;}@media (min-width:768px){padding:96px 6.9vw;}h3{font-size:28px;margin:0;@media (min-width:960px){font-size:36px;}}"], function (props) {
  return getLightColor(props.color);
});
var PriorityIcon = styled.div.withConfig({
  displayName: "Priorities__PriorityIcon",
  componentId: "avkltv-2"
})(["background-color:", ";width:80px;height:80px;border-radius:50%;display:flex;justify-content:center;align-items:center;margin-bottom:16px;@media (min-width:600px){width:120px;height:120px;position:absolute;top:-40px;left:20px;}@media (min-width:768px){left:6.9vw;}img{width:50px;height:50px;object-fit:contain;@media (min-width:600px){width:74px;height:74px;}}"], function (props) {
  return props.color;
});

var Priorities = function Priorities(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      items = _ref.items,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? '' : _ref$root,
      site = _ref.site;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      anchors = _useState2[0],
      setAnchors = _useState2[1];

  useEffect(function () {
    if (site === 'henry-l-hillman-foundation' || site === 'hillman-foundation') {
      setAnchors(true);
    }
  }, [site]);

  var findAnchor = function findAnchor(name) {
    var priority = _toConsumableArray(document.querySelectorAll('h1, h2, h3:not(.priority), h4, h5, h6')).find(function (a) {
      return a.textContent.includes(name);
    });

    if (priority) {
      priority.id = "item-".concat(name.replace(/\s/g, '-'));
      return "#item-".concat(name.replace(/\s/g, '-'));
    }

    return '';
  };

  return items ? /*#__PURE__*/React__default.createElement(StyledPriorities, null, items.map(function (priority, index) {
    return /*#__PURE__*/React__default.createElement(Priority, {
      color: color,
      key: index
    }, priority.icon && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, anchors ? /*#__PURE__*/React__default.createElement("a", {
      href: findAnchor(priority.name)
    }, /*#__PURE__*/React__default.createElement(PriorityIcon, {
      color: color
    }, /*#__PURE__*/React__default.createElement("img", {
      src: "".concat(root).concat(priority.icon)
    }))) : /*#__PURE__*/React__default.createElement(PriorityIcon, {
      color: color
    }, /*#__PURE__*/React__default.createElement("img", {
      src: "".concat(root).concat(priority.icon)
    }))), /*#__PURE__*/React__default.createElement("h3", {
      className: "priority"
    }, priority.name));
  })) : null;
};

Priorities.propTypes = {
  items: PropTypes.array
};

var StyledPromo = styled.div.withConfig({
  displayName: "Promo__StyledPromo",
  componentId: "rx81p6-0"
})(["padding:32px 20px 32px;overflow:hidden;@media (min-width:768px){display:flex;align-items:center;padding:128px 6.9% 99px;}svg{display:none;@media (min-width:768px){display:block;width:43.5%;position:absolute;top:-56px;left:78%;}*{fill:", ";}}img{position:relative;}h2{@media (min-width:768px){margin-bottom:44px;}}"], function (props) {
  return getLightColor(props.color);
});

var Promo = function Promo(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      image = _ref.image,
      alt = _ref.alt,
      credit = _ref.credit,
      heading = _ref.heading,
      copy = _ref.copy,
      link = _ref.link,
      linkText = _ref.linkText,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? '' : _ref$root;
  return /*#__PURE__*/React__default.createElement(StyledPromo, {
    color: color
  }, /*#__PURE__*/React__default.createElement(MediaImage, null, /*#__PURE__*/React__default.createElement(SvgSquare, null), image && /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(root).concat(image),
    alt: alt
  }), credit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, credit)), /*#__PURE__*/React__default.createElement(MediaCopy, null, heading && /*#__PURE__*/React__default.createElement("h2", null, heading), copy && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  }), (link || {}).url && /*#__PURE__*/React__default.createElement(StyledLink, {
    color: color,
    label: linkText || 'Read More',
    to: link.url,
    external: link.new_tab ? true : false
  })));
};

Promo.propTypes = {
  color: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string,
  credit: PropTypes.string,
  heading: PropTypes.string,
  copy: PropTypes.string,
  link: PropTypes.object,
  linkText: PropTypes.string
};

var StyledSectionIntro = styled.div.withConfig({
  displayName: "SectionIntro__StyledSectionIntro",
  componentId: "sc-1xvs7cn-0"
})(["padding:50px 20px 0;text-align:center;@media (min-width:768px){padding:50px 6.9% 0;}& h5{margin-bottom:0.25rem;}& h3{color:", ";font-weight:400;font-family:cambria,serif;}& h4{color:", ";font-family:proxima-nova-condensed,sans-serif;text-transform:uppercase;margin-top:0.5rem;}"], function (props) {
  return props.color;
}, function (props) {
  return props.color;
});

var SectionIntro = function SectionIntro(_ref) {
  var color = _ref.color,
      label1 = _ref.label1,
      heading1 = _ref.heading1,
      label2 = _ref.label2,
      heading2 = _ref.heading2;
  return /*#__PURE__*/React__default.createElement(StyledSectionIntro, {
    color: color
  }, label1 && /*#__PURE__*/React__default.createElement("h5", null, label1), heading1 && /*#__PURE__*/React__default.createElement("h3", null, heading1), label2 && /*#__PURE__*/React__default.createElement("h5", null, label2), heading2 && /*#__PURE__*/React__default.createElement("h4", null, heading2));
};

var SnapshotOuter = styled.div.withConfig({
  displayName: "Snapshot__SnapshotOuter",
  componentId: "sc-12lbhf7-0"
})(["margin:50px 0;@media (min-width:600px){display:flex;justify-content:flex-start;}"]);
var SnapshotBlock = styled.div.withConfig({
  displayName: "Snapshot__SnapshotBlock",
  componentId: "sc-12lbhf7-1"
})(["background-color:", ";padding:1.5rem 1.25rem 4rem;@media (min-width:600px){padding:1.5rem 4rem 2rem 6.9%;}& h3{font-size:1.25rem;text-transform:uppercase;text-align:center;}"], function (props) {
  return getLightColor(props.color);
});
var SnapshotContainer = styled.div.withConfig({
  displayName: "Snapshot__SnapshotContainer",
  componentId: "sc-12lbhf7-2"
})(["@media (min-width:600px){display:flex;align-items:center;}"]);
var SnapshotItem = styled.div.withConfig({
  displayName: "Snapshot__SnapshotItem",
  componentId: "sc-12lbhf7-3"
})(["position:relative;&:nth-child(1){@media (min-width:600px){padding-right:1.75rem;margin-right:1.125rem;}}&:nth-child(2){border-top:1px solid ", ";padding-top:1.25rem;margin-top:1.25rem;@media (min-width:600px){border:0;padding:0;margin:0;}}& p{margin:0;font-family:proxima-nova-condensed,sans-serif;font-size:2.25rem;font-weight:500;text-align:center;text-transform:uppercase;color:", ";line-height:1;& span:nth-of-type(1){display:block;font-family:cambria,serif;font-weight:400;text-transform:none;color:#1d2042;font-size:1.25rem;margin-top:2px;margin-bottom:6px;}& span:nth-of-type(2){display:block;font-size:1.625rem;font-weight:600;}}& > span{@media (min-width:600px){display:block;height:100%;width:2px;position:absolute;top:0;right:0;transform-origin:center;transform:rotate(20deg);border-left:1px solid ", ";}}"], function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});

var Snapshot = function Snapshot(_ref) {
  var color = _ref.color,
      heading = _ref.heading,
      grants = _ref.grants,
      organizations = _ref.organizations,
      total = _ref.total;
  return /*#__PURE__*/React__default.createElement(SnapshotOuter, null, /*#__PURE__*/React__default.createElement(SnapshotBlock, {
    color: color
  }, heading && /*#__PURE__*/React__default.createElement("h3", null, heading), /*#__PURE__*/React__default.createElement(SnapshotContainer, {
    color: color
  }, /*#__PURE__*/React__default.createElement(SnapshotItem, {
    color: color
  }, grants && organizations && /*#__PURE__*/React__default.createElement("p", null, grants, " grants", /*#__PURE__*/React__default.createElement("span", null, " made to "), /*#__PURE__*/React__default.createElement("span", null, organizations, " organizations")), total && /*#__PURE__*/React__default.createElement("span", null)), /*#__PURE__*/React__default.createElement(SnapshotItem, {
    color: color
  }, total && /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("span", null, " Total investment "), total)))));
};

var StyledStaff = styled.div.withConfig({
  displayName: "StaffMembers__StyledStaff",
  componentId: "sc-1rt9jxy-0"
})(["background-color:", ";padding:43px 20px 55px;@media (min-width:768px){padding:65px 6.9% 106px;}&:nth-child(odd){background:none;}h2{margin-bottom:44px;@media (min-width:768px){margin-bottom:71px;}}ul{list-style:none;margin:0;padding:0;display:grid;grid-gap:45px;@media (min-width:600px){grid-template-columns:repeat(2,1fr);}@media (min-width:768px){grid-gap:55px 45px;}@media (min-width:960px){grid-template-columns:repeat(3,1fr);}}+ div[class*='Anchor']:nth-child(odd) + div[class*='Staff']{background:none;}"], function (props) {
  return props.color === '#1D2042' ? '#EEEFF2' : getLightColor(props.color);
});
var Person = styled.li.withConfig({
  displayName: "StaffMembers__Person",
  componentId: "sc-1rt9jxy-1"
})(["margin:0;position:relative;&::before{content:'';display:block;width:58px;height:8px;background-color:", ";margin-bottom:12px;}> *:last-child{margin-bottom:0;}h4{margin-bottom:7px;}h6{color:#62668d;font-family:proxima-nova-condensed,sans-serif;font-weight:500;text-transform:uppercase;margin-bottom:6px;}a{font-size:20px;color:", ";}p{margin-top:8px;}"], function (props) {
  return props.color;
}, function (props) {
  return props.color;
});

var StaffMembers = function StaffMembers(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      heading = _ref.heading,
      people = _ref.people;
  return /*#__PURE__*/React__default.createElement(StyledStaff, {
    color: color
  }, heading && /*#__PURE__*/React__default.createElement("h2", null, heading), (people || []) && /*#__PURE__*/React__default.createElement("ul", null, people.map(function (person, index) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, person.name && /*#__PURE__*/React__default.createElement(Person, {
      color: color
    }, /*#__PURE__*/React__default.createElement("h4", null, person.name), person.title && /*#__PURE__*/React__default.createElement("h6", null, person.title), person.email && /*#__PURE__*/React__default.createElement("a", {
      href: "mailto:".concat(person.email)
    }, person.email), person.phone && /*#__PURE__*/React__default.createElement("p", null, person.phone)));
  })));
};

StaffMembers.propTypes = {
  heading: PropTypes.string,
  people: PropTypes.array
};

var TOCContainer = styled.div.withConfig({
  displayName: "TableOfContents__TOCContainer",
  componentId: "sc-1emzloe-0"
})(["padding:32px 20px 32px;position:relative;@media (min-width:768px){padding:99px 6.9% 32px;display:flex;align-items:flex-start;}"]);
var TOCListContainer = styled.div.withConfig({
  displayName: "TableOfContents__TOCListContainer",
  componentId: "sc-1emzloe-1"
})(["@media (min-width:768px){width:50%;flex:0 0 auto;padding-right:2.5rem;position:sticky;top:40px;}"]);
var TOCList = styled.ul.withConfig({
  displayName: "TableOfContents__TOCList",
  componentId: "sc-1emzloe-2"
})(["list-style:none;padding:0;margin:2rem 0;@media (min-width:768px){margin:0;}li{margin-bottom:0.75rem;}"]);
var TOCHeader = styled.h2.withConfig({
  displayName: "TableOfContents__TOCHeader",
  componentId: "sc-1emzloe-3"
})(["font-size:1rem;text-transform:uppercase;padding-bottom:0.375rem;border-bottom:4px solid ", ";margin:0 0 1rem;"], function (props) {
  return props.color;
});
var TOCImageContainer = styled.div.withConfig({
  displayName: "TableOfContents__TOCImageContainer",
  componentId: "sc-1emzloe-4"
})(["@media (min-width:768px){width:50%;flex:0 0 auto;}"]);
var TOCImage = styled.div.withConfig({
  displayName: "TableOfContents__TOCImage",
  componentId: "sc-1emzloe-5"
})(["position:relative;& img{display:block;width:100%;}"]);
var TOCCAption = styled.p.withConfig({
  displayName: "TableOfContents__TOCCAption",
  componentId: "sc-1emzloe-6"
})(["font-size:0.875rem;color:#1d2042;background-color:", ";padding:1rem;"], function (props) {
  return getLightColor(props.color);
});

var TableOfContents = function TableOfContents(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#1D2042" : _ref$color,
      set = _ref.set,
      image = _ref.image,
      alt = _ref.alt,
      photoCredit = _ref.photoCredit,
      caption = _ref.caption,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? "" : _ref$root;
  return /*#__PURE__*/React__default.createElement(TOCContainer, null, /*#__PURE__*/React__default.createElement(TOCListContainer, null, /*#__PURE__*/React__default.createElement(TOCHeader, {
    color: color
  }, "Table of Contents"), /*#__PURE__*/React__default.createElement(TOCList, {
    color: color
  }, set.map(function (doc, index) {
    return index !== 0 ? /*#__PURE__*/React__default.createElement("li", {
      key: doc.slug
    }, /*#__PURE__*/React__default.createElement(StyledLink, {
      to: "/pages/".concat(doc.slug),
      label: doc.custom_title || doc.title,
      "native": true
    })) : null;
  }))), image && /*#__PURE__*/React__default.createElement(TOCImageContainer, null, /*#__PURE__*/React__default.createElement(TOCImage, null, /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(root).concat(image),
    alt: alt
  }), photoCredit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, photoCredit)), caption && /*#__PURE__*/React__default.createElement(TOCCAption, {
    color: color
  }, caption)));
};

var Sidebar = styled.div.withConfig({
  displayName: "TwoColumnContent__Sidebar",
  componentId: "sc-6gii58-0"
})(["display:grid;gap:1.5rem;margin-top:42px;@media (min-width:768px){width:30%;flex:1 1 auto;margin-top:0;", "}"], function (props) {
  return props.flip ? "order: 0;" : "";
});
var Callout = styled.div.withConfig({
  displayName: "TwoColumnContent__Callout",
  componentId: "sc-6gii58-1"
})(["& p,& li{font-family:proxima-nova,sans-serif;font-size:1.125rem;color:", ";}"], function (props) {
  return props.colored ? "white" : "#1d2042";
});
var Grid$2 = styled.div.withConfig({
  displayName: "TwoColumnContent__Grid",
  componentId: "sc-6gii58-2"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:1rem;background-color:", ";padding:1rem;& img{display:block;width:100%;}"], function (props) {
  return getLightColor(props.color);
});

var TwoColumnContent = function TwoColumnContent(_ref) {
  var copy = _ref.copy,
      color = _ref.color,
      sidebar = _ref.sidebar,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? "" : _ref$root,
      _ref$flip = _ref.flip,
      flip = _ref$flip === void 0 ? false : _ref$flip,
      _ref$colored = _ref.colored,
      colored = _ref$colored === void 0 ? false : _ref$colored;
  return /*#__PURE__*/React__default.createElement(StyledWysiwyg, {
    color: color,
    start: true,
    flip: flip,
    colored: colored
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  }), /*#__PURE__*/React__default.createElement(Sidebar, {
    flip: flip
  }, sidebar.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, item.type === "quote" && /*#__PURE__*/React__default.createElement(Quote, {
      position: "top",
      color: color,
      fullWidth: true,
      colored: colored
    }, item.quote && /*#__PURE__*/React__default.createElement("p", null, item.quote), item.quote_author && /*#__PURE__*/React__default.createElement("h5", null, item.quote_author, item.quote_author_line_2 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("br", null), item.quote_author_line_2))), item.type === "image" && item.image && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TOCImage, null, /*#__PURE__*/React__default.createElement("img", {
      src: "".concat(root).concat(item.image),
      alt: item.image_alt
    }), item.photo_credit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, item.photo_credit)), item.caption && /*#__PURE__*/React__default.createElement(TOCCAption, {
      color: color
    }, item.caption)), item.type === "callout" && /*#__PURE__*/React__default.createElement(Callout, {
      dangerouslySetInnerHTML: {
        __html: item.copy
      },
      colored: colored
    }), item.type === "grid" && /*#__PURE__*/React__default.createElement(Grid$2, {
      color: color
    }, item.image1 && /*#__PURE__*/React__default.createElement("img", {
      src: "".concat(root).concat(item.image1)
    }), item.image2 && /*#__PURE__*/React__default.createElement("img", {
      src: "".concat(root).concat(item.image2)
    })));
  })));
};

var Block = function Block(_ref) {
  var data = _ref.data,
      color = _ref.color,
      site = _ref.site;
  var context = useContext(SiteContext);

  var renderBlock = function renderBlock() {
    var cell_action = data.cell_action,
        settings = data.settings;

    switch (cell_action) {
      case "accordions":
        return /*#__PURE__*/React__default.createElement(Accordions, {
          accordions: settings.accordions,
          quote: settings.quote,
          quoteAuthor: settings.quote_author,
          quoteAuthorLine2: settings.quote_author_line_2,
          quotePosition: settings.quote_position,
          color: color
        });

      case "anchor":
        return /*#__PURE__*/React__default.createElement(Anchor, {
          name: settings.anchor_name.replace(/\d|\W/g, "")
        });

      case "call_to_action":
        return /*#__PURE__*/React__default.createElement(CallToAction, {
          color: color,
          heading: settings.heading,
          copy: settings.copy,
          link: settings.link,
          linkText: settings.link_text
        });

      case "child_hero":
        return /*#__PURE__*/React__default.createElement(ChildHero, {
          color: color,
          cities: context.site.cities,
          heading: settings.heading,
          copy: settings.copy,
          image: data.image ? data.image : null,
          alt: settings.alt_attribute_description,
          credit: settings.photo_credit,
          focus: settings.image_focal_point,
          hideLocation: settings.hide_location,
          root: context.root
        });

      case "divider":
        return /*#__PURE__*/React__default.createElement(Divider, {
          color: color
        });

      case "featured_grant":
        return /*#__PURE__*/React__default.createElement(FeaturedGrant, {
          color: color,
          image: data.image ? data.image : null,
          alt: settings.alt_attribute_description,
          credit: settings.photo_credit,
          name: settings.grantee_name,
          purpose: settings.grant_purpose,
          amount: settings.grant_amount,
          year: settings.grant_year,
          root: context.root
        });

      case "full_width_quote":
        return /*#__PURE__*/React__default.createElement(FullWidthQuote, {
          color: color,
          quote: settings.quote,
          authorLine1: settings.quote_author,
          authorLine2: settings.quote_author_line_2
        });

      case "form":
        return /*#__PURE__*/React__default.createElement(ContactForm, {
          color: color === "#1D2042" ? "#373A67" : color,
          heading: settings.heading,
          copy: settings.content,
          form: data.form
        });

      case "foundation_links":
        return /*#__PURE__*/React__default.createElement(FoundationLinks, {
          sites: data.sites,
          copy: settings.copy,
          root: context.root
        });

      case "gallery":
        return /*#__PURE__*/React__default.createElement(Gallery, {
          slides: data.slides,
          root: context.root
        });

      case "grant_impacts":
        return /*#__PURE__*/React__default.createElement(GrantImpacts, {
          color: color,
          heading: settings.heading,
          impacts: data.impacts,
          root: context.root
        });

      case "image":
        return /*#__PURE__*/React__default.createElement(Image, {
          image: data.image ? data.image : null,
          alt: settings.alt_attribute_description,
          credit: settings.photo_credit,
          root: context.root
        });

      case "link":
        return /*#__PURE__*/React__default.createElement(LargeLink, {
          color: color,
          link: settings.link,
          linkText: settings.custom_link_text
        });

      case "latest_news":
        return /*#__PURE__*/React__default.createElement(LatestNews, {
          site: site,
          heading: settings.heading
        });

      case "media_with_copy":
        return /*#__PURE__*/React__default.createElement(MediaWithCopy, {
          color: color,
          image: data.image ? data.image : null,
          alt: settings.alt_attribute_description,
          credit: settings.photo_credit,
          heading: settings.heading,
          copy: settings.copy,
          link: settings.link,
          linkText: settings.link_text,
          background: settings.colored_background,
          root: context.root
        });

      case "objective":
        return /*#__PURE__*/React__default.createElement(Objective, {
          color: color,
          heading: settings.heading,
          copy: settings.copy,
          icon: data.icon,
          root: context.root
        });

      case "parent_hero":
        return /*#__PURE__*/React__default.createElement(ParentHero, {
          heading: settings.heading,
          copy: settings.copy,
          image: data.image ? data.image : null,
          alt: settings.alt_attribute_description,
          credit: settings.photo_credit,
          image2: data.image2 ? data.image2 : null,
          alt2: settings.alt_attribute_description_2,
          credit2: settings.photo_credit_2,
          image3: data.image3 ? data.image3 : null,
          alt3: settings.alt_attribute_description_3,
          credit3: settings.photo_credit_3
        });

      case "page_title":
        return /*#__PURE__*/React__default.createElement(PageTitle, {
          color: color,
          heading: settings.heading,
          image: data.image ? data.image : null,
          alt: settings.alt_attribute_description,
          root: context.root,
          credit: settings.photo_credit
        });

      case "priorities":
        return /*#__PURE__*/React__default.createElement(Priorities, {
          color: color,
          items: data.items,
          root: context.root,
          site: site
        });

      case "promo":
        return /*#__PURE__*/React__default.createElement(Promo, {
          color: color,
          image: data.image ? data.image : null,
          alt: settings.alt_attribute_description,
          credit: settings.photo_credit,
          heading: settings.heading,
          copy: settings.copy,
          link: settings.link,
          linkText: settings.link_text,
          root: context.root
        });

      case "section_intro":
        return /*#__PURE__*/React__default.createElement(SectionIntro, {
          color: color,
          label1: settings.label_1,
          heading1: settings.heading_1,
          label2: settings.label_2,
          heading2: settings.heading_2
        });

      case "snapshot":
        return /*#__PURE__*/React__default.createElement(Snapshot, {
          color: color,
          heading: settings.heading,
          grants: settings.grant_number,
          organizations: settings.organization_number,
          total: settings.total_amount
        });

      case "staff_members":
        return /*#__PURE__*/React__default.createElement(StaffMembers, {
          color: color,
          heading: settings.heading,
          people: settings.people
        });

      case "table_of_contents":
        return /*#__PURE__*/React__default.createElement(TableOfContents, {
          set: data.set,
          image: data.image,
          photoCredit: settings.photo_credit,
          alt: settings.image_alt,
          caption: settings.image_caption,
          root: context.root,
          color: color
        });

      case "two_column_content":
        return /*#__PURE__*/React__default.createElement(TwoColumnContent, {
          color: color,
          copy: settings.copy,
          sidebar: data.sidebar,
          root: context.root,
          flip: settings.sidebar_on_left,
          colored: settings.colored_background
        });

      case "wysiwyg":
        return /*#__PURE__*/React__default.createElement(Wysiwyg, {
          color: color,
          copy: settings.copy,
          quote: settings.quote,
          quoteAuthor: settings.quote_author,
          quoteAuthorLine2: settings.quote_author_line_2,
          quotePosition: settings.quote_position
        });

      default:
        return JSON.stringify(data);
    }
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderBlock());
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var hashFragment = '';
var observer = null;
var asyncTimerId = null;
var scrollFunction = null;

function reset() {
  hashFragment = '';
  if (observer !== null) observer.disconnect();

  if (asyncTimerId !== null) {
    window.clearTimeout(asyncTimerId);
    asyncTimerId = null;
  }
}

function isInteractiveElement(element) {
  var formTags = ['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'];
  var linkTags = ['A', 'AREA'];
  return formTags.includes(element.tagName) && !element.hasAttribute('disabled') || linkTags.includes(element.tagName) && element.hasAttribute('href');
}

function getElAndScroll() {
  var element = null;

  if (hashFragment === '#') {
    // use document.body instead of document.documentElement because of a bug in smoothscroll-polyfill in safari
    // see https://github.com/iamdustan/smoothscroll/issues/138
    // while smoothscroll-polyfill is not included, it is the recommended way to implement smoothscroll
    // in browsers that don't natively support el.scrollIntoView({ behavior: 'smooth' })
    element = document.body;
  } else {
    // check for element with matching id before assume '#top' is the top of the document
    // see https://html.spec.whatwg.org/multipage/browsing-the-web.html#target-element
    var id = hashFragment.replace('#', '');
    element = document.getElementById(id);

    if (element === null && hashFragment === '#top') {
      // see above comment for why document.body instead of document.documentElement
      element = document.body;
    }
  }

  if (element !== null) {
    scrollFunction(element); // update focus to where the page is scrolled to
    // unfortunately this doesn't work in safari (desktop and iOS) when blur() is called

    var originalTabIndex = element.getAttribute('tabindex');

    if (originalTabIndex === null && !isInteractiveElement(element)) {
      element.setAttribute('tabindex', -1);
    }

    element.focus({
      preventScroll: true
    });

    if (originalTabIndex === null && !isInteractiveElement(element)) {
      // for some reason calling blur() in safari resets the focus region to where it was previously,
      // if blur() is not called it works in safari, but then are stuck with default focus styles
      // on an element that otherwise might never had focus styles applied, so not an option
      element.blur();
      element.removeAttribute('tabindex');
    }

    reset();
    return true;
  }

  return false;
}

function hashLinkScroll(timeout) {
  // Push onto callback queue so it runs after the DOM is updated
  window.setTimeout(function () {
    if (getElAndScroll() === false) {
      if (observer === null) {
        observer = new MutationObserver(getElAndScroll);
      }

      observer.observe(document, {
        attributes: true,
        childList: true,
        subtree: true
      }); // if the element doesn't show up in specified timeout or 10 seconds, stop checking

      asyncTimerId = window.setTimeout(function () {
        reset();
      }, timeout || 10000);
    }
  }, 0);
}

function genericHashLink(As) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var linkHash = '';

    if (typeof props.to === 'string' && props.to.includes('#')) {
      linkHash = "#" + props.to.split('#').slice(1).join('#');
    } else if (_typeof(props.to) === 'object' && typeof props.to.hash === 'string') {
      linkHash = props.to.hash;
    }

    var passDownProps = {};

    if (As === NavLink) {
      passDownProps.isActive = function (match, location) {
        return match && match.isExact && location.hash === linkHash;
      };
    }

    function handleClick(e) {
      reset();
      hashFragment = props.elementId ? "#" + props.elementId : linkHash;
      if (props.onClick) props.onClick(e);

      if (hashFragment !== '' && // ignore non-vanilla click events, same as react-router
      // below logic adapted from react-router: https://github.com/ReactTraining/react-router/blob/fc91700e08df8147bd2bb1be19a299cbb14dbcaa/packages/react-router-dom/modules/Link.js#L43-L48
      !e.defaultPrevented && // onClick prevented default
      e.button === 0 && ( // ignore everything but left clicks
      !props.target || props.target === '_self') && // let browser handle "target=_blank" etc
      !(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) // ignore clicks with modifier keys
      ) {
          scrollFunction = props.scroll || function (el) {
            return props.smooth ? el.scrollIntoView({
              behavior: 'smooth'
            }) : el.scrollIntoView();
          };

          hashLinkScroll(props.timeout);
        }
    }

    var filteredProps = __rest(props, ["scroll", "smooth", "timeout", "elementId"]);

    return /*#__PURE__*/React__default.createElement(As, _assign({}, passDownProps, filteredProps, {
      onClick: handleClick,
      ref: ref
    }), props.children);
  });
}

var HashLink = genericHashLink(Link);
var NavHashLink = genericHashLink(NavLink);

if (process.env.NODE_ENV !== 'production') {
  HashLink.displayName = 'HashLink';
  NavHashLink.displayName = 'NavHashLink';
  var propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node,
    scroll: PropTypes.func,
    timeout: PropTypes.number,
    elementId: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };
  HashLink.propTypes = propTypes;
  NavHashLink.propTypes = propTypes;
}

var StyledNavigation = styled.nav.withConfig({
  displayName: "SectionNavigation__StyledNavigation",
  componentId: "sc-115iw3u-0"
})(["background-color:white;width:100%;position:sticky;top:0;z-index:3;> div{width:100%;background-color:", ";padding:14px 20px 0;position:relative;@media (min-width:768px){padding:25px 6.9% 0;}}ul{margin:0;padding:0;list-style:none;display:flex;overflow:auto;}li{margin-right:36px;@media (min-width:768px){margin-right:48px;}&:last-child{margin-right:0;}}a{display:block;font-family:proxima-nova,sans-serif;font-weight:700;font-size:21px;text-decoration:none;color:#1d2042;padding-bottom:18px;position:relative;transition:opacity 0.2s ease-out;@media (min-width:768px){padding-bottom:26px;}&:hover,&:focus{opacity:0.75;}&.active{&::after{content:'';position:absolute;bottom:0;left:0;width:100%;height:5px;background-color:", ";}}}"], function (props) {
  return getLightColor(props.color);
}, function (props) {
  return props.color;
});
var ScrollButton = styled.button.withConfig({
  displayName: "SectionNavigation__ScrollButton",
  componentId: "sc-115iw3u-1"
})(["height:100%;width:50px;background:none;background:linear-gradient( 90deg,rgba( ", ",0 ) 0%,", " 48% );border:none;border-radius:0;position:absolute;top:0;right:0;cursor:pointer;&.hide{display:none;}svg *{stroke:", ";}"], function (props) {
  return convertHexToRGB(convertRGBAtoHEX(getLightColor(props.color)), true);
}, function (props) {
  return convertRGBAtoHEX(getLightColor(props.color));
}, function (props) {
  return props.color;
});

var elementInViewport = function elementInViewport(item) {
  if (item) {
    var elementTop = item.offsetTop;
    var elementBottom = elementTop + item.offsetHeight;
    var viewportTop = window.pageYOffset + window.innerHeight / 2;
    return elementTop < viewportTop && elementBottom > viewportTop;
  } else {
    return false;
  }
};

var highlightItems = function highlightItems(elements, links) {
  elements.forEach(function (anchor, index) {
    if (elementInViewport(anchor.nextSibling)) {
      links[index].classList.add('active');
    } else {
      links[index].classList.remove('active');
    }
  });
};

var SectionNavigation = function SectionNavigation(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color,
      anchors = _ref.anchors;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      scroll = _useState2[0],
      setScroll = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hideScroll = _useState4[0],
      setHideScroll = _useState4[1];

  var navigation = useRef(null);
  useEffect(function () {
    if (navigation.current) {
      var anchorElements = Array.from(document.querySelectorAll('.anchor'));
      var links = Array.from(navigation.current.querySelectorAll('a'));
      var nav = navigation.current.querySelector('ul');

      if (anchorElements.length) {
        window.addEventListener('load', highlightItems(anchorElements, links));
        window.addEventListener('scroll', function () {
          return highlightItems(anchorElements, links);
        });
      }

      window.addEventListener('load', addScroll(nav));
      window.addEventListener('resize', function () {
        return addScroll(nav);
      });
      nav.addEventListener('scroll', function () {
        if (nav.scrollLeft + nav.offsetWidth >= nav.scrollWidth) {
          setHideScroll(true);
        } else {
          setHideScroll(false);
        }
      });
    }
  }, [navigation]);

  var addScroll = function addScroll(nav) {
    var parent = nav.parentElement;

    if (nav.scrollWidth > parent.offsetWidth - parseFloat(window.getComputedStyle(parent).paddingLeft) * 2) {
      setScroll(true);
    } else {
      setScroll(false);
    }

    if (nav.scrollLeft + nav.offsetWidth >= nav.scrollWidth) {
      setHideScroll(true);
    } else {
      setHideScroll(false);
    }
  };

  var scrollNav = function scrollNav() {
    var list = navigation.current.querySelector('ul');
    list.scrollBy({
      left: 200,
      behavior: 'smooth'
    });
  };

  return anchors.length > 0 ? /*#__PURE__*/React__default.createElement(StyledNavigation, {
    ref: navigation,
    color: color
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("ul", null, anchors.map(function (anchor, index) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, anchor.settings.anchor_name && /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(NavHashLink, {
      activeClassName: "",
      to: "#".concat(anchor.settings.anchor_name.replace(/\d|\W/g, ''))
    }, anchor.settings.anchor_name)));
  }), scroll && /*#__PURE__*/React__default.createElement(ScrollButton, {
    className: "".concat(hideScroll ? 'hide' : ''),
    color: color,
    onClick: scrollNav
  }, /*#__PURE__*/React__default.createElement(SvgIconNext, null))))) : null;
};

var Homepage = function Homepage(_ref) {
  var color = _ref.color,
      site = _ref.site;
  var context = useContext(SiteContext);
  useEffect(function () {
    context.getHomepage(site);
  }, []);
  return /*#__PURE__*/React__default.createElement("main", null, Object.keys(context.page).length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SEO, {
    document: context.page
  }), /*#__PURE__*/React__default.createElement(SectionNavigation, {
    color: color,
    anchors: context.page.blocks['Content'].filter(function (block) {
      return block.cell_action === 'anchor';
    })
  }), (context.page.blocks || {})['Hero'] && (context.page.blocks || {})['Hero'].map(function (block) {
    return /*#__PURE__*/React__default.createElement(Block, {
      key: block.id,
      data: block,
      color: color,
      site: site
    });
  }), (context.page.blocks || {})['Content'] && (context.page.blocks || {})['Content'].map(function (block) {
    return /*#__PURE__*/React__default.createElement(Block, {
      key: block.id,
      data: block,
      color: color,
      site: site
    });
  })));
};

var Navigation = styled.nav.withConfig({
  displayName: "PublicationNav__Navigation",
  componentId: "sc-1bapphd-0"
})(["display:flex;border-top:2px solid ", ";& > div{width:50%;& a{display:flex;align-items:center;}}& > div:first-child{border-right:2px solid ", ";& span{mask:url(\"", "\") no-repeat center;margin-right:0.75rem;@media (min-width:768px){margin-right:1.5rem;}}}& > div:last-child{& a{justify-content:flex-end;}& span{mask:url(\"", "\") no-repeat center;margin-left:0.75rem;@media (min-width:768px){margin-left:1.5rem;}}}"], function (props) {
  return getLightColor(props.color);
}, function (props) {
  return getLightColor(props.color);
}, prev, next);
var PublicationLink = styled.a.withConfig({
  displayName: "PublicationNav__PublicationLink",
  componentId: "sc-1bapphd-1"
})(["display:block;height:100%;padding:2rem 6.9%;color:", ";font-size:1rem;font-weight:800;text-decoration:none;font-family:proxima-nova-condensed,sans-serif;position:relative;transition:background-color 0.2s ease;line-height:1.1;@media (min-width:768px){font-size:1.25rem;}&:hover{background-color:#375f901a;}& > span{display:block;width:1.5rem;height:2.625rem;background-color:", ";flex:0 0 auto;}& div > span{display:block;color:#666;mask:none !important;margin:0.25rem 0 0 !important;font-weight:400;font-size:0.75rem;text-transform:uppercase;}"], function (props) {
  return props.color;
}, function (props) {
  return props.color;
});
var PublicationNav = function PublicationNav(_ref) {
  var color = _ref.color,
      prev = _ref.prev,
      next = _ref.next;
  return prev || next ? /*#__PURE__*/React__default.createElement(Navigation, {
    color: color
  }, /*#__PURE__*/React__default.createElement("div", null, prev && /*#__PURE__*/React__default.createElement(PublicationLink, {
    href: "/pages/".concat(prev.slug),
    color: color
  }, /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("div", null, prev.custom_title || prev.title, /*#__PURE__*/React__default.createElement("span", null, "Previous Page")))), /*#__PURE__*/React__default.createElement("div", null, next && /*#__PURE__*/React__default.createElement(PublicationLink, {
    href: "/pages/".concat(next.slug),
    color: color
  }, /*#__PURE__*/React__default.createElement("div", null, next.custom_title || next.title, /*#__PURE__*/React__default.createElement("span", null, "Next Page")), /*#__PURE__*/React__default.createElement("span", null)))) : null;
};

var BackLinkContainer = styled.div.withConfig({
  displayName: "BackLink__BackLinkContainer",
  componentId: "sc-1x8i0ua-0"
})(["padding:32px 20px 0;@media (min-width:768px){padding:32px 6.9% 0;}"]);

var BackLink = function BackLink(_ref) {
  var start = _ref.start;
  return start !== undefined && start !== null ? /*#__PURE__*/React__default.createElement(BackLinkContainer, null, /*#__PURE__*/React__default.createElement(StyledLink, {
    label: "Table of Contents",
    to: "/pages/".concat(start.slug),
    back: true
  })) : null;
};

var Page = function Page(_ref) {
  var color = _ref.color,
      site = _ref.site;
  var context = useContext(SiteContext);
  var historyParams = useParams();
  useEffect(function () {
    context.getPage(historyParams.id, site);
  }, []);
  useEffect(function () {
    if (context.page.blocks && location.hash) {
      var link = document.querySelector("a[href*=\"".concat(location.hash, "\"]"));

      if (link) {
        setTimeout(function () {
          link.click();
        }, 100);
      }
    }
  }, [context.page.blocks]);
  return /*#__PURE__*/React__default.createElement("main", null, /*#__PURE__*/React__default.createElement(BackLink, {
    start: context.page.start_page
  }), Object.keys(context.page).length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SEO, {
    document: context.page
  }), (context.page.blocks || {})["Hero"] && (context.page.blocks || {})["Hero"].map(function (block) {
    return /*#__PURE__*/React__default.createElement(Block, {
      key: block.id,
      data: block,
      color: color,
      site: site
    });
  }), (context.page.blocks || {})["Content"] && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SectionNavigation, {
    color: color,
    anchors: context.page.blocks["Content"].filter(function (block) {
      return block.cell_action === "anchor";
    })
  }), context.page.blocks["Content"].map(function (block) {
    return /*#__PURE__*/React__default.createElement(Block, {
      key: block.id,
      data: block,
      color: color,
      site: site
    });
  }))), /*#__PURE__*/React__default.createElement(PublicationNav, {
    color: color,
    prev: context.page.prev_page,
    next: context.page.next_page
  }));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var lib = {};

var Range = {};

var utils = {};

var types = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Direction = void 0;

(function (Direction) {
  Direction["Right"] = "to right";
  Direction["Left"] = "to left";
  Direction["Down"] = "to bottom";
  Direction["Up"] = "to top";
})(exports.Direction || (exports.Direction = {}));
}(types));

(function (exports) {

var __spreadArrays = commonjsGlobal && commonjsGlobal.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThumbOverlap = exports.assertUnreachable = exports.voidFn = exports.getTrackBackground = exports.replaceAt = exports.schd = exports.translate = exports.getClosestThumbIndex = exports.translateThumbs = exports.getPaddingAndBorder = exports.getMargin = exports.checkInitialOverlap = exports.checkValuesAgainstBoundaries = exports.checkBoundaries = exports.isVertical = exports.relativeValue = exports.normalizeValue = exports.isStepDivisible = exports.isTouchEvent = exports.getStepDecimals = void 0;

var react_1 = React__default;

var types_1 = types;

var getStepDecimals = function getStepDecimals(step) {
  var decimals = step.toString().split('.')[1];
  return decimals ? decimals.length : 0;
};

exports.getStepDecimals = getStepDecimals;

function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}

exports.isTouchEvent = isTouchEvent;

function isStepDivisible(min, max, step) {
  var res = (max - min) / step;
  return parseInt(res.toString(), 10) === res;
}

exports.isStepDivisible = isStepDivisible;

function normalizeValue(value, index, min, max, step, allowOverlap, values) {
  var BIG_NUM = 10e10;
  value = Math.round(value * BIG_NUM) / BIG_NUM;

  if (!allowOverlap) {
    var prev = values[index - 1];
    var next = values[index + 1];
    if (prev && prev > value) return prev;
    if (next && next < value) return next;
  }

  if (value > max) return max;
  if (value < min) return min; // `remainder` is a difference between the given value and a full step value
  // that is closest lower to the given value and is in the range between the min value
  // and the given value

  var remainder = Math.floor(value * BIG_NUM - min * BIG_NUM) % Math.floor(step * BIG_NUM);
  var closestLowerNum = Math.floor(value * BIG_NUM - Math.abs(remainder));
  var rounded = remainder === 0 ? value : closestLowerNum / BIG_NUM; // Values with a remainder `< step/2` are rounded to the closest lower value
  // while values with a remainder `= > step/2` are rounded to the closest bigger value

  var res = Math.abs(remainder / BIG_NUM) < step / 2 ? rounded : rounded + step;
  var decimalPlaces = exports.getStepDecimals(step);
  return parseFloat(res.toFixed(decimalPlaces));
}

exports.normalizeValue = normalizeValue;

function relativeValue(value, min, max) {
  return (value - min) / (max - min);
}

exports.relativeValue = relativeValue;

function isVertical(direction) {
  return direction === types_1.Direction.Up || direction === types_1.Direction.Down;
}

exports.isVertical = isVertical;

function checkBoundaries(value, min, max) {
  if (min >= max) {
    throw new RangeError("min (" + min + ") is equal/bigger than max (" + max + ")");
  }

  if (value < min) {
    throw new RangeError("value (" + value + ") is smaller than min (" + min + ")");
  }

  if (value > max) {
    throw new RangeError("value (" + value + ") is bigger than max (" + max + ")");
  }
}

exports.checkBoundaries = checkBoundaries;

function checkValuesAgainstBoundaries(value, min, max) {
  if (value < min) {
    // set selectedValue to min
    return min;
  }

  if (value > max) {
    // set selectedValue to max
    return max;
  } else {
    return value;
  }
}

exports.checkValuesAgainstBoundaries = checkValuesAgainstBoundaries;

function checkInitialOverlap(values) {
  if (values.length < 2) return;

  if (!values.slice(1).every(function (item, i) {
    return values[i] <= item;
  })) {
    throw new RangeError("values={[" + values + "]} needs to be sorted when allowOverlap={false}");
  }
}

exports.checkInitialOverlap = checkInitialOverlap;

function getMargin(element) {
  var style = window.getComputedStyle(element);
  return {
    top: parseInt(style['margin-top'], 10),
    bottom: parseInt(style['margin-bottom'], 10),
    left: parseInt(style['margin-left'], 10),
    right: parseInt(style['margin-right'], 10)
  };
}

exports.getMargin = getMargin;

function getPaddingAndBorder(element) {
  var style = window.getComputedStyle(element);
  return {
    top: parseInt(style['padding-top'], 10) + parseInt(style['border-top-width'], 10),
    bottom: parseInt(style['padding-bottom'], 10) + parseInt(style['border-bottom-width'], 10),
    left: parseInt(style['padding-left'], 10) + parseInt(style['border-left-width'], 10),
    right: parseInt(style['padding-right'], 10) + parseInt(style['border-right-width'], 10)
  };
}

exports.getPaddingAndBorder = getPaddingAndBorder;

function translateThumbs(elements, offsets, rtl) {
  var inverter = rtl ? -1 : 1;
  elements.forEach(function (element, index) {
    return translate(element, inverter * offsets[index].x, offsets[index].y);
  });
}

exports.translateThumbs = translateThumbs;
/**
 * Util function for calculating the index of the thumb that is closes to a given position
 * @param thumbs - array of Thumb element to calculate the distance from
 * @param clientX - target x position (mouse/touch)
 * @param clientY - target y position (mouse/touch)
 * @param direction - the direction of the track
 */

function getClosestThumbIndex(thumbs, clientX, clientY, direction) {
  var thumbIndex = 0;
  var minThumbDistance = getThumbDistance(thumbs[0], clientX, clientY, direction);

  for (var i = 1; i < thumbs.length; i++) {
    var thumbDistance = getThumbDistance(thumbs[i], clientX, clientY, direction);

    if (thumbDistance < minThumbDistance) {
      minThumbDistance = thumbDistance;
      thumbIndex = i;
    }
  }

  return thumbIndex;
}

exports.getClosestThumbIndex = getClosestThumbIndex;

function translate(element, x, y) {
  element.style.transform = "translate(" + x + "px, " + y + "px)";
}

exports.translate = translate; // adapted from https://github.com/alexreardon/raf-schd

var schd = function schd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  return wrapperFn;
};

exports.schd = schd;

function replaceAt(values, index, value) {
  var ret = values.slice(0);
  ret[index] = value;
  return ret;
}

exports.replaceAt = replaceAt;

function getTrackBackground(_a) {
  var values = _a.values,
      colors = _a.colors,
      min = _a.min,
      max = _a.max,
      _b = _a.direction,
      direction = _b === void 0 ? types_1.Direction.Right : _b,
      _c = _a.rtl,
      rtl = _c === void 0 ? false : _c;

  if (rtl && direction === types_1.Direction.Right) {
    direction = types_1.Direction.Left;
  } else if (rtl && types_1.Direction.Left) {
    direction = types_1.Direction.Right;
  } // sort values ascending


  var progress = values.slice(0).sort(function (a, b) {
    return a - b;
  }).map(function (value) {
    return (value - min) / (max - min) * 100;
  });
  var middle = progress.reduce(function (acc, point, index) {
    return acc + ", " + colors[index] + " " + point + "%, " + colors[index + 1] + " " + point + "%";
  }, '');
  return "linear-gradient(" + direction + ", " + colors[0] + " 0%" + middle + ", " + colors[colors.length - 1] + " 100%)";
}

exports.getTrackBackground = getTrackBackground;

function voidFn() {}

exports.voidFn = voidFn;

function assertUnreachable(x) {
  throw new Error("Didn't expect to get here");
}

exports.assertUnreachable = assertUnreachable;
/**
 * Util function for grabbing the true largest width of a thumb
 * including the label
 * @param thumbEl - Thumb element to grab the largest width from
 * @param value - Thumb value, not label value
 * @param separator - Label separator value
 */

var getThumbWidth = function getThumbWidth(thumbEl, value, separator, decimalPlaces, valueToLabel) {
  if (valueToLabel === void 0) {
    valueToLabel = function valueToLabel(value) {
      return value;
    };
  }

  var width = Math.ceil(__spreadArrays([thumbEl], Array.from(thumbEl.children)).reduce(function (width, el) {
    var elWidth = Math.ceil(el.getBoundingClientRect().width);
    /**
     * If a label contains a merged label value, it won't return the true
     * label width for that Thumb. Clone the label and change the value
     * to that individual Thumb value in order to grab the true width.
     */

    if (el.innerText && el.innerText.includes(separator) && el.childElementCount === 0) {
      var elClone = el.cloneNode(true);
      elClone.innerHTML = valueToLabel(value.toFixed(decimalPlaces));
      elClone.style.visibility = 'hidden';
      document.body.appendChild(elClone);
      elWidth = Math.ceil(elClone.getBoundingClientRect().width);
      document.body.removeChild(elClone);
    }

    return elWidth > width ? elWidth : width;
  }, thumbEl.getBoundingClientRect().width));
  return width;
};
/**
 * Bulk of logic for thumb overlaps
 * Consider a scenario with 5 thumbs;
 * Thumb 1 overlaps with thumb 0 and thumb 2
 * Thumb 2 overlaps with thumb 3
 * We need an array that contains [0, 1, 2, 3]
 * The function needs to return the directly overlapping thumbs
 * and all thumbs overlapping linked to those and so on
 * @param index - Thumb index calculating overlaps for
 * @param offsets - Current Array of Thumb offsets for Range
 * @param thumbs - Array of Thumb elements
 * @param values - Array of Thumb values
 * @param separator - String separator for merged label values
 * @returns overlaps - Array of all overlapping thumbs from the index
 */


var getOverlaps = function getOverlaps(index, offsets, thumbs, values, separator, decimalPlaces, valueToLabel) {
  if (valueToLabel === void 0) {
    valueToLabel = function valueToLabel(value) {
      return value;
    };
  }

  var overlaps = [];
  /**
   * Recursive function for building the overlaps Array
   * If an overlap is found, find the overlaps for that overlap
   * @param thumbIndex current Thumb index to find overlaps from
   */

  var buildOverlaps = function buildOverlaps(thumbIndex) {
    var thumbXWidth = getThumbWidth(thumbs[thumbIndex], values[thumbIndex], separator, decimalPlaces, valueToLabel);
    var thumbX = offsets[thumbIndex].x;
    /**
     * Iterate through the Thumb offsets, if there is a match
     * add the thumbIndex and siblingIndex to the overlaps Array
     *
     * Then build overlaps from the overlapping siblingIndex
     */

    offsets.forEach(function (_a, siblingIndex) {
      var siblingX = _a.x;
      var siblingWidth = getThumbWidth(thumbs[siblingIndex], values[siblingIndex], separator, decimalPlaces, valueToLabel);

      if (thumbIndex !== siblingIndex && (thumbX >= siblingX && thumbX <= siblingX + siblingWidth || thumbX + thumbXWidth >= siblingX && thumbX + thumbXWidth <= siblingX + siblingWidth)) {
        if (!overlaps.includes(siblingIndex)) {
          overlaps.push(thumbIndex);
          overlaps.push(siblingIndex);
          overlaps = __spreadArrays(overlaps, [thumbIndex, siblingIndex]);
          buildOverlaps(siblingIndex);
        }
      }
    });
  };

  buildOverlaps(index); // Sort and remove duplicates from the built overlaps

  return Array.from(new Set(overlaps.sort()));
};
/**
 * A custom React Hook for calculating whether a thumb overlaps
 * another and whether labels could/should merge.
 * @param rangeRef - React ref value of Range component
 * @param values - current Range values Array
 * @param index - thumb index
 * @param step - step value, used to calculate the number of decimal places
 * @param separator - string to separate thumb values
 * @returns label value + styling for thumb label
 */


var useThumbOverlap = function useThumbOverlap(rangeRef, values, index, step, separator, valueToLabel) {
  if (step === void 0) {
    step = 0.1;
  }

  if (separator === void 0) {
    separator = ' - ';
  }

  if (valueToLabel === void 0) {
    valueToLabel = function valueToLabel(value) {
      return value;
    };
  }

  var decimalPlaces = exports.getStepDecimals(step); // Create initial label style and value. Label value defaults to thumb value

  var _a = react_1.useState({}),
      labelStyle = _a[0],
      setLabelStyle = _a[1];

  var _b = react_1.useState(valueToLabel(values[index].toFixed(decimalPlaces))),
      labelValue = _b[0],
      setLabelValue = _b[1]; // When the rangeRef or values change, update the Thumb label values and styling


  react_1.useEffect(function () {
    if (rangeRef) {
      var thumbs = rangeRef.getThumbs();
      if (thumbs.length < 1) return;
      var newStyle = {};
      var offsets_1 = rangeRef.getOffsets();
      /**
       * Get any overlaps for the given Thumb index. This must return all linked
       * Thumbs. So if there are 4 Thumbs and Thumbs 2, 3 and 4 overlap. If we are
       * getting the overlaps for Thumb 1 and it overlaps only Thumb 2, we must get
       * 2, 3 and 4 also.
       */

      var overlaps = getOverlaps(index, offsets_1, thumbs, values, separator, decimalPlaces, valueToLabel); // Set a default label value of the Thumb value

      var labelValue_1 = valueToLabel(values[index].toFixed(decimalPlaces));
      /**
       * If there are overlaps for the Thumb, we need to calculate the correct
       * Label value along with the relevant styling. We only want to show a Label
       * for the left most Thumb in an overlapping set.
       * All other Thumbs will be set to display: none.
       */

      if (overlaps.length) {
        /**
         * Get an Array of the offsets for the overlapping Thumbs
         * This is so we can determine if the Thumb we are looking at
         * is the left most thumb in an overlapping set
         */
        var offsetsX = overlaps.reduce(function (a, c, i, s) {
          return a.length ? __spreadArrays(a, [offsets_1[s[i]].x]) : [offsets_1[s[i]].x];
        }, []);
        /**
         * If our Thumb is the left most Thumb, we can build a Label value
         * and set the style for that Label
         */

        if (Math.min.apply(Math, offsetsX) === offsets_1[index].x) {
          /**
           * First calculate the Label value. To do this,
           * grab all the values for the Thumbs in our overlaps.
           * Then convert that to a Set and sort it whilst removing duplicates.
           */
          var labelValues_1 = [];
          overlaps.forEach(function (thumb) {
            labelValues_1.push(values[thumb].toFixed(decimalPlaces));
          });
          /**
           *  Update the labelValue with the resulting Array
           *  joined by our defined separator
           */

          labelValue_1 = Array.from(new Set(labelValues_1.sort(function (a, b) {
            return parseFloat(a) - parseFloat(b);
          }))).map(valueToLabel).join(separator);
          /**
           * Lastly, build the label styling. The label styling will
           * position the label and apply a transform so that it's centered.
           * We want the center point between the left edge of the left most Thumb
           * and the right edge of the right most Thumb.
           */

          var first = Math.min.apply(Math, offsetsX);
          var last = Math.max.apply(Math, offsetsX);
          var lastWidth = thumbs[overlaps[offsetsX.indexOf(last)]].getBoundingClientRect().width;
          newStyle.left = Math.abs(first - (last + lastWidth)) / 2 + "px";
          newStyle.transform = 'translate(-50%, 0)';
        } else {
          // If the Thumb isn't the left most Thumb, hide the Label!
          newStyle.visibility = 'hidden';
        }
      } // Update the label value and style


      setLabelValue(labelValue_1);
      setLabelStyle(newStyle);
    }
  }, [rangeRef, values]);
  return [labelValue, labelStyle];
};

exports.useThumbOverlap = useThumbOverlap;
/**
 * Util function for calculating the distance of the center of a thumb
 * form a given mouse/touch target's position
 * @param thumbEl - Thumb element to calculate the distance from
 * @param clientX - target x position (mouse/touch)
 * @param clientY - target y position (mouse/touch)
 * @param direction - the direction of the track
 */

function getThumbDistance(thumbEl, clientX, clientY, direction) {
  var _a = thumbEl.getBoundingClientRect(),
      left = _a.left,
      top = _a.top,
      width = _a.width,
      height = _a.height;

  return isVertical(direction) ? Math.abs(clientY - (top + height / 2)) : Math.abs(clientX - (left + width / 2));
}
}(utils));

(function (exports) {

var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __spreadArrays = commonjsGlobal && commonjsGlobal.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(React__default);

var utils_1 = utils;

var types_1 = types;

var INCREASE_KEYS = ['ArrowRight', 'ArrowUp', 'k', 'PageUp'];
var DECREASE_KEYS = ['ArrowLeft', 'ArrowDown', 'j', 'PageDown'];

var Range =
/** @class */
function (_super) {
  __extends(Range, _super);

  function Range(props) {
    var _this = _super.call(this, props) || this;

    _this.trackRef = React.createRef();
    _this.thumbRefs = [];
    _this.markRefs = [];
    _this.state = {
      draggedTrackPos: [-1, -1],
      draggedThumbIndex: -1,
      thumbZIndexes: new Array(_this.props.values.length).fill(0).map(function (t, i) {
        return i;
      }),
      isChanged: false,
      markOffsets: []
    };

    _this.getOffsets = function () {
      var _a = _this.props,
          direction = _a.direction,
          values = _a.values,
          min = _a.min,
          max = _a.max;
      var trackElement = _this.trackRef.current;
      var trackRect = trackElement.getBoundingClientRect();
      var trackPadding = utils_1.getPaddingAndBorder(trackElement);
      return _this.getThumbs().map(function (thumb, index) {
        var thumbOffsets = {
          x: 0,
          y: 0
        };
        var thumbRect = thumb.getBoundingClientRect();
        var thumbMargins = utils_1.getMargin(thumb);

        switch (direction) {
          case types_1.Direction.Right:
            thumbOffsets.x = (thumbMargins.left + trackPadding.left) * -1;
            thumbOffsets.y = ((thumbRect.height - trackRect.height) / 2 + trackPadding.top) * -1;
            thumbOffsets.x += trackRect.width * utils_1.relativeValue(values[index], min, max) - thumbRect.width / 2;
            return thumbOffsets;

          case types_1.Direction.Left:
            thumbOffsets.x = (thumbMargins.right + trackPadding.right) * -1;
            thumbOffsets.y = ((thumbRect.height - trackRect.height) / 2 + trackPadding.top) * -1;
            thumbOffsets.x += trackRect.width - trackRect.width * utils_1.relativeValue(values[index], min, max) - thumbRect.width / 2;
            return thumbOffsets;

          case types_1.Direction.Up:
            thumbOffsets.x = ((thumbRect.width - trackRect.width) / 2 + thumbMargins.left + trackPadding.left) * -1;
            thumbOffsets.y = -trackPadding.left;
            thumbOffsets.y += trackRect.height - trackRect.height * utils_1.relativeValue(values[index], min, max) - thumbRect.height / 2;
            return thumbOffsets;

          case types_1.Direction.Down:
            thumbOffsets.x = ((thumbRect.width - trackRect.width) / 2 + thumbMargins.left + trackPadding.left) * -1;
            thumbOffsets.y = -trackPadding.left;
            thumbOffsets.y += trackRect.height * utils_1.relativeValue(values[index], min, max) - thumbRect.height / 2;
            return thumbOffsets;

          default:
            return utils_1.assertUnreachable(direction);
        }
      });
    };

    _this.getThumbs = function () {
      if (_this.trackRef && _this.trackRef.current) {
        return Array.from(_this.trackRef.current.children).filter(function (el) {
          return el.hasAttribute('aria-valuenow');
        });
      }

      console.warn('No thumbs found in the track container. Did you forget to pass & spread the `props` param in renderTrack?');
      return [];
    };

    _this.getTargetIndex = function (e) {
      return _this.getThumbs().findIndex(function (child) {
        return child === e.target || child.contains(e.target);
      });
    };

    _this.addTouchEvents = function (e) {
      document.addEventListener('touchmove', _this.schdOnTouchMove, {
        passive: false
      });
      document.addEventListener('touchend', _this.schdOnEnd, {
        passive: false
      });
      document.addEventListener('touchcancel', _this.schdOnEnd, {
        passive: false
      });
    };

    _this.addMouseEvents = function (e) {
      document.addEventListener('mousemove', _this.schdOnMouseMove);
      document.addEventListener('mouseup', _this.schdOnEnd);
    };

    _this.onMouseDownTrack = function (e) {
      var _a;

      if (e.button !== 0) return;
      e.persist();
      e.preventDefault();

      _this.addMouseEvents(e.nativeEvent);

      if (_this.props.values.length > 1 && _this.props.draggableTrack) {
        if (_this.thumbRefs.some(function (thumbRef) {
          var _a;

          return (_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target);
        })) return; // handle dragging the whole track

        _this.setState({
          draggedTrackPos: [e.clientX, e.clientY]
        }, function () {
          return _this.onMove(e.clientX, e.clientY);
        });
      } else {
        // get the index of the thumb that is closest to the place where the track is clicked
        var draggedThumbIndex = utils_1.getClosestThumbIndex(_this.thumbRefs.map(function (t) {
          return t.current;
        }), e.clientX, e.clientY, _this.props.direction); // move the thumb which is closest to the place where the track is clicked

        (_a = _this.thumbRefs[draggedThumbIndex].current) === null || _a === void 0 ? void 0 : _a.focus();

        _this.setState({
          draggedThumbIndex: draggedThumbIndex
        }, function () {
          return _this.onMove(e.clientX, e.clientY);
        });
      }
    };

    _this.onResize = function () {
      utils_1.translateThumbs(_this.getThumbs(), _this.getOffsets(), _this.props.rtl);

      _this.calculateMarkOffsets();
    };

    _this.onTouchStartTrack = function (e) {
      var _a;

      e.persist();

      _this.addTouchEvents(e.nativeEvent);

      if (_this.props.values.length > 1 && _this.props.draggableTrack) {
        if (_this.thumbRefs.some(function (thumbRef) {
          var _a;

          return (_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target);
        })) return; // handle dragging the whole track

        _this.setState({
          draggedTrackPos: [e.touches[0].clientX, e.touches[0].clientY]
        }, function () {
          return _this.onMove(e.touches[0].clientX, e.touches[0].clientY);
        });
      } else {
        // get the index of the thumb that is closest to the place where the track is clicked
        var draggedThumbIndex = utils_1.getClosestThumbIndex(_this.thumbRefs.map(function (t) {
          return t.current;
        }), e.touches[0].clientX, e.touches[0].clientY, _this.props.direction); // move the thumb which is closest to the place where the track is clicked

        (_a = _this.thumbRefs[draggedThumbIndex].current) === null || _a === void 0 ? void 0 : _a.focus();

        _this.setState({
          draggedThumbIndex: draggedThumbIndex
        }, function () {
          return _this.onMove(e.touches[0].clientX, e.touches[0].clientY);
        });
      }
    };

    _this.onMouseOrTouchStart = function (e) {
      if (_this.props.disabled) return;
      var isTouch = utils_1.isTouchEvent(e);
      if (!isTouch && e.button !== 0) return;

      var index = _this.getTargetIndex(e);

      if (index === -1) return;

      if (isTouch) {
        _this.addTouchEvents(e);
      } else {
        _this.addMouseEvents(e);
      }

      _this.setState({
        draggedThumbIndex: index,
        thumbZIndexes: _this.state.thumbZIndexes.map(function (t, i) {
          if (i === index) {
            return Math.max.apply(Math, _this.state.thumbZIndexes);
          }

          return t <= _this.state.thumbZIndexes[index] ? t : t - 1;
        })
      });
    };

    _this.onMouseMove = function (e) {
      e.preventDefault();

      _this.onMove(e.clientX, e.clientY);
    };

    _this.onTouchMove = function (e) {
      e.preventDefault();

      _this.onMove(e.touches[0].clientX, e.touches[0].clientY);
    };

    _this.onKeyDown = function (e) {
      var _a = _this.props,
          values = _a.values,
          onChange = _a.onChange,
          step = _a.step,
          rtl = _a.rtl;
      var isChanged = _this.state.isChanged;

      var index = _this.getTargetIndex(e.nativeEvent);

      var inverter = rtl ? -1 : 1;
      if (index === -1) return;

      if (INCREASE_KEYS.includes(e.key)) {
        e.preventDefault();

        _this.setState({
          draggedThumbIndex: index,
          isChanged: true
        });

        onChange(utils_1.replaceAt(values, index, _this.normalizeValue(values[index] + inverter * (e.key === 'PageUp' ? step * 10 : step), index)));
      } else if (DECREASE_KEYS.includes(e.key)) {
        e.preventDefault();

        _this.setState({
          draggedThumbIndex: index,
          isChanged: true
        });

        onChange(utils_1.replaceAt(values, index, _this.normalizeValue(values[index] - inverter * (e.key === 'PageDown' ? step * 10 : step), index)));
      } else if (e.key === 'Tab') {
        _this.setState({
          draggedThumbIndex: -1
        }, function () {
          // If key pressed when thumb was moving, fire onFinalChange
          if (isChanged) {
            _this.fireOnFinalChange();
          }
        });
      } else {
        if (isChanged) {
          _this.fireOnFinalChange();
        }
      }
    };

    _this.onKeyUp = function (e) {
      var isChanged = _this.state.isChanged;

      _this.setState({
        draggedThumbIndex: -1
      }, function () {
        if (isChanged) {
          _this.fireOnFinalChange();
        }
      });
    };

    _this.onMove = function (clientX, clientY) {
      var _a = _this.state,
          draggedThumbIndex = _a.draggedThumbIndex,
          draggedTrackPos = _a.draggedTrackPos;
      var _b = _this.props,
          direction = _b.direction,
          min = _b.min,
          max = _b.max,
          onChange = _b.onChange,
          values = _b.values,
          step = _b.step,
          rtl = _b.rtl;
      if (draggedThumbIndex === -1 && draggedTrackPos[0] === -1 && draggedTrackPos[1] === -1) return null;
      var trackElement = _this.trackRef.current; // If component was closed down prematurely, A last onMove could be triggered based on requestAnimationFrame()

      if (!trackElement) return null;
      var trackRect = trackElement.getBoundingClientRect();
      var trackLength = utils_1.isVertical(direction) ? trackRect.height : trackRect.width;

      if (draggedTrackPos[0] !== -1 && draggedTrackPos[1] !== -1) {
        // calculate how much it moved since the last update
        var dX = clientX - draggedTrackPos[0];
        var dY = clientY - draggedTrackPos[1]; // calculate the delta of the value

        var deltaValue = 0;

        switch (direction) {
          case types_1.Direction.Right:
          case types_1.Direction.Left:
            deltaValue = dX / trackLength * (max - min);
            break;

          case types_1.Direction.Down:
          case types_1.Direction.Up:
            deltaValue = dY / trackLength * (max - min);
            break;

          default:
            utils_1.assertUnreachable(direction);
        } // invert for RTL


        if (rtl) {
          deltaValue *= -1;
        }

        if (Math.abs(deltaValue) >= step / 2) {
          // adjust delta so it fits into the range
          for (var i = 0; i < _this.thumbRefs.length; i++) {
            if (values[i] === max && Math.sign(deltaValue) === 1 || values[i] === min && Math.sign(deltaValue) === -1) return;
            var thumbValue = values[i] + deltaValue;
            if (thumbValue > max) deltaValue = max - values[i];else if (thumbValue < min) deltaValue = min - values[i];
          } // add the delta to each thumb


          var newValues = values.slice(0);

          for (var i = 0; i < _this.thumbRefs.length; i++) {
            newValues = utils_1.replaceAt(newValues, i, _this.normalizeValue(values[i] + deltaValue, i));
          }

          _this.setState({
            draggedTrackPos: [clientX, clientY]
          });

          onChange(newValues);
        }
      } else {
        var newValue = 0;

        switch (direction) {
          case types_1.Direction.Right:
            newValue = (clientX - trackRect.left) / trackLength * (max - min) + min;
            break;

          case types_1.Direction.Left:
            newValue = (trackLength - (clientX - trackRect.left)) / trackLength * (max - min) + min;
            break;

          case types_1.Direction.Down:
            newValue = (clientY - trackRect.top) / trackLength * (max - min) + min;
            break;

          case types_1.Direction.Up:
            newValue = (trackLength - (clientY - trackRect.top)) / trackLength * (max - min) + min;
            break;

          default:
            utils_1.assertUnreachable(direction);
        } // invert for RTL


        if (rtl) {
          newValue = max + min - newValue;
        }

        if (Math.abs(values[draggedThumbIndex] - newValue) >= step / 2) {
          onChange(utils_1.replaceAt(values, draggedThumbIndex, _this.normalizeValue(newValue, draggedThumbIndex)));
        }
      }
    };

    _this.normalizeValue = function (value, index) {
      var _a = _this.props,
          min = _a.min,
          max = _a.max,
          step = _a.step,
          allowOverlap = _a.allowOverlap,
          values = _a.values;
      return utils_1.normalizeValue(value, index, min, max, step, allowOverlap, values);
    };

    _this.onEnd = function (e) {
      e.preventDefault();
      document.removeEventListener('mousemove', _this.schdOnMouseMove);
      document.removeEventListener('touchmove', _this.schdOnTouchMove);
      document.removeEventListener('mouseup', _this.schdOnEnd);
      document.removeEventListener('touchend', _this.schdOnEnd);
      document.removeEventListener('touchcancel', _this.schdOnEnd);
      if (_this.state.draggedThumbIndex === -1 && _this.state.draggedTrackPos[0] === -1 && _this.state.draggedTrackPos[1] === -1) return null;

      _this.setState({
        draggedThumbIndex: -1,
        draggedTrackPos: [-1, -1]
      }, function () {
        _this.fireOnFinalChange();
      });
    };

    _this.fireOnFinalChange = function () {
      _this.setState({
        isChanged: false
      });

      var _a = _this.props,
          onFinalChange = _a.onFinalChange,
          values = _a.values;

      if (onFinalChange) {
        onFinalChange(values);
      }
    };

    _this.calculateMarkOffsets = function () {
      if (!_this.props.renderMark || !_this.trackRef || _this.trackRef.current === null) return;
      var elStyles = window.getComputedStyle(_this.trackRef.current);
      var trackWidth = parseInt(elStyles.width, 10);
      var trackHeight = parseInt(elStyles.height, 10);
      var paddingLeft = parseInt(elStyles.paddingLeft, 10);
      var paddingTop = parseInt(elStyles.paddingTop, 10);
      var res = [];

      for (var i = 0; i < _this.numOfMarks + 1; i++) {
        var markHeight = 9999;
        var markWidth = 9999;

        if (_this.markRefs[i].current) {
          var markRect = _this.markRefs[i].current.getBoundingClientRect();

          markHeight = markRect.height;
          markWidth = markRect.width;
        }

        if (_this.props.direction === types_1.Direction.Left || _this.props.direction === types_1.Direction.Right) {
          res.push([Math.round(trackWidth / _this.numOfMarks * i + paddingLeft - markWidth / 2), -Math.round((markHeight - trackHeight) / 2)]);
        } else {
          res.push([Math.round(trackHeight / _this.numOfMarks * i + paddingTop - markHeight / 2), -Math.round((markWidth - trackWidth) / 2)]);
        }
      }

      _this.setState({
        markOffsets: res
      });
    };

    if (props.step === 0) {
      throw new Error('"step" property should be a positive number');
    }

    _this.numOfMarks = (props.max - props.min) / _this.props.step;
    _this.schdOnMouseMove = utils_1.schd(_this.onMouseMove);
    _this.schdOnTouchMove = utils_1.schd(_this.onTouchMove);
    _this.schdOnEnd = utils_1.schd(_this.onEnd);
    _this.thumbRefs = props.values.map(function () {
      return React.createRef();
    });

    for (var i = 0; i < _this.numOfMarks + 1; i++) {
      _this.markRefs[i] = React.createRef();
    }

    return _this;
  }

  Range.prototype.componentDidMount = function () {
    var _this = this;

    var _a = this.props,
        values = _a.values,
        min = _a.min,
        step = _a.step;
    this.resizeObserver = window.ResizeObserver ? new window.ResizeObserver(this.onResize) : {
      observe: function observe() {
        return window.addEventListener('resize', _this.onResize);
      },
      unobserve: function unobserve() {
        return window.removeEventListener('resize', _this.onResize);
      }
    };
    document.addEventListener('touchstart', this.onMouseOrTouchStart, {
      passive: false
    });
    document.addEventListener('mousedown', this.onMouseOrTouchStart, {
      passive: false
    });
    !this.props.allowOverlap && utils_1.checkInitialOverlap(this.props.values);
    this.props.values.forEach(function (value) {
      return utils_1.checkBoundaries(value, _this.props.min, _this.props.max);
    });
    this.resizeObserver.observe(this.trackRef.current);
    utils_1.translateThumbs(this.getThumbs(), this.getOffsets(), this.props.rtl);
    this.calculateMarkOffsets();
    values.forEach(function (value) {
      if (!utils_1.isStepDivisible(min, value, step)) {
        console.warn('The `values` property is in conflict with the current `step`, `min`, and `max` properties. Please provide values that are accessible using the min, max, and step values.');
      }
    });
  };

  Range.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a = this.props,
        max = _a.max,
        min = _a.min,
        step = _a.step,
        values = _a.values,
        rtl = _a.rtl;

    if (prevProps.max !== max || prevProps.min !== min || prevProps.step !== step) {
      this.markRefs = [];
      this.numOfMarks = (max - min) / step;

      for (var i = 0; i < this.numOfMarks + 1; i++) {
        this.markRefs[i] = React.createRef();
      }
    }

    utils_1.translateThumbs(this.getThumbs(), this.getOffsets(), rtl); // ensure offsets are calculated when the refs for the marks have been created
    // and those refs have been mounted to the dom
    // on the state update in calculateOffsets with new markOffsets are calculated

    if (prevProps.max !== max || prevProps.min !== min || prevProps.step !== step || prevState.markOffsets.length !== this.state.markOffsets.length) {
      this.calculateMarkOffsets();
      values.forEach(function (value) {
        if (!utils_1.isStepDivisible(min, value, step)) {
          console.warn('The `values` property is in conflict with the current `step`, `min`, and `max` properties. Please provide values that are accessible using the min, max, and step values.');
        }
      });
    }
  };

  Range.prototype.componentWillUnmount = function () {
    var options = {
      passive: false
    };
    document.removeEventListener('mousedown', this.onMouseOrTouchStart, options); // These need to be removed!!

    document.removeEventListener('mousemove', this.schdOnMouseMove);
    document.removeEventListener('touchmove', this.schdOnTouchMove);
    document.removeEventListener('touchstart', this.onMouseOrTouchStart);
    document.removeEventListener('mouseup', this.schdOnEnd);
    document.removeEventListener('touchend', this.schdOnEnd);
    this.resizeObserver.unobserve(this.trackRef.current);
  };

  Range.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        renderTrack = _a.renderTrack,
        renderThumb = _a.renderThumb,
        _b = _a.renderMark,
        renderMark = _b === void 0 ? function () {
      return null;
    } : _b,
        values = _a.values,
        min = _a.min,
        max = _a.max,
        allowOverlap = _a.allowOverlap,
        disabled = _a.disabled;
    var _c = this.state,
        draggedThumbIndex = _c.draggedThumbIndex,
        thumbZIndexes = _c.thumbZIndexes,
        markOffsets = _c.markOffsets;
    return renderTrack({
      props: {
        style: {
          // creates stacking context that prevents z-index applied to thumbs
          // interfere with other elements
          transform: 'scale(1)',
          cursor: draggedThumbIndex > -1 ? 'grabbing' : this.props.draggableTrack ? utils_1.isVertical(this.props.direction) ? 'ns-resize' : 'ew-resize' : values.length === 1 && !disabled ? 'pointer' : 'inherit'
        },
        onMouseDown: disabled ? utils_1.voidFn : this.onMouseDownTrack,
        onTouchStart: disabled ? utils_1.voidFn : this.onTouchStartTrack,
        ref: this.trackRef
      },
      isDragged: this.state.draggedThumbIndex > -1,
      disabled: disabled,
      children: __spreadArrays(markOffsets.map(function (offset, index, arr) {
        return renderMark({
          props: {
            style: _this.props.direction === types_1.Direction.Left || _this.props.direction === types_1.Direction.Right ? {
              position: 'absolute',
              left: offset[0] + "px",
              marginTop: offset[1] + "px"
            } : {
              position: 'absolute',
              top: offset[0] + "px",
              marginLeft: offset[1] + "px"
            },
            key: "mark" + index,
            ref: _this.markRefs[index]
          },
          index: index
        });
      }), values.map(function (value, index) {
        var isDragged = _this.state.draggedThumbIndex === index;
        return renderThumb({
          index: index,
          value: value,
          isDragged: isDragged,
          props: {
            style: {
              position: 'absolute',
              zIndex: thumbZIndexes[index],
              cursor: disabled ? 'inherit' : isDragged ? 'grabbing' : 'grab',
              userSelect: 'none',
              touchAction: 'none',
              WebkitUserSelect: 'none',
              MozUserSelect: 'none',
              msUserSelect: 'none'
            },
            key: index,
            tabIndex: disabled ? undefined : 0,
            'aria-valuemax': allowOverlap ? max : values[index + 1] || max,
            'aria-valuemin': allowOverlap ? min : values[index - 1] || min,
            'aria-valuenow': value,
            draggable: false,
            ref: _this.thumbRefs[index],
            role: 'slider',
            onKeyDown: disabled ? utils_1.voidFn : _this.onKeyDown,
            onKeyUp: disabled ? utils_1.voidFn : _this.onKeyUp
          }
        });
      }))
    });
  };

  Range.defaultProps = {
    step: 1,
    direction: types_1.Direction.Right,
    rtl: false,
    disabled: false,
    allowOverlap: false,
    draggableTrack: false,
    min: 0,
    max: 100
  };
  return Range;
}(React.Component);

exports["default"] = Range;
}(Range));

(function (exports) {

var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkValuesAgainstBoundaries = exports.relativeValue = exports.useThumbOverlap = exports.Direction = exports.getTrackBackground = exports.Range = void 0;

var Range_1 = __importDefault(Range);

exports.Range = Range_1["default"];

var utils_1 = utils;

Object.defineProperty(exports, "getTrackBackground", {
  enumerable: true,
  get: function get() {
    return utils_1.getTrackBackground;
  }
});
Object.defineProperty(exports, "useThumbOverlap", {
  enumerable: true,
  get: function get() {
    return utils_1.useThumbOverlap;
  }
});
Object.defineProperty(exports, "relativeValue", {
  enumerable: true,
  get: function get() {
    return utils_1.relativeValue;
  }
});
Object.defineProperty(exports, "checkValuesAgainstBoundaries", {
  enumerable: true,
  get: function get() {
    return utils_1.checkValuesAgainstBoundaries;
  }
});

var types_1 = types;

Object.defineProperty(exports, "Direction", {
  enumerable: true,
  get: function get() {
    return types_1.Direction;
  }
});
}(lib));

var StyledThumbLabel = styled.div.withConfig({
  displayName: "RangeSlider__StyledThumbLabel",
  componentId: "sc-1at7hde-0"
})(["left:", ";transform:", " !important;"], function (props) {
  return props.leftEdge ? '0 !important' : props.rightEdge ? '100% !important' : '50%';
}, function (props) {
  return props.leftEdge ? 'translateX(0)' : props.rightEdge ? 'translateX(-100%)' : props.left ? 'translateX(-9px)' : props.right ? 'translateX(calc(-100% + 9px))' : 'translateX(-50%)';
});

var ThumbLabel = function ThumbLabel(_ref) {
  var rangeRef = _ref.rangeRef,
      values = _ref.values,
      index = _ref.index,
      currency = _ref.currency,
      min = _ref.min,
      max = _ref.max,
      currentValue = _ref.currentValue;

  var _useThumbOverlap = lib.useThumbOverlap(rangeRef, values, index, 1, ' - ', function (value) {
    return currency ? parseInt(value).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) : value;
  }),
      _useThumbOverlap2 = _slicedToArray(_useThumbOverlap, 2),
      labelValue = _useThumbOverlap2[0],
      labelStyle = _useThumbOverlap2[1];

  var between = max - min;
  var location = (currentValue - min) / between;
  var left = location < 0.35;
  var right = location > 0.6;
  var leftEdge = false;
  var rightEdge = false;

  if (labelValue.match(/-/)) {
    if (left) {
      leftEdge = true;
    } else if (right) {
      rightEdge = true;
    } else {
      leftEdge = false;
      rightEdge = false;
    }
  }

  return /*#__PURE__*/React.createElement(StyledThumbLabel, {
    "data-label": index,
    left: left,
    right: right,
    leftEdge: leftEdge,
    rightEdge: rightEdge,
    style: _objectSpread2({
      display: 'block',
      position: 'absolute',
      top: 'calc(100% + 3px)',
      transition: 'transform 0.25s ease-out',
      color: '#000',
      fontWeight: 500,
      fontSize: 18,
      fontFamily: 'proxima-nova-condensed, sans-serif',
      whiteSpace: 'nowrap'
    }, labelStyle)
  }, labelValue);
};

var RangeSlider = function RangeSlider(_ref2) {
  var values = _ref2.values,
      setValues = _ref2.setValues,
      min = _ref2.min,
      max = _ref2.max,
      step = _ref2.step,
      currency = _ref2.currency,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? getActiveColor('#1D2042') : _ref2$color;

  var _React$useState = React.useState(values),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tempValues = _React$useState2[0],
      setTempValues = _React$useState2[1];

  var rangeRef = React.useRef();

  var Thumb = function Thumb(_ref3) {
    var props = _ref3.props,
        index = _ref3.index,
        isDragged = _ref3.isDragged;
    return /*#__PURE__*/React.createElement("div", _extends$d({}, props, {
      style: _objectSpread2(_objectSpread2({}, props.style), {}, {
        height: 32,
        width: 16,
        borderRadius: 2,
        backgroundColor: '#1D2042',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'opacity 0.2s ease-out',
        opacity: isDragged ? 0.8 : 1,
        boxShadow: '2px 1px 4px rgba(0, 0, 0, 0.22)'
      })
    }), /*#__PURE__*/React.createElement(ThumbLabel, {
      rangeRef: rangeRef.current,
      values: tempValues,
      index: index,
      currency: currency,
      min: min,
      max: max,
      currentValue: props['aria-valuenow']
    }));
  };

  var Track = function Track(_ref4) {
    var props = _ref4.props,
        children = _ref4.children;
    return /*#__PURE__*/React.createElement("div", {
      onMouseDown: props.onMouseDown,
      onTouchStart: props.onTouchStart,
      style: _objectSpread2(_objectSpread2({}, props.style), {}, {
        height: 32,
        display: 'flex',
        width: '100%'
      })
    }, /*#__PURE__*/React.createElement("div", {
      ref: props.ref,
      style: {
        height: 8,
        width: '100%',
        background: lib.getTrackBackground({
          values: tempValues,
          colors: ['#ccc', color, '#ccc'],
          min: min,
          max: max
        }),
        alignSelf: 'center'
      }
    }, children));
  };

  return /*#__PURE__*/React.createElement(lib.Range, {
    ref: rangeRef,
    values: tempValues,
    onChange: function onChange(values) {
      return setTempValues(values);
    },
    onFinalChange: function onFinalChange(values) {
      return setValues(values);
    },
    renderThumb: Thumb,
    renderTrack: Track,
    allowOverlap: true,
    step: step || 1,
    min: min,
    max: max
  });
};

var StyledGrantFilters = styled.div.withConfig({
  displayName: "GrantFilters__StyledGrantFilters",
  componentId: "sc-1h2ka0p-0"
})(["@media (min-width:768px){width:280px;padding-right:42px;flex:0 0 auto;position:sticky;top:24px;align-self:flex-start;overflow:auto;}@media (min-width:960px){width:337px;}> .collapse-css-transition{@media (min-width:768px){overflow:visible !important;visibility:visible !important;height:auto !important;}}.keyword{padding-bottom:32px;}input[type='text']{display:block;width:100%;margin-top:4px;margin-bottom:0;height:48px;background-color:white;border:2px solid ", ";border-radius:4px;font-family:proxima-nova,sans-serif;font-weight:400;font-size:18px;padding:0 14px;&::placeholder{color:white;opacity:0.65;}}fieldset{border:0;padding:0 0 32px;margin-bottom:38px;border-bottom:2px solid #eeeeef;&:last-of-type{border-bottom:0;margin-bottom:0;}&.priority-filter{+ .range-slider{border-top:2px solid #eeeeef;padding-top:28px;}}legend{font-family:proxima-nova,sans-serif;font-weight:700;text-transform:uppercase;font-size:16px;margin-bottom:7px;}button{width:43px;height:43px;display:flex;justify-content:center;align-items:center;border:0;border-radius:0;position:absolute;top:-4px;right:0;cursor:pointer;transition:opacity 0.2s ease-out;background:none;&:hover,&:focus{opacity:0.65;}svg{transition:transform 0.35s ease-out;*{stroke:", ";}}&.open{svg{transform:rotate(-180deg);}}&.retired{width:100%;height:auto;position:relative;top:0;display:block;text-align:left;font-family:proxima-nova-condensed,sans-serif;font-weight:700;font-size:18px;padding:13px 0 0;border-top:2px solid #eeeeef;margin-top:20px;margin-bottom:-30px;svg{position:absolute;top:21px;right:0;}+ div{margin-top:40px;margin-bottom:-28px;> label:last-child{margin-bottom:8px;}}}}ul{margin:0;padding:0;list-style:none;li{position:relative;}}> ul > li{border-bottom:2px solid #eeeeef;margin-bottom:10px;> label{height:43px;}ul{padding:0 0 10px 16px;}}label{display:block;font-family:proxima-nova-condensed,sans-serif;font-weight:500;font-size:18px;padding:7px 0;&:last-child{border:0;}}input{position:absolute;left:-99999px;&:checked + span::after{top:2px;left:2px;width:15px;height:15px;background-color:", ";}}span{display:block;padding-left:26px;position:relative;line-height:1.1;&::before,&::after{content:'';position:absolute;}&::before{width:19px;height:19px;border:2px solid ", ";border-radius:2px;opacity:0.5;top:0;left:0;}}}> div > label{display:block;font-family:proxima-nova,sans-serif;font-weight:700;text-transform:uppercase;font-size:16px;padding-bottom:66px;margin-bottom:28px;border-bottom:2px solid #eeeeef;&:last-of-type{border-bottom:0;}> div{padding:14px 18px 0;}}"], function (props) {
  return getActiveColor(props.color);
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return getActiveColor(props.color);
});
var FilterToggle = styled.button.withConfig({
  displayName: "GrantFilters__FilterToggle",
  componentId: "sc-1h2ka0p-1"
})(["background:none;border:4px solid ", ";border-radius:2px;width:100%;height:54px;padding:0 12px;display:flex;align-items:center;font-size:20px;font-family:proxima-nova,sans-serif;font-weight:800;text-transform:uppercase;color:", ";position:relative;margin-bottom:36px;@media (min-width:768px){display:none;}svg{width:20px;position:absolute;top:50%;right:14px;transform:translateY(-50%);&:last-child{display:none;}*{stroke:#1d2042;}}&.open{svg{display:none;&:last-child{display:block;}}}"], function (props) {
  return props.color;
}, function (props) {
  return props.color;
});

var stateSort = function stateSort(a, b) {
  if (a.state < b.state) {
    return -1;
  }

  if (a.state > b.state) {
    return 1;
  }

  return 0;
};

var citySort = function citySort(a, b) {
  if (a.city < b.city) {
    return -1;
  }

  if (a.city > b.city) {
    return 1;
  }

  return 0;
};

function getMinValue(data, prop) {
  return data.reduce(function (min, x) {
    return parseInt(x[prop]) < min ? parseInt(x[prop]) : min;
  }, parseInt(data[0][prop]));
}

function getMaxValue(data, prop) {
  return data.reduce(function (max, x) {
    return parseInt(x[prop]) > max ? parseInt(x[prop]) : max;
  }, parseInt(data[0][prop]));
}

var GrantFilters = function GrantFilters(_ref) {
  var color = _ref.color,
      filters = _ref.filters,
      setFilters = _ref.setFilters;
  var context = useContext(SiteContext);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      priorities = _useState2[0],
      setPriorities = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      retired = _useState4[0],
      setRetired = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showRetired = _useState6[0],
      setShowRetired = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      cities = _useState8[0],
      setCities = _useState8[1];

  var _useState9 = useState([0, 0]),
      _useState10 = _slicedToArray(_useState9, 2),
      yearsMinMax = _useState10[0],
      setYearsMinMax = _useState10[1];

  var _useState11 = useState([0, 0]),
      _useState12 = _slicedToArray(_useState11, 2),
      amountMinMax = _useState12[0],
      setAmountMinMax = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showFilters = _useState14[0],
      setShowFilters = _useState14[1];

  useEffect(function () {
    if (Object.keys(context.grants).length) {
      if (context.grants.data.length) {
        var currentPriorities = context.grants.data.filter(function (grant) {
          return grant['RETIRED'] === 'N';
        }).map(function (grant) {
          return grant['PROGRAM_AREA'];
        }).filter(function (el) {
          return el != null;
        }).filter(function (x, i, a) {
          return a.indexOf(x) == i;
        }).sort();
        var retiredPriorities = context.grants.data.filter(function (grant) {
          return grant['RETIRED'] === 'Y';
        }).map(function (grant) {
          return grant['PROGRAM_AREA'];
        }).filter(function (el) {
          return el != null;
        }).filter(function (x, i, a) {
          return a.indexOf(x) == i;
        }).sort(); // Get list of states and their cities

        var currentLocations = context.grants.data.map(function (grant) {
          return {
            state: grant['STATE'],
            cities: [],
            open: false
          };
        });
        currentLocations = currentLocations.filter(function (elem, index) {
          return currentLocations.findIndex(function (obj) {
            return obj.state.trim().toLowerCase() === elem.state.trim().toLowerCase();
          }) === index;
        }).sort(stateSort);
        var currentCities = context.grants.data.map(function (grant) {
          return {
            city: grant['CITY'],
            state: grant['STATE']
          };
        }).filter(function (el) {
          return el != null;
        });
        currentCities = currentCities.filter(function (elem, index) {
          return currentCities.findIndex(function (obj) {
            return obj.city.trim().toLowerCase() === elem.city.trim().toLowerCase();
          }) === index;
        }).filter(function (place) {
          return place.city !== 'PA';
        }).sort(citySort);
        currentCities.forEach(function (place) {
          var foundState = currentLocations.find(function (location) {
            return place.state === location.state;
          });

          if (foundState.cities.indexOf(place.city) < 0) {
            foundState.cities.push(place.city);
          }
        });
        var minYear = getMinValue(context.grants.data, 'GRANT_APPROVED_DATE');
        var maxYear = getMaxValue(context.grants.data, 'GRANT_APPROVED_DATE');
        var minAmount = getMinValue(context.grants.data, 'AMOUNT_RECOMMENDED');
        var maxAmount = getMaxValue(context.grants.data, 'AMOUNT_RECOMMENDED');
        setYearsMinMax([minYear, maxYear]);
        setAmountMinMax([minAmount, maxAmount]);
        setFilters(_objectSpread2(_objectSpread2({}, filters), {}, {
          years: [minYear, maxYear],
          amount: [minAmount, maxAmount]
        }));
        setCities(currentLocations);
        setPriorities(currentPriorities);
        setRetired(retiredPriorities);
      } else {
        setFilters(_objectSpread2({}, filters));
      }
    }
  }, [context.grants]);

  var changeFilters = function changeFilters(event, type, value) {
    var updatedFilters = _objectSpread2({}, filters);

    if (type === 'state') {
      var _cities = value.cities;

      if (event.target.checked) {
        _cities.forEach(function (city) {
          if (!updatedFilters['cities'].includes(city)) {
            updatedFilters['cities'].push(city);
          }
        });
      } else {
        _cities.forEach(function (city) {
          if (updatedFilters['cities'].includes(city)) {
            var existing = updatedFilters['cities'].indexOf(city);
            updatedFilters['cities'].splice(existing, 1);
          }
        });
      }
    } else if (type === 'query') {
      updatedFilters.query = value;
    } else if (event.target.checked) {
      updatedFilters[type].push(value);
    } else {
      var existing = updatedFilters[type].indexOf(value);
      updatedFilters[type].splice(existing, 1);
    }

    setFilters(updatedFilters);
  };

  var openCityDropdown = function openCityDropdown(place) {
    var updatedLocations = _toConsumableArray(cities);

    var currentPlace = updatedLocations.find(function (p) {
      return p.state === place.state;
    });
    currentPlace.open = !currentPlace.open;
    setCities(updatedLocations);
  };

  var stateIsChecked = function stateIsChecked(place) {
    var checked = false;
    var includedCities = [];
    place.cities.forEach(function (city) {
      if (filters.cities.includes(city)) {
        includedCities.push(city);
      }
    });

    if (includedCities.length === place.cities.length) {
      checked = true;
    }

    return checked;
  };

  return /*#__PURE__*/React__default.createElement(StyledGrantFilters, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FilterToggle, {
    className: showFilters ? 'open' : '',
    color: color,
    onClick: function onClick() {
      return setShowFilters(!showFilters);
    }
  }, "Filters", /*#__PURE__*/React__default.createElement(SvgIconPlus, null), /*#__PURE__*/React__default.createElement(SvgIconMinus, null)), /*#__PURE__*/React__default.createElement(Collapse, {
    className: "collapse-css-transition",
    isOpen: showFilters
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "keyword"
  }, "Keyword", /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    value: filters.query,
    onChange: function onChange() {
      return changeFilters(null, 'query', event.target.value);
    }
  })), (priorities.length > 1 || retired.length > 1) && /*#__PURE__*/React__default.createElement("fieldset", {
    className: "priority-filter"
  }, /*#__PURE__*/React__default.createElement("legend", null, "Priority"), priorities.map(function (priority, index) {
    return /*#__PURE__*/React__default.createElement("label", {
      key: index
    }, /*#__PURE__*/React__default.createElement("input", {
      name: "priority",
      type: "checkbox",
      onChange: function onChange(event) {
        return changeFilters(event, 'priorities', priority);
      }
    }), /*#__PURE__*/React__default.createElement("span", null, priority));
  }), retired.length > 1 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("button", {
    className: "retired ".concat(showRetired ? 'open' : ''),
    onClick: function onClick() {
      return setShowRetired(!showRetired);
    }
  }, "Retired Priorities", /*#__PURE__*/React__default.createElement(SvgIconDropdown, null)), /*#__PURE__*/React__default.createElement(Collapse, {
    className: "collapse-css-transition",
    isOpen: showRetired
  }, retired.map(function (priority, index) {
    return /*#__PURE__*/React__default.createElement("label", {
      key: index
    }, /*#__PURE__*/React__default.createElement("input", {
      name: "priority",
      type: "checkbox",
      onChange: function onChange(event) {
        return changeFilters(event, 'priorities', priority);
      }
    }), /*#__PURE__*/React__default.createElement("span", null, priority));
  })))), !context.site.hideLocations && cities.length > 1 && /*#__PURE__*/React__default.createElement("fieldset", null, /*#__PURE__*/React__default.createElement("legend", null, "Location"), cities.map(function (place, index) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, place.cities.length > 0 ? /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("label", null, /*#__PURE__*/React__default.createElement("input", {
      name: "city",
      type: "checkbox",
      checked: stateIsChecked(place),
      onChange: function onChange(event) {
        return changeFilters(event, 'state', place);
      }
    }), /*#__PURE__*/React__default.createElement("span", null, place.state)), /*#__PURE__*/React__default.createElement("button", {
      className: place.open ? 'open' : '',
      onClick: function onClick() {
        return openCityDropdown(place);
      }
    }, /*#__PURE__*/React__default.createElement(SvgIconDropdown, null)), /*#__PURE__*/React__default.createElement(Collapse, {
      className: "collapse-css-transition",
      isOpen: place.open
    }, /*#__PURE__*/React__default.createElement("ul", null, place.cities.map(function (city, index) {
      return /*#__PURE__*/React__default.createElement("li", {
        key: index
      }, /*#__PURE__*/React__default.createElement("label", null, /*#__PURE__*/React__default.createElement("input", {
        name: "city",
        type: "checkbox",
        checked: filters.cities.includes(city),
        onChange: function onChange(event) {
          return changeFilters(event, 'cities', city);
        }
      }), /*#__PURE__*/React__default.createElement("span", null, city)));
    }))))) : null);
  })), yearsMinMax[0] < yearsMinMax[1] && /*#__PURE__*/React__default.createElement("label", {
    className: "range-slider"
  }, "Year", /*#__PURE__*/React__default.createElement(RangeSlider, {
    values: filters.years,
    setValues: function setValues(values) {
      return setFilters(_objectSpread2(_objectSpread2({}, filters), {}, {
        years: values
      }));
    },
    min: yearsMinMax[0],
    max: yearsMinMax[1],
    step: 1,
    color: getActiveColor(color)
  })), amountMinMax[0] < amountMinMax[1] && /*#__PURE__*/React__default.createElement("label", {
    className: "range-slider"
  }, "Amount", /*#__PURE__*/React__default.createElement(RangeSlider, {
    values: filters.amount,
    setValues: function setValues(values) {
      return setFilters(_objectSpread2(_objectSpread2({}, filters), {}, {
        amount: values
      }));
    },
    min: amountMinMax[0],
    max: amountMinMax[1],
    step: 1000,
    color: getActiveColor(color),
    currency: true
  }))));
};

var dist = {};

var loader = {};

var Circles$1 = {};

Object.defineProperty(Circles$1, "__esModule", {
  value: true
});
Circles$1.Circles = void 0;

var _react$g = _interopRequireDefault$g(React__default);

var _propTypes$g = _interopRequireDefault$g(PropTypes);

function _interopRequireDefault$g(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Circles = function Circles(props) {
  return /*#__PURE__*/_react$g["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 135 135",
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color,
    "aria-label": props.label
  }, /*#__PURE__*/_react$g["default"].createElement("path", {
    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
  }, /*#__PURE__*/_react$g["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 67 67",
    to: "-360 67 67",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$g["default"].createElement("path", {
    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
  }, /*#__PURE__*/_react$g["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 67 67",
    to: "360 67 67",
    dur: "8s",
    repeatCount: "indefinite"
  })));
};

Circles$1.Circles = Circles;
Circles.propTypes = {
  height: _propTypes$g["default"].oneOfType([_propTypes$g["default"].string, _propTypes$g["default"].number]),
  width: _propTypes$g["default"].oneOfType([_propTypes$g["default"].string, _propTypes$g["default"].number]),
  color: _propTypes$g["default"].string,
  label: _propTypes$g["default"].string
};
Circles.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading"
};

var Watch$1 = {};

Object.defineProperty(Watch$1, "__esModule", {
  value: true
});
Watch$1.Watch = void 0;

var _react$f = _interopRequireDefault$f(React__default);

var _propTypes$f = _interopRequireDefault$f(PropTypes);

function _interopRequireDefault$f(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Watch = function Watch(props) {
  return /*#__PURE__*/_react$f["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    version: "1.1",
    id: "L2",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    "aria-label": props.label
  }, /*#__PURE__*/_react$f["default"].createElement("circle", {
    fill: "none",
    stroke: props.color,
    strokeWidth: "4",
    strokeMiterlimit: "10",
    cx: "50",
    cy: "50",
    r: props.radius
  }), /*#__PURE__*/_react$f["default"].createElement("line", {
    fill: "none",
    strokeLinecap: "round",
    stroke: props.color,
    strokeWidth: "4",
    strokeMiterlimit: "10",
    x1: "50",
    y1: "50",
    x2: "85",
    y2: "50.5"
  }, /*#__PURE__*/_react$f["default"].createElement("animateTransform", {
    attributeName: "transform",
    dur: "2s",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$f["default"].createElement("line", {
    fill: "none",
    strokeLinecap: "round",
    stroke: props.color,
    strokeWidth: "4",
    strokeMiterlimit: "10",
    x1: "50",
    y1: "50",
    x2: "49.5",
    y2: "74"
  }, /*#__PURE__*/_react$f["default"].createElement("animateTransform", {
    attributeName: "transform",
    dur: "15s",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  })));
};

Watch$1.Watch = Watch;
Watch.propTypes = {
  height: _propTypes$f["default"].oneOfType([_propTypes$f["default"].string, _propTypes$f["default"].number]),
  width: _propTypes$f["default"].oneOfType([_propTypes$f["default"].string, _propTypes$f["default"].number]),
  color: _propTypes$f["default"].string,
  label: _propTypes$f["default"].string,
  radius: _propTypes$f["default"].number
};
Watch.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 48
};

var Audio$1 = {};

Object.defineProperty(Audio$1, "__esModule", {
  value: true
});
Audio$1.Audio = void 0;

var _react$e = _interopRequireDefault$e(React__default);

var _propTypes$e = _interopRequireDefault$e(PropTypes);

function _interopRequireDefault$e(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Audio = function Audio(props) {
  return /*#__PURE__*/_react$e["default"].createElement("svg", {
    height: props.height,
    width: props.width,
    fill: props.color,
    viewBox: "0 0 55 80",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": props.label
  }, /*#__PURE__*/_react$e["default"].createElement("g", {
    transform: "matrix(1 0 0 -1 0 80)"
  }, /*#__PURE__*/_react$e["default"].createElement("rect", {
    width: "10",
    height: "20",
    rx: "3"
  }, /*#__PURE__*/_react$e["default"].createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "4.3s",
    values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$e["default"].createElement("rect", {
    x: "15",
    width: "10",
    height: "80",
    rx: "3"
  }, /*#__PURE__*/_react$e["default"].createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "2s",
    values: "80;55;33;5;75;23;73;33;12;14;60;80",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$e["default"].createElement("rect", {
    x: "30",
    width: "10",
    height: "50",
    rx: "3"
  }, /*#__PURE__*/_react$e["default"].createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "1.4s",
    values: "50;34;78;23;56;23;34;76;80;54;21;50",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$e["default"].createElement("rect", {
    x: "45",
    width: "10",
    height: "30",
    rx: "3"
  }, /*#__PURE__*/_react$e["default"].createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "2s",
    values: "30;45;13;80;56;72;45;76;34;23;67;30",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))));
};

Audio$1.Audio = Audio;
Audio.propTypes = {
  height: _propTypes$e["default"].oneOfType([_propTypes$e["default"].string, _propTypes$e["default"].number]),
  width: _propTypes$e["default"].oneOfType([_propTypes$e["default"].string, _propTypes$e["default"].number]),
  color: _propTypes$e["default"].string,
  label: _propTypes$e["default"].string
};
Audio.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading"
};

var BallTriangle$1 = {};

Object.defineProperty(BallTriangle$1, "__esModule", {
  value: true
});
BallTriangle$1.BallTriangle = void 0;

var _react$d = _interopRequireDefault$d(React__default);

var _propTypes$d = _interopRequireDefault$d(PropTypes);

function _interopRequireDefault$d(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var BallTriangle = function BallTriangle(props) {
  return /*#__PURE__*/_react$d["default"].createElement("svg", {
    height: props.height,
    width: props.width,
    stroke: props.color,
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": props.label
  }, /*#__PURE__*/_react$d["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react$d["default"].createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
  }, /*#__PURE__*/_react$d["default"].createElement("circle", {
    cx: "5",
    cy: "50",
    r: props.radius
  }, /*#__PURE__*/_react$d["default"].createElement("animate", {
    attributeName: "cy",
    begin: "0s",
    dur: "2.2s",
    values: "50;5;50;50",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$d["default"].createElement("animate", {
    attributeName: "cx",
    begin: "0s",
    dur: "2.2s",
    values: "5;27;49;5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$d["default"].createElement("circle", {
    cx: "27",
    cy: "5",
    r: props.radius
  }, /*#__PURE__*/_react$d["default"].createElement("animate", {
    attributeName: "cy",
    begin: "0s",
    dur: "2.2s",
    from: "5",
    to: "5",
    values: "5;50;50;5",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$d["default"].createElement("animate", {
    attributeName: "cx",
    begin: "0s",
    dur: "2.2s",
    from: "27",
    to: "27",
    values: "27;49;5;27",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$d["default"].createElement("circle", {
    cx: "49",
    cy: "50",
    r: props.radius
  }, /*#__PURE__*/_react$d["default"].createElement("animate", {
    attributeName: "cy",
    begin: "0s",
    dur: "2.2s",
    values: "50;50;5;50",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$d["default"].createElement("animate", {
    attributeName: "cx",
    from: "49",
    to: "49",
    begin: "0s",
    dur: "2.2s",
    values: "49;5;27;49",
    calcMode: "linear",
    repeatCount: "indefinite"
  })))));
};

BallTriangle$1.BallTriangle = BallTriangle;
BallTriangle.propTypes = {
  height: _propTypes$d["default"].oneOfType([_propTypes$d["default"].string, _propTypes$d["default"].number]),
  width: _propTypes$d["default"].oneOfType([_propTypes$d["default"].string, _propTypes$d["default"].number]),
  color: _propTypes$d["default"].string,
  label: _propTypes$d["default"].string,
  radius: _propTypes$d["default"].number
};
BallTriangle.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  radius: 5,
  label: "audio-loading"
};

var Bars$1 = {};

Object.defineProperty(Bars$1, "__esModule", {
  value: true
});
Bars$1.Bars = void 0;

var _react$c = _interopRequireDefault$c(React__default);

var _propTypes$c = _interopRequireDefault$c(PropTypes);

function _interopRequireDefault$c(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Bars = function Bars(props) {
  return /*#__PURE__*/_react$c["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    fill: props.color,
    viewBox: "0 0 135 140",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": props.label
  }, /*#__PURE__*/_react$c["default"].createElement("rect", {
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$c["default"].createElement("rect", {
    x: "30",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$c["default"].createElement("rect", {
    x: "60",
    width: "15",
    height: "140",
    rx: "6"
  }, /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "y",
    begin: "0s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$c["default"].createElement("rect", {
    x: "90",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$c["default"].createElement("rect", {
    x: "120",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$c["default"].createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
};

Bars$1.Bars = Bars;
Bars.propTypes = {
  height: _propTypes$c["default"].oneOfType([_propTypes$c["default"].string, _propTypes$c["default"].number]),
  width: _propTypes$c["default"].oneOfType([_propTypes$c["default"].string, _propTypes$c["default"].number]),
  color: _propTypes$c["default"].string,
  label: _propTypes$c["default"].string
};
Bars.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading"
};

var CradleLoader$1 = {};

Object.defineProperty(CradleLoader$1, "__esModule", {
  value: true
});
CradleLoader$1.CradleLoader = void 0;

var _react$b = _interopRequireDefault$b(React__default);

var _propTypes$b = _interopRequireDefault$b(PropTypes);

function _interopRequireDefault$b(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CradleLoader = function CradleLoader(props) {
  return /*#__PURE__*/_react$b["default"].createElement("div", {
    "aria-label": props.label,
    role: "presentation",
    className: "container"
  }, /*#__PURE__*/_react$b["default"].createElement("div", {
    className: "react-spinner-loader-swing"
  }, /*#__PURE__*/_react$b["default"].createElement("div", {
    className: "react-spinner-loader-swing-l"
  }), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", {
    className: "react-spinner-loader-swing-r"
  })), /*#__PURE__*/_react$b["default"].createElement("div", {
    className: "react-spinner-loader-shadow"
  }, /*#__PURE__*/_react$b["default"].createElement("div", {
    className: "react-spinner-loader-shadow-l"
  }), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", null), /*#__PURE__*/_react$b["default"].createElement("div", {
    className: "react-spinner-loader-shadow-r"
  })));
};

CradleLoader$1.CradleLoader = CradleLoader;
CradleLoader.propTypes = {
  label: _propTypes$b["default"].string
};
CradleLoader.defaultProps = {
  label: "audio-loading"
};

var Grid$1 = {};

Object.defineProperty(Grid$1, "__esModule", {
  value: true
});
Grid$1.Grid = void 0;

var _react$a = _interopRequireDefault$a(React__default);

var _propTypes$a = _interopRequireDefault$a(PropTypes);

function _interopRequireDefault$a(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Grid = function Grid(props) {
  return /*#__PURE__*/_react$a["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 105 105",
    fill: props.color,
    "aria-label": props.label
  }, /*#__PURE__*/_react$a["default"].createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: props.radius
  }, /*#__PURE__*/_react$a["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$a["default"].createElement("circle", {
    cx: "12.5",
    cy: "52.5",
    r: props.radius
  }, /*#__PURE__*/_react$a["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "100ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$a["default"].createElement("circle", {
    cx: "52.5",
    cy: "12.5",
    r: props.radius
  }, /*#__PURE__*/_react$a["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "300ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$a["default"].createElement("circle", {
    cx: "52.5",
    cy: "52.5",
    r: props.radius
  }, /*#__PURE__*/_react$a["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "600ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$a["default"].createElement("circle", {
    cx: "92.5",
    cy: "12.5",
    r: props.radius
  }, /*#__PURE__*/_react$a["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "800ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$a["default"].createElement("circle", {
    cx: "92.5",
    cy: "52.5",
    r: props.radius
  }, /*#__PURE__*/_react$a["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "400ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$a["default"].createElement("circle", {
    cx: "12.5",
    cy: "92.5",
    r: props.radius
  }, /*#__PURE__*/_react$a["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "700ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$a["default"].createElement("circle", {
    cx: "52.5",
    cy: "92.5",
    r: props.radius
  }, /*#__PURE__*/_react$a["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "500ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$a["default"].createElement("circle", {
    cx: "92.5",
    cy: "92.5",
    r: props.radius
  }, /*#__PURE__*/_react$a["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "200ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
};

Grid$1.Grid = Grid;
Grid.propTypes = {
  height: _propTypes$a["default"].oneOfType([_propTypes$a["default"].string, _propTypes$a["default"].number]),
  width: _propTypes$a["default"].oneOfType([_propTypes$a["default"].string, _propTypes$a["default"].number]),
  color: _propTypes$a["default"].string,
  label: _propTypes$a["default"].string,
  radius: _propTypes$a["default"].number
};
Grid.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  radius: 12.5,
  label: "audio-loading"
};

var Hearts$1 = {};

Object.defineProperty(Hearts$1, "__esModule", {
  value: true
});
Hearts$1.Hearts = void 0;

var _react$9 = _interopRequireDefault$9(React__default);

var _propTypes$9 = _interopRequireDefault$9(PropTypes);

function _interopRequireDefault$9(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Hearts = function Hearts(props) {
  return /*#__PURE__*/_react$9["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 140 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color,
    "aria-label": props.label
  }, /*#__PURE__*/_react$9["default"].createElement("path", {
    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
    attributeName: "fill-opacity",
    from: "0",
    to: ".5"
  }, /*#__PURE__*/_react$9["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    dur: "1.4s",
    values: "0.5;1;0.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$9["default"].createElement("path", {
    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
    attributeName: "fill-opacity",
    from: "0",
    to: ".5"
  }, /*#__PURE__*/_react$9["default"].createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0.7s",
    dur: "1.4s",
    values: "0.5;1;0.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$9["default"].createElement("path", {
    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
  }));
};

Hearts$1.Hearts = Hearts;
Hearts.propTypes = {
  height: _propTypes$9["default"].oneOfType([_propTypes$9["default"].string, _propTypes$9["default"].number]),
  width: _propTypes$9["default"].oneOfType([_propTypes$9["default"].string, _propTypes$9["default"].number]),
  color: _propTypes$9["default"].string,
  label: _propTypes$9["default"].string
};
Hearts.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading"
};

var MutatingDots$1 = {};

Object.defineProperty(MutatingDots$1, "__esModule", {
  value: true
});
MutatingDots$1.MutatingDots = void 0;

var _react$8 = _interopRequireDefault$8(React__default);

var _propTypes$8 = _interopRequireDefault$8(PropTypes);

function _interopRequireDefault$8(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MutatingDots = function MutatingDots(props) {
  return /*#__PURE__*/_react$8["default"].createElement("svg", {
    id: "goo-loader",
    width: props.width,
    height: props.height,
    "aria-label": props.label
  }, /*#__PURE__*/_react$8["default"].createElement("filter", {
    id: "fancy-goo"
  }, /*#__PURE__*/_react$8["default"].createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    stdDeviation: "6",
    result: "blur"
  }), /*#__PURE__*/_react$8["default"].createElement("feColorMatrix", {
    "in": "blur",
    mode: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
    result: "goo"
  }), /*#__PURE__*/_react$8["default"].createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "goo",
    operator: "atop"
  })), /*#__PURE__*/_react$8["default"].createElement("g", {
    filter: "url(#fancy-goo)"
  }, /*#__PURE__*/_react$8["default"].createElement("animateTransform", {
    id: "mainAnim",
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 50 50",
    to: "359 50 50",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$8["default"].createElement("circle", {
    cx: "50%",
    cy: "40",
    r: props.radius,
    fill: props.color
  }, /*#__PURE__*/_react$8["default"].createElement("animate", {
    id: "cAnim1",
    attributeType: "XML",
    attributeName: "cy",
    dur: "0.6s",
    begin: "0;cAnim1.end+0.2s",
    calcMode: "spline",
    values: "40;20;40",
    keyTimes: "0;0.3;1",
    keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
  })), /*#__PURE__*/_react$8["default"].createElement("circle", {
    cx: "50%",
    cy: "60",
    r: props.radius,
    fill: props.secondaryColor
  }, /*#__PURE__*/_react$8["default"].createElement("animate", {
    id: "cAnim2",
    attributeType: "XML",
    attributeName: "cy",
    dur: "0.6s",
    begin: "0.4s;cAnim2.end+0.2s",
    calcMode: "spline",
    values: "60;80;60",
    keyTimes: "0;0.3;1",
    keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
  }))));
};

MutatingDots$1.MutatingDots = MutatingDots;
MutatingDots.propTypes = {
  width: _propTypes$8["default"].number,
  secondaryColor: _propTypes$8["default"].string,
  height: _propTypes$8["default"].number,
  color: _propTypes$8["default"].string,
  radius: _propTypes$8["default"].number,
  label: _propTypes$8["default"].string
};
MutatingDots.defaultProps = {
  width: 80,
  height: 90,
  color: "green",
  radius: 11,
  secondaryColor: "green",
  label: "audio-loading"
};

var Oval$1 = {};

Object.defineProperty(Oval$1, "__esModule", {
  value: true
});
Oval$1.Oval = void 0;

var _react$7 = _interopRequireDefault$7(React__default);

var _propTypes$7 = _interopRequireDefault$7(PropTypes);

function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Oval = function Oval(props) {
  return /*#__PURE__*/_react$7["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: props.color,
    "aria-label": props.label
  }, /*#__PURE__*/_react$7["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react$7["default"].createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
  }, /*#__PURE__*/_react$7["default"].createElement("circle", {
    strokeOpacity: ".5",
    cx: "18",
    cy: "18",
    r: props.radius
  }), /*#__PURE__*/_react$7["default"].createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
  }, /*#__PURE__*/_react$7["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
};

Oval$1.Oval = Oval;
Oval.propTypes = {
  height: _propTypes$7["default"].oneOfType([_propTypes$7["default"].string, _propTypes$7["default"].number]),
  width: _propTypes$7["default"].oneOfType([_propTypes$7["default"].string, _propTypes$7["default"].number]),
  color: _propTypes$7["default"].string,
  label: _propTypes$7["default"].string,
  radius: _propTypes$7["default"].number
};
Oval.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 18
};

var Plane$1 = {};

Object.defineProperty(Plane$1, "__esModule", {
  value: true
});
Plane$1.Plane = void 0;

var _react$6 = _interopRequireDefault$6(React__default);

var _propTypes$6 = _interopRequireDefault$6(PropTypes);

function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Plane = function Plane(props) {
  return /*#__PURE__*/_react$6["default"].createElement("svg", {
    className: "react-spinner-loader-svg-calLoader",
    xmlns: "http://www.w3.org/2000/svg",
    width: "230",
    height: "230",
    "aria-label": props.label
  }, /*#__PURE__*/_react$6["default"].createElement("desc", null, "Plane animation. Loading "), /*#__PURE__*/_react$6["default"].createElement("path", {
    className: "react-spinner-loader-cal-loader__path",
    style: {
      stroke: props.secondaryColor
    },
    d: "M86.429 40c63.616-20.04 101.511 25.08 107.265 61.93 6.487 41.54-18.593 76.99-50.6 87.643-59.46 19.791-101.262-23.577-107.142-62.616C29.398 83.441 59.945 48.343 86.43 40z",
    fill: "none",
    stroke: "#0099cc",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10 10 10 10 10 10 432",
    strokeDashoffset: "77"
  }), /*#__PURE__*/_react$6["default"].createElement("path", {
    className: "cal-loader__plane",
    style: {
      fill: props.color
    },
    d: "M141.493 37.93c-1.087-.927-2.942-2.002-4.32-2.501-2.259-.824-3.252-.955-9.293-1.172-4.017-.146-5.197-.23-5.47-.37-.766-.407-1.526-1.448-7.114-9.773-4.8-7.145-5.344-7.914-6.327-8.976-1.214-1.306-1.396-1.378-3.79-1.473-1.036-.04-2-.043-2.153-.002-.353.1-.87.586-1 .952-.139.399-.076.71.431 2.22.241.72 1.029 3.386 1.742 5.918 1.644 5.844 2.378 8.343 2.863 9.705.206.601.33 1.1.275 1.125-.24.097-10.56 1.066-11.014 1.032a3.532 3.532 0 0 1-1.002-.276l-.487-.246-2.044-2.613c-2.234-2.87-2.228-2.864-3.35-3.309-.717-.287-2.82-.386-3.276-.163-.457.237-.727.644-.737 1.152-.018.39.167.805 1.916 4.373 1.06 2.166 1.964 4.083 1.998 4.27.04.179.004.521-.076.75-.093.228-1.109 2.064-2.269 4.088-1.921 3.34-2.11 3.711-2.123 4.107-.008.25.061.557.168.725.328.512.72.644 1.966.676 1.32.029 2.352-.236 3.05-.762.222-.171 1.275-1.313 2.412-2.611 1.918-2.185 2.048-2.32 2.45-2.505.241-.111.601-.232.82-.271.267-.058 2.213.201 5.912.8 3.036.48 5.525.894 5.518.914 0 .026-.121.306-.27.638-.54 1.198-1.515 3.842-3.35 9.021-1.029 2.913-2.107 5.897-2.4 6.62-.703 1.748-.725 1.833-.594 2.286.137.46.45.833.872 1.012.41.177 3.823.24 4.37.085.852-.25 1.44-.688 2.312-1.724 1.166-1.39 3.169-3.948 6.771-8.661 5.8-7.583 6.561-8.49 7.387-8.702.233-.065 2.828-.056 5.784.011 5.827.138 6.64.09 8.62-.5 2.24-.67 4.035-1.65 5.517-3.016 1.136-1.054 1.135-1.014.207-1.962-.357-.38-.767-.777-.902-.893z",
    fill: "#000033"
  }));
};

Plane$1.Plane = Plane;
Plane.propTypes = {
  secondaryColor: _propTypes$6["default"].string,
  color: _propTypes$6["default"].string,
  label: _propTypes$6["default"].string
};
Plane.defaultProps = {
  secondaryColor: "grey",
  color: "#FFA500",
  label: "async-loading"
};

var Puff$1 = {};

Object.defineProperty(Puff$1, "__esModule", {
  value: true
});
Puff$1.Puff = void 0;

var _react$5 = _interopRequireDefault$5(React__default);

var _propTypes$5 = _interopRequireDefault$5(PropTypes);

function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Puff = function Puff(props) {
  return /*#__PURE__*/_react$5["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: props.color,
    "aria-label": props.label
  }, /*#__PURE__*/_react$5["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "2"
  }, /*#__PURE__*/_react$5["default"].createElement("circle", {
    cx: "22",
    cy: "22",
    r: props.radius
  }, /*#__PURE__*/_react$5["default"].createElement("animate", {
    attributeName: "r",
    begin: "0s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$5["default"].createElement("animate", {
    attributeName: "strokeOpacity",
    begin: "0s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$5["default"].createElement("circle", {
    cx: "22",
    cy: "22",
    r: props.radius
  }, /*#__PURE__*/_react$5["default"].createElement("animate", {
    attributeName: "r",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$5["default"].createElement("animate", {
    attributeName: "strokeOpacity",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  }))));
};

Puff$1.Puff = Puff;
Puff.propTypes = {
  height: _propTypes$5["default"].oneOfType([_propTypes$5["default"].string, _propTypes$5["default"].number]),
  width: _propTypes$5["default"].oneOfType([_propTypes$5["default"].string, _propTypes$5["default"].number]),
  color: _propTypes$5["default"].string,
  label: _propTypes$5["default"].string,
  radius: _propTypes$5["default"].number
};
Puff.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 1
};

var RevolvingDot$1 = {};

Object.defineProperty(RevolvingDot$1, "__esModule", {
  value: true
});
RevolvingDot$1.RevolvingDot = void 0;

var _react$4 = _interopRequireDefault$4(React__default);

var _propTypes$4 = _interopRequireDefault$4(PropTypes);

function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var RevolvingDot = function RevolvingDot(props) {
  return /*#__PURE__*/_react$4["default"].createElement("svg", {
    version: "1.1",
    width: props.width,
    height: props.height,
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    "aria-label": props.label
  }, /*#__PURE__*/_react$4["default"].createElement("circle", {
    fill: "none",
    stroke: props.color,
    strokeWidth: "4",
    cx: "50",
    cy: "50",
    r: props.radius + 38,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/_react$4["default"].createElement("circle", {
    fill: props.color,
    stroke: props.color,
    strokeWidth: "3",
    cx: "8",
    cy: "54",
    r: props.radius
  }, /*#__PURE__*/_react$4["default"].createElement("animateTransform", {
    attributeName: "transform",
    dur: "2s",
    type: "rotate",
    from: "0 50 48",
    to: "360 50 52",
    repeatCount: "indefinite"
  })));
};

RevolvingDot$1.RevolvingDot = RevolvingDot;
RevolvingDot.propTypes = {
  height: _propTypes$4["default"].oneOfType([_propTypes$4["default"].string, _propTypes$4["default"].number]),
  width: _propTypes$4["default"].oneOfType([_propTypes$4["default"].string, _propTypes$4["default"].number]),
  color: _propTypes$4["default"].string,
  label: _propTypes$4["default"].string,
  radius: _propTypes$4["default"].number
};
RevolvingDot.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 6
};

var Rings$1 = {};

Object.defineProperty(Rings$1, "__esModule", {
  value: true
});
Rings$1.Rings = void 0;

var _react$3 = _interopRequireDefault$3(React__default);

var _propTypes$3 = _interopRequireDefault$3(PropTypes);

function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Rings = function Rings(props) {
  return /*#__PURE__*/_react$3["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: props.color,
    "aria-label": props.label
  }, /*#__PURE__*/_react$3["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)",
    strokeWidth: "2"
  }, /*#__PURE__*/_react$3["default"].createElement("circle", {
    cx: "22",
    cy: "22",
    r: props.radius,
    strokeOpacity: "0"
  }, /*#__PURE__*/_react$3["default"].createElement("animate", {
    attributeName: "r",
    begin: "1.5s",
    dur: "3s",
    values: "6;22",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$3["default"].createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "1.5s",
    dur: "3s",
    values: "1;0",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$3["default"].createElement("animate", {
    attributeName: "stroke-width",
    begin: "1.5s",
    dur: "3s",
    values: "2;0",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$3["default"].createElement("circle", {
    cx: "22",
    cy: "22",
    r: props.radius,
    strokeOpacity: "0"
  }, /*#__PURE__*/_react$3["default"].createElement("animate", {
    attributeName: "r",
    begin: "3s",
    dur: "3s",
    values: "6;22",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$3["default"].createElement("animate", {
    attributeName: "strokeOpacity",
    begin: "3s",
    dur: "3s",
    values: "1;0",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$3["default"].createElement("animate", {
    attributeName: "strokeWidth",
    begin: "3s",
    dur: "3s",
    values: "2;0",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$3["default"].createElement("circle", {
    cx: "22",
    cy: "22",
    r: props.radius + 2
  }, /*#__PURE__*/_react$3["default"].createElement("animate", {
    attributeName: "r",
    begin: "0s",
    dur: "1.5s",
    values: "6;1;2;3;4;5;6",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))));
};

Rings$1.Rings = Rings;
Rings.propTypes = {
  height: _propTypes$3["default"].oneOfType([_propTypes$3["default"].string, _propTypes$3["default"].number]),
  width: _propTypes$3["default"].oneOfType([_propTypes$3["default"].string, _propTypes$3["default"].number]),
  color: _propTypes$3["default"].string,
  label: _propTypes$3["default"].string,
  radius: _propTypes$3["default"].number
};
Rings.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  radius: 6,
  label: "audio-loading"
};

var TailSpin$1 = {};

Object.defineProperty(TailSpin$1, "__esModule", {
  value: true
});
TailSpin$1.TailSpin = void 0;

var _react$2 = _interopRequireDefault$2(React__default);

var _propTypes$2 = _interopRequireDefault$2(PropTypes);

function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TailSpin = function TailSpin(props) {
  return /*#__PURE__*/_react$2["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": props.label
  }, /*#__PURE__*/_react$2["default"].createElement("defs", null, /*#__PURE__*/_react$2["default"].createElement("linearGradient", {
    x1: "8.042%",
    y1: "0%",
    x2: "65.682%",
    y2: "23.865%",
    id: "a"
  }, /*#__PURE__*/_react$2["default"].createElement("stop", {
    stopColor: props.color,
    stopOpacity: "0",
    offset: "0%"
  }), /*#__PURE__*/_react$2["default"].createElement("stop", {
    stopColor: props.color,
    stopOpacity: ".631",
    offset: "63.146%"
  }), /*#__PURE__*/_react$2["default"].createElement("stop", {
    stopColor: props.color,
    offset: "100%"
  }))), /*#__PURE__*/_react$2["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react$2["default"].createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/_react$2["default"].createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18",
    id: "Oval-2",
    stroke: props.color,
    strokeWidth: "2"
  }, /*#__PURE__*/_react$2["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "0.9s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$2["default"].createElement("circle", {
    fill: "#fff",
    cx: "36",
    cy: "18",
    r: props.radius
  }, /*#__PURE__*/_react$2["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "0.9s",
    repeatCount: "indefinite"
  })))));
};

TailSpin$1.TailSpin = TailSpin;
TailSpin.propTypes = {
  height: _propTypes$2["default"].oneOfType([_propTypes$2["default"].string, _propTypes$2["default"].number]),
  width: _propTypes$2["default"].oneOfType([_propTypes$2["default"].string, _propTypes$2["default"].number]),
  color: _propTypes$2["default"].string,
  label: _propTypes$2["default"].string,
  radius: _propTypes$2["default"].number
};
TailSpin.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  radius: 1,
  label: "audio-loading"
};

var ThreeDots$1 = {};

Object.defineProperty(ThreeDots$1, "__esModule", {
  value: true
});
ThreeDots$1.ThreeDots = void 0;

var _react$1 = _interopRequireDefault$1(React__default);

var _propTypes$1 = _interopRequireDefault$1(PropTypes);

function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ThreeDots = function ThreeDots(props) {
  return /*#__PURE__*/_react$1["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 120 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color,
    "aria-label": props.label
  }, /*#__PURE__*/_react$1["default"].createElement("circle", {
    cx: "15",
    cy: "15",
    r: props.radius + 6
  }, /*#__PURE__*/_react$1["default"].createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$1["default"].createElement("animate", {
    attributeName: "fillOpacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$1["default"].createElement("circle", {
    cx: "60",
    cy: "15",
    r: props.radius,
    attributeName: "fillOpacity",
    from: "1",
    to: "0.3"
  }, /*#__PURE__*/_react$1["default"].createElement("animate", {
    attributeName: "r",
    from: "9",
    to: "9",
    begin: "0s",
    dur: "0.8s",
    values: "9;15;9",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$1["default"].createElement("animate", {
    attributeName: "fillOpacity",
    from: "0.5",
    to: "0.5",
    begin: "0s",
    dur: "0.8s",
    values: ".5;1;.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react$1["default"].createElement("circle", {
    cx: "105",
    cy: "15",
    r: props.radius + 6
  }, /*#__PURE__*/_react$1["default"].createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react$1["default"].createElement("animate", {
    attributeName: "fillOpacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
};

ThreeDots$1.ThreeDots = ThreeDots;
ThreeDots.propTypes = {
  height: _propTypes$1["default"].oneOfType([_propTypes$1["default"].string, _propTypes$1["default"].number]),
  width: _propTypes$1["default"].oneOfType([_propTypes$1["default"].string, _propTypes$1["default"].number]),
  color: _propTypes$1["default"].string,
  label: _propTypes$1["default"].string,
  radius: _propTypes$1["default"].number
};
ThreeDots.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 9
};

var Triangle$1 = {};

Object.defineProperty(Triangle$1, "__esModule", {
  value: true
});
Triangle$1.Triangle = void 0;

var _react = _interopRequireDefault(React__default);

var _propTypes = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Triangle = function Triangle(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "react-spinner-loader-svg"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    id: "triangle",
    width: props.width,
    height: props.height,
    viewBox: "-3 -4 39 39",
    "aria-label": props.label
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "transparent",
    stroke: props.color,
    strokeWidth: "1",
    points: "16,0 32,32 0,32"
  })));
};

Triangle$1.Triangle = Triangle;
Triangle.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string
};
Triangle.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading"
};

Object.defineProperty(loader, "__esModule", {
  value: true
});
loader.Spinner = void 0;

var _Circles = Circles$1;

var _Watch = Watch$1;

var _Audio = Audio$1;

var _BallTriangle = BallTriangle$1;

var _Bars = Bars$1;

var _CradleLoader = CradleLoader$1;

var _Grid = Grid$1;

var _Hearts = Hearts$1;

var _MutatingDots = MutatingDots$1;

var _Oval = Oval$1;

var _Plane = Plane$1;

var _Puff = Puff$1;

var _RevolvingDot = RevolvingDot$1;

var _Rings = Rings$1;

var _TailSpin = TailSpin$1;

var _ThreeDots = ThreeDots$1;

var _Triangle = Triangle$1;

var Spinner = {
  Circles: _Circles.Circles,
  Audio: _Audio.Audio,
  BallTriangle: _BallTriangle.BallTriangle,
  Bars: _Bars.Bars,
  CradleLoader: _CradleLoader.CradleLoader,
  Grid: _Grid.Grid,
  Hearts: _Hearts.Hearts,
  MutatingDots: _MutatingDots.MutatingDots,
  Oval: _Oval.Oval,
  Plane: _Plane.Plane,
  Puff: _Puff.Puff,
  RevolvingDot: _RevolvingDot.RevolvingDot,
  Rings: _Rings.Rings,
  TailSpin: _TailSpin.TailSpin,
  ThreeDots: _ThreeDots.ThreeDots,
  Triangle: _Triangle.Triangle,
  Watch: _Watch.Watch
};
loader.Spinner = Spinner;

(function (exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Loader;

var _react = _interopRequireWildcard(React__default);

var _propTypes = _interopRequireDefault(PropTypes);

var _loader = loader;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var componentNames = ["Audio", "BallTriangle", "Bars", "Circles", "Grid", "Hearts", "Oval", "Puff", "Rings", "TailSpin", "ThreeDots", "Watch", "RevolvingDot", "Triangle", "Plane", "MutatingDots", "CradleLoader"];

function componentName(type) {
  if (componentNames.includes(type)) {
    return _loader.Spinner[type];
  }

  return _loader.Spinner.Audio;
}
/**
 * @return {null}
 */


function Loader(props) {
  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      display = _useState2[0],
      setDisplay = _useState2[1];

  (0, _react.useEffect)(function () {
    var timer;

    if (props.timeout && props.timeout > 0) {
      timer = setTimeout(function () {
        setDisplay(false);
      }, props.timeout);
    }

    return function () {
      if (timer) clearTimeout(timer);
    };
  });

  if (!props.visible || props.visible === "false") {
    return null;
  }

  return display ? /*#__PURE__*/_react["default"].createElement("div", {
    "aria-busy": "true",
    className: props.className,
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement(componentName(props.type), _objectSpread({}, props))) : null;
}

Loader.propTypes = {
  type: _propTypes["default"].oneOf([].concat(componentNames)),
  style: _propTypes["default"].objectOf(_propTypes["default"].string),
  className: _propTypes["default"].string,
  visible: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  timeout: _propTypes["default"].number
};
Loader.defaultProps = {
  type: "Audio",
  style: {},
  className: "",
  visible: true,
  timeout: 0
};
}(dist));

var Loader = /*@__PURE__*/getDefaultExportFromCjs(dist);

var css_248z = "@import\"./CradleLoader.css\";\n@import\"./Plane.css\";\n@import\"./Triangle.css\";\n";
styleInject(css_248z);

var GrantsContainer = styled.div.withConfig({
  displayName: "Grants__GrantsContainer",
  componentId: "sc-1sjzbad-0"
})(["padding:0 20px;position:relative;@media (min-width:768px){display:flex;padding:0 6.9%;}p{font-size:24px;}.loader{position:absolute;top:0;left:calc(50% - 30px);}"]);
var Grant = styled.div.withConfig({
  displayName: "Grants__Grant",
  componentId: "sc-1sjzbad-1"
})(["background-color:", ";padding:13px 14px 17px;margin-bottom:20px;@media (min-width:600px){padding:23px 22px 25px;}@media (min-width:1024px){display:flex;margin-bottom:16px;}h3{font-family:proxima-nova-condensed,sans-serif;font-weight:700;font-size:24px;padding-bottom:14px;margin-bottom:9px;border-bottom:2px solid white;@media (min-width:1024px){width:45%;flex:0 0 auto;border-bottom:0;padding:0 40px 0 0;margin-bottom:0;}}h5{font-family:proxima-nova-condensed,sans-serif;font-weight:500;font-size:16px;color:", ";margin-bottom:7px;@media (min-width:600px){margin-bottom:16px;}}> div{@media (min-width:1024px){border-left:2px solid white;padding-left:22px;}p{margin-bottom:0;}}"], function (props) {
  return getLightColor(props.color);
}, function (props) {
  return getSecondaryColor(props.color);
});
var LoadMore = styled.div.withConfig({
  displayName: "Grants__LoadMore",
  componentId: "sc-1sjzbad-2"
})(["text-align:center;margin-bottom:120px;button{margin-top:34px;}"]);

var grantSort = function grantSort(a, b) {
  if (a["GRANT_APPROVED_DATE"] === b["GRANT_APPROVED_DATE"]) {
    return b["PROJECT_TITLE"] - a["PROJECT_TITLE"];
  }

  return parseInt(a["GRANT_APPROVED_DATE"]) < parseInt(b["GRANT_APPROVED_DATE"]) ? 1 : -1;
};

var lowest = function lowest(amounts) {
  if (amounts[0] === amounts[1]) {
    return amounts[0];
  } else if (amounts[0] < amounts[1]) {
    return amounts[0];
  } else {
    return amounts[1];
  }
};

var highest = function highest(amounts) {
  if (amounts[0] === amounts[1]) {
    return amounts[0];
  } else if (amounts[0] > amounts[1]) {
    return amounts[0];
  } else {
    return amounts[1];
  }
};

var Grants = function Grants(_ref) {
  var color = _ref.color,
      grantTitle = _ref.grantTitle;
  var context = useContext(SiteContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      initialized = _useState2[0],
      setInitialized = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      grants = _useState4[0],
      setGrants = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      page = _useState6[0],
      setPage = _useState6[1];

  var _useState7 = useState({
    priorities: [],
    cities: [],
    years: [0, 0],
    amount: [0, 0],
    query: ""
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      filters = _useState8[0],
      setFilters = _useState8[1];

  useEffect(function () {
    context.getGrants(grantTitle);
  }, []);
  useEffect(function () {
    if (Object.keys(context.grants).length) {
      var filteredGrants = _toConsumableArray(context.grants.data);

      if (filters.priorities.length) {
        filteredGrants = filteredGrants.filter(function (grant) {
          return filters.priorities.includes(grant["PROGRAM_AREA"]);
        });
      }

      if (filters.cities.length) {
        filteredGrants = filteredGrants.filter(function (grant) {
          return filters.cities.includes(grant["CITY"]);
        });
      }

      filteredGrants = filteredGrants.filter(function (grant) {
        return parseInt(grant["GRANT_APPROVED_DATE"]) >= lowest(filters.years) && parseInt(grant["GRANT_APPROVED_DATE"]) <= highest(filters.years);
      });
      filteredGrants = filteredGrants.filter(function (grant) {
        return parseInt(grant["AMOUNT_RECOMMENDED"]) >= lowest(filters.amount) && parseInt(grant["AMOUNT_RECOMMENDED"]) <= highest(filters.amount);
      });

      if (filters.query) {
        filteredGrants = filteredGrants.filter(function (grant) {
          return grant["NAME"].toLowerCase().search(filters.query.toLowerCase()) !== -1 || (grant["PROJECT_TITLE"] || "").toLowerCase().search(filters.query.toLowerCase()) !== -1;
        });
      }

      setPage(0);
      setGrants(filteredGrants);
      setInitialized(true);
    }
  }, [filters]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SEO, {
    document: {
      meta_title: "Grants - ".concat(context.defaultTitle)
    }
  }), /*#__PURE__*/React__default.createElement(PageTitle, {
    heading: "Explore Recent Grants",
    color: color
  }), /*#__PURE__*/React__default.createElement(GrantsContainer, null, !initialized && /*#__PURE__*/React__default.createElement(Loader, {
    className: "loader",
    type: "Oval",
    color: color,
    height: 60,
    width: 60,
    timeout: null
  }), /*#__PURE__*/React__default.createElement(GrantFilters, {
    color: color,
    filters: filters,
    setFilters: setFilters
  }), /*#__PURE__*/React__default.createElement("div", null, grants.length > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, grants.sort(grantSort).slice(0, page * 8 + 8).map(function (grant, index) {
    return /*#__PURE__*/React__default.createElement(Grant, {
      key: index,
      color: color
    }, /*#__PURE__*/React__default.createElement("h3", null, grant["NAME"]), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h5", null, "".concat(grant["GRANT_APPROVED_DATE"], " | ").concat(parseInt(grant["AMOUNT_RECOMMENDED"]).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }))), /*#__PURE__*/React__default.createElement("p", null, grant["PROJECT_TITLE"])));
  })) : initialized ? /*#__PURE__*/React__default.createElement("p", null, "No results found.") : null, /*#__PURE__*/React__default.createElement(LoadMore, null, grants.length > page * 8 + 8 && /*#__PURE__*/React__default.createElement(Button, {
    label: "Load More",
    color: color,
    onClick: function onClick() {
      return setPage(page + 1);
    }
  })))));
};

// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
var LuxonError = /*#__PURE__*/function (_Error) {
  _inherits(LuxonError, _Error);

  var _super = _createSuper(LuxonError);

  function LuxonError() {
    _classCallCheck(this, LuxonError);

    return _super.apply(this, arguments);
  }

  return LuxonError;
}( /*#__PURE__*/_wrapNativeSuper$1(Error));
/**
 * @private
 */


var InvalidDateTimeError = /*#__PURE__*/function (_LuxonError) {
  _inherits(InvalidDateTimeError, _LuxonError);

  var _super2 = _createSuper(InvalidDateTimeError);

  function InvalidDateTimeError(reason) {
    _classCallCheck(this, InvalidDateTimeError);

    return _super2.call(this, "Invalid DateTime: ".concat(reason.toMessage()));
  }

  return InvalidDateTimeError;
}(LuxonError);
/**
 * @private
 */

var InvalidIntervalError = /*#__PURE__*/function (_LuxonError2) {
  _inherits(InvalidIntervalError, _LuxonError2);

  var _super3 = _createSuper(InvalidIntervalError);

  function InvalidIntervalError(reason) {
    _classCallCheck(this, InvalidIntervalError);

    return _super3.call(this, "Invalid Interval: ".concat(reason.toMessage()));
  }

  return InvalidIntervalError;
}(LuxonError);
/**
 * @private
 */

var InvalidDurationError = /*#__PURE__*/function (_LuxonError3) {
  _inherits(InvalidDurationError, _LuxonError3);

  var _super4 = _createSuper(InvalidDurationError);

  function InvalidDurationError(reason) {
    _classCallCheck(this, InvalidDurationError);

    return _super4.call(this, "Invalid Duration: ".concat(reason.toMessage()));
  }

  return InvalidDurationError;
}(LuxonError);
/**
 * @private
 */

var ConflictingSpecificationError = /*#__PURE__*/function (_LuxonError4) {
  _inherits(ConflictingSpecificationError, _LuxonError4);

  var _super5 = _createSuper(ConflictingSpecificationError);

  function ConflictingSpecificationError() {
    _classCallCheck(this, ConflictingSpecificationError);

    return _super5.apply(this, arguments);
  }

  return ConflictingSpecificationError;
}(LuxonError);
/**
 * @private
 */

var InvalidUnitError = /*#__PURE__*/function (_LuxonError5) {
  _inherits(InvalidUnitError, _LuxonError5);

  var _super6 = _createSuper(InvalidUnitError);

  function InvalidUnitError(unit) {
    _classCallCheck(this, InvalidUnitError);

    return _super6.call(this, "Invalid unit ".concat(unit));
  }

  return InvalidUnitError;
}(LuxonError);
/**
 * @private
 */

var InvalidArgumentError = /*#__PURE__*/function (_LuxonError6) {
  _inherits(InvalidArgumentError, _LuxonError6);

  var _super7 = _createSuper(InvalidArgumentError);

  function InvalidArgumentError() {
    _classCallCheck(this, InvalidArgumentError);

    return _super7.apply(this, arguments);
  }

  return InvalidArgumentError;
}(LuxonError);
/**
 * @private
 */

var ZoneIsAbstractError = /*#__PURE__*/function (_LuxonError7) {
  _inherits(ZoneIsAbstractError, _LuxonError7);

  var _super8 = _createSuper(ZoneIsAbstractError);

  function ZoneIsAbstractError() {
    _classCallCheck(this, ZoneIsAbstractError);

    return _super8.call(this, "Zone is an abstract class");
  }

  return ZoneIsAbstractError;
}(LuxonError);

/**
 * @private
 */
var n = "numeric",
    s = "short",
    l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23', always 24-hour.
 */

var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23 EDT', always 24-hour.
 */

var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hour12: false,
  timeZoneName: s
};
/**
 * {@link toLocaleString}; format like '09:30:23 Eastern Daylight Time', always 24-hour.
 */

var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hour12: false,
  timeZoneName: l
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
 */

var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
 */

var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/
/**
 * @private
 */
// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
} // CAPABILITIES

function hasIntl() {
  try {
    return typeof Intl !== "undefined" && Intl.DateTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasFormatToParts() {
  return !isUndefined(Intl.DateTimeFormat.prototype.formatToParts);
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
} // OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }

  return arr.reduce(function (best, next) {
    var pair = [by(next), next];

    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce(function (a, k) {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
} // NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
} // x % n but takes the sign of n instead of x

function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}
function padStart(input) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var minus = input < 0 ? "-" : "";
  var target = minus ? input * -1 : input;
  var result;

  if (target.toString().length < n) {
    result = ("0".repeat(n) + target).slice(-n);
  } else {
    result = target.toString();
  }

  return "".concat(minus).concat(result);
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}
function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    var f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}
function roundTo(number, digits) {
  var towardZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var factor = Math.pow(10, digits),
      rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
} // DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  var modMonth = floorMod(month - 1, 12) + 1,
      modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)

function objToLocalTS(obj) {
  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that

  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }

  return +d;
}
function weeksInWeekYear(weekYear) {
  var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7,
      last = weekYear - 1,
      p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
  return p1 === 4 || p2 === 3 ? 53 : 52;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > 60 ? 1900 + year : 2000 + year;
} // PARSING

function parseZoneInfo(ts, offsetFormat, locale) {
  var timeZone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var date = new Date(ts),
      intlOpts = {
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  var modified = Object.assign({
    timeZoneName: offsetFormat
  }, intlOpts),
      intl = hasIntl();

  if (intl && hasFormatToParts()) {
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
      return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
  } else if (intl) {
    // this probably doesn't work for all locales
    var without = new Intl.DateTimeFormat(locale, intlOpts).format(date),
        included = new Intl.DateTimeFormat(locale, modified).format(date),
        diffed = included.substring(without.length),
        trimmed = diffed.replace(/^[, \u200e]+/, "");
    return trimmed;
  } else {
    return null;
  }
} // signedOffset('-5', '30') -> -330

function signedOffset(offHourStr, offMinuteStr) {
  var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0

  if (Number.isNaN(offHour)) {
    offHour = 0;
  }

  var offMin = parseInt(offMinuteStr, 10) || 0,
      offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
} // COERCION

function asNumber(value) {
  var numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError("Invalid unit value ".concat(value));
  return numericValue;
}
function normalizeObject(obj, normalizer, nonUnitKeys) {
  var normalized = {};

  for (var u in obj) {
    if (hasOwnProperty(obj, u)) {
      if (nonUnitKeys.indexOf(u) >= 0) continue;
      var v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }

  return normalized;
}
function formatOffset(offset, format) {
  var hours = Math.trunc(Math.abs(offset / 60)),
      minutes = Math.trunc(Math.abs(offset % 60)),
      sign = offset >= 0 ? "+" : "-";

  switch (format) {
    case "short":
      return "".concat(sign).concat(padStart(hours, 2), ":").concat(padStart(minutes, 2));

    case "narrow":
      return "".concat(sign).concat(hours).concat(minutes > 0 ? ":".concat(minutes) : "");

    case "techie":
      return "".concat(sign).concat(padStart(hours, 2)).concat(padStart(minutes, 2));

    default:
      throw new RangeError("Value format ".concat(format, " is out of range for property format"));
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}
var ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;

function stringify(obj) {
  return JSON.stringify(obj, Object.keys(obj).sort());
}
/**
 * @private
 */


var monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [].concat(monthsNarrow);

    case "short":
      return [].concat(monthsShort);

    case "long":
      return [].concat(monthsLong);

    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

    default:
      return null;
  }
}
var weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [].concat(weekdaysNarrow);

    case "short":
      return [].concat(weekdaysShort);

    case "long":
      return [].concat(weekdaysLong);

    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];

    default:
      return null;
  }
}
var meridiems = ["AM", "PM"];
var erasLong = ["Before Christ", "Anno Domini"];
var erasShort = ["BC", "AD"];
var erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [].concat(erasNarrow);

    case "short":
      return [].concat(erasShort);

    case "long":
      return [].concat(erasLong);

    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count) {
  var numeric = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "always";
  var narrow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  var lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;

  if (numeric === "auto" && lastable) {
    var isDay = unit === "days";

    switch (count) {
      case 1:
        return isDay ? "tomorrow" : "next ".concat(units[unit][0]);

      case -1:
        return isDay ? "yesterday" : "last ".concat(units[unit][0]);

      case 0:
        return isDay ? "today" : "this ".concat(units[unit][0]);

    }
  }

  var isInPast = Object.is(count, -0) || count < 0,
      fmtValue = Math.abs(count),
      singular = fmtValue === 1,
      lilUnits = units[unit],
      fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? "".concat(fmtValue, " ").concat(fmtUnit, " ago") : "in ".concat(fmtValue, " ").concat(fmtUnit);
}
function formatString(knownFormat) {
  // these all have the offsets removed because we don't have access to them
  // without all the intl stuff this is backfilling
  var filtered = pick(knownFormat, ["weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName", "hour12"]),
      key = stringify(filtered),
      dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";

  switch (key) {
    case stringify(DATE_SHORT):
      return "M/d/yyyy";

    case stringify(DATE_MED):
      return "LLL d, yyyy";

    case stringify(DATE_MED_WITH_WEEKDAY):
      return "EEE, LLL d, yyyy";

    case stringify(DATE_FULL):
      return "LLLL d, yyyy";

    case stringify(DATE_HUGE):
      return "EEEE, LLLL d, yyyy";

    case stringify(TIME_SIMPLE):
      return "h:mm a";

    case stringify(TIME_WITH_SECONDS):
      return "h:mm:ss a";

    case stringify(TIME_WITH_SHORT_OFFSET):
      return "h:mm a";

    case stringify(TIME_WITH_LONG_OFFSET):
      return "h:mm a";

    case stringify(TIME_24_SIMPLE):
      return "HH:mm";

    case stringify(TIME_24_WITH_SECONDS):
      return "HH:mm:ss";

    case stringify(TIME_24_WITH_SHORT_OFFSET):
      return "HH:mm";

    case stringify(TIME_24_WITH_LONG_OFFSET):
      return "HH:mm";

    case stringify(DATETIME_SHORT):
      return "M/d/yyyy, h:mm a";

    case stringify(DATETIME_MED):
      return "LLL d, yyyy, h:mm a";

    case stringify(DATETIME_FULL):
      return "LLLL d, yyyy, h:mm a";

    case stringify(DATETIME_HUGE):
      return dateTimeHuge;

    case stringify(DATETIME_SHORT_WITH_SECONDS):
      return "M/d/yyyy, h:mm:ss a";

    case stringify(DATETIME_MED_WITH_SECONDS):
      return "LLL d, yyyy, h:mm:ss a";

    case stringify(DATETIME_MED_WITH_WEEKDAY):
      return "EEE, d LLL yyyy, h:mm a";

    case stringify(DATETIME_FULL_WITH_SECONDS):
      return "LLLL d, yyyy, h:mm:ss a";

    case stringify(DATETIME_HUGE_WITH_SECONDS):
      return "EEEE, LLLL d, yyyy, h:mm:ss a";

    default:
      return dateTimeHuge;
  }
}

function stringifyTokens(splits, tokenToString) {
  var s = "";

  var _iterator = _createForOfIteratorHelper(splits),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var token = _step.value;

      if (token.literal) {
        s += token.val;
      } else {
        s += tokenToString(token.val);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return s;
}

var _macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */

var Formatter = /*#__PURE__*/function () {
  function Formatter(locale, formatOpts) {
    _classCallCheck(this, Formatter);

    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  _createClass$1(Formatter, [{
    key: "formatWithSystemDefault",
    value: function formatWithSystemDefault(dt, opts) {
      if (this.systemLoc === null) {
        this.systemLoc = this.loc.redefaultToSystem();
      }

      var df = this.systemLoc.dtFormatter(dt, Object.assign({}, this.opts, opts));
      return df.format();
    }
  }, {
    key: "formatDateTime",
    value: function formatDateTime(dt) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
      return df.format();
    }
  }, {
    key: "formatDateTimeParts",
    value: function formatDateTimeParts(dt) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
      return df.formatToParts();
    }
  }, {
    key: "resolvedOptions",
    value: function resolvedOptions(dt) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
      return df.resolvedOptions();
    }
  }, {
    key: "num",
    value: function num(n) {
      var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      // we get some perf out of doing this here, annoyingly
      if (this.opts.forceSimple) {
        return padStart(n, p);
      }

      var opts = Object.assign({}, this.opts);

      if (p > 0) {
        opts.padTo = p;
      }

      return this.loc.numberFormatter(opts).format(n);
    }
  }, {
    key: "formatDateTimeFromString",
    value: function formatDateTimeFromString(dt, fmt) {
      var _this = this;

      var knownEnglish = this.loc.listingMode() === "en",
          useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory" && hasFormatToParts(),
          string = function string(opts, extract) {
        return _this.loc.extract(dt, opts, extract);
      },
          formatOffset = function formatOffset(opts) {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }

        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
          meridiem = function meridiem() {
        return knownEnglish ? meridiemForDateTime(dt) : string({
          hour: "numeric",
          hour12: true
        }, "dayperiod");
      },
          month = function month(length, standalone) {
        return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
          month: length
        } : {
          month: length,
          day: "numeric"
        }, "month");
      },
          weekday = function weekday(length, standalone) {
        return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
          weekday: length
        } : {
          weekday: length,
          month: "long",
          day: "numeric"
        }, "weekday");
      },
          maybeMacro = function maybeMacro(token) {
        var formatOpts = Formatter.macroTokenToFormatOpts(token);

        if (formatOpts) {
          return _this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
          era = function era(length) {
        return knownEnglish ? eraForDateTime(dt, length) : string({
          era: length
        }, "era");
      },
          tokenToString = function tokenToString(token) {
        // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
        switch (token) {
          // ms
          case "S":
            return _this.num(dt.millisecond);

          case "u": // falls through

          case "SSS":
            return _this.num(dt.millisecond, 3);
          // seconds

          case "s":
            return _this.num(dt.second);

          case "ss":
            return _this.num(dt.second, 2);
          // minutes

          case "m":
            return _this.num(dt.minute);

          case "mm":
            return _this.num(dt.minute, 2);
          // hours

          case "h":
            return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);

          case "hh":
            return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);

          case "H":
            return _this.num(dt.hour);

          case "HH":
            return _this.num(dt.hour, 2);
          // offset

          case "Z":
            // like +6
            return formatOffset({
              format: "narrow",
              allowZ: _this.opts.allowZ
            });

          case "ZZ":
            // like +06:00
            return formatOffset({
              format: "short",
              allowZ: _this.opts.allowZ
            });

          case "ZZZ":
            // like +0600
            return formatOffset({
              format: "techie",
              allowZ: _this.opts.allowZ
            });

          case "ZZZZ":
            // like EST
            return dt.zone.offsetName(dt.ts, {
              format: "short",
              locale: _this.loc.locale
            });

          case "ZZZZZ":
            // like Eastern Standard Time
            return dt.zone.offsetName(dt.ts, {
              format: "long",
              locale: _this.loc.locale
            });
          // zone

          case "z":
            // like America/New_York
            return dt.zoneName;
          // meridiems

          case "a":
            return meridiem();
          // dates

          case "d":
            return useDateTimeFormatter ? string({
              day: "numeric"
            }, "day") : _this.num(dt.day);

          case "dd":
            return useDateTimeFormatter ? string({
              day: "2-digit"
            }, "day") : _this.num(dt.day, 2);
          // weekdays - standalone

          case "c":
            // like 1
            return _this.num(dt.weekday);

          case "ccc":
            // like 'Tues'
            return weekday("short", true);

          case "cccc":
            // like 'Tuesday'
            return weekday("long", true);

          case "ccccc":
            // like 'T'
            return weekday("narrow", true);
          // weekdays - format

          case "E":
            // like 1
            return _this.num(dt.weekday);

          case "EEE":
            // like 'Tues'
            return weekday("short", false);

          case "EEEE":
            // like 'Tuesday'
            return weekday("long", false);

          case "EEEEE":
            // like 'T'
            return weekday("narrow", false);
          // months - standalone

          case "L":
            // like 1
            return useDateTimeFormatter ? string({
              month: "numeric",
              day: "numeric"
            }, "month") : _this.num(dt.month);

          case "LL":
            // like 01, doesn't seem to work
            return useDateTimeFormatter ? string({
              month: "2-digit",
              day: "numeric"
            }, "month") : _this.num(dt.month, 2);

          case "LLL":
            // like Jan
            return month("short", true);

          case "LLLL":
            // like January
            return month("long", true);

          case "LLLLL":
            // like J
            return month("narrow", true);
          // months - format

          case "M":
            // like 1
            return useDateTimeFormatter ? string({
              month: "numeric"
            }, "month") : _this.num(dt.month);

          case "MM":
            // like 01
            return useDateTimeFormatter ? string({
              month: "2-digit"
            }, "month") : _this.num(dt.month, 2);

          case "MMM":
            // like Jan
            return month("short", false);

          case "MMMM":
            // like January
            return month("long", false);

          case "MMMMM":
            // like J
            return month("narrow", false);
          // years

          case "y":
            // like 2014
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : _this.num(dt.year);

          case "yy":
            // like 14
            return useDateTimeFormatter ? string({
              year: "2-digit"
            }, "year") : _this.num(dt.year.toString().slice(-2), 2);

          case "yyyy":
            // like 0012
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : _this.num(dt.year, 4);

          case "yyyyyy":
            // like 000012
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : _this.num(dt.year, 6);
          // eras

          case "G":
            // like AD
            return era("short");

          case "GG":
            // like Anno Domini
            return era("long");

          case "GGGGG":
            return era("narrow");

          case "kk":
            return _this.num(dt.weekYear.toString().slice(-2), 2);

          case "kkkk":
            return _this.num(dt.weekYear, 4);

          case "W":
            return _this.num(dt.weekNumber);

          case "WW":
            return _this.num(dt.weekNumber, 2);

          case "o":
            return _this.num(dt.ordinal);

          case "ooo":
            return _this.num(dt.ordinal, 3);

          case "q":
            // like 1
            return _this.num(dt.quarter);

          case "qq":
            // like 01
            return _this.num(dt.quarter, 2);

          case "X":
            return _this.num(Math.floor(dt.ts / 1000));

          case "x":
            return _this.num(dt.ts);

          default:
            return maybeMacro(token);
        }
      };

      return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    }
  }, {
    key: "formatDurationFromString",
    value: function formatDurationFromString(dur, fmt) {
      var _this2 = this;

      var tokenToField = function tokenToField(token) {
        switch (token[0]) {
          case "S":
            return "millisecond";

          case "s":
            return "second";

          case "m":
            return "minute";

          case "h":
            return "hour";

          case "d":
            return "day";

          case "M":
            return "month";

          case "y":
            return "year";

          default:
            return null;
        }
      },
          tokenToString = function tokenToString(lildur) {
        return function (token) {
          var mapped = tokenToField(token);

          if (mapped) {
            return _this2.num(lildur.get(mapped), token.length);
          } else {
            return token;
          }
        };
      },
          tokens = Formatter.parseFormat(fmt),
          realTokens = tokens.reduce(function (found, _ref) {
        var literal = _ref.literal,
            val = _ref.val;
        return literal ? found : found.concat(val);
      }, []),
          collapsed = dur.shiftTo.apply(dur, _toConsumableArray(realTokens.map(tokenToField).filter(function (t) {
        return t;
      })));

      return stringifyTokens(tokens, tokenToString(collapsed));
    }
  }], [{
    key: "create",
    value: function create(locale) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Formatter(locale, opts);
    }
  }, {
    key: "parseFormat",
    value: function parseFormat(fmt) {
      var current = null,
          currentFull = "",
          bracketed = false;
      var splits = [];

      for (var i = 0; i < fmt.length; i++) {
        var c = fmt.charAt(i);

        if (c === "'") {
          if (currentFull.length > 0) {
            splits.push({
              literal: bracketed,
              val: currentFull
            });
          }

          current = null;
          currentFull = "";
          bracketed = !bracketed;
        } else if (bracketed) {
          currentFull += c;
        } else if (c === current) {
          currentFull += c;
        } else {
          if (currentFull.length > 0) {
            splits.push({
              literal: false,
              val: currentFull
            });
          }

          currentFull = c;
          current = c;
        }
      }

      if (currentFull.length > 0) {
        splits.push({
          literal: bracketed,
          val: currentFull
        });
      }

      return splits;
    }
  }, {
    key: "macroTokenToFormatOpts",
    value: function macroTokenToFormatOpts(token) {
      return _macroTokenToFormatOpts[token];
    }
  }]);

  return Formatter;
}();

var Invalid = /*#__PURE__*/function () {
  function Invalid(reason, explanation) {
    _classCallCheck(this, Invalid);

    this.reason = reason;
    this.explanation = explanation;
  }

  _createClass$1(Invalid, [{
    key: "toMessage",
    value: function toMessage() {
      if (this.explanation) {
        return "".concat(this.reason, ": ").concat(this.explanation);
      } else {
        return this.reason;
      }
    }
  }]);

  return Invalid;
}();

/**
 * @interface
 */

var Zone = /*#__PURE__*/function () {
  function Zone() {
    _classCallCheck(this, Zone);
  }

  _createClass$1(Zone, [{
    key: "type",
    get:
    /**
     * The type of zone
     * @abstract
     * @type {string}
     */
    function get() {
      throw new ZoneIsAbstractError();
    }
    /**
     * The name of this zone.
     * @abstract
     * @type {string}
     */

  }, {
    key: "name",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
    /**
     * Returns whether the offset is known to be fixed for the whole year.
     * @abstract
     * @type {boolean}
     */

  }, {
    key: "universal",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
    /**
     * Returns the offset's common name (such as EST) at the specified timestamp
     * @abstract
     * @param {number} ts - Epoch milliseconds for which to get the name
     * @param {Object} opts - Options to affect the format
     * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
     * @param {string} opts.locale - What locale to return the offset name in.
     * @return {string}
     */

  }, {
    key: "offsetName",
    value: function offsetName(ts, opts) {
      throw new ZoneIsAbstractError();
    }
    /**
     * Returns the offset's value as a string
     * @abstract
     * @param {number} ts - Epoch milliseconds for which to get the offset
     * @param {string} format - What style of offset to return.
     *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
     * @return {string}
     */

  }, {
    key: "formatOffset",
    value: function formatOffset(ts, format) {
      throw new ZoneIsAbstractError();
    }
    /**
     * Return the offset in minutes for this zone at the specified timestamp.
     * @abstract
     * @param {number} ts - Epoch milliseconds for which to compute the offset
     * @return {number}
     */

  }, {
    key: "offset",
    value: function offset(ts) {
      throw new ZoneIsAbstractError();
    }
    /**
     * Return whether this Zone is equal to another zone
     * @abstract
     * @param {Zone} otherZone - the zone to compare
     * @return {boolean}
     */

  }, {
    key: "equals",
    value: function equals(otherZone) {
      throw new ZoneIsAbstractError();
    }
    /**
     * Return whether this Zone is valid.
     * @abstract
     * @type {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }]);

  return Zone;
}();

var singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */

var LocalZone = /*#__PURE__*/function (_Zone) {
  _inherits(LocalZone, _Zone);

  var _super = _createSuper(LocalZone);

  function LocalZone() {
    _classCallCheck(this, LocalZone);

    return _super.apply(this, arguments);
  }

  _createClass$1(LocalZone, [{
    key: "type",
    get:
    /** @override **/
    function get() {
      return "local";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      if (hasIntl()) {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else return "local";
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
    /** @override **/

  }, {
    key: "offsetName",
    value: function offsetName(ts, _ref) {
      var format = _ref.format,
          locale = _ref.locale;
      return parseZoneInfo(ts, format, locale);
    }
    /** @override **/

  }, {
    key: "formatOffset",
    value: function formatOffset$1(ts, format) {
      return formatOffset(this.offset(ts), format);
    }
    /** @override **/

  }, {
    key: "offset",
    value: function offset(ts) {
      return -new Date(ts).getTimezoneOffset();
    }
    /** @override **/

  }, {
    key: "equals",
    value: function equals(otherZone) {
      return otherZone.type === "local";
    }
    /** @override **/

  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "instance",
    get:
    /**
     * Get a singleton instance of the local zone
     * @return {LocalZone}
     */
    function get() {
      if (singleton$1 === null) {
        singleton$1 = new LocalZone();
      }

      return singleton$1;
    }
  }]);

  return LocalZone;
}(Zone);

var matchingRegex = RegExp("^".concat(ianaRegex.source, "$"));
var dtfCache = {};

function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }

  return dtfCache[zone];
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, ""),
      parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted),
      _parsed = _slicedToArray(parsed, 7),
      fMonth = _parsed[1],
      fDay = _parsed[2],
      fYear = _parsed[3],
      fHour = _parsed[4],
      fMinute = _parsed[5],
      fSecond = _parsed[6];

  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date),
      filled = [];

  for (var i = 0; i < formatted.length; i++) {
    var _formatted$i = formatted[i],
        type = _formatted$i.type,
        value = _formatted$i.value,
        pos = typeToPos[type];

    if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }

  return filled;
}

var ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */

var IANAZone = /*#__PURE__*/function (_Zone) {
  _inherits(IANAZone, _Zone);

  var _super = _createSuper(IANAZone);

  function IANAZone(name) {
    var _this;

    _classCallCheck(this, IANAZone);

    _this = _super.call(this);
    /** @private **/

    _this.zoneName = name;
    /** @private **/

    _this.valid = IANAZone.isValidZone(name);
    return _this;
  }
  /** @override **/


  _createClass$1(IANAZone, [{
    key: "type",
    get: function get() {
      return "iana";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
    /** @override **/

  }, {
    key: "offsetName",
    value: function offsetName(ts, _ref) {
      var format = _ref.format,
          locale = _ref.locale;
      return parseZoneInfo(ts, format, locale, this.name);
    }
    /** @override **/

  }, {
    key: "formatOffset",
    value: function formatOffset$1(ts, format) {
      return formatOffset(this.offset(ts), format);
    }
    /** @override **/

  }, {
    key: "offset",
    value: function offset(ts) {
      var date = new Date(ts);
      if (isNaN(date)) return NaN;

      var dtf = makeDTF(this.name),
          _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
          _ref3 = _slicedToArray(_ref2, 6),
          year = _ref3[0],
          month = _ref3[1],
          day = _ref3[2],
          hour = _ref3[3],
          minute = _ref3[4],
          second = _ref3[5],
          adjustedHour = hour === 24 ? 0 : hour;

      var asUTC = objToLocalTS({
        year: year,
        month: month,
        day: day,
        hour: adjustedHour,
        minute: minute,
        second: second,
        millisecond: 0
      });
      var asTS = +date;
      var over = asTS % 1000;
      asTS -= over >= 0 ? over : 1000 + over;
      return (asUTC - asTS) / (60 * 1000);
    }
    /** @override **/

  }, {
    key: "equals",
    value: function equals(otherZone) {
      return otherZone.type === "iana" && otherZone.name === this.name;
    }
    /** @override **/

  }, {
    key: "isValid",
    get: function get() {
      return this.valid;
    }
  }], [{
    key: "create",
    value:
    /**
     * @param {string} name - Zone name
     * @return {IANAZone}
     */
    function create(name) {
      if (!ianaZoneCache[name]) {
        ianaZoneCache[name] = new IANAZone(name);
      }

      return ianaZoneCache[name];
    }
    /**
     * Reset local caches. Should only be necessary in testing scenarios.
     * @return {void}
     */

  }, {
    key: "resetCache",
    value: function resetCache() {
      ianaZoneCache = {};
      dtfCache = {};
    }
    /**
     * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
     * @param {string} s - The string to check validity on
     * @example IANAZone.isValidSpecifier("America/New_York") //=> true
     * @example IANAZone.isValidSpecifier("Fantasia/Castle") //=> true
     * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
     * @return {boolean}
     */

  }, {
    key: "isValidSpecifier",
    value: function isValidSpecifier(s) {
      return !!(s && s.match(matchingRegex));
    }
    /**
     * Returns whether the provided string identifies a real zone
     * @param {string} zone - The string to check
     * @example IANAZone.isValidZone("America/New_York") //=> true
     * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
     * @example IANAZone.isValidZone("Sport~~blorp") //=> false
     * @return {boolean}
     */

  }, {
    key: "isValidZone",
    value: function isValidZone(zone) {
      try {
        new Intl.DateTimeFormat("en-US", {
          timeZone: zone
        }).format();
        return true;
      } catch (e) {
        return false;
      }
    } // Etc/GMT+8 -> -480

    /** @ignore */

  }, {
    key: "parseGMTOffset",
    value: function parseGMTOffset(specifier) {
      if (specifier) {
        var match = specifier.match(/^Etc\/GMT(0|[+-]\d{1,2})$/i);

        if (match) {
          return -60 * parseInt(match[1]);
        }
      }

      return null;
    }
  }]);

  return IANAZone;
}(Zone);

var singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */

var FixedOffsetZone = /*#__PURE__*/function (_Zone) {
  _inherits(FixedOffsetZone, _Zone);

  var _super = _createSuper(FixedOffsetZone);

  function FixedOffsetZone(offset) {
    var _this;

    _classCallCheck(this, FixedOffsetZone);

    _this = _super.call(this);
    /** @private **/

    _this.fixed = offset;
    return _this;
  }
  /** @override **/


  _createClass$1(FixedOffsetZone, [{
    key: "type",
    get: function get() {
      return "fixed";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.fixed === 0 ? "UTC" : "UTC".concat(formatOffset(this.fixed, "narrow"));
    }
    /** @override **/

  }, {
    key: "offsetName",
    value: function offsetName() {
      return this.name;
    }
    /** @override **/

  }, {
    key: "formatOffset",
    value: function formatOffset$1(ts, format) {
      return formatOffset(this.fixed, format);
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return true;
    }
    /** @override **/

  }, {
    key: "offset",
    value: function offset() {
      return this.fixed;
    }
    /** @override **/

  }, {
    key: "equals",
    value: function equals(otherZone) {
      return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    }
    /** @override **/

  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "utcInstance",
    get:
    /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */
    function get() {
      if (singleton === null) {
        singleton = new FixedOffsetZone(0);
      }

      return singleton;
    }
    /**
     * Get an instance with a specified offset
     * @param {number} offset - The offset in minutes
     * @return {FixedOffsetZone}
     */

  }, {
    key: "instance",
    value: function instance(offset) {
      return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    }
    /**
     * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
     * @param {string} s - The offset string to parse
     * @example FixedOffsetZone.parseSpecifier("UTC+6")
     * @example FixedOffsetZone.parseSpecifier("UTC+06")
     * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
     * @return {FixedOffsetZone}
     */

  }, {
    key: "parseSpecifier",
    value: function parseSpecifier(s) {
      if (s) {
        var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);

        if (r) {
          return new FixedOffsetZone(signedOffset(r[1], r[2]));
        }
      }

      return null;
    }
  }]);

  return FixedOffsetZone;
}(Zone);

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */

var InvalidZone = /*#__PURE__*/function (_Zone) {
  _inherits(InvalidZone, _Zone);

  var _super = _createSuper(InvalidZone);

  function InvalidZone(zoneName) {
    var _this;

    _classCallCheck(this, InvalidZone);

    _this = _super.call(this);
    /**  @private */

    _this.zoneName = zoneName;
    return _this;
  }
  /** @override **/


  _createClass$1(InvalidZone, [{
    key: "type",
    get: function get() {
      return "invalid";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
    /** @override **/

  }, {
    key: "offsetName",
    value: function offsetName() {
      return null;
    }
    /** @override **/

  }, {
    key: "formatOffset",
    value: function formatOffset() {
      return "";
    }
    /** @override **/

  }, {
    key: "offset",
    value: function offset() {
      return NaN;
    }
    /** @override **/

  }, {
    key: "equals",
    value: function equals() {
      return false;
    }
    /** @override **/

  }, {
    key: "isValid",
    get: function get() {
      return false;
    }
  }]);

  return InvalidZone;
}(Zone);

function normalizeZone(input, defaultZone) {
  var offset;

  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    var lowered = input.toLowerCase();
    if (lowered === "local") return defaultZone;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else if ((offset = IANAZone.parseGMTOffset(input)) != null) {
      // handle Etc/GMT-4, which V8 chokes on
      return FixedOffsetZone.instance(offset);
    } else if (IANAZone.isValidSpecifier(lowered)) return IANAZone.create(input);else return FixedOffsetZone.parseSpecifier(lowered) || new InvalidZone(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (_typeof(input) === "object" && input.offset && typeof input.offset === "number") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

var now = function now() {
  return Date.now();
},
    defaultZone = null,
    // not setting this directly to LocalZone.instance bc loading order issues
defaultLocale = null,
    defaultNumberingSystem = null,
    defaultOutputCalendar = null,
    throwOnInvalid = false;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */


var Settings = /*#__PURE__*/function () {
  function Settings() {
    _classCallCheck(this, Settings);
  }

  _createClass$1(Settings, null, [{
    key: "now",
    get:
    /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */
    function get() {
      return now;
    }
    /**
     * Set the callback for returning the current timestamp.
     * The function should return a number, which will be interpreted as an Epoch millisecond count
     * @type {function}
     * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
     * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
     */
    ,
    set: function set(n) {
      now = n;
    }
    /**
     * Get the default time zone to create DateTimes in.
     * @type {string}
     */

  }, {
    key: "defaultZoneName",
    get: function get() {
      return Settings.defaultZone.name;
    }
    /**
     * Set the default time zone to create DateTimes in. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(z) {
      if (!z) {
        defaultZone = null;
      } else {
        defaultZone = normalizeZone(z);
      }
    }
    /**
     * Get the default time zone object to create DateTimes in. Does not affect existing instances.
     * @type {Zone}
     */

  }, {
    key: "defaultZone",
    get: function get() {
      return defaultZone || LocalZone.instance;
    }
    /**
     * Get the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultLocale",
    get: function get() {
      return defaultLocale;
    }
    /**
     * Set the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(locale) {
      defaultLocale = locale;
    }
    /**
     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultNumberingSystem",
    get: function get() {
      return defaultNumberingSystem;
    }
    /**
     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(numberingSystem) {
      defaultNumberingSystem = numberingSystem;
    }
    /**
     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultOutputCalendar",
    get: function get() {
      return defaultOutputCalendar;
    }
    /**
     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(outputCalendar) {
      defaultOutputCalendar = outputCalendar;
    }
    /**
     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */

  }, {
    key: "throwOnInvalid",
    get: function get() {
      return throwOnInvalid;
    }
    /**
     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */
    ,
    set: function set(t) {
      throwOnInvalid = t;
    }
    /**
     * Reset Luxon's global caches. Should only be necessary in testing scenarios.
     * @return {void}
     */

  }, {
    key: "resetCaches",
    value: function resetCaches() {
      Locale.resetCache();
      IANAZone.resetCache();
    }
  }]);

  return Settings;
}();

var _excluded = ["base"];
var intlDTCache = {};

function getCachedDTF(locString) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var key = JSON.stringify([locString, opts]);
  var dtf = intlDTCache[key];

  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }

  return dtf;
}

var intlNumCache = {};

function getCachedINF(locString) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var key = JSON.stringify([locString, opts]);
  var inf = intlNumCache[key];

  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }

  return inf;
}

var intlRelCache = {};

function getCachedRTF(locString) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  opts.base;
      var cacheKeyOpts = _objectWithoutProperties(opts, _excluded); // exclude `base` from the options


  var key = JSON.stringify([locString, cacheKeyOpts]);
  var inf = intlRelCache[key];

  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }

  return inf;
}

var sysLocaleCache = null;

function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else if (hasIntl()) {
    var computedSys = new Intl.DateTimeFormat().resolvedOptions().locale; // node sometimes defaults to "und". Override that because that is dumb

    sysLocaleCache = !computedSys || computedSys === "und" ? "en-US" : computedSys;
    return sysLocaleCache;
  } else {
    sysLocaleCache = "en-US";
    return sysLocaleCache;
  }
}

function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:
  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u
  var uIndex = localeStr.indexOf("-u-");

  if (uIndex === -1) {
    return [localeStr];
  } else {
    var options;
    var smaller = localeStr.substring(0, uIndex);

    try {
      options = getCachedDTF(localeStr).resolvedOptions();
    } catch (e) {
      options = getCachedDTF(smaller).resolvedOptions();
    }

    var _options = options,
        numberingSystem = _options.numberingSystem,
        calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it

    return [smaller, numberingSystem, calendar];
  }
}

function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (hasIntl()) {
    if (outputCalendar || numberingSystem) {
      localeStr += "-u";

      if (outputCalendar) {
        localeStr += "-ca-".concat(outputCalendar);
      }

      if (numberingSystem) {
        localeStr += "-nu-".concat(numberingSystem);
      }

      return localeStr;
    } else {
      return localeStr;
    }
  } else {
    return [];
  }
}

function mapMonths(f) {
  var ms = [];

  for (var i = 1; i <= 12; i++) {
    var dt = DateTime.utc(2016, i, 1);
    ms.push(f(dt));
  }

  return ms;
}

function mapWeekdays(f) {
  var ms = [];

  for (var i = 1; i <= 7; i++) {
    var dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }

  return ms;
}

function listStuff(loc, length, defaultOK, englishFn, intlFn) {
  var mode = loc.listingMode(defaultOK);

  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || hasIntl() && new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
/**
 * @private
 */


var PolyNumberFormatter = /*#__PURE__*/function () {
  function PolyNumberFormatter(intl, forceSimple, opts) {
    _classCallCheck(this, PolyNumberFormatter);

    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;

    if (!forceSimple && hasIntl()) {
      var intlOpts = {
        useGrouping: false
      };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }

  _createClass$1(PolyNumberFormatter, [{
    key: "format",
    value: function format(i) {
      if (this.inf) {
        var fixed = this.floor ? Math.floor(i) : i;
        return this.inf.format(fixed);
      } else {
        // to match the browser's numberformatter defaults
        var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);

        return padStart(_fixed, this.padTo);
      }
    }
  }]);

  return PolyNumberFormatter;
}();
/**
 * @private
 */


var PolyDateFormatter = /*#__PURE__*/function () {
  function PolyDateFormatter(dt, intl, opts) {
    _classCallCheck(this, PolyDateFormatter);

    this.opts = opts;
    this.hasIntl = hasIntl();
    var z;

    if (dt.zone.universal && this.hasIntl) {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      var gmtOffset = -1 * (dt.offset / 60);
      var offsetZ = gmtOffset >= 0 ? "Etc/GMT+".concat(gmtOffset) : "Etc/GMT".concat(gmtOffset);
      var isOffsetZoneSupported = IANAZone.isValidZone(offsetZ);

      if (dt.offset !== 0 && isOffsetZoneSupported) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
        // So we have to make do. Two cases:
        // 1. The format options tell us to show the zone. We can't do that, so the best
        // we can do is format the date in UTC.
        // 2. The format options don't tell us to show the zone. Then we can adjust them
        // the time and tell the formatter to show it to us in UTC, so that the time is right
        // and the bad zone doesn't show up.
        z = "UTC";

        if (opts.timeZoneName) {
          this.dt = dt;
        } else {
          this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
        }
      }
    } else if (dt.zone.type === "local") {
      this.dt = dt;
    } else {
      this.dt = dt;
      z = dt.zone.name;
    }

    if (this.hasIntl) {
      var intlOpts = Object.assign({}, this.opts);

      if (z) {
        intlOpts.timeZone = z;
      }

      this.dtf = getCachedDTF(intl, intlOpts);
    }
  }

  _createClass$1(PolyDateFormatter, [{
    key: "format",
    value: function format() {
      if (this.hasIntl) {
        return this.dtf.format(this.dt.toJSDate());
      } else {
        var tokenFormat = formatString(this.opts),
            loc = Locale.create("en-US");
        return Formatter.create(loc).formatDateTimeFromString(this.dt, tokenFormat);
      }
    }
  }, {
    key: "formatToParts",
    value: function formatToParts() {
      if (this.hasIntl && hasFormatToParts()) {
        return this.dtf.formatToParts(this.dt.toJSDate());
      } else {
        // This is kind of a cop out. We actually could do this for English. However, we couldn't do it for intl strings
        // and IMO it's too weird to have an uncanny valley like that
        return [];
      }
    }
  }, {
    key: "resolvedOptions",
    value: function resolvedOptions() {
      if (this.hasIntl) {
        return this.dtf.resolvedOptions();
      } else {
        return {
          locale: "en-US",
          numberingSystem: "latn",
          outputCalendar: "gregory"
        };
      }
    }
  }]);

  return PolyDateFormatter;
}();
/**
 * @private
 */


var PolyRelFormatter = /*#__PURE__*/function () {
  function PolyRelFormatter(intl, isEnglish, opts) {
    _classCallCheck(this, PolyRelFormatter);

    this.opts = Object.assign({
      style: "long"
    }, opts);

    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }

  _createClass$1(PolyRelFormatter, [{
    key: "format",
    value: function format(count, unit) {
      if (this.rtf) {
        return this.rtf.format(count, unit);
      } else {
        return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
      }
    }
  }, {
    key: "formatToParts",
    value: function formatToParts(count, unit) {
      if (this.rtf) {
        return this.rtf.formatToParts(count, unit);
      } else {
        return [];
      }
    }
  }]);

  return PolyRelFormatter;
}();
/**
 * @private
 */


var Locale = /*#__PURE__*/function () {
  function Locale(locale, numbering, outputCalendar, specifiedLocale) {
    _classCallCheck(this, Locale);

    var _parseLocaleString = parseLocaleString(locale),
        _parseLocaleString2 = _slicedToArray(_parseLocaleString, 3),
        parsedLocale = _parseLocaleString2[0],
        parsedNumberingSystem = _parseLocaleString2[1],
        parsedOutputCalendar = _parseLocaleString2[2];

    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  _createClass$1(Locale, [{
    key: "fastNumbers",
    get: function get() {
      if (this.fastNumbersCached == null) {
        this.fastNumbersCached = supportsFastNumbers(this);
      }

      return this.fastNumbersCached;
    }
  }, {
    key: "listingMode",
    value: function listingMode() {
      var defaultOK = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var intl = hasIntl(),
          hasFTP = intl && hasFormatToParts(),
          isActuallyEn = this.isEnglish(),
          hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");

      if (!hasFTP && !(isActuallyEn && hasNoWeirdness) && !defaultOK) {
        return "error";
      } else if (!hasFTP || isActuallyEn && hasNoWeirdness) {
        return "en";
      } else {
        return "intl";
      }
    }
  }, {
    key: "clone",
    value: function clone(alts) {
      if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
        return this;
      } else {
        return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
      }
    }
  }, {
    key: "redefaultToEN",
    value: function redefaultToEN() {
      var alts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.clone(Object.assign({}, alts, {
        defaultToEN: true
      }));
    }
  }, {
    key: "redefaultToSystem",
    value: function redefaultToSystem() {
      var alts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.clone(Object.assign({}, alts, {
        defaultToEN: false
      }));
    }
  }, {
    key: "months",
    value: function months$1(length) {
      var _this = this;

      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var defaultOK = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return listStuff(this, length, defaultOK, months, function () {
        var intl = format ? {
          month: length,
          day: "numeric"
        } : {
          month: length
        },
            formatStr = format ? "format" : "standalone";

        if (!_this.monthsCache[formatStr][length]) {
          _this.monthsCache[formatStr][length] = mapMonths(function (dt) {
            return _this.extract(dt, intl, "month");
          });
        }

        return _this.monthsCache[formatStr][length];
      });
    }
  }, {
    key: "weekdays",
    value: function weekdays$1(length) {
      var _this2 = this;

      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var defaultOK = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return listStuff(this, length, defaultOK, weekdays, function () {
        var intl = format ? {
          weekday: length,
          year: "numeric",
          month: "long",
          day: "numeric"
        } : {
          weekday: length
        },
            formatStr = format ? "format" : "standalone";

        if (!_this2.weekdaysCache[formatStr][length]) {
          _this2.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
            return _this2.extract(dt, intl, "weekday");
          });
        }

        return _this2.weekdaysCache[formatStr][length];
      });
    }
  }, {
    key: "meridiems",
    value: function meridiems$1() {
      var _this3 = this;

      var defaultOK = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return listStuff(this, undefined, defaultOK, function () {
        return meridiems;
      }, function () {
        // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
        // for AM and PM. This is probably wrong, but it's makes parsing way easier.
        if (!_this3.meridiemCache) {
          var intl = {
            hour: "numeric",
            hour12: true
          };
          _this3.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
            return _this3.extract(dt, intl, "dayperiod");
          });
        }

        return _this3.meridiemCache;
      });
    }
  }, {
    key: "eras",
    value: function eras$1(length) {
      var _this4 = this;

      var defaultOK = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return listStuff(this, length, defaultOK, eras, function () {
        var intl = {
          era: length
        }; // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
        // to definitely enumerate them.

        if (!_this4.eraCache[length]) {
          _this4.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
            return _this4.extract(dt, intl, "era");
          });
        }

        return _this4.eraCache[length];
      });
    }
  }, {
    key: "extract",
    value: function extract(dt, intlOpts, field) {
      var df = this.dtFormatter(dt, intlOpts),
          results = df.formatToParts(),
          matching = results.find(function (m) {
        return m.type.toLowerCase() === field;
      });
      return matching ? matching.value : null;
    }
  }, {
    key: "numberFormatter",
    value: function numberFormatter() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
      // (in contrast, the rest of the condition is used heavily)
      return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    }
  }, {
    key: "dtFormatter",
    value: function dtFormatter(dt) {
      var intlOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new PolyDateFormatter(dt, this.intl, intlOpts);
    }
  }, {
    key: "relFormatter",
    value: function relFormatter() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
    }
  }, {
    key: "isEnglish",
    value: function isEnglish() {
      return this.locale === "en" || this.locale.toLowerCase() === "en-us" || hasIntl() && new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    }
  }], [{
    key: "fromOpts",
    value: function fromOpts(opts) {
      return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    }
  }, {
    key: "create",
    value: function create(locale, numberingSystem, outputCalendar) {
      var defaultToEN = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var specifiedLocale = locale || Settings.defaultLocale,
          // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
      localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale()),
          numberingSystemR = numberingSystem || Settings.defaultNumberingSystem,
          outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
      return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    }
  }, {
    key: "resetCache",
    value: function resetCache() {
      sysLocaleCache = null;
      intlDTCache = {};
      intlNumCache = {};
      intlRelCache = {};
    }
  }, {
    key: "fromObject",
    value: function fromObject() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          locale = _ref.locale,
          numberingSystem = _ref.numberingSystem,
          outputCalendar = _ref.outputCalendar;

      return Locale.create(locale, numberingSystem, outputCalendar);
    }
  }]);

  return Locale;
}();

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

function combineRegexes() {
  for (var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++) {
    regexes[_key] = arguments[_key];
  }

  var full = regexes.reduce(function (f, r) {
    return f + r.source;
  }, "");
  return RegExp("^".concat(full, "$"));
}

function combineExtractors() {
  for (var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    extractors[_key2] = arguments[_key2];
  }

  return function (m) {
    return extractors.reduce(function (_ref, ex) {
      var _ref2 = _slicedToArray(_ref, 3),
          mergedVals = _ref2[0],
          mergedZone = _ref2[1],
          cursor = _ref2[2];

      var _ex = ex(m, cursor),
          _ex2 = _slicedToArray(_ex, 3),
          val = _ex2[0],
          zone = _ex2[1],
          next = _ex2[2];

      return [Object.assign(mergedVals, val), mergedZone || zone, next];
    }, [{}, null, 1]).slice(0, 2);
  };
}

function parse(s) {
  if (s == null) {
    return [null, null];
  }

  for (var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    patterns[_key3 - 1] = arguments[_key3];
  }

  for (var _i = 0, _patterns = patterns; _i < _patterns.length; _i++) {
    var _patterns$_i = _slicedToArray(_patterns[_i], 2),
        regex = _patterns$_i[0],
        extractor = _patterns$_i[1];

    var m = regex.exec(s);

    if (m) {
      return extractor(m);
    }
  }

  return [null, null];
}

function simpleParse() {
  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    keys[_key4] = arguments[_key4];
  }

  return function (match, cursor) {
    var ret = {};
    var i;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }

    return [ret, null, cursor + i];
  };
} // ISO and SQL parsing


var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
    isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/,
    isoTimeRegex = RegExp("".concat(isoTimeBaseRegex.source).concat(offsetRegex.source, "?")),
    isoTimeExtensionRegex = RegExp("(?:T".concat(isoTimeRegex.source, ")?")),
    isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
    isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/,
    isoOrdinalRegex = /(\d{4})-?(\d{3})/,
    extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"),
    extractISOOrdinalData = simpleParse("year", "ordinal"),
    sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/,
    // dumbed-down version of the ISO one
sqlTimeRegex = RegExp("".concat(isoTimeBaseRegex.source, " ?(?:").concat(offsetRegex.source, "|(").concat(ianaRegex.source, "))?")),
    sqlTimeExtensionRegex = RegExp("(?: ".concat(sqlTimeRegex.source, ")?"));

function _int(match, pos, fallback) {
  var m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}

function extractISOYmd(match, cursor) {
  var item = {
    year: _int(match, cursor),
    month: _int(match, cursor + 1, 1),
    day: _int(match, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  var item = {
    hours: _int(match, cursor, 0),
    minutes: _int(match, cursor + 1, 0),
    seconds: _int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3])
  };
  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  var local = !match[cursor] && !match[cursor + 1],
      fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
      zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
} // ISO time parsing


var isoTimeOnly = RegExp("^T?".concat(isoTimeBaseRegex.source, "$")); // ISO duration parsing

var isoDuration = /^-?P(?:(?:(-?\d{1,9})Y)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})W)?(?:(-?\d{1,9})D)?(?:T(?:(-?\d{1,9})H)?(?:(-?\d{1,9})M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;

function extractISODuration(match) {
  var _match = _slicedToArray(match, 9),
      s = _match[0],
      yearStr = _match[1],
      monthStr = _match[2],
      weekStr = _match[3],
      dayStr = _match[4],
      hourStr = _match[5],
      minuteStr = _match[6],
      secondStr = _match[7],
      millisecondsStr = _match[8];

  var hasNegativePrefix = s[0] === "-";
  var negativeSeconds = secondStr && secondStr[0] === "-";

  var maybeNegate = function maybeNegate(num) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
  };

  return [{
    years: maybeNegate(parseInteger(yearStr)),
    months: maybeNegate(parseInteger(monthStr)),
    weeks: maybeNegate(parseInteger(weekStr)),
    days: maybeNegate(parseInteger(dayStr)),
    hours: maybeNegate(parseInteger(hourStr)),
    minutes: maybeNegate(parseInteger(minuteStr)),
    seconds: maybeNegate(parseInteger(secondStr), secondStr === "-0"),
    milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
  }];
} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that


var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);

  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
} // RFC 2822/5322


var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  var _match2 = _slicedToArray(match, 12),
      weekdayStr = _match2[1],
      dayStr = _match2[2],
      monthStr = _match2[3],
      yearStr = _match2[4],
      hourStr = _match2[5],
      minuteStr = _match2[6],
      secondStr = _match2[7],
      obsOffset = _match2[8],
      milOffset = _match2[9],
      offHourStr = _match2[10],
      offMinuteStr = _match2[11],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  var offset;

  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }

  return [result, new FixedOffsetZone(offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
} // http date


var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
    rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
    ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  var _match3 = _slicedToArray(match, 8),
      weekdayStr = _match3[1],
      dayStr = _match3[2],
      monthStr = _match3[3],
      yearStr = _match3[4],
      hourStr = _match3[5],
      minuteStr = _match3[6],
      secondStr = _match3[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  return [result, FixedOffsetZone.utcInstance];
}

function extractASCII(match) {
  var _match4 = _slicedToArray(match, 8),
      weekdayStr = _match4[1],
      monthStr = _match4[2],
      dayStr = _match4[3],
      hourStr = _match4[4],
      minuteStr = _match4[5],
      secondStr = _match4[6],
      yearStr = _match4[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  return [result, FixedOffsetZone.utcInstance];
}

var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset);
var extractISOOrdinalDataAndTime = combineExtractors(extractISOOrdinalData, extractISOTime);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset);
/**
 * @private
 */

function parseISODate(s) {
  return parse(s, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDataAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
}
function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s) {
  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
}
function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOYmdTimeOffsetAndIANAZone = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
  return parse(s, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeOffsetAndIANAZone], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
}

var INVALID$2 = "Invalid Duration"; // unit conversion constants

var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1000
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1000
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1000
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1000
  },
  seconds: {
    milliseconds: 1000
  }
},
    casualMatrix = Object.assign({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1000
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix),
    daysInYearAccurate = 146097.0 / 400,
    daysInMonthAccurate = 146097.0 / 4800,
    accurateMatrix = Object.assign({
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix); // units ordered by size

var orderedUnits$1 = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
var reverseUnits = orderedUnits$1.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"

function clone$1(dur, alts) {
  var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // deep merge for vals
  var conf = {
    values: clear ? alts.values : Object.assign({}, dur.values, alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
  };
  return new Duration(conf);
}

function antiTrunc(n) {
  return n < 0 ? Math.floor(n) : Math.ceil(n);
} // NB: mutates parameters


function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
  var conv = matrix[toUnit][fromUnit],
      raw = fromMap[fromUnit] / conv,
      sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]),
      // ok, so this is wild, but see the matrix in the tests
  added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
  toMap[toUnit] += added;
  fromMap[fromUnit] -= added * conv;
} // NB: mutates parameters


function normalizeValues(matrix, vals) {
  reverseUnits.reduce(function (previous, current) {
    if (!isUndefined(vals[current])) {
      if (previous) {
        convert(matrix, vals, previous, vals, current);
      }

      return current;
    } else {
      return previous;
    }
  }, null);
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime.plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration.years}, {@link Duration.months}, {@link Duration.weeks}, {@link Duration.days}, {@link Duration.hours}, {@link Duration.minutes}, {@link Duration.seconds}, {@link Duration.milliseconds} accessors.
 * * **Configuration** See  {@link Duration.locale} and {@link Duration.numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration.plus}, {@link Duration.minus}, {@link Duration.normalize}, {@link Duration.set}, {@link Duration.reconfigure}, {@link Duration.shiftTo}, and {@link Duration.negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration.as}, {@link Duration.toISO}, {@link Duration.toFormat}, and {@link Duration.toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */


var Duration = /*#__PURE__*/function () {
  /**
   * @private
   */
  function Duration(config) {
    _classCallCheck(this, Duration);

    var accurate = config.conversionAccuracy === "longterm" || false;
    /**
     * @access private
     */

    this.values = config.values;
    /**
     * @access private
     */

    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */

    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */

    this.invalid = config.invalid || null;
    /**
     * @access private
     */

    this.matrix = accurate ? accurateMatrix : casualMatrix;
    /**
     * @access private
     */

    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */


  _createClass$1(Duration, [{
    key: "locale",
    get:
    /**
     * Get  the locale of a Duration, such 'en-GB'
     * @type {string}
     */
    function get() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
     *
     * @type {string}
     */

  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
     * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
     * * `S` for milliseconds
     * * `s` for seconds
     * * `m` for minutes
     * * `h` for hours
     * * `d` for days
     * * `M` for months
     * * `y` for years
     * Notes:
     * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
     * * The duration will be converted to the set of units in the format string using {@link Duration.shiftTo} and the Durations's conversion accuracy setting.
     * @param {string} fmt - the format string
     * @param {Object} opts - options
     * @param {boolean} [opts.floor=true] - floor numerical values
     * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
     * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
     * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
     * @return {string}
     */

  }, {
    key: "toFormat",
    value: function toFormat(fmt) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // reverse-compat since 1.2; we always round down now, never up, and we do it by default
      var fmtOpts = Object.assign({}, opts, {
        floor: opts.round !== false && opts.floor !== false
      });
      return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
    }
    /**
     * Returns a JavaScript object with this Duration's values.
     * @param opts - options for generating the object
     * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
     * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
     * @return {Object}
     */

  }, {
    key: "toObject",
    value: function toObject() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isValid) return {};
      var base = Object.assign({}, this.values);

      if (opts.includeConfig) {
        base.conversionAccuracy = this.conversionAccuracy;
        base.numberingSystem = this.loc.numberingSystem;
        base.locale = this.loc.locale;
      }

      return base;
    }
    /**
     * Returns an ISO 8601-compliant string representation of this Duration.
     * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
     * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
     * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
     * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
     * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
     * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
     * @return {string}
     */

  }, {
    key: "toISO",
    value: function toISO() {
      // we could use the formatter, but this is an easier way to get the minimum string
      if (!this.isValid) return null;
      var s = "P";
      if (this.years !== 0) s += this.years + "Y";
      if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
      if (this.weeks !== 0) s += this.weeks + "W";
      if (this.days !== 0) s += this.days + "D";
      if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
      if (this.hours !== 0) s += this.hours + "H";
      if (this.minutes !== 0) s += this.minutes + "M";
      if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
      if (s === "P") s += "T0S";
      return s;
    }
    /**
     * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
     * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
     * @see https://en.wikipedia.org/wiki/ISO_8601#Times
     * @param {Object} opts - options
     * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
     * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
     * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
     * @param {string} [opts.format='extended'] - choose between the basic and extended format
     * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
     * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
     * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
     * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
     * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
     * @return {string}
     */

  }, {
    key: "toISOTime",
    value: function toISOTime() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isValid) return null;
      var millis = this.toMillis();
      if (millis < 0 || millis >= 86400000) return null;
      opts = Object.assign({
        suppressMilliseconds: false,
        suppressSeconds: false,
        includePrefix: false,
        format: "extended"
      }, opts);
      var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
      var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";

      if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
        fmt += opts.format === "basic" ? "ss" : ":ss";

        if (!opts.suppressMilliseconds || value.milliseconds !== 0) {
          fmt += ".SSS";
        }
      }

      var str = value.toFormat(fmt);

      if (opts.includePrefix) {
        str = "T" + str;
      }

      return str;
    }
    /**
     * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
     * @return {string}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toISO();
    }
    /**
     * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.toISO();
    }
    /**
     * Returns an milliseconds value of this Duration.
     * @return {number}
     */

  }, {
    key: "toMillis",
    value: function toMillis() {
      return this.as("milliseconds");
    }
    /**
     * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
     * @return {number}
     */

  }, {
    key: "valueOf",
    value: function valueOf() {
      return this.toMillis();
    }
    /**
     * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
     * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
     * @return {Duration}
     */

  }, {
    key: "plus",
    value: function plus(duration) {
      if (!this.isValid) return this;
      var dur = friendlyDuration(duration),
          result = {};

      var _iterator = _createForOfIteratorHelper(orderedUnits$1),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var k = _step.value;

          if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
            result[k] = dur.get(k) + this.get(k);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return clone$1(this, {
        values: result
      }, true);
    }
    /**
     * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
     * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
     * @return {Duration}
     */

  }, {
    key: "minus",
    value: function minus(duration) {
      if (!this.isValid) return this;
      var dur = friendlyDuration(duration);
      return this.plus(dur.negate());
    }
    /**
     * Scale this Duration by the specified amount. Return a newly-constructed Duration.
     * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
     * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit(x => x * 2) //=> { hours: 2, minutes: 60 }
     * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
     * @return {Duration}
     */

  }, {
    key: "mapUnits",
    value: function mapUnits(fn) {
      if (!this.isValid) return this;
      var result = {};

      for (var _i = 0, _Object$keys = Object.keys(this.values); _i < _Object$keys.length; _i++) {
        var k = _Object$keys[_i];
        result[k] = asNumber(fn(this.values[k], k));
      }

      return clone$1(this, {
        values: result
      }, true);
    }
    /**
     * Get the value of unit.
     * @param {string} unit - a unit such as 'minute' or 'day'
     * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
     * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
     * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
     * @return {number}
     */

  }, {
    key: "get",
    value: function get(unit) {
      return this[Duration.normalizeUnit(unit)];
    }
    /**
     * "Set" the values of specified units. Return a newly-constructed Duration.
     * @param {Object} values - a mapping of units to numbers
     * @example dur.set({ years: 2017 })
     * @example dur.set({ hours: 8, minutes: 30 })
     * @return {Duration}
     */

  }, {
    key: "set",
    value: function set(values) {
      if (!this.isValid) return this;
      var mixed = Object.assign(this.values, normalizeObject(values, Duration.normalizeUnit, []));
      return clone$1(this, {
        values: mixed
      });
    }
    /**
     * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
     * @example dur.reconfigure({ locale: 'en-GB' })
     * @return {Duration}
     */

  }, {
    key: "reconfigure",
    value: function reconfigure() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          locale = _ref.locale,
          numberingSystem = _ref.numberingSystem,
          conversionAccuracy = _ref.conversionAccuracy;

      var loc = this.loc.clone({
        locale: locale,
        numberingSystem: numberingSystem
      }),
          opts = {
        loc: loc
      };

      if (conversionAccuracy) {
        opts.conversionAccuracy = conversionAccuracy;
      }

      return clone$1(this, opts);
    }
    /**
     * Return the length of the duration in the specified unit.
     * @param {string} unit - a unit such as 'minutes' or 'days'
     * @example Duration.fromObject({years: 1}).as('days') //=> 365
     * @example Duration.fromObject({years: 1}).as('months') //=> 12
     * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
     * @return {number}
     */

  }, {
    key: "as",
    value: function as(unit) {
      return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    }
    /**
     * Reduce this Duration to its canonical representation in its current units.
     * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
     * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
     * @return {Duration}
     */

  }, {
    key: "normalize",
    value: function normalize() {
      if (!this.isValid) return this;
      var vals = this.toObject();
      normalizeValues(this.matrix, vals);
      return clone$1(this, {
        values: vals
      }, true);
    }
    /**
     * Convert this Duration into its representation in a different set of units.
     * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
     * @return {Duration}
     */

  }, {
    key: "shiftTo",
    value: function shiftTo() {
      for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
        units[_key] = arguments[_key];
      }

      if (!this.isValid) return this;

      if (units.length === 0) {
        return this;
      }

      units = units.map(function (u) {
        return Duration.normalizeUnit(u);
      });
      var built = {},
          accumulated = {},
          vals = this.toObject();
      var lastUnit;

      var _iterator2 = _createForOfIteratorHelper(orderedUnits$1),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var k = _step2.value;

          if (units.indexOf(k) >= 0) {
            lastUnit = k;
            var own = 0; // anything we haven't boiled down yet should get boiled to this unit

            for (var ak in accumulated) {
              own += this.matrix[ak][k] * accumulated[ak];
              accumulated[ak] = 0;
            } // plus anything that's already in this unit


            if (isNumber(vals[k])) {
              own += vals[k];
            }

            var i = Math.trunc(own);
            built[k] = i;
            accumulated[k] = own - i; // we'd like to absorb these fractions in another unit
            // plus anything further down the chain that should be rolled up in to this

            for (var down in vals) {
              if (orderedUnits$1.indexOf(down) > orderedUnits$1.indexOf(k)) {
                convert(this.matrix, vals, down, built, k);
              }
            } // otherwise, keep it in the wings to boil it later

          } else if (isNumber(vals[k])) {
            accumulated[k] = vals[k];
          }
        } // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      for (var key in accumulated) {
        if (accumulated[key] !== 0) {
          built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        }
      }

      return clone$1(this, {
        values: built
      }, true).normalize();
    }
    /**
     * Return the negative of this Duration.
     * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
     * @return {Duration}
     */

  }, {
    key: "negate",
    value: function negate() {
      if (!this.isValid) return this;
      var negated = {};

      for (var _i2 = 0, _Object$keys2 = Object.keys(this.values); _i2 < _Object$keys2.length; _i2++) {
        var k = _Object$keys2[_i2];
        negated[k] = -this.values[k];
      }

      return clone$1(this, {
        values: negated
      }, true);
    }
    /**
     * Get the years.
     * @type {number}
     */

  }, {
    key: "years",
    get: function get() {
      return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
     * Get the quarters.
     * @type {number}
     */

  }, {
    key: "quarters",
    get: function get() {
      return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
     * Get the months.
     * @type {number}
     */

  }, {
    key: "months",
    get: function get() {
      return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
     * Get the weeks
     * @type {number}
     */

  }, {
    key: "weeks",
    get: function get() {
      return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
     * Get the days.
     * @type {number}
     */

  }, {
    key: "days",
    get: function get() {
      return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
     * Get the hours.
     * @type {number}
     */

  }, {
    key: "hours",
    get: function get() {
      return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
     * Get the minutes.
     * @type {number}
     */

  }, {
    key: "minutes",
    get: function get() {
      return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
     * Get the seconds.
     * @return {number}
     */

  }, {
    key: "seconds",
    get: function get() {
      return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
     * Get the milliseconds.
     * @return {number}
     */

  }, {
    key: "milliseconds",
    get: function get() {
      return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
     * on invalid DateTimes or Intervals.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this Duration became invalid, or null if the Duration is valid
     * @return {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
    /**
     * Equality check
     * Two Durations are equal iff they have the same units and the same values for each unit.
     * @param {Duration} other
     * @return {boolean}
     */

  }, {
    key: "equals",
    value: function equals(other) {
      if (!this.isValid || !other.isValid) {
        return false;
      }

      if (!this.loc.equals(other.loc)) {
        return false;
      }

      function eq(v1, v2) {
        // Consider 0 and undefined as equal
        if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
        return v1 === v2;
      }

      var _iterator3 = _createForOfIteratorHelper(orderedUnits$1),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var u = _step3.value;

          if (!eq(this.values[u], other.values[u])) {
            return false;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return true;
    }
  }], [{
    key: "fromMillis",
    value: function fromMillis(count, opts) {
      return Duration.fromObject(Object.assign({
        milliseconds: count
      }, opts));
    }
    /**
     * Create a Duration from a JavaScript object with keys like 'years' and 'hours.
     * If this object is empty then a zero milliseconds duration is returned.
     * @param {Object} obj - the object to create the DateTime from
     * @param {number} obj.years
     * @param {number} obj.quarters
     * @param {number} obj.months
     * @param {number} obj.weeks
     * @param {number} obj.days
     * @param {number} obj.hours
     * @param {number} obj.minutes
     * @param {number} obj.seconds
     * @param {number} obj.milliseconds
     * @param {string} [obj.locale='en-US'] - the locale to use
     * @param {string} obj.numberingSystem - the numbering system to use
     * @param {string} [obj.conversionAccuracy='casual'] - the conversion system to use
     * @return {Duration}
     */

  }, {
    key: "fromObject",
    value: function fromObject(obj) {
      if (obj == null || _typeof(obj) !== "object") {
        throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got ".concat(obj === null ? "null" : _typeof(obj)));
      }

      return new Duration({
        values: normalizeObject(obj, Duration.normalizeUnit, ["locale", "numberingSystem", "conversionAccuracy", "zone" // a bit of debt; it's super inconvenient internally not to be able to blindly pass this
        ]),
        loc: Locale.fromObject(obj),
        conversionAccuracy: obj.conversionAccuracy
      });
    }
    /**
     * Create a Duration from an ISO 8601 duration string.
     * @param {string} text - text to parse
     * @param {Object} opts - options for parsing
     * @param {string} [opts.locale='en-US'] - the locale to use
     * @param {string} opts.numberingSystem - the numbering system to use
     * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
     * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
     * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
     * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
     * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
     * @return {Duration}
     */

  }, {
    key: "fromISO",
    value: function fromISO(text, opts) {
      var _parseISODuration = parseISODuration(text),
          _parseISODuration2 = _slicedToArray(_parseISODuration, 1),
          parsed = _parseISODuration2[0];

      if (parsed) {
        var obj = Object.assign(parsed, opts);
        return Duration.fromObject(obj);
      } else {
        return Duration.invalid("unparsable", "the input \"".concat(text, "\" can't be parsed as ISO 8601"));
      }
    }
    /**
     * Create a Duration from an ISO 8601 time string.
     * @param {string} text - text to parse
     * @param {Object} opts - options for parsing
     * @param {string} [opts.locale='en-US'] - the locale to use
     * @param {string} opts.numberingSystem - the numbering system to use
     * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
     * @see https://en.wikipedia.org/wiki/ISO_8601#Times
     * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
     * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
     * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
     * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
     * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
     * @return {Duration}
     */

  }, {
    key: "fromISOTime",
    value: function fromISOTime(text, opts) {
      var _parseISOTimeOnly = parseISOTimeOnly(text),
          _parseISOTimeOnly2 = _slicedToArray(_parseISOTimeOnly, 1),
          parsed = _parseISOTimeOnly2[0];

      if (parsed) {
        var obj = Object.assign(parsed, opts);
        return Duration.fromObject(obj);
      } else {
        return Duration.invalid("unparsable", "the input \"".concat(text, "\" can't be parsed as ISO 8601"));
      }
    }
    /**
     * Create an invalid Duration.
     * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
     * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
     * @return {Duration}
     */

  }, {
    key: "invalid",
    value: function invalid(reason) {
      var explanation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!reason) {
        throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
      }

      var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

      if (Settings.throwOnInvalid) {
        throw new InvalidDurationError(invalid);
      } else {
        return new Duration({
          invalid: invalid
        });
      }
    }
    /**
     * @private
     */

  }, {
    key: "normalizeUnit",
    value: function normalizeUnit(unit) {
      var normalized = {
        year: "years",
        years: "years",
        quarter: "quarters",
        quarters: "quarters",
        month: "months",
        months: "months",
        week: "weeks",
        weeks: "weeks",
        day: "days",
        days: "days",
        hour: "hours",
        hours: "hours",
        minute: "minutes",
        minutes: "minutes",
        second: "seconds",
        seconds: "seconds",
        millisecond: "milliseconds",
        milliseconds: "milliseconds"
      }[unit ? unit.toLowerCase() : unit];
      if (!normalized) throw new InvalidUnitError(unit);
      return normalized;
    }
    /**
     * Check if an object is a Duration. Works across context boundaries
     * @param {object} o
     * @return {boolean}
     */

  }, {
    key: "isDuration",
    value: function isDuration(o) {
      return o && o.isLuxonDuration || false;
    }
  }]);

  return Duration;
}();
function friendlyDuration(durationish) {
  if (isNumber(durationish)) {
    return Duration.fromMillis(durationish);
  } else if (Duration.isDuration(durationish)) {
    return durationish;
  } else if (_typeof(durationish) === "object") {
    return Duration.fromObject(durationish);
  } else {
    throw new InvalidArgumentError("Unknown duration argument ".concat(durationish, " of type ").concat(_typeof(durationish)));
  }
}

var INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end

function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=".concat(start.toISO(), " and end=").concat(end.toISO()));
  } else {
    return null;
  }
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link fromDateTimes}, {@link after}, {@link before}, or {@link fromISO}.
 * * **Accessors** Use {@link start} and {@link end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link count}, {@link length}, {@link hasSame}, {@link contains}, {@link isAfter}, or {@link isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link set}, {@link splitAt}, {@link splitBy}, {@link divideEqually}, {@link merge}, {@link xor}, {@link union}, {@link intersection}, or {@link difference}.
 * * **Comparison** To compare this Interval to another one, use {@link equals}, {@link overlaps}, {@link abutsStart}, {@link abutsEnd}, {@link engulfs}.
 * * **Output** To convert the Interval into other representations, see {@link toString}, {@link toISO}, {@link toISODate}, {@link toISOTime}, {@link toFormat}, and {@link toDuration}.
 */


var Interval = /*#__PURE__*/function () {
  /**
   * @private
   */
  function Interval(config) {
    _classCallCheck(this, Interval);

    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */

    this.e = config.end;
    /**
     * @access private
     */

    this.invalid = config.invalid || null;
    /**
     * @access private
     */

    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */


  _createClass$1(Interval, [{
    key: "start",
    get:
    /**
     * Returns the start of the Interval
     * @type {DateTime}
     */
    function get() {
      return this.isValid ? this.s : null;
    }
    /**
     * Returns the end of the Interval
     * @type {DateTime}
     */

  }, {
    key: "end",
    get: function get() {
      return this.isValid ? this.e : null;
    }
    /**
     * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
     * @type {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      return this.invalidReason === null;
    }
    /**
     * Returns an error code if this Interval is invalid, or null if the Interval is valid
     * @type {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
    /**
     * Returns the length of the Interval in the specified unit.
     * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
     * @return {number}
     */

  }, {
    key: "length",
    value: function length() {
      var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "milliseconds";
      return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
    }
    /**
     * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
     * Unlike {@link length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
     * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
     * @param {string} [unit='milliseconds'] - the unit of time to count.
     * @return {number}
     */

  }, {
    key: "count",
    value: function count() {
      var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "milliseconds";
      if (!this.isValid) return NaN;
      var start = this.start.startOf(unit),
          end = this.end.startOf(unit);
      return Math.floor(end.diff(start, unit).get(unit)) + 1;
    }
    /**
     * Returns whether this Interval's start and end are both in the same unit of time
     * @param {string} unit - the unit of time to check sameness on
     * @return {boolean}
     */

  }, {
    key: "hasSame",
    value: function hasSame(unit) {
      return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    }
    /**
     * Return whether this Interval has the same start and end DateTimes.
     * @return {boolean}
     */

  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.s.valueOf() === this.e.valueOf();
    }
    /**
     * Return whether this Interval's start is after the specified DateTime.
     * @param {DateTime} dateTime
     * @return {boolean}
     */

  }, {
    key: "isAfter",
    value: function isAfter(dateTime) {
      if (!this.isValid) return false;
      return this.s > dateTime;
    }
    /**
     * Return whether this Interval's end is before the specified DateTime.
     * @param {DateTime} dateTime
     * @return {boolean}
     */

  }, {
    key: "isBefore",
    value: function isBefore(dateTime) {
      if (!this.isValid) return false;
      return this.e <= dateTime;
    }
    /**
     * Return whether this Interval contains the specified DateTime.
     * @param {DateTime} dateTime
     * @return {boolean}
     */

  }, {
    key: "contains",
    value: function contains(dateTime) {
      if (!this.isValid) return false;
      return this.s <= dateTime && this.e > dateTime;
    }
    /**
     * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
     * @param {Object} values - the values to set
     * @param {DateTime} values.start - the starting DateTime
     * @param {DateTime} values.end - the ending DateTime
     * @return {Interval}
     */

  }, {
    key: "set",
    value: function set() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          start = _ref.start,
          end = _ref.end;

      if (!this.isValid) return this;
      return Interval.fromDateTimes(start || this.s, end || this.e);
    }
    /**
     * Split this Interval at each of the specified DateTimes
     * @param {...[DateTime]} dateTimes - the unit of time to count.
     * @return {[Interval]}
     */

  }, {
    key: "splitAt",
    value: function splitAt() {
      var _this = this;

      if (!this.isValid) return [];

      for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
        dateTimes[_key] = arguments[_key];
      }

      var sorted = dateTimes.map(friendlyDateTime).filter(function (d) {
        return _this.contains(d);
      }).sort(),
          results = [];
      var s = this.s,
          i = 0;

      while (s < this.e) {
        var added = sorted[i] || this.e,
            next = +added > +this.e ? this.e : added;
        results.push(Interval.fromDateTimes(s, next));
        s = next;
        i += 1;
      }

      return results;
    }
    /**
     * Split this Interval into smaller Intervals, each of the specified length.
     * Left over time is grouped into a smaller interval
     * @param {Duration|Object|number} duration - The length of each resulting interval.
     * @return {[Interval]}
     */

  }, {
    key: "splitBy",
    value: function splitBy(duration) {
      var dur = friendlyDuration(duration);

      if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
        return [];
      }

      var s = this.s,
          idx = 1,
          next;
      var results = [];

      while (s < this.e) {
        var added = this.start.plus(dur.mapUnits(function (x) {
          return x * idx;
        }));
        next = +added > +this.e ? this.e : added;
        results.push(Interval.fromDateTimes(s, next));
        s = next;
        idx += 1;
      }

      return results;
    }
    /**
     * Split this Interval into the specified number of smaller intervals.
     * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
     * @return {[Interval]}
     */

  }, {
    key: "divideEqually",
    value: function divideEqually(numberOfParts) {
      if (!this.isValid) return [];
      return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    }
    /**
     * Return whether this Interval overlaps with the specified Interval
     * @param {Interval} other
     * @return {boolean}
     */

  }, {
    key: "overlaps",
    value: function overlaps(other) {
      return this.e > other.s && this.s < other.e;
    }
    /**
     * Return whether this Interval's end is adjacent to the specified Interval's start.
     * @param {Interval} other
     * @return {boolean}
     */

  }, {
    key: "abutsStart",
    value: function abutsStart(other) {
      if (!this.isValid) return false;
      return +this.e === +other.s;
    }
    /**
     * Return whether this Interval's start is adjacent to the specified Interval's end.
     * @param {Interval} other
     * @return {boolean}
     */

  }, {
    key: "abutsEnd",
    value: function abutsEnd(other) {
      if (!this.isValid) return false;
      return +other.e === +this.s;
    }
    /**
     * Return whether this Interval engulfs the start and end of the specified Interval.
     * @param {Interval} other
     * @return {boolean}
     */

  }, {
    key: "engulfs",
    value: function engulfs(other) {
      if (!this.isValid) return false;
      return this.s <= other.s && this.e >= other.e;
    }
    /**
     * Return whether this Interval has the same start and end as the specified Interval.
     * @param {Interval} other
     * @return {boolean}
     */

  }, {
    key: "equals",
    value: function equals(other) {
      if (!this.isValid || !other.isValid) {
        return false;
      }

      return this.s.equals(other.s) && this.e.equals(other.e);
    }
    /**
     * Return an Interval representing the intersection of this Interval and the specified Interval.
     * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
     * Returns null if the intersection is empty, meaning, the intervals don't intersect.
     * @param {Interval} other
     * @return {Interval}
     */

  }, {
    key: "intersection",
    value: function intersection(other) {
      if (!this.isValid) return this;
      var s = this.s > other.s ? this.s : other.s,
          e = this.e < other.e ? this.e : other.e;

      if (s >= e) {
        return null;
      } else {
        return Interval.fromDateTimes(s, e);
      }
    }
    /**
     * Return an Interval representing the union of this Interval and the specified Interval.
     * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
     * @param {Interval} other
     * @return {Interval}
     */

  }, {
    key: "union",
    value: function union(other) {
      if (!this.isValid) return this;
      var s = this.s < other.s ? this.s : other.s,
          e = this.e > other.e ? this.e : other.e;
      return Interval.fromDateTimes(s, e);
    }
    /**
     * Merge an array of Intervals into a equivalent minimal set of Intervals.
     * Combines overlapping and adjacent Intervals.
     * @param {[Interval]} intervals
     * @return {[Interval]}
     */

  }, {
    key: "difference",
    value:
    /**
     * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
     * @param {...Interval} intervals
     * @return {[Interval]}
     */
    function difference() {
      var _this2 = this;

      for (var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        intervals[_key2] = arguments[_key2];
      }

      return Interval.xor([this].concat(intervals)).map(function (i) {
        return _this2.intersection(i);
      }).filter(function (i) {
        return i && !i.isEmpty();
      });
    }
    /**
     * Returns a string representation of this Interval appropriate for debugging.
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      if (!this.isValid) return INVALID$1;
      return "[".concat(this.s.toISO(), " \u2013 ").concat(this.e.toISO(), ")");
    }
    /**
     * Returns an ISO 8601-compliant string representation of this Interval.
     * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
     * @param {Object} opts - The same options as {@link DateTime.toISO}
     * @return {string}
     */

  }, {
    key: "toISO",
    value: function toISO(opts) {
      if (!this.isValid) return INVALID$1;
      return "".concat(this.s.toISO(opts), "/").concat(this.e.toISO(opts));
    }
    /**
     * Returns an ISO 8601-compliant string representation of date of this Interval.
     * The time components are ignored.
     * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
     * @return {string}
     */

  }, {
    key: "toISODate",
    value: function toISODate() {
      if (!this.isValid) return INVALID$1;
      return "".concat(this.s.toISODate(), "/").concat(this.e.toISODate());
    }
    /**
     * Returns an ISO 8601-compliant string representation of time of this Interval.
     * The date components are ignored.
     * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
     * @param {Object} opts - The same options as {@link DateTime.toISO}
     * @return {string}
     */

  }, {
    key: "toISOTime",
    value: function toISOTime(opts) {
      if (!this.isValid) return INVALID$1;
      return "".concat(this.s.toISOTime(opts), "/").concat(this.e.toISOTime(opts));
    }
    /**
     * Returns a string representation of this Interval formatted according to the specified format string.
     * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime.toFormat} for details.
     * @param {Object} opts - options
     * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
     * @return {string}
     */

  }, {
    key: "toFormat",
    value: function toFormat(dateFormat) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$separator = _ref2.separator,
          separator = _ref2$separator === void 0 ? " – " : _ref2$separator;

      if (!this.isValid) return INVALID$1;
      return "".concat(this.s.toFormat(dateFormat)).concat(separator).concat(this.e.toFormat(dateFormat));
    }
    /**
     * Return a Duration representing the time spanned by this interval.
     * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
     * @param {Object} opts - options that affect the creation of the Duration
     * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
     * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
     * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
     * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
     * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
     * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
     * @return {Duration}
     */

  }, {
    key: "toDuration",
    value: function toDuration(unit, opts) {
      if (!this.isValid) {
        return Duration.invalid(this.invalidReason);
      }

      return this.e.diff(this.s, unit, opts);
    }
    /**
     * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
     * @param {function} mapFn
     * @return {Interval}
     * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
     * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
     */

  }, {
    key: "mapEndpoints",
    value: function mapEndpoints(mapFn) {
      return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    }
  }], [{
    key: "invalid",
    value: function invalid(reason) {
      var explanation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!reason) {
        throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
      }

      var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

      if (Settings.throwOnInvalid) {
        throw new InvalidIntervalError(invalid);
      } else {
        return new Interval({
          invalid: invalid
        });
      }
    }
    /**
     * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
     * @param {DateTime|Date|Object} start
     * @param {DateTime|Date|Object} end
     * @return {Interval}
     */

  }, {
    key: "fromDateTimes",
    value: function fromDateTimes(start, end) {
      var builtStart = friendlyDateTime(start),
          builtEnd = friendlyDateTime(end);
      var validateError = validateStartEnd(builtStart, builtEnd);

      if (validateError == null) {
        return new Interval({
          start: builtStart,
          end: builtEnd
        });
      } else {
        return validateError;
      }
    }
    /**
     * Create an Interval from a start DateTime and a Duration to extend to.
     * @param {DateTime|Date|Object} start
     * @param {Duration|Object|number} duration - the length of the Interval.
     * @return {Interval}
     */

  }, {
    key: "after",
    value: function after(start, duration) {
      var dur = friendlyDuration(duration),
          dt = friendlyDateTime(start);
      return Interval.fromDateTimes(dt, dt.plus(dur));
    }
    /**
     * Create an Interval from an end DateTime and a Duration to extend backwards to.
     * @param {DateTime|Date|Object} end
     * @param {Duration|Object|number} duration - the length of the Interval.
     * @return {Interval}
     */

  }, {
    key: "before",
    value: function before(end, duration) {
      var dur = friendlyDuration(duration),
          dt = friendlyDateTime(end);
      return Interval.fromDateTimes(dt.minus(dur), dt);
    }
    /**
     * Create an Interval from an ISO 8601 string.
     * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
     * @param {string} text - the ISO string to parse
     * @param {Object} [opts] - options to pass {@link DateTime.fromISO} and optionally {@link Duration.fromISO}
     * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
     * @return {Interval}
     */

  }, {
    key: "fromISO",
    value: function fromISO(text, opts) {
      var _split = (text || "").split("/", 2),
          _split2 = _slicedToArray(_split, 2),
          s = _split2[0],
          e = _split2[1];

      if (s && e) {
        var start, startIsValid;

        try {
          start = DateTime.fromISO(s, opts);
          startIsValid = start.isValid;
        } catch (e) {
          startIsValid = false;
        }

        var end, endIsValid;

        try {
          end = DateTime.fromISO(e, opts);
          endIsValid = end.isValid;
        } catch (e) {
          endIsValid = false;
        }

        if (startIsValid && endIsValid) {
          return Interval.fromDateTimes(start, end);
        }

        if (startIsValid) {
          var dur = Duration.fromISO(e, opts);

          if (dur.isValid) {
            return Interval.after(start, dur);
          }
        } else if (endIsValid) {
          var _dur = Duration.fromISO(s, opts);

          if (_dur.isValid) {
            return Interval.before(end, _dur);
          }
        }
      }

      return Interval.invalid("unparsable", "the input \"".concat(text, "\" can't be parsed as ISO 8601"));
    }
    /**
     * Check if an object is an Interval. Works across context boundaries
     * @param {object} o
     * @return {boolean}
     */

  }, {
    key: "isInterval",
    value: function isInterval(o) {
      return o && o.isLuxonInterval || false;
    }
  }, {
    key: "merge",
    value: function merge(intervals) {
      var _intervals$sort$reduc = intervals.sort(function (a, b) {
        return a.s - b.s;
      }).reduce(function (_ref3, item) {
        var _ref4 = _slicedToArray(_ref3, 2),
            sofar = _ref4[0],
            current = _ref4[1];

        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      }, [[], null]),
          _intervals$sort$reduc2 = _slicedToArray(_intervals$sort$reduc, 2),
          found = _intervals$sort$reduc2[0],
          _final = _intervals$sort$reduc2[1];

      if (_final) {
        found.push(_final);
      }

      return found;
    }
    /**
     * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
     * @param {[Interval]} intervals
     * @return {[Interval]}
     */

  }, {
    key: "xor",
    value: function xor(intervals) {
      var _Array$prototype;

      var start = null,
          currentCount = 0;

      var results = [],
          ends = intervals.map(function (i) {
        return [{
          time: i.s,
          type: "s"
        }, {
          time: i.e,
          type: "e"
        }];
      }),
          flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, _toConsumableArray(ends)),
          arr = flattened.sort(function (a, b) {
        return a.time - b.time;
      });

      var _iterator = _createForOfIteratorHelper(arr),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          currentCount += i.type === "s" ? 1 : -1;

          if (currentCount === 1) {
            start = i.time;
          } else {
            if (start && +start !== +i.time) {
              results.push(Interval.fromDateTimes(start, i.time));
            }

            start = null;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return Interval.merge(results);
    }
  }]);

  return Interval;
}();

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */

var Info = /*#__PURE__*/function () {
  function Info() {
    _classCallCheck(this, Info);
  }

  _createClass$1(Info, null, [{
    key: "hasDST",
    value:
    /**
     * Return whether the specified zone contains a DST.
     * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
     * @return {boolean}
     */
    function hasDST() {
      var zone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Settings.defaultZone;
      var proto = DateTime.now().setZone(zone).set({
        month: 12
      });
      return !zone.universal && proto.offset !== proto.set({
        month: 6
      }).offset;
    }
    /**
     * Return whether the specified zone is a valid IANA specifier.
     * @param {string} zone - Zone to check
     * @return {boolean}
     */

  }, {
    key: "isValidIANAZone",
    value: function isValidIANAZone(zone) {
      return IANAZone.isValidSpecifier(zone) && IANAZone.isValidZone(zone);
    }
    /**
     * Converts the input into a {@link Zone} instance.
     *
     * * If `input` is already a Zone instance, it is returned unchanged.
     * * If `input` is a string containing a valid time zone name, a Zone instance
     *   with that name is returned.
     * * If `input` is a string that doesn't refer to a known time zone, a Zone
     *   instance with {@link Zone.isValid} == false is returned.
     * * If `input is a number, a Zone instance with the specified fixed offset
     *   in minutes is returned.
     * * If `input` is `null` or `undefined`, the default zone is returned.
     * @param {string|Zone|number} [input] - the value to be converted
     * @return {Zone}
     */

  }, {
    key: "normalizeZone",
    value: function normalizeZone$1(input) {
      return normalizeZone(input, Settings.defaultZone);
    }
    /**
     * Return an array of standalone month names.
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
     * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
     * @param {Object} opts - options
     * @param {string} [opts.locale] - the locale code
     * @param {string} [opts.numberingSystem=null] - the numbering system
     * @param {string} [opts.locObj=null] - an existing locale object to use
     * @param {string} [opts.outputCalendar='gregory'] - the calendar
     * @example Info.months()[0] //=> 'January'
     * @example Info.months('short')[0] //=> 'Jan'
     * @example Info.months('numeric')[0] //=> '1'
     * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
     * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
     * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
     * @return {[string]}
     */

  }, {
    key: "months",
    value: function months() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "long";

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$locale = _ref.locale,
          locale = _ref$locale === void 0 ? null : _ref$locale,
          _ref$numberingSystem = _ref.numberingSystem,
          numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem,
          _ref$locObj = _ref.locObj,
          locObj = _ref$locObj === void 0 ? null : _ref$locObj,
          _ref$outputCalendar = _ref.outputCalendar,
          outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;

      return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    }
    /**
     * Return an array of format month names.
     * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
     * changes the string.
     * See {@link months}
     * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
     * @param {Object} opts - options
     * @param {string} [opts.locale] - the locale code
     * @param {string} [opts.numberingSystem=null] - the numbering system
     * @param {string} [opts.locObj=null] - an existing locale object to use
     * @param {string} [opts.outputCalendar='gregory'] - the calendar
     * @return {[string]}
     */

  }, {
    key: "monthsFormat",
    value: function monthsFormat() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "long";

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$locale = _ref2.locale,
          locale = _ref2$locale === void 0 ? null : _ref2$locale,
          _ref2$numberingSystem = _ref2.numberingSystem,
          numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem,
          _ref2$locObj = _ref2.locObj,
          locObj = _ref2$locObj === void 0 ? null : _ref2$locObj,
          _ref2$outputCalendar = _ref2.outputCalendar,
          outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;

      return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    }
    /**
     * Return an array of standalone week names.
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
     * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
     * @param {Object} opts - options
     * @param {string} [opts.locale] - the locale code
     * @param {string} [opts.numberingSystem=null] - the numbering system
     * @param {string} [opts.locObj=null] - an existing locale object to use
     * @example Info.weekdays()[0] //=> 'Monday'
     * @example Info.weekdays('short')[0] //=> 'Mon'
     * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
     * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
     * @return {[string]}
     */

  }, {
    key: "weekdays",
    value: function weekdays() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "long";

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$locale = _ref3.locale,
          locale = _ref3$locale === void 0 ? null : _ref3$locale,
          _ref3$numberingSystem = _ref3.numberingSystem,
          numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem,
          _ref3$locObj = _ref3.locObj,
          locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;

      return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
    }
    /**
     * Return an array of format week names.
     * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
     * changes the string.
     * See {@link weekdays}
     * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
     * @param {Object} opts - options
     * @param {string} [opts.locale=null] - the locale code
     * @param {string} [opts.numberingSystem=null] - the numbering system
     * @param {string} [opts.locObj=null] - an existing locale object to use
     * @return {[string]}
     */

  }, {
    key: "weekdaysFormat",
    value: function weekdaysFormat() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "long";

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$locale = _ref4.locale,
          locale = _ref4$locale === void 0 ? null : _ref4$locale,
          _ref4$numberingSystem = _ref4.numberingSystem,
          numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem,
          _ref4$locObj = _ref4.locObj,
          locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;

      return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    }
    /**
     * Return an array of meridiems.
     * @param {Object} opts - options
     * @param {string} [opts.locale] - the locale code
     * @example Info.meridiems() //=> [ 'AM', 'PM' ]
     * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
     * @return {[string]}
     */

  }, {
    key: "meridiems",
    value: function meridiems() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$locale = _ref5.locale,
          locale = _ref5$locale === void 0 ? null : _ref5$locale;

      return Locale.create(locale).meridiems();
    }
    /**
     * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
     * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
     * @param {Object} opts - options
     * @param {string} [opts.locale] - the locale code
     * @example Info.eras() //=> [ 'BC', 'AD' ]
     * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
     * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
     * @return {[string]}
     */

  }, {
    key: "eras",
    value: function eras() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "short";

      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$locale = _ref6.locale,
          locale = _ref6$locale === void 0 ? null : _ref6$locale;

      return Locale.create(locale, null, "gregory").eras(length);
    }
    /**
     * Return the set of available features in this environment.
     * Some features of Luxon are not available in all environments. For example, on older browsers, timezone support is not available. Use this function to figure out if that's the case.
     * Keys:
     * * `zones`: whether this environment supports IANA timezones
     * * `intlTokens`: whether this environment supports internationalized token-based formatting/parsing
     * * `intl`: whether this environment supports general internationalization
     * * `relative`: whether this environment supports relative time formatting
     * @example Info.features() //=> { intl: true, intlTokens: false, zones: true, relative: false }
     * @return {Object}
     */

  }, {
    key: "features",
    value: function features() {
      var intl = false,
          intlTokens = false,
          zones = false,
          relative = false;

      if (hasIntl()) {
        intl = true;
        intlTokens = hasFormatToParts();
        relative = hasRelative();

        try {
          zones = new Intl.DateTimeFormat("en", {
            timeZone: "America/New_York"
          }).resolvedOptions().timeZone === "America/New_York";
        } catch (e) {
          zones = false;
        }
      }

      return {
        intl: intl,
        intlTokens: intlTokens,
        zones: zones,
        relative: relative
      };
    }
  }]);

  return Info;
}();

function dayDiff(earlier, later) {
  var utcDayStart = function utcDayStart(dt) {
    return dt.toUTC(0, {
      keepLocalTime: true
    }).startOf("day").valueOf();
  },
      ms = utcDayStart(later) - utcDayStart(earlier);

  return Math.floor(Duration.fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  var differs = [["years", function (a, b) {
    return b.year - a.year;
  }], ["quarters", function (a, b) {
    return b.quarter - a.quarter;
  }], ["months", function (a, b) {
    return b.month - a.month + (b.year - a.year) * 12;
  }], ["weeks", function (a, b) {
    var days = dayDiff(a, b);
    return (days - days % 7) / 7;
  }], ["days", dayDiff]];
  var results = {};
  var lowestOrder, highWater;

  for (var _i = 0, _differs = differs; _i < _differs.length; _i++) {
    var _differs$_i = _slicedToArray(_differs[_i], 2),
        unit = _differs$_i[0],
        differ = _differs$_i[1];

    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      var delta = differ(cursor, later);
      highWater = cursor.plus(_defineProperty({}, unit, delta));

      if (highWater > later) {
        cursor = cursor.plus(_defineProperty({}, unit, delta - 1));
        delta -= 1;
      } else {
        cursor = highWater;
      }

      results[unit] = delta;
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

function _diff (earlier, later, units, opts) {
  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
      _highOrderDiffs2 = _slicedToArray(_highOrderDiffs, 4),
      cursor = _highOrderDiffs2[0],
      results = _highOrderDiffs2[1],
      highWater = _highOrderDiffs2[2],
      lowestOrder = _highOrderDiffs2[3];

  var remainingMillis = later - cursor;
  var lowerOrderUnits = units.filter(function (u) {
    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
  });

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus(_defineProperty({}, lowestOrder, 1));
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  var duration = Duration.fromObject(Object.assign(results, opts));

  if (lowerOrderUnits.length > 0) {
    var _Duration$fromMillis;

    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, _toConsumableArray(lowerOrderUnits)).plus(duration);
  } else {
    return duration;
  }
}

var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}; // eslint-disable-next-line

var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  var value = parseInt(str, 10);

  if (isNaN(value)) {
    value = "";

    for (var i = 0; i < str.length; i++) {
      var code = str.charCodeAt(i);

      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (var key in numberingSystemsUTF16) {
          var _numberingSystemsUTF = _slicedToArray(numberingSystemsUTF16[key], 2),
              min = _numberingSystemsUTF[0],
              max = _numberingSystemsUTF[1];

          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }

    return parseInt(value, 10);
  } else {
    return value;
  }
}
function digitRegex(_ref) {
  var numberingSystem = _ref.numberingSystem;
  var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return new RegExp("".concat(numberingSystems[numberingSystem || "latn"]).concat(append));
}

var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";

function intUnit(regex) {
  var post = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
    return i;
  };
  return {
    regex: regex,
    deser: function deser(_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          s = _ref2[0];

      return post(parseDigits(s));
    }
  };
}

var NBSP = String.fromCharCode(160);
var spaceOrNBSP = "( |".concat(NBSP, ")");
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");

function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}

function stripInsensitivities(s) {
  return s.replace(/\./g, "") // ignore dots that were made optional
  .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
  .toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: function deser(_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            s = _ref4[0];

        return strings.findIndex(function (i) {
          return stripInsensitivities(s) === stripInsensitivities(i);
        }) + startIndex;
      }
    };
  }
}

function offset(regex, groups) {
  return {
    regex: regex,
    deser: function deser(_ref5) {
      var _ref6 = _slicedToArray(_ref5, 3),
          h = _ref6[1],
          m = _ref6[2];

      return signedOffset(h, m);
    },
    groups: groups
  };
}

function simple(regex) {
  return {
    regex: regex,
    deser: function deser(_ref7) {
      var _ref8 = _slicedToArray(_ref7, 1),
          s = _ref8[0];

      return s;
    }
  };
}

function escapeToken(value) {
  // eslint-disable-next-line no-useless-escape
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

function unitForToken(token, loc) {
  var one = digitRegex(loc),
      two = digitRegex(loc, "{2}"),
      three = digitRegex(loc, "{3}"),
      four = digitRegex(loc, "{4}"),
      six = digitRegex(loc, "{6}"),
      oneOrTwo = digitRegex(loc, "{1,2}"),
      oneToThree = digitRegex(loc, "{1,3}"),
      oneToSix = digitRegex(loc, "{1,6}"),
      oneToNine = digitRegex(loc, "{1,9}"),
      twoToFour = digitRegex(loc, "{2,4}"),
      fourToSix = digitRegex(loc, "{4,6}"),
      literal = function literal(t) {
    return {
      regex: RegExp(escapeToken(t.val)),
      deser: function deser(_ref9) {
        var _ref10 = _slicedToArray(_ref9, 1),
            s = _ref10[0];

        return s;
      },
      literal: true
    };
  },
      unitate = function unitate(t) {
    if (token.literal) {
      return literal(t);
    }

    switch (t.val) {
      // era
      case "G":
        return oneOf(loc.eras("short", false), 0);

      case "GG":
        return oneOf(loc.eras("long", false), 0);
      // years

      case "y":
        return intUnit(oneToSix);

      case "yy":
        return intUnit(twoToFour, untruncateYear);

      case "yyyy":
        return intUnit(four);

      case "yyyyy":
        return intUnit(fourToSix);

      case "yyyyyy":
        return intUnit(six);
      // months

      case "M":
        return intUnit(oneOrTwo);

      case "MM":
        return intUnit(two);

      case "MMM":
        return oneOf(loc.months("short", true, false), 1);

      case "MMMM":
        return oneOf(loc.months("long", true, false), 1);

      case "L":
        return intUnit(oneOrTwo);

      case "LL":
        return intUnit(two);

      case "LLL":
        return oneOf(loc.months("short", false, false), 1);

      case "LLLL":
        return oneOf(loc.months("long", false, false), 1);
      // dates

      case "d":
        return intUnit(oneOrTwo);

      case "dd":
        return intUnit(two);
      // ordinals

      case "o":
        return intUnit(oneToThree);

      case "ooo":
        return intUnit(three);
      // time

      case "HH":
        return intUnit(two);

      case "H":
        return intUnit(oneOrTwo);

      case "hh":
        return intUnit(two);

      case "h":
        return intUnit(oneOrTwo);

      case "mm":
        return intUnit(two);

      case "m":
        return intUnit(oneOrTwo);

      case "q":
        return intUnit(oneOrTwo);

      case "qq":
        return intUnit(two);

      case "s":
        return intUnit(oneOrTwo);

      case "ss":
        return intUnit(two);

      case "S":
        return intUnit(oneToThree);

      case "SSS":
        return intUnit(three);

      case "u":
        return simple(oneToNine);
      // meridiem

      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)

      case "kkkk":
        return intUnit(four);

      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)

      case "W":
        return intUnit(oneOrTwo);

      case "WW":
        return intUnit(two);
      // weekdays

      case "E":
      case "c":
        return intUnit(one);

      case "EEE":
        return oneOf(loc.weekdays("short", false, false), 1);

      case "EEEE":
        return oneOf(loc.weekdays("long", false, false), 1);

      case "ccc":
        return oneOf(loc.weekdays("short", true, false), 1);

      case "cccc":
        return oneOf(loc.weekdays("long", true, false), 1);
      // offset/zone

      case "Z":
      case "ZZ":
        return offset(new RegExp("([+-]".concat(oneOrTwo.source, ")(?::(").concat(two.source, "))?")), 2);

      case "ZZZ":
        return offset(new RegExp("([+-]".concat(oneOrTwo.source, ")(").concat(two.source, ")?")), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are

      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);

      default:
        return literal(t);
    }
  };

  var unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}

var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    "short": "MMM",
    "long": "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    "short": "EEE",
    "long": "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  }
};

function tokenForPart(part, locale, formatOpts) {
  var type = part.type,
      value = part.value;

  if (type === "literal") {
    return {
      literal: true,
      val: value
    };
  }

  var style = formatOpts[type];
  var val = partTypeStyleToTokenVal[type];

  if (_typeof(val) === "object") {
    val = val[style];
  }

  if (val) {
    return {
      literal: false,
      val: val
    };
  }

  return undefined;
}

function buildRegex(units) {
  var re = units.map(function (u) {
    return u.regex;
  }).reduce(function (f, r) {
    return "".concat(f, "(").concat(r.source, ")");
  }, "");
  return ["^".concat(re, "$"), units];
}

function match(input, regex, handlers) {
  var matches = input.match(regex);

  if (matches) {
    var all = {};
    var matchIndex = 1;

    for (var i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        var h = handlers[i],
            groups = h.groups ? h.groups + 1 : 1;

        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }

        matchIndex += groups;
      }
    }

    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  var toField = function toField(token) {
    switch (token) {
      case "S":
        return "millisecond";

      case "s":
        return "second";

      case "m":
        return "minute";

      case "h":
      case "H":
        return "hour";

      case "d":
        return "day";

      case "o":
        return "ordinal";

      case "L":
      case "M":
        return "month";

      case "y":
        return "year";

      case "E":
      case "c":
        return "weekday";

      case "W":
        return "weekNumber";

      case "k":
        return "weekYear";

      case "q":
        return "quarter";

      default:
        return null;
    }
  };

  var zone;

  if (!isUndefined(matches.Z)) {
    zone = new FixedOffsetZone(matches.Z);
  } else if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  } else {
    zone = null;
  }

  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }

  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }

  var vals = Object.keys(matches).reduce(function (r, k) {
    var f = toField(k);

    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});
  return [vals, zone];
}

var dummyDateTimeCache = null;

function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }

  return dummyDateTimeCache;
}

function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }

  var formatOpts = Formatter.macroTokenToFormatOpts(token.val);

  if (!formatOpts) {
    return token;
  }

  var formatter = Formatter.create(locale, formatOpts);
  var parts = formatter.formatDateTimeParts(getDummyDateTime());
  var tokens = parts.map(function (p) {
    return tokenForPart(p, locale, formatOpts);
  });

  if (tokens.includes(undefined)) {
    return token;
  }

  return tokens;
}

function expandMacroTokens(tokens, locale) {
  var _Array$prototype;

  return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, _toConsumableArray(tokens.map(function (t) {
    return maybeExpandMacroToken(t, locale);
  })));
}
/**
 * @private
 */


function explainFromTokens(locale, input, format) {
  var tokens = expandMacroTokens(Formatter.parseFormat(format), locale),
      units = tokens.map(function (t) {
    return unitForToken(t, locale);
  }),
      disqualifyingUnit = units.find(function (t) {
    return t.invalidReason;
  });

  if (disqualifyingUnit) {
    return {
      input: input,
      tokens: tokens,
      invalidReason: disqualifyingUnit.invalidReason
    };
  } else {
    var _buildRegex = buildRegex(units),
        _buildRegex2 = _slicedToArray(_buildRegex, 2),
        regexString = _buildRegex2[0],
        handlers = _buildRegex2[1],
        regex = RegExp(regexString, "i"),
        _match = match(input, regex, handlers),
        _match2 = _slicedToArray(_match, 2),
        rawMatches = _match2[0],
        matches = _match2[1],
        _ref11 = matches ? dateTimeFromMatches(matches) : [null, null],
        _ref12 = _slicedToArray(_ref11, 2),
        result = _ref12[0],
        zone = _ref12[1];

    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
    }

    return {
      input: input,
      tokens: tokens,
      regex: regex,
      rawMatches: rawMatches,
      matches: matches,
      result: result,
      zone: zone
    };
  }
}
function parseFromTokens(locale, input, format) {
  var _explainFromTokens = explainFromTokens(locale, input, format),
      result = _explainFromTokens.result,
      zone = _explainFromTokens.zone,
      invalidReason = _explainFromTokens.invalidReason;

  return [result, zone, invalidReason];
}

var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
    leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", "you specified ".concat(value, " (of type ").concat(_typeof(value), ") as a ").concat(unit, ", which is invalid"));
}

function dayOfWeek(year, month, day) {
  var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
      month0 = table.findIndex(function (i) {
    return i < ordinal;
  }),
      day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day: day
  };
}
/**
 * @private
 */


function gregorianToWeek(gregObj) {
  var year = gregObj.year,
      month = gregObj.month,
      day = gregObj.day,
      ordinal = computeOrdinal(year, month, day),
      weekday = dayOfWeek(year, month, day);
  var weekNumber = Math.floor((ordinal - weekday + 10) / 7),
      weekYear;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear);
  } else if (weekNumber > weeksInWeekYear(year)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return Object.assign({
    weekYear: weekYear,
    weekNumber: weekNumber,
    weekday: weekday
  }, timeObject(gregObj));
}
function weekToGregorian(weekData) {
  var weekYear = weekData.weekYear,
      weekNumber = weekData.weekNumber,
      weekday = weekData.weekday,
      weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
      yearInDays = daysInYear(weekYear);
  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
      year;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }

  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal.month,
      day = _uncomputeOrdinal.day;

  return Object.assign({
    year: year,
    month: month,
    day: day
  }, timeObject(weekData));
}
function gregorianToOrdinal(gregData) {
  var year = gregData.year,
      month = gregData.month,
      day = gregData.day,
      ordinal = computeOrdinal(year, month, day);
  return Object.assign({
    year: year,
    ordinal: ordinal
  }, timeObject(gregData));
}
function ordinalToGregorian(ordinalData) {
  var year = ordinalData.year,
      ordinal = ordinalData.ordinal,
      _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal2.month,
      day = _uncomputeOrdinal2.day;

  return Object.assign({
    year: year,
    month: month,
    day: day
  }, timeObject(ordinalData));
}
function hasInvalidWeekData(obj) {
  var validYear = isInteger(obj.weekYear),
      validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
      validWeekday = integerBetween(obj.weekday, 1, 7);

  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.week);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  var validYear = isInteger(obj.year),
      validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  var validYear = isInteger(obj.year),
      validMonth = integerBetween(obj.month, 1, 12),
      validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  var hour = obj.hour,
      minute = obj.minute,
      second = obj.second,
      millisecond = obj.millisecond;
  var validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0,
      validMinute = integerBetween(minute, 0, 59),
      validSecond = integerBetween(second, 0, 59),
      validMillisecond = integerBetween(millisecond, 0, 999);

  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

var INVALID = "Invalid DateTime";
var MAX_DATE = 8.64e15;

function unsupportedZone(zone) {
  return new Invalid("unsupported zone", "the zone \"".concat(zone.name, "\" is not supported"));
} // we cache week data on the DT object and this intermediates the cache


function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }

  return dt.weekData;
} // clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties


function clone(inst, alts) {
  var current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(Object.assign({}, current, alts, {
    old: current
  }));
} // find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)


function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - o * 60 * 1000; // Test whether the zone matches the offset for this ts

  var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done

  if (o === o2) {
    return [utcGuess, o];
  } // If not, change the ts by the difference in the offset


  utcGuess -= (o2 - o) * 60 * 1000; // If that gives us the local time we want, we're done

  var o3 = tz.offset(utcGuess);

  if (o2 === o3) {
    return [utcGuess, o2];
  } // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time


  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
} // convert an epoch timestamp into a calendar object with the given offset


function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;
  var d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
} // convert a calendar object to a epoch timestamp


function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
} // create a new DT instance by adding a duration, adjusting for DSTs


function adjustTime(inst, dur) {
  var oPre = inst.o,
      year = inst.c.year + Math.trunc(dur.years),
      month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
      c = Object.assign({}, inst.c, {
    year: year,
    month: month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }),
      millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"),
      localTS = objToLocalTS(c);

  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
      _fixOffset2 = _slicedToArray(_fixOffset, 2),
      ts = _fixOffset2[0],
      o = _fixOffset2[1];

  if (millisToAdd !== 0) {
    ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same

    o = inst.zone.offset(ts);
  }

  return {
    ts: ts,
    o: o
  };
} // helper useful in turning the results of parsing into real dates
// by handling the zone options


function parseDataToDateTime(parsed, parsedZone, opts, format, text) {
  var setZone = opts.setZone,
      zone = opts.zone;

  if (parsed && Object.keys(parsed).length !== 0) {
    var interpretationZone = parsedZone || zone,
        inst = DateTime.fromObject(Object.assign(parsed, opts, {
      zone: interpretationZone,
      // setZone is a valid option in the calling methods, but not in fromObject
      setZone: undefined
    }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", "the input \"".concat(text, "\" can't be parsed as ").concat(format)));
  }
} // if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details


function toTechFormat(dt, format) {
  var allowZ = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ: allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
} // technical time formats (e.g. the time part of ISO 8601), take some options
// and this commonizes their handling


function toTechTimeFormat(dt, _ref) {
  var _ref$suppressSeconds = _ref.suppressSeconds,
      suppressSeconds = _ref$suppressSeconds === void 0 ? false : _ref$suppressSeconds,
      _ref$suppressMillisec = _ref.suppressMilliseconds,
      suppressMilliseconds = _ref$suppressMillisec === void 0 ? false : _ref$suppressMillisec,
      includeOffset = _ref.includeOffset,
      _ref$includePrefix = _ref.includePrefix,
      includePrefix = _ref$includePrefix === void 0 ? false : _ref$includePrefix,
      _ref$includeZone = _ref.includeZone,
      includeZone = _ref$includeZone === void 0 ? false : _ref$includeZone,
      _ref$spaceZone = _ref.spaceZone,
      spaceZone = _ref$spaceZone === void 0 ? false : _ref$spaceZone,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "extended" : _ref$format;
  var fmt = format === "basic" ? "HHmm" : "HH:mm";

  if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
    fmt += format === "basic" ? "ss" : ":ss";

    if (!suppressMilliseconds || dt.millisecond !== 0) {
      fmt += ".SSS";
    }
  }

  if ((includeZone || includeOffset) && spaceZone) {
    fmt += " ";
  }

  if (includeZone) {
    fmt += "z";
  } else if (includeOffset) {
    fmt += format === "basic" ? "ZZZ" : "ZZ";
  }

  var str = toTechFormat(dt, fmt);

  if (includePrefix) {
    str = "T" + str;
  }

  return str;
} // defaults for unspecified units in the supported calendars


var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}; // Units in the supported calendars, sorted by bigness

var orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
    orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
    orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"]; // standardize case and plurality in units

function normalizeUnit(unit) {
  var normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
} // this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.


function quickDT(obj, zone) {
  // assume we have the higher-order units
  var _iterator = _createForOfIteratorHelper(orderedUnits),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var u = _step.value;

      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);

  if (invalid) {
    return DateTime.invalid(invalid);
  }

  var tsNow = Settings.now(),
      offsetProvis = zone.offset(tsNow),
      _objToTS = objToTS(obj, offsetProvis, zone),
      _objToTS2 = _slicedToArray(_objToTS, 2),
      ts = _objToTS2[0],
      o = _objToTS2[1];

  return new DateTime({
    ts: ts,
    zone: zone,
    o: o
  });
}

function diffRelative(start, end, opts) {
  var round = isUndefined(opts.round) ? true : opts.round,
      format = function format(c, unit) {
    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
    var formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  },
      differ = function differ(unit) {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };

  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }

  var _iterator2 = _createForOfIteratorHelper(opts.units),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var unit = _step2.value;
      var count = differ(unit);

      if (Math.abs(count) >= 1) {
        return format(count, unit);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link local}, {@link utc}, and (most flexibly) {@link fromObject}. To create one from a standard string format, use {@link fromISO}, {@link fromHTTP}, and {@link fromRFC2822}. To create one from a custom string format, use {@link fromFormat}. To create one from a native JS date, use {@link fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link toObject}), use the {@link year}, {@link month},
 * {@link day}, {@link hour}, {@link minute}, {@link second}, {@link millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link weekYear}, {@link weekNumber}, and {@link weekday} accessors.
 * * **Configuration** See the {@link locale} and {@link numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link set}, {@link reconfigure}, {@link setZone}, {@link setLocale}, {@link plus}, {@link minus}, {@link endOf}, {@link startOf}, {@link toUTC}, and {@link toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link toRelative}, {@link toRelativeCalendar}, {@link toJSON}, {@link toISO}, {@link toHTTP}, {@link toObject}, {@link toRFC2822}, {@link toString}, {@link toLocaleString}, {@link toFormat}, {@link toMillis} and {@link toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */


var DateTime = /*#__PURE__*/function () {
  /**
   * @access private
   */
  function DateTime(config) {
    _classCallCheck(this, DateTime);

    var zone = config.zone || Settings.defaultZone;
    var invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */

    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    var c = null,
        o = null;

    if (!invalid) {
      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);

      if (unchanged) {
        var _ref2 = [config.old.c, config.old.o];
        c = _ref2[0];
        o = _ref2[1];
      } else {
        var ot = zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    /**
     * @access private
     */


    this._zone = zone;
    /**
     * @access private
     */

    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */

    this.invalid = invalid;
    /**
     * @access private
     */

    this.weekData = null;
    /**
     * @access private
     */

    this.c = c;
    /**
     * @access private
     */

    this.o = o;
    /**
     * @access private
     */

    this.isLuxonDateTime = true;
  } // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */


  _createClass$1(DateTime, [{
    key: "get",
    value: // INFO

    /**
     * Get the value of unit.
     * @param {string} unit - a unit such as 'minute' or 'day'
     * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
     * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
     * @return {number}
     */
    function get(unit) {
      return this[unit];
    }
    /**
     * Returns whether the DateTime is valid. Invalid DateTimes occur when:
     * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
     * * The DateTime was created by an operation on another invalid date
     * @type {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
     * @type {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
    /**
     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "outputCalendar",
    get: function get() {
      return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
     * Get the time zone associated with this DateTime.
     * @type {Zone}
     */

  }, {
    key: "zone",
    get: function get() {
      return this._zone;
    }
    /**
     * Get the name of the time zone.
     * @type {string}
     */

  }, {
    key: "zoneName",
    get: function get() {
      return this.isValid ? this.zone.name : null;
    }
    /**
     * Get the year
     * @example DateTime.local(2017, 5, 25).year //=> 2017
     * @type {number}
     */

  }, {
    key: "year",
    get: function get() {
      return this.isValid ? this.c.year : NaN;
    }
    /**
     * Get the quarter
     * @example DateTime.local(2017, 5, 25).quarter //=> 2
     * @type {number}
     */

  }, {
    key: "quarter",
    get: function get() {
      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
     * Get the month (1-12).
     * @example DateTime.local(2017, 5, 25).month //=> 5
     * @type {number}
     */

  }, {
    key: "month",
    get: function get() {
      return this.isValid ? this.c.month : NaN;
    }
    /**
     * Get the day of the month (1-30ish).
     * @example DateTime.local(2017, 5, 25).day //=> 25
     * @type {number}
     */

  }, {
    key: "day",
    get: function get() {
      return this.isValid ? this.c.day : NaN;
    }
    /**
     * Get the hour of the day (0-23).
     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
     * @type {number}
     */

  }, {
    key: "hour",
    get: function get() {
      return this.isValid ? this.c.hour : NaN;
    }
    /**
     * Get the minute of the hour (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
     * @type {number}
     */

  }, {
    key: "minute",
    get: function get() {
      return this.isValid ? this.c.minute : NaN;
    }
    /**
     * Get the second of the minute (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
     * @type {number}
     */

  }, {
    key: "second",
    get: function get() {
      return this.isValid ? this.c.second : NaN;
    }
    /**
     * Get the millisecond of the second (0-999).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
     * @type {number}
     */

  }, {
    key: "millisecond",
    get: function get() {
      return this.isValid ? this.c.millisecond : NaN;
    }
    /**
     * Get the week year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
     * @type {number}
     */

  }, {
    key: "weekYear",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
     * Get the week number of the week year (1-52ish).
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
     * @type {number}
     */

  }, {
    key: "weekNumber",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
     * Get the day of the week.
     * 1 is Monday and 7 is Sunday
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 11, 31).weekday //=> 4
     * @type {number}
     */

  }, {
    key: "weekday",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
     * Get the ordinal (meaning the day of the year)
     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
     * @type {number|DateTime}
     */

  }, {
    key: "ordinal",
    get: function get() {
      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
    }
    /**
     * Get the human readable short month name, such as 'Oct'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
     * @type {string}
     */

  }, {
    key: "monthShort",
    get: function get() {
      return this.isValid ? Info.months("short", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable long month name, such as 'October'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthLong //=> October
     * @type {string}
     */

  }, {
    key: "monthLong",
    get: function get() {
      return this.isValid ? Info.months("long", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable short weekday, such as 'Mon'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
     * @type {string}
     */

  }, {
    key: "weekdayShort",
    get: function get() {
      return this.isValid ? Info.weekdays("short", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the human readable long weekday, such as 'Monday'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
     * @type {string}
     */

  }, {
    key: "weekdayLong",
    get: function get() {
      return this.isValid ? Info.weekdays("long", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the UTC offset of this DateTime in minutes
     * @example DateTime.now().offset //=> -240
     * @example DateTime.utc().offset //=> 0
     * @type {number}
     */

  }, {
    key: "offset",
    get: function get() {
      return this.isValid ? +this.o : NaN;
    }
    /**
     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: "offsetNameShort",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "short",
          locale: this.locale
        });
      } else {
        return null;
      }
    }
    /**
     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: "offsetNameLong",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "long",
          locale: this.locale
        });
      } else {
        return null;
      }
    }
    /**
     * Get whether this zone's offset ever changes, as in a DST.
     * @type {boolean}
     */

  }, {
    key: "isOffsetFixed",
    get: function get() {
      return this.isValid ? this.zone.universal : null;
    }
    /**
     * Get whether the DateTime is in a DST.
     * @type {boolean}
     */

  }, {
    key: "isInDST",
    get: function get() {
      if (this.isOffsetFixed) {
        return false;
      } else {
        return this.offset > this.set({
          month: 1
        }).offset || this.offset > this.set({
          month: 5
        }).offset;
      }
    }
    /**
     * Returns true if this DateTime is in a leap year, false otherwise
     * @example DateTime.local(2016).isInLeapYear //=> true
     * @example DateTime.local(2013).isInLeapYear //=> false
     * @type {boolean}
     */

  }, {
    key: "isInLeapYear",
    get: function get() {
      return isLeapYear(this.year);
    }
    /**
     * Returns the number of days in this DateTime's month
     * @example DateTime.local(2016, 2).daysInMonth //=> 29
     * @example DateTime.local(2016, 3).daysInMonth //=> 31
     * @type {number}
     */

  }, {
    key: "daysInMonth",
    get: function get() {
      return daysInMonth(this.year, this.month);
    }
    /**
     * Returns the number of days in this DateTime's year
     * @example DateTime.local(2016).daysInYear //=> 366
     * @example DateTime.local(2013).daysInYear //=> 365
     * @type {number}
     */

  }, {
    key: "daysInYear",
    get: function get() {
      return this.isValid ? daysInYear(this.year) : NaN;
    }
    /**
     * Returns the number of weeks in this DateTime's year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2004).weeksInWeekYear //=> 53
     * @example DateTime.local(2013).weeksInWeekYear //=> 52
     * @type {number}
     */

  }, {
    key: "weeksInWeekYear",
    get: function get() {
      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
    }
    /**
     * Returns the resolved Intl options for this DateTime.
     * This is useful in understanding the behavior of formatting methods
     * @param {Object} opts - the same options as toLocaleString
     * @return {Object}
     */

  }, {
    key: "resolvedLocaleOpts",
    value: function resolvedLocaleOpts() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
          locale = _Formatter$create$res.locale,
          numberingSystem = _Formatter$create$res.numberingSystem,
          calendar = _Formatter$create$res.calendar;

      return {
        locale: locale,
        numberingSystem: numberingSystem,
        outputCalendar: calendar
      };
    } // TRANSFORM

    /**
     * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
     *
     * Equivalent to {@link setZone}('utc')
     * @param {number} [offset=0] - optionally, an offset from UTC in minutes
     * @param {Object} [opts={}] - options to pass to `setZone()`
     * @return {DateTime}
     */

  }, {
    key: "toUTC",
    value: function toUTC() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.setZone(FixedOffsetZone.instance(offset), opts);
    }
    /**
     * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
     *
     * Equivalent to `setZone('local')`
     * @return {DateTime}
     */

  }, {
    key: "toLocal",
    value: function toLocal() {
      return this.setZone(Settings.defaultZone);
    }
    /**
     * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
     *
     * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link plus}. You may wish to use {@link toLocal} and {@link toUTC} which provide simple convenience wrappers for commonly used zones.
     * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link Zone} class.
     * @param {Object} opts - options
     * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
     * @return {DateTime}
     */

  }, {
    key: "setZone",
    value: function setZone(zone) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$keepLocalTime = _ref3.keepLocalTime,
          keepLocalTime = _ref3$keepLocalTime === void 0 ? false : _ref3$keepLocalTime,
          _ref3$keepCalendarTim = _ref3.keepCalendarTime,
          keepCalendarTime = _ref3$keepCalendarTim === void 0 ? false : _ref3$keepCalendarTim;

      zone = normalizeZone(zone, Settings.defaultZone);

      if (zone.equals(this.zone)) {
        return this;
      } else if (!zone.isValid) {
        return DateTime.invalid(unsupportedZone(zone));
      } else {
        var newTS = this.ts;

        if (keepLocalTime || keepCalendarTime) {
          var offsetGuess = zone.offset(this.ts);
          var asObj = this.toObject();

          var _objToTS3 = objToTS(asObj, offsetGuess, zone);

          var _objToTS4 = _slicedToArray(_objToTS3, 1);

          newTS = _objToTS4[0];
        }

        return clone(this, {
          ts: newTS,
          zone: zone
        });
      }
    }
    /**
     * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
     * @param {Object} properties - the properties to set
     * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
     * @return {DateTime}
     */

  }, {
    key: "reconfigure",
    value: function reconfigure() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          locale = _ref4.locale,
          numberingSystem = _ref4.numberingSystem,
          outputCalendar = _ref4.outputCalendar;

      var loc = this.loc.clone({
        locale: locale,
        numberingSystem: numberingSystem,
        outputCalendar: outputCalendar
      });
      return clone(this, {
        loc: loc
      });
    }
    /**
     * "Set" the locale. Returns a newly-constructed DateTime.
     * Just a convenient alias for reconfigure({ locale })
     * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
     * @return {DateTime}
     */

  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      return this.reconfigure({
        locale: locale
      });
    }
    /**
     * "Set" the values of specified units. Returns a newly-constructed DateTime.
     * You can only set units with this method; for "setting" metadata, see {@link reconfigure} and {@link setZone}.
     * @param {Object} values - a mapping of units to numbers
     * @example dt.set({ year: 2017 })
     * @example dt.set({ hour: 8, minute: 30 })
     * @example dt.set({ weekday: 5 })
     * @example dt.set({ year: 2005, ordinal: 234 })
     * @return {DateTime}
     */

  }, {
    key: "set",
    value: function set(values) {
      if (!this.isValid) return this;
      var normalized = normalizeObject(values, normalizeUnit, []),
          settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday),
          containsOrdinal = !isUndefined(normalized.ordinal),
          containsGregorYear = !isUndefined(normalized.year),
          containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
          containsGregor = containsGregorYear || containsGregorMD,
          definiteWeekDef = normalized.weekYear || normalized.weekNumber;

      if ((containsGregor || containsOrdinal) && definiteWeekDef) {
        throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
      }

      if (containsGregorMD && containsOrdinal) {
        throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
      }

      var mixed;

      if (settingWeekStuff) {
        mixed = weekToGregorian(Object.assign(gregorianToWeek(this.c), normalized));
      } else if (!isUndefined(normalized.ordinal)) {
        mixed = ordinalToGregorian(Object.assign(gregorianToOrdinal(this.c), normalized));
      } else {
        mixed = Object.assign(this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
        // use the last day of the right month

        if (isUndefined(normalized.day)) {
          mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
        }
      }

      var _objToTS5 = objToTS(mixed, this.o, this.zone),
          _objToTS6 = _slicedToArray(_objToTS5, 2),
          ts = _objToTS6[0],
          o = _objToTS6[1];

      return clone(this, {
        ts: ts,
        o: o
      });
    }
    /**
     * Add a period of time to this DateTime and return the resulting DateTime
     *
     * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
     * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
     * @example DateTime.now().plus(123) //~> in 123 milliseconds
     * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
     * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
     * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
     * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
     * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
     * @return {DateTime}
     */

  }, {
    key: "plus",
    value: function plus(duration) {
      if (!this.isValid) return this;
      var dur = friendlyDuration(duration);
      return clone(this, adjustTime(this, dur));
    }
    /**
     * Subtract a period of time to this DateTime and return the resulting DateTime
     * See {@link plus}
     * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
     @return {DateTime}
    */

  }, {
    key: "minus",
    value: function minus(duration) {
      if (!this.isValid) return this;
      var dur = friendlyDuration(duration).negate();
      return clone(this, adjustTime(this, dur));
    }
    /**
     * "Set" this DateTime to the beginning of a unit of time.
     * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
     * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
     * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
     * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
     * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
     * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
     * @return {DateTime}
     */

  }, {
    key: "startOf",
    value: function startOf(unit) {
      if (!this.isValid) return this;
      var o = {},
          normalizedUnit = Duration.normalizeUnit(unit);

      switch (normalizedUnit) {
        case "years":
          o.month = 1;
        // falls through

        case "quarters":
        case "months":
          o.day = 1;
        // falls through

        case "weeks":
        case "days":
          o.hour = 0;
        // falls through

        case "hours":
          o.minute = 0;
        // falls through

        case "minutes":
          o.second = 0;
        // falls through

        case "seconds":
          o.millisecond = 0;
          break;
        // no default, invalid units throw in normalizeUnit()
      }

      if (normalizedUnit === "weeks") {
        o.weekday = 1;
      }

      if (normalizedUnit === "quarters") {
        var q = Math.ceil(this.month / 3);
        o.month = (q - 1) * 3 + 1;
      }

      return this.set(o);
    }
    /**
     * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
     * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
     * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
     * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
     * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
     * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
     * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
     * @return {DateTime}
     */

  }, {
    key: "endOf",
    value: function endOf(unit) {
      return this.isValid ? this.plus(_defineProperty({}, unit, 1)).startOf(unit).minus(1) : this;
    } // OUTPUT

    /**
     * Returns a string representation of this DateTime formatted according to the specified format string.
     * **You may not want this.** See {@link toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens).
     * Defaults to en-US if no locale has been specified, regardless of the system's locale.
     * @see https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
     * @param {string} fmt - the format string
     * @param {Object} opts - opts to override the configuration options
     * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
     * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
     * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
     * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
     * @return {string}
     */

  }, {
    key: "toFormat",
    value: function toFormat(fmt) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
    }
    /**
     * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
     * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
     * of the DateTime in the assigned locale.
     * Defaults to the system's locale if no locale has been specified
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
     * @param opts {Object} - Intl.DateTimeFormat constructor options and configuration options
     * @example DateTime.now().toLocaleString(); //=> 4/20/2017
     * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
     * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
     * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
     * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
     * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
     * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
     * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
     * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hour12: false }); //=> '11:32'
     * @return {string}
     */

  }, {
    key: "toLocaleString",
    value: function toLocaleString() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DATE_SHORT;
      return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTime(this) : INVALID;
    }
    /**
     * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
     * Defaults to the system's locale if no locale has been specified
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
     * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
     * @example DateTime.now().toLocaleParts(); //=> [
     *                                   //=>   { type: 'day', value: '25' },
     *                                   //=>   { type: 'literal', value: '/' },
     *                                   //=>   { type: 'month', value: '05' },
     *                                   //=>   { type: 'literal', value: '/' },
     *                                   //=>   { type: 'year', value: '1982' }
     *                                   //=> ]
     */

  }, {
    key: "toLocaleParts",
    value: function toLocaleParts() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    }
    /**
     * Returns an ISO 8601-compliant string representation of this DateTime
     * @param {Object} opts - options
     * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
     * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
     * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
     * @param {string} [opts.format='extended'] - choose between the basic and extended format
     * @example DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
     * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
     * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
     * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
     * @return {string}
     */

  }, {
    key: "toISO",
    value: function toISO() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.isValid) {
        return null;
      }

      return "".concat(this.toISODate(opts), "T").concat(this.toISOTime(opts));
    }
    /**
     * Returns an ISO 8601-compliant string representation of this DateTime's date component
     * @param {Object} opts - options
     * @param {string} [opts.format='extended'] - choose between the basic and extended format
     * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
     * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
     * @return {string}
     */

  }, {
    key: "toISODate",
    value: function toISODate() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$format = _ref5.format,
          format = _ref5$format === void 0 ? "extended" : _ref5$format;

      var fmt = format === "basic" ? "yyyyMMdd" : "yyyy-MM-dd";

      if (this.year > 9999) {
        fmt = "+" + fmt;
      }

      return toTechFormat(this, fmt);
    }
    /**
     * Returns an ISO 8601-compliant string representation of this DateTime's week date
     * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
     * @return {string}
     */

  }, {
    key: "toISOWeekDate",
    value: function toISOWeekDate() {
      return toTechFormat(this, "kkkk-'W'WW-c");
    }
    /**
     * Returns an ISO 8601-compliant string representation of this DateTime's time component
     * @param {Object} opts - options
     * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
     * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
     * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
     * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
     * @param {string} [opts.format='extended'] - choose between the basic and extended format
     * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
     * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
     * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
     * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
     * @return {string}
     */

  }, {
    key: "toISOTime",
    value: function toISOTime() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$suppressMillise = _ref6.suppressMilliseconds,
          suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise,
          _ref6$suppressSeconds = _ref6.suppressSeconds,
          suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds,
          _ref6$includeOffset = _ref6.includeOffset,
          includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset,
          _ref6$includePrefix = _ref6.includePrefix,
          includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix,
          _ref6$format = _ref6.format,
          format = _ref6$format === void 0 ? "extended" : _ref6$format;

      return toTechTimeFormat(this, {
        suppressSeconds: suppressSeconds,
        suppressMilliseconds: suppressMilliseconds,
        includeOffset: includeOffset,
        includePrefix: includePrefix,
        format: format
      });
    }
    /**
     * Returns an RFC 2822-compatible string representation of this DateTime, always in UTC
     * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
     * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
     * @return {string}
     */

  }, {
    key: "toRFC2822",
    value: function toRFC2822() {
      return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    }
    /**
     * Returns a string representation of this DateTime appropriate for use in HTTP headers.
     * Specifically, the string conforms to RFC 1123.
     * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
     * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
     * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
     * @return {string}
     */

  }, {
    key: "toHTTP",
    value: function toHTTP() {
      return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    }
    /**
     * Returns a string representation of this DateTime appropriate for use in SQL Date
     * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
     * @return {string}
     */

  }, {
    key: "toSQLDate",
    value: function toSQLDate() {
      return toTechFormat(this, "yyyy-MM-dd");
    }
    /**
     * Returns a string representation of this DateTime appropriate for use in SQL Time
     * @param {Object} opts - options
     * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
     * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
     * @example DateTime.utc().toSQL() //=> '05:15:16.345'
     * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
     * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
     * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
     * @return {string}
     */

  }, {
    key: "toSQLTime",
    value: function toSQLTime() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$includeOffset = _ref7.includeOffset,
          includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset,
          _ref7$includeZone = _ref7.includeZone,
          includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone;

      return toTechTimeFormat(this, {
        includeOffset: includeOffset,
        includeZone: includeZone,
        spaceZone: true
      });
    }
    /**
     * Returns a string representation of this DateTime appropriate for use in SQL DateTime
     * @param {Object} opts - options
     * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
     * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
     * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
     * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
     * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
     * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
     * @return {string}
     */

  }, {
    key: "toSQL",
    value: function toSQL() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.isValid) {
        return null;
      }

      return "".concat(this.toSQLDate(), " ").concat(this.toSQLTime(opts));
    }
    /**
     * Returns a string representation of this DateTime appropriate for debugging
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.isValid ? this.toISO() : INVALID;
    }
    /**
     * Returns the epoch milliseconds of this DateTime. Alias of {@link toMillis}
     * @return {number}
     */

  }, {
    key: "valueOf",
    value: function valueOf() {
      return this.toMillis();
    }
    /**
     * Returns the epoch milliseconds of this DateTime.
     * @return {number}
     */

  }, {
    key: "toMillis",
    value: function toMillis() {
      return this.isValid ? this.ts : NaN;
    }
    /**
     * Returns the epoch seconds of this DateTime.
     * @return {number}
     */

  }, {
    key: "toSeconds",
    value: function toSeconds() {
      return this.isValid ? this.ts / 1000 : NaN;
    }
    /**
     * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
     * @return {string}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toISO();
    }
    /**
     * Returns a BSON serializable equivalent to this DateTime.
     * @return {Date}
     */

  }, {
    key: "toBSON",
    value: function toBSON() {
      return this.toJSDate();
    }
    /**
     * Returns a JavaScript object with this DateTime's year, month, day, and so on.
     * @param opts - options for generating the object
     * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
     * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
     * @return {Object}
     */

  }, {
    key: "toObject",
    value: function toObject() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isValid) return {};
      var base = Object.assign({}, this.c);

      if (opts.includeConfig) {
        base.outputCalendar = this.outputCalendar;
        base.numberingSystem = this.loc.numberingSystem;
        base.locale = this.loc.locale;
      }

      return base;
    }
    /**
     * Returns a JavaScript Date equivalent to this DateTime.
     * @return {Date}
     */

  }, {
    key: "toJSDate",
    value: function toJSDate() {
      return new Date(this.isValid ? this.ts : NaN);
    } // COMPARE

    /**
     * Return the difference between two DateTimes as a Duration.
     * @param {DateTime} otherDateTime - the DateTime to compare this one to
     * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
     * @param {Object} opts - options that affect the creation of the Duration
     * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
     * @example
     * var i1 = DateTime.fromISO('1982-05-25T09:45'),
     *     i2 = DateTime.fromISO('1983-10-14T10:30');
     * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
     * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
     * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
     * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
     * @return {Duration}
     */

  }, {
    key: "diff",
    value: function diff(otherDateTime) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "milliseconds";
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!this.isValid || !otherDateTime.isValid) {
        return Duration.invalid(this.invalid || otherDateTime.invalid, "created by diffing an invalid DateTime");
      }

      var durOpts = Object.assign({
        locale: this.locale,
        numberingSystem: this.numberingSystem
      }, opts);

      var units = maybeArray(unit).map(Duration.normalizeUnit),
          otherIsLater = otherDateTime.valueOf() > this.valueOf(),
          earlier = otherIsLater ? this : otherDateTime,
          later = otherIsLater ? otherDateTime : this,
          diffed = _diff(earlier, later, units, durOpts);

      return otherIsLater ? diffed.negate() : diffed;
    }
    /**
     * Return the difference between this DateTime and right now.
     * See {@link diff}
     * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
     * @param {Object} opts - options that affect the creation of the Duration
     * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
     * @return {Duration}
     */

  }, {
    key: "diffNow",
    value: function diffNow() {
      var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "milliseconds";
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.diff(DateTime.now(), unit, opts);
    }
    /**
     * Return an Interval spanning between this DateTime and another DateTime
     * @param {DateTime} otherDateTime - the other end point of the Interval
     * @return {Interval}
     */

  }, {
    key: "until",
    value: function until(otherDateTime) {
      return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
    }
    /**
     * Return whether this DateTime is in the same unit of time as another DateTime.
     * Higher-order units must also be identical for this function to return `true`.
     * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link setZone} to convert one of the dates if needed.
     * @param {DateTime} otherDateTime - the other DateTime
     * @param {string} unit - the unit of time to check sameness on
     * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
     * @return {boolean}
     */

  }, {
    key: "hasSame",
    value: function hasSame(otherDateTime, unit) {
      if (!this.isValid) return false;
      var inputMs = otherDateTime.valueOf();
      var otherZoneDateTime = this.setZone(otherDateTime.zone, {
        keepLocalTime: true
      });
      return otherZoneDateTime.startOf(unit) <= inputMs && inputMs <= otherZoneDateTime.endOf(unit);
    }
    /**
     * Equality check
     * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
     * To compare just the millisecond values, use `+dt1 === +dt2`.
     * @param {DateTime} other - the other DateTime
     * @return {boolean}
     */

  }, {
    key: "equals",
    value: function equals(other) {
      return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    }
    /**
     * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
     * platform supports Intl.RelativeTimeFormat. Rounds down by default.
     * @param {Object} options - options that affect the output
     * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
     * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
     * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
     * @param {boolean} [options.round=true] - whether to round the numbers in the output.
     * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
     * @param {string} options.locale - override the locale of this DateTime
     * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
     * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
     * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
     * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
     * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
     * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
     * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
     */

  }, {
    key: "toRelative",
    value: function toRelative() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isValid) return null;
      var base = options.base || DateTime.fromObject({
        zone: this.zone
      }),
          padding = options.padding ? this < base ? -options.padding : options.padding : 0;
      var units = ["years", "months", "days", "hours", "minutes", "seconds"];
      var unit = options.unit;

      if (Array.isArray(options.unit)) {
        units = options.unit;
        unit = undefined;
      }

      return diffRelative(base, this.plus(padding), Object.assign(options, {
        numeric: "always",
        units: units,
        unit: unit
      }));
    }
    /**
     * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
     * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
     * @param {Object} options - options that affect the output
     * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
     * @param {string} options.locale - override the locale of this DateTime
     * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
     * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
     * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
     * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
     * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
     * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
     */

  }, {
    key: "toRelativeCalendar",
    value: function toRelativeCalendar() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isValid) return null;
      return diffRelative(options.base || DateTime.fromObject({
        zone: this.zone
      }), this, Object.assign(options, {
        numeric: "auto",
        units: ["years", "months", "days"],
        calendary: true
      }));
    }
    /**
     * Return the min of several date times
     * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
     * @return {DateTime} the min DateTime, or undefined if called with no argument
     */

  }], [{
    key: "now",
    value: function now() {
      return new DateTime({});
    }
    /**
     * Create a local DateTime
     * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
     * @param {number} [month=1] - The month, 1-indexed
     * @param {number} [day=1] - The day of the month, 1-indexed
     * @param {number} [hour=0] - The hour of the day, in 24-hour time
     * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
     * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
     * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
     * @example DateTime.local()                            //~> now
     * @example DateTime.local(2017)                        //~> 2017-01-01T00:00:00
     * @example DateTime.local(2017, 3)                     //~> 2017-03-01T00:00:00
     * @example DateTime.local(2017, 3, 12)                 //~> 2017-03-12T00:00:00
     * @example DateTime.local(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00
     * @example DateTime.local(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00
     * @example DateTime.local(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10
     * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765
     * @return {DateTime}
     */

  }, {
    key: "local",
    value: function local(year, month, day, hour, minute, second, millisecond) {
      if (isUndefined(year)) {
        return DateTime.now();
      } else {
        return quickDT({
          year: year,
          month: month,
          day: day,
          hour: hour,
          minute: minute,
          second: second,
          millisecond: millisecond
        }, Settings.defaultZone);
      }
    }
    /**
     * Create a DateTime in UTC
     * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
     * @param {number} [month=1] - The month, 1-indexed
     * @param {number} [day=1] - The day of the month
     * @param {number} [hour=0] - The hour of the day, in 24-hour time
     * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
     * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
     * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
     * @example DateTime.utc()                            //~> now
     * @example DateTime.utc(2017)                        //~> 2017-01-01T00:00:00Z
     * @example DateTime.utc(2017, 3)                     //~> 2017-03-01T00:00:00Z
     * @example DateTime.utc(2017, 3, 12)                 //~> 2017-03-12T00:00:00Z
     * @example DateTime.utc(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00Z
     * @example DateTime.utc(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00Z
     * @example DateTime.utc(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10Z
     * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765Z
     * @return {DateTime}
     */

  }, {
    key: "utc",
    value: function utc(year, month, day, hour, minute, second, millisecond) {
      if (isUndefined(year)) {
        return new DateTime({
          ts: Settings.now(),
          zone: FixedOffsetZone.utcInstance
        });
      } else {
        return quickDT({
          year: year,
          month: month,
          day: day,
          hour: hour,
          minute: minute,
          second: second,
          millisecond: millisecond
        }, FixedOffsetZone.utcInstance);
      }
    }
    /**
     * Create a DateTime from a JavaScript Date object. Uses the default zone.
     * @param {Date} date - a JavaScript Date object
     * @param {Object} options - configuration options for the DateTime
     * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
     * @return {DateTime}
     */

  }, {
    key: "fromJSDate",
    value: function fromJSDate(date) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ts = isDate(date) ? date.valueOf() : NaN;

      if (Number.isNaN(ts)) {
        return DateTime.invalid("invalid input");
      }

      var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);

      if (!zoneToUse.isValid) {
        return DateTime.invalid(unsupportedZone(zoneToUse));
      }

      return new DateTime({
        ts: ts,
        zone: zoneToUse,
        loc: Locale.fromObject(options)
      });
    }
    /**
     * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
     * @param {number} milliseconds - a number of milliseconds since 1970 UTC
     * @param {Object} options - configuration options for the DateTime
     * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
     * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
     * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
     * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
     * @return {DateTime}
     */

  }, {
    key: "fromMillis",
    value: function fromMillis(milliseconds) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!isNumber(milliseconds)) {
        throw new InvalidArgumentError("fromMillis requires a numerical input, but received a ".concat(_typeof(milliseconds), " with value ").concat(milliseconds));
      } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
        // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
      } else {
        return new DateTime({
          ts: milliseconds,
          zone: normalizeZone(options.zone, Settings.defaultZone),
          loc: Locale.fromObject(options)
        });
      }
    }
    /**
     * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
     * @param {number} seconds - a number of seconds since 1970 UTC
     * @param {Object} options - configuration options for the DateTime
     * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
     * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
     * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
     * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
     * @return {DateTime}
     */

  }, {
    key: "fromSeconds",
    value: function fromSeconds(seconds) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!isNumber(seconds)) {
        throw new InvalidArgumentError("fromSeconds requires a numerical input");
      } else {
        return new DateTime({
          ts: seconds * 1000,
          zone: normalizeZone(options.zone, Settings.defaultZone),
          loc: Locale.fromObject(options)
        });
      }
    }
    /**
     * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
     * @param {Object} obj - the object to create the DateTime from
     * @param {number} obj.year - a year, such as 1987
     * @param {number} obj.month - a month, 1-12
     * @param {number} obj.day - a day of the month, 1-31, depending on the month
     * @param {number} obj.ordinal - day of the year, 1-365 or 366
     * @param {number} obj.weekYear - an ISO week year
     * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
     * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
     * @param {number} obj.hour - hour of the day, 0-23
     * @param {number} obj.minute - minute of the hour, 0-59
     * @param {number} obj.second - second of the minute, 0-59
     * @param {number} obj.millisecond - millisecond of the second, 0-999
     * @param {string|Zone} [obj.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
     * @param {string} [obj.locale='system's locale'] - a locale to set on the resulting DateTime instance
     * @param {string} obj.outputCalendar - the output calendar to set on the resulting DateTime instance
     * @param {string} obj.numberingSystem - the numbering system to set on the resulting DateTime instance
     * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
     * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
     * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
     * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'utc' }),
     * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'local' })
     * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'America/New_York' })
     * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
     * @return {DateTime}
     */

  }, {
    key: "fromObject",
    value: function fromObject(obj) {
      var zoneToUse = normalizeZone(obj.zone, Settings.defaultZone);

      if (!zoneToUse.isValid) {
        return DateTime.invalid(unsupportedZone(zoneToUse));
      }

      var tsNow = Settings.now(),
          offsetProvis = zoneToUse.offset(tsNow),
          normalized = normalizeObject(obj, normalizeUnit, ["zone", "locale", "outputCalendar", "numberingSystem"]),
          containsOrdinal = !isUndefined(normalized.ordinal),
          containsGregorYear = !isUndefined(normalized.year),
          containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
          containsGregor = containsGregorYear || containsGregorMD,
          definiteWeekDef = normalized.weekYear || normalized.weekNumber,
          loc = Locale.fromObject(obj); // cases:
      // just a weekday -> this week's instance of that weekday, no worries
      // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
      // (gregorian month or day) + ordinal -> error
      // otherwise just use weeks or ordinals or gregorian, depending on what's specified

      if ((containsGregor || containsOrdinal) && definiteWeekDef) {
        throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
      }

      if (containsGregorMD && containsOrdinal) {
        throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
      }

      var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff

      var units,
          defaultValues,
          objNow = tsToObj(tsNow, offsetProvis);

      if (useWeekData) {
        units = orderedWeekUnits;
        defaultValues = defaultWeekUnitValues;
        objNow = gregorianToWeek(objNow);
      } else if (containsOrdinal) {
        units = orderedOrdinalUnits;
        defaultValues = defaultOrdinalUnitValues;
        objNow = gregorianToOrdinal(objNow);
      } else {
        units = orderedUnits;
        defaultValues = defaultUnitValues;
      } // set default values for missing stuff


      var foundFirst = false;

      var _iterator3 = _createForOfIteratorHelper(units),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var u = _step3.value;
          var v = normalized[u];

          if (!isUndefined(v)) {
            foundFirst = true;
          } else if (foundFirst) {
            normalized[u] = defaultValues[u];
          } else {
            normalized[u] = objNow[u];
          }
        } // make sure the values we have are in range

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
          invalid = higherOrderInvalid || hasInvalidTimeData(normalized);

      if (invalid) {
        return DateTime.invalid(invalid);
      } // compute the actual time


      var gregorian = useWeekData ? weekToGregorian(normalized) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
          _objToTS7 = objToTS(gregorian, offsetProvis, zoneToUse),
          _objToTS8 = _slicedToArray(_objToTS7, 2),
          tsFinal = _objToTS8[0],
          offsetFinal = _objToTS8[1],
          inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc: loc
      }); // gregorian data + weekday serves only to validate


      if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
        return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of ".concat(normalized.weekday, " and a date of ").concat(inst.toISO()));
      }

      return inst;
    }
    /**
     * Create a DateTime from an ISO 8601 string
     * @param {string} text - the ISO string
     * @param {Object} opts - options to affect the creation
     * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
     * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
     * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
     * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
     * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
     * @example DateTime.fromISO('2016-05-25T09:08:34.123')
     * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
     * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
     * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
     * @example DateTime.fromISO('2016-W05-4')
     * @return {DateTime}
     */

  }, {
    key: "fromISO",
    value: function fromISO(text) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _parseISODate = parseISODate(text),
          _parseISODate2 = _slicedToArray(_parseISODate, 2),
          vals = _parseISODate2[0],
          parsedZone = _parseISODate2[1];

      return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    }
    /**
     * Create a DateTime from an RFC 2822 string
     * @param {string} text - the RFC 2822 string
     * @param {Object} opts - options to affect the creation
     * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
     * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
     * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
     * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
     * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
     * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
     * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
     * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
     * @return {DateTime}
     */

  }, {
    key: "fromRFC2822",
    value: function fromRFC2822(text) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _parseRFC2822Date = parseRFC2822Date(text),
          _parseRFC2822Date2 = _slicedToArray(_parseRFC2822Date, 2),
          vals = _parseRFC2822Date2[0],
          parsedZone = _parseRFC2822Date2[1];

      return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    }
    /**
     * Create a DateTime from an HTTP header date
     * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
     * @param {string} text - the HTTP header date
     * @param {Object} opts - options to affect the creation
     * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
     * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
     * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
     * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
     * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
     * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
     * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
     * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
     * @return {DateTime}
     */

  }, {
    key: "fromHTTP",
    value: function fromHTTP(text) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _parseHTTPDate = parseHTTPDate(text),
          _parseHTTPDate2 = _slicedToArray(_parseHTTPDate, 2),
          vals = _parseHTTPDate2[0],
          parsedZone = _parseHTTPDate2[1];

      return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    }
    /**
     * Create a DateTime from an input string and format string.
     * Defaults to en-US if no locale has been specified, regardless of the system's locale.
     * @see https://moment.github.io/luxon/docs/manual/parsing.html#table-of-tokens
     * @param {string} text - the string to parse
     * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
     * @param {Object} opts - options to affect the creation
     * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
     * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
     * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
     * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
     * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
     * @return {DateTime}
     */

  }, {
    key: "fromFormat",
    value: function fromFormat(text, fmt) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (isUndefined(text) || isUndefined(fmt)) {
        throw new InvalidArgumentError("fromFormat requires an input string and a format");
      }

      var _opts$locale = opts.locale,
          locale = _opts$locale === void 0 ? null : _opts$locale,
          _opts$numberingSystem = opts.numberingSystem,
          numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem,
          localeToUse = Locale.fromOpts({
        locale: locale,
        numberingSystem: numberingSystem,
        defaultToEN: true
      }),
          _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
          _parseFromTokens2 = _slicedToArray(_parseFromTokens, 3),
          vals = _parseFromTokens2[0],
          parsedZone = _parseFromTokens2[1],
          invalid = _parseFromTokens2[2];

      if (invalid) {
        return DateTime.invalid(invalid);
      } else {
        return parseDataToDateTime(vals, parsedZone, opts, "format ".concat(fmt), text);
      }
    }
    /**
     * @deprecated use fromFormat instead
     */

  }, {
    key: "fromString",
    value: function fromString(text, fmt) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return DateTime.fromFormat(text, fmt, opts);
    }
    /**
     * Create a DateTime from a SQL date, time, or datetime
     * Defaults to en-US if no locale has been specified, regardless of the system's locale
     * @param {string} text - the string to parse
     * @param {Object} opts - options to affect the creation
     * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
     * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
     * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
     * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
     * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
     * @example DateTime.fromSQL('2017-05-15')
     * @example DateTime.fromSQL('2017-05-15 09:12:34')
     * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
     * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
     * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
     * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
     * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
     * @example DateTime.fromSQL('09:12:34.342')
     * @return {DateTime}
     */

  }, {
    key: "fromSQL",
    value: function fromSQL(text) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _parseSQL = parseSQL(text),
          _parseSQL2 = _slicedToArray(_parseSQL, 2),
          vals = _parseSQL2[0],
          parsedZone = _parseSQL2[1];

      return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    }
    /**
     * Create an invalid DateTime.
     * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
     * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
     * @return {DateTime}
     */

  }, {
    key: "invalid",
    value: function invalid(reason) {
      var explanation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!reason) {
        throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
      }

      var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

      if (Settings.throwOnInvalid) {
        throw new InvalidDateTimeError(invalid);
      } else {
        return new DateTime({
          invalid: invalid
        });
      }
    }
    /**
     * Check if an object is a DateTime. Works across context boundaries
     * @param {object} o
     * @return {boolean}
     */

  }, {
    key: "isDateTime",
    value: function isDateTime(o) {
      return o && o.isLuxonDateTime || false;
    }
  }, {
    key: "min",
    value: function min() {
      for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
        dateTimes[_key] = arguments[_key];
      }

      if (!dateTimes.every(DateTime.isDateTime)) {
        throw new InvalidArgumentError("min requires all arguments be DateTimes");
      }

      return bestBy(dateTimes, function (i) {
        return i.valueOf();
      }, Math.min);
    }
    /**
     * Return the max of several date times
     * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
     * @return {DateTime} the max DateTime, or undefined if called with no argument
     */

  }, {
    key: "max",
    value: function max() {
      for (var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        dateTimes[_key2] = arguments[_key2];
      }

      if (!dateTimes.every(DateTime.isDateTime)) {
        throw new InvalidArgumentError("max requires all arguments be DateTimes");
      }

      return bestBy(dateTimes, function (i) {
        return i.valueOf();
      }, Math.max);
    } // MISC

    /**
     * Explain how a string would be parsed by fromFormat()
     * @param {string} text - the string to parse
     * @param {string} fmt - the format the string is expected to be in (see description)
     * @param {Object} options - options taken by fromFormat()
     * @return {Object}
     */

  }, {
    key: "fromFormatExplain",
    value: function fromFormatExplain(text, fmt) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$locale = options.locale,
          locale = _options$locale === void 0 ? null : _options$locale,
          _options$numberingSys = options.numberingSystem,
          numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys,
          localeToUse = Locale.fromOpts({
        locale: locale,
        numberingSystem: numberingSystem,
        defaultToEN: true
      });
      return explainFromTokens(localeToUse, text, fmt);
    }
    /**
     * @deprecated use fromFormatExplain instead
     */

  }, {
    key: "fromStringExplain",
    value: function fromStringExplain(text, fmt) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return DateTime.fromFormatExplain(text, fmt, options);
    } // FORMAT PRESETS

    /**
     * {@link toLocaleString} format like 10/14/1983
     * @type {Object}
     */

  }, {
    key: "DATE_SHORT",
    get: function get() {
      return DATE_SHORT;
    }
    /**
     * {@link toLocaleString} format like 'Oct 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_MED",
    get: function get() {
      return DATE_MED;
    }
    /**
     * {@link toLocaleString} format like 'Fri, Oct 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_MED_WITH_WEEKDAY",
    get: function get() {
      return DATE_MED_WITH_WEEKDAY;
    }
    /**
     * {@link toLocaleString} format like 'October 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_FULL",
    get: function get() {
      return DATE_FULL;
    }
    /**
     * {@link toLocaleString} format like 'Tuesday, October 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_HUGE",
    get: function get() {
      return DATE_HUGE;
    }
    /**
     * {@link toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_SIMPLE",
    get: function get() {
      return TIME_SIMPLE;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_SECONDS",
    get: function get() {
      return TIME_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_WITH_SHORT_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_WITH_LONG_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '09:30', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_SIMPLE",
    get: function get() {
      return TIME_24_SIMPLE;
    }
    /**
     * {@link toLocaleString} format like '09:30:23', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_SECONDS",
    get: function get() {
      return TIME_24_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 EDT', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_24_WITH_SHORT_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_24_WITH_LONG_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_SHORT",
    get: function get() {
      return DATETIME_SHORT;
    }
    /**
     * {@link toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_SHORT_WITH_SECONDS",
    get: function get() {
      return DATETIME_SHORT_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED",
    get: function get() {
      return DATETIME_MED;
    }
    /**
     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED_WITH_SECONDS",
    get: function get() {
      return DATETIME_MED_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED_WITH_WEEKDAY",
    get: function get() {
      return DATETIME_MED_WITH_WEEKDAY;
    }
    /**
     * {@link toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_FULL",
    get: function get() {
      return DATETIME_FULL;
    }
    /**
     * {@link toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_FULL_WITH_SECONDS",
    get: function get() {
      return DATETIME_FULL_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_HUGE",
    get: function get() {
      return DATETIME_HUGE;
    }
    /**
     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_HUGE_WITH_SECONDS",
    get: function get() {
      return DATETIME_HUGE_WITH_SECONDS;
    }
  }]);

  return DateTime;
}();
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && _typeof(dateTimeish) === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError("Unknown datetime argument: ".concat(dateTimeish, ", of type ").concat(_typeof(dateTimeish)));
  }
}

var NewsHero = styled.div.withConfig({
  displayName: "Post__NewsHero",
  componentId: "r4fi7x-0"
})(["background-color:", ";@media (min-width:768px){display:flex;}"], function (props) {
  return getLightColor(props.color);
});
var NewsHeroCopy = styled.div.withConfig({
  displayName: "Post__NewsHeroCopy",
  componentId: "r4fi7x-1"
})(["padding:40px 20px 14px;@media (min-width:768px){padding:40px 6.9% 4px;width:50%;flex:0 0 auto;}@media (min-width:960px){padding:86px 6.9% 4px;}h1{font-family:cambria,serif;font-weight:400;font-size:46px;color:#1d2042;margin-bottom:24px;@media (min-width:960px){font-size:54px;margin-bottom:69px;}@media (min-width:1200px){font-size:72px;}}div{display:flex;flex-wrap:wrap;}h6{font-family:proxima-nova-condensed,sans-serif;font-size:16px;font-weight:500;color:#62668d;margin-right:30px;&:last-child{margin-right:0;}}"]);
var NewsHeroImage = styled.div.withConfig({
  displayName: "Post__NewsHeroImage",
  componentId: "r4fi7x-2"
})(["position:relative;@media (min-width:768px){width:50%;flex:0 0 auto;}img{display:block;width:100%;height:100%;object-fit:cover;}"]);

var Post = function Post(_ref) {
  var site = _ref.site,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color;
  var context = useContext(SiteContext);
  var historyParams = useParams();

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      blocks = _useState2[0],
      setBlocks = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      related = _useState4[0],
      setRelated = _useState4[1];

  useEffect(function () {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    context.getPost(historyParams.id, site);
    var getRelated = new Promise(function (resolve) {
      context.getRelatedPosts(site, historyParams.id, resolve);
    });
    getRelated.then(function (data) {
      setRelated(data);
    });
    return function () {
      context.clearPost();
    };
  }, [historyParams.id]);
  useEffect(function () {
    if (context.post.blocks) {
      setBlocks(context.post.blocks);
    }
  }, [context.post]);
  return /*#__PURE__*/React__default.createElement("main", null, Object.keys(context.post).length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SEO, {
    document: context.post
  }), /*#__PURE__*/React__default.createElement(NewsHero, {
    color: color
  }, /*#__PURE__*/React__default.createElement(NewsHeroCopy, null, /*#__PURE__*/React__default.createElement("h1", null, context.post.title), /*#__PURE__*/React__default.createElement("div", null, context.post.categories && /*#__PURE__*/React__default.createElement("h6", null, context.post.categories.join(', ')), context.post.published && /*#__PURE__*/React__default.createElement("h6", null, DateTime.fromISO(context.post.published).toFormat('LLLL d, yyyy')))), /*#__PURE__*/React__default.createElement(NewsHeroImage, null, (blocks.Featured || []).length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, blocks.Featured[0].settings.image && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("img", {
    src: blocks.Featured[0].settings.image.image,
    alt: blocks.Featured[0].settings.alt_attribute_description
  }), blocks.Featured[0].settings.photo_credit && /*#__PURE__*/React__default.createElement(PhotoCredit, null, blocks.Featured[0].settings.photo_credit))))), (context.post.blocks || {})['Content'] && (context.post.blocks || {})['Content'].map(function (block) {
    return /*#__PURE__*/React__default.createElement(Block, {
      key: block.id,
      data: block,
      color: color,
      site: site
    });
  })), related.length > 0 && /*#__PURE__*/React__default.createElement(StyledLatestNews, {
    style: {
      marginTop: 32
    },
    color: color
  }, /*#__PURE__*/React__default.createElement("h2", null, "Read More"), /*#__PURE__*/React__default.createElement(LargeGrid, {
    color: color
  }, related.map(function (post) {
    return /*#__PURE__*/React__default.createElement(PostCard, {
      post: post,
      key: post.id
    });
  }))));
};

var queryString = require('query-string');

var Results = styled.div.withConfig({
  displayName: "Search__Results",
  componentId: "sc-6cr64g-0"
})(["margin-bottom:90px;@media (min-width:600px){margin-bottom:128px;}form{display:flex;align-items:center;}input{width:100%;flex:1 1 auto;appearance:none;background:none;border-radius:4px 0 0 4px;border:2px solid #bec0d6;border-right:0;height:48px;font-family:proxima-nova,sans-serif;font-weight:400;font-size:18px;padding:0 14px;@media (min-width:600px){width:383px;flex:0 0 auto;margin-right:15px;border-radius:4px;border:2px solid #bec0d6;height:54px;}}button{padding:9px 18px 11px;@media (min-width:600px){padding:12px 21px 14px;}}ul{margin:48px 0 0;padding:0;list-style:none;@media (min-width:600px){margin-top:62px;}}li{margin-bottom:24px;@media (min-width:600px){margin-bottom:44px;}}a{text-decoration:none;h4{margin-bottom:6px;}}"]);
var ResultsList = styled.div.withConfig({
  displayName: "Search__ResultsList",
  componentId: "sc-6cr64g-1"
})(["padding:0 20px;@media (min-width:768px){padding:0 6.9%;}> p{font-family:proxima-nova-condensed,sans-serif;font-size:18px;color:#2f2f2f;margin-top:11px;}"]);

var Search = function Search(_ref) {
  var site = _ref.site,
      color = _ref.color;
  var context = useContext(SiteContext);
  var location = useLocation();

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      query = _useState2[0],
      setQuery = _useState2[1];

  useEffect(function () {
    var initialQuery = queryString.parse(location.search);

    if (initialQuery.query) {
      context.getResults(site, initialQuery.query);
      setQuery(initialQuery.query);
    }
  }, []);
  return /*#__PURE__*/React__default.createElement("main", null, /*#__PURE__*/React__default.createElement(Results, {
    color: color
  }, /*#__PURE__*/React__default.createElement(PageTitle, {
    heading: "Search Results",
    color: color
  }), /*#__PURE__*/React__default.createElement(ResultsList, null, /*#__PURE__*/React__default.createElement("form", {
    action: "/search",
    method: "get"
  }, /*#__PURE__*/React__default.createElement("input", {
    name: "query",
    type: "text",
    value: query,
    onChange: function onChange(event) {
      return setQuery(event.target.value);
    }
  }), /*#__PURE__*/React__default.createElement(Button, {
    type: "submit",
    label: "Search",
    color: color
  })), /*#__PURE__*/React__default.createElement("p", null, "Showing ", context.results.length, " Result", context.results.length === 1 ? '' : 's'), context.results.length > 0 && /*#__PURE__*/React__default.createElement("ul", null, context.results.map(function (result, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: index
    }, /*#__PURE__*/React__default.createElement("a", {
      href: result.url.replace('news_posts', 'news')
    }, /*#__PURE__*/React__default.createElement("h4", null, result.meta_title || result.title)), result.meta_description && /*#__PURE__*/React__default.createElement("p", null, result.meta_description));
  })))));
};

var StyledError = styled.main.withConfig({
  displayName: "Error404__StyledError",
  componentId: "sc-1axhrog-0"
})(["background-color:", ";text-align:center;padding:60px 20px;min-height:calc(100vh - 80px);display:flex;flex-direction:column;align-items:center;justify-content:center;@media (min-width:1024px){min-height:calc(100vh - 122px);padding:140px 6.9%;}+ footer{display:none;}h1{font-family:proxima-nova-condensed,sans-serif;font-size:120px;font-weight:600;color:white;margin-bottom:12px;@media (min-width:450px){font-size:160px;}}p{max-width:568px;margin:0 auto 38px;color:white;font-size:21px;@media (min-width:450px){font-size:24px;}}a{color:white;border-color:white;}"], function (props) {
  return getTertiaryColor(props.color);
});

var Error404 = function Error404(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color;
  return /*#__PURE__*/React__default.createElement(StyledError, {
    color: color
  }, /*#__PURE__*/React__default.createElement("h1", null, "404"), /*#__PURE__*/React__default.createElement("p", null, "Uh Oh! It looks like that page you\u2019re looking for does not exist. Return home or try searching instead."), /*#__PURE__*/React__default.createElement(ButtonLink, {
    to: "/",
    label: "Home"
  }));
};

var Error500 = function Error500(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color;
  return /*#__PURE__*/React__default.createElement(StyledError, {
    color: color
  }, /*#__PURE__*/React__default.createElement("h1", null, "500"), /*#__PURE__*/React__default.createElement("p", null, "We're sorry, but something went wrong."), /*#__PURE__*/React__default.createElement(ButtonLink, {
    to: "/",
    label: "Home"
  }));
};

function ScrollToTop() {
  var history = useHistory();

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  useEffect(function () {
    var html = document.querySelector('html');
    var unlisten = history.listen(function (location, action) {
      if (!location.hash) {
        html.style.scrollBehavior = 'auto';
        setTimeout(function () {
          window.scrollTo(0, 0);
          html.style.scrollBehavior = 'smooth';
        }, 125);
      }
    });
    return function () {
      unlisten();
    };
  }, [pathname]);
  return null;
}

var App = function App(_ref) {
  var site = _ref.site,
      grantTitle = _ref.grantTitle,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1D2042' : _ref$color;
  var root = process.env.NODE_ENV === 'production' ? 'https://hillmanfamilyfoundations.org' : 'http://localhost:4242';
  return /*#__PURE__*/React__default.createElement(HeadProvider, null, /*#__PURE__*/React__default.createElement(BrowserRouter, null, /*#__PURE__*/React__default.createElement(ScrollToTop, null), /*#__PURE__*/React__default.createElement(DefaultStyles, {
    color: color
  }), /*#__PURE__*/React__default.createElement(SiteProvider, {
    root: root,
    title: grantTitle
  }, /*#__PURE__*/React__default.createElement(Header, {
    color: color,
    site: site
  }), /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: ['/', '/pages/home']
  }, /*#__PURE__*/React__default.createElement(Homepage, {
    site: site,
    color: color
  })), /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: "/grants"
  }, /*#__PURE__*/React__default.createElement(Grants, {
    color: color,
    grantTitle: grantTitle
  })), /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: "/news"
  }, /*#__PURE__*/React__default.createElement(News, {
    color: color,
    site: site
  })), /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: "/search"
  }, /*#__PURE__*/React__default.createElement(Search, {
    site: site,
    color: color
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: "/news/:id"
  }, /*#__PURE__*/React__default.createElement(Post, {
    site: site,
    color: color
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: "/pages/:id"
  }, /*#__PURE__*/React__default.createElement(Page, {
    site: site,
    color: color
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: "/500"
  }, /*#__PURE__*/React__default.createElement(Error500, {
    color: color
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: "/404"
  }, /*#__PURE__*/React__default.createElement(Error404, {
    color: color
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: "/404"
  }))), /*#__PURE__*/React__default.createElement(Footer, {
    site: site
  }))));
};

export default App;
//# sourceMappingURL=index.esm.js.map
